/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface User {
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: string;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: any[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
}

export interface AuthorizationType {
  /** 권한타입 객체 오브젝트 아이디 */
  _id: string;
  /**
   * 샘플 데이터 구분
   * @default false
   */
  isSample?: boolean;
  /** 권한타입이 속한 병원 아이디 */
  hospitalID: string;
  /** 권한타입의 이름. 마스터, 관리자, 일반 중 하나 */
  name?: string;
  /** 환자 채팅 관리 권한 */
  canControlPatientChatting?: boolean;
  /** 환자 서비스 차단 권한 */
  canBanPatientToService?: boolean;
  /** 자동화 설정 권한 */
  canUpsertAutomation?: boolean;
  /** 자동화 삭제 권한 */
  canDeleteAutomation?: boolean;
  /** 자동화 대시보드 조회 권한 */
  canReadAutomationDashboard?: boolean;
  /** 콘텐츠 수정 권한 */
  canUpsertContent?: boolean;
  /** 콘텐츠 삭제 권한 */
  canDeleteContent?: boolean;
  /** 메뉴얼 폴더 및 태그 설정 권한 */
  canControlManualFolderAndTagStatus?: boolean;
  /** 메뉴얼 생성 권한 */
  canCreateManual?: boolean;
  /** 병원 정보 조회 권한 */
  canAccessHospitalInformation?: boolean;
  /** 서비스 정보 조회 권한 */
  canAccessHospitalService?: boolean;
  /** 계정 정보 조회 권한 */
  canAccessHospitalAccount?: boolean;
  /** 결제 관리 접근 권한 */
  canAccessPaymentManagement?: boolean;
  /** 결제 권한 */
  canCreatePayment?: boolean;
  /** 서비스 정보 수정 권한 */
  canModifyService?: boolean;
  /** 서비스 종료 권한 */
  canSuspendService?: boolean;
  /** 예약설정 수정 권한 */
  canManageReservation?: boolean;
  /** 예약설정 스케줄 수정 권한 */
  canManageSchedule?: boolean;
  /** 병원정보 수정 권한 */
  canUpdateHospital?: boolean;
  /** 환자 정보 다운로드 권한 */
  canDownloadPatientData?: boolean;
  /** 재진 마케팅 등록/수정 */
  canUpsertMarketingAutomation?: boolean;
  /** 재진 마케팅 삭제 */
  canDeleteMarketingAutomation?: boolean;
  /** 대시보드 조회 여부 */
  canReadMarketingAutomationDashboard?: boolean;
  /** 결제 정보 조회 여부 */
  canReadPaymentRecords?: boolean;
  /** 재진마케팅 전송 기록 엑셀 다운로드 권한 */
  canDownloadMarketingHistory?: boolean;
  /** 상담자동화 발송 기록 엑셀 다운로드 권한 */
  canDownloadConsultationHistory?: boolean;
  /** 메디팔 AI 사용현황 조회 권한 */
  canReadMedipalAIUsage?: boolean;
  /** 메디팔 AI 업무 조정 권한 */
  canAdjustMedipalAITask?: boolean;
  /** 메디팔 AI 예약 조회 권한 */
  canReadMedipalAIReservation?: boolean;
  /** 메디팔 AI 콜 조회 권한 */
  canReadMedipalAICall?: boolean;
  /** 메디팔 AI 콜 최고 권한 */
  canControlMedipalAICall?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface UserHServicePhotoAuthorizationType {
  /** 사용자 아이디 - ObjectId */
  _id: string;
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: File;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: HServiceNurseDoctorHospitalChatroom[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
  /**
   * 기본 상담사 여부
   * @default false
   */
  isDefaultCounselor: boolean;
}

export interface File {
  /**
   * 파일 ID
   * @example "66aca461f8238a4fd30abe15"
   */
  _id: string;
  /** 파일의 소유자 ID */
  userID?: string;
  /**
   * 파일 타입
   * - 300: Image
   * - 400: Video
   * - 500: File
   */
  type: number;
  /** 파일 객체에 포함된 파일의 URL 배열 */
  paths: string[];
  /** 파일 별, S3 스토리지에 업로드 된 파일의 정보 객체 배열 */
  aws?: Record<string, any>[];
  /** 파일 만료일. 외부 연동 서비스일 경우에 존재 */
  expiredAt?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface HServiceNurseDoctorHospitalChatroom {
  /** 서비스 대상이 되는 유저 ID */
  userID?: string;
  /** 서비스 대상의 이름 */
  name?: string;
  /** 서비스 대상의 생년월일 */
  birth?: string;
  /** 서비스 대상의 전화번호 */
  phone?: string;
  /** 서비스 대상의 성별 */
  gender?: string;
  /** 서비스 대상의 차트번호 */
  chartNumber?: string;
  /** 서비스 진행 매니저의 ID */
  nurseID?: UserPhoto;
  /** 서비스 진행 매니저가 여럿인 경우의 매니저 ID 배열 */
  nurseIDs?: any[];
  /** 담당의 유저 ID */
  doctorID?: User;
  /** 서비스가 진행중인 병원의 ID */
  hospitalID?: HospitalRepresentImage;
  /** 서비스 내 포함된 채팅방 ID */
  chatRoomID?: ChatRoom;
  /** 전능 대표 연동 고객번호 (유일) */
  ALCustomerNumber?: string;
  /** 전능 연동 고객번호 리스트 */
  ALCustomerNumbers?: any[];
  /** 서비스 내 작성된 모든 메모의 ID 배열 */
  memos?: any[];
  /** 매니저만 작성/열람 가능한 메모 ID 배열 */
  managementDiaries?: any[];
  /** 고객 태그 ObjectID 배열 */
  userTagIDs?: any[];
  /** 환자 설정 완료 여부(설정/미설정 수 count용) */
  hasPatientSetting?: boolean;
  /** 초기 치료내역 문자열 배열 */
  initialTreatments?: any[];
  /** 초기 치료내역 중  기타를 선택하고 입력한 내역 */
  etcTreatments?: string;
  /** 읽지 않은 매니저 메모의 존재 여부 */
  hasUnreadNurseMemo?: boolean;
  /** 읽지않은 병원 메모 존재 유무 */
  hasUnreadDoctorMemo?: boolean;
  /** 문자유입 프로세스를 통해 서비스를 시작한 경우 유입 Link */
  shortLinkID?: string;
  /** 링크형태의 웹을 통해 진입한 유저의 경우 Type */
  linkType?: string;
  /** 서비스 환자에 대한 간단 설명 */
  description?: string;
  /** 병원 계정의 경우  new 뱃지 표기를 위한 플래그 */
  new?: boolean;
  /** 가입 상태에 대한 string 플래그 */
  status?: string;
  /** query를 위한 서비스 시작 여부 플래그 */
  isRun?: boolean;
  /** 서비스 종료 구분 플래그 */
  isClosed?: boolean;
  /** 서비스 종료시 사용자가 선택한 서비스 종료 이유. 혹은 병원에서 서비스를 종료한 후 사용자에게 보여주기 위한 문구. */
  closeReason?: any[];
  /** 서비스 약관 동의 일시 (HService 기준) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (HService 기준) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (HService 기준) */
  agree_sensitive?: string;
  /** 가입일시 */
  joinedAt?: string;
  /** 서비스 대상 유저의 마지막 로그인 일시 */
  lastLogin?: string;
  /** 마지막 유저의 채팅 모델 ID */
  lastUserChat?: string;
  /** 마지막 유저의 채팅 전송 일시 */
  lastUserChatDate?: string;
  /** 마지막 유저 채팅 존재 유무 */
  hasLastUserChat?: boolean;
  /** 마지막 매니저의 채팅 모델 ID */
  lastNurseChat?: string;
  /** 마지막 매니저의 채팅 전송 일시 */
  lastNurseChatDate?: string;
  /** 마지막 매니저 채팅 존재 유무 */
  hasLastNurseChat?: boolean;
  /** 채팅방에서 마지막으로 수신한 메세지 */
  lastMessage?: string;
  /** 마지막으로 수신된 메세지의 수신 일시 */
  lastMessageUpdatedAt?: string;
  /** 마지막 가입 문자 메시지 수신일자 */
  lastSMSDate?: string;
  /** 고객 유형(치료 유형) 카테고리 ID 목록 */
  treatmentCategories?: any[];
  /** 치료시작일 */
  treatmentStartDate?: string;
  /** 초진/재진 여부 */
  isFirstVisit?: boolean;
  /** 테스트 계정 여부. */
  isTest?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** // 미가입 - 발송 예정인 기본 운동콘텐츠 목록 */
  reservedVCHIDs?: any[];
  /** 전송된 운동콘텐츠의 중 카테고리 ObjectID 배열. 누적 */
  vccIDs?: any[];
  /** 가장 최근에 운동콘텐츠가 전송된 날짜 */
  lastVCUDate?: string;
  /** 모든 운동콘텐츠가 종료되는 날짜 */
  lastVCUEndDate?: string;
  /** 직접 전송한 운동콘텐츠 유무. */
  hasVCU?: boolean;
  /** 병원에서 설정한 평균 이행률 이상 달성했는지 여부 */
  isOverHCompletionRate?: boolean;
  /** 운동콘텐츠 진행중 여부. */
  isVCUOngoing?: boolean;
  /** 합산 공유횟수(현재 반올림 하여 정수로 표현중이나  변경될 수 있음.) */
  sumShareCount?: number;
  /** 평균 이행률(현재 반올림 하여 정수로 저장하나  double 로 변경될 수 있음) */
  avgCompletionRate?: number;
  /** 운동콘텐츠 전송 필요 종모양 알람 표시 여부 */
  needVCU?: boolean;
  /** 운동콘텐츠 발송화면(Electron) 에서의 정렬을 위한 코드 */
  sortDigitVC?: string;
  /** 구분정보1 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote1?: string;
  /** 구분정보2 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote2?: string;
  /** 서비스 시작을 기준으로 카운팅되는 정수 인덱스 */
  seq?: number;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
  /** 서비스 시작일 */
  startedAt?: string;
}

export interface UserPhoto {
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: File;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: any[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
}

export interface HospitalRepresentImage {
  /** 병원의 정식 명칭 */
  name?: string;
  /** 사용자에게 보여질 병원명 */
  shortName?: string;
  /** 병원 주소 */
  address?: string;
  /** 병원 주소체계 검색 및 지도용 주소 정보 */
  addressInfo?: Record<string, any>;
  /** 네이버 지도 API 사용을 위한 주소 정보 */
  addressInfoNaver?: Record<string, any>;
  /** 병원의 과 ID */
  department?: any[];
  /** 병원 소개 글 */
  introduction?: string;
  /** 병원 정보페이지에 노출 될 이미지 파일 ID */
  representImage?: File;
  /** 대표 원장님 */
  representUser?: string;
  /** 병원의 홈페이지 URL */
  homepageURL?: string;
  /** 병원 전화번호 */
  phone?: string;
  /** 병원 전화번호 숨김 여부 */
  isHiddenPhoneNumber?: boolean;
  /** 병원 홈페이지 / 전화번호 사용여부 */
  usingHomepage?: boolean;
  /** 초기 채팅 발송 문구 */
  initialChat?: any[];
  /** 초기 채팅 발송 문구 (텍스트 및 이미지) */
  initialChats?: any[];
  /** 환자 관리를 위해서 매니저가 사용할 ServiceFlagCategory의 디폴트 값 아이디 */
  defaultFlag?: string;
  /** 1차 프로덕트에서 사용된 치료 목록 */
  therapyList?: any[];
  /** 서비스 매니저측에서 병원에 대한 특이사항을 기록하기 위한 JSON Object. */
  additionalInfo?: Record<string, any>;
  /** 문자유입 프로세스 내에서 기본 메세지 발송 여부 플래그 */
  isBasicMessage?: boolean;
  /** 문자유입 시 발송될 기본 문구 */
  smsMessage?: string;
  /** AB 테스트를 위한 메세지 문구 A */
  smsMessageA?: string;
  /** AB 테스트를 위한 메세지 문구 B */
  smsMessageB?: string;
  /** 자동 발송될 기본 채팅 메세지 */
  smsChatMessage?: string;
  /** AB 테스트를 위한 초기 채팅 메세지 A */
  smsChatMessageA?: string;
  /** AB 테스트를 위한 초기 채팅 메세지 B */
  smsChatMessageB?: string;
  /** 고객등록시 가입 문자 직접입력 설정 여부 */
  usingBasicMessage?: boolean;
  /** 고객등록시 가입 문자 기본 문구 */
  smsBasicMessage?: string;
  /** 고객등록시 가입 문자 직접 입력 문구 */
  smsBasicMessageEdit?: string;
  /** 예약등록시 가입 문자 직접입력 설정 여부 */
  usingReservationMessage?: boolean;
  /** 예약등록시 가입 문자 기본 문구 */
  smsReservation?: string;
  /** 예약등록시 가입 문자 직접 입력 문구 */
  smsReservationEdit?: string;
  /** 기존 고객 가입 문자 재발송 직접입력 설정 여부 */
  usingResendMessage?: boolean;
  /** 기존 고객 가입 문자 재발송 기본 문구 */
  smsResendMessage?: string;
  /** 기존 고객 가입 문자 재발송 직접 입력 문구 */
  smsResendMessageEdit?: string;
  /** 채팅 예약 발송 시 커스텀 메시지 */
  chatReservationGuide?: string;
  /** 진료 시간 */
  careSchedule?: any[];
  /** 진료 시간 설명 */
  careScheduleDescription?: string;
  /** 문자 유입내 사용할 이미지 파일 ID */
  smsLogoImage?: string;
  /** 문자유입간 이미지의 사용 여부 */
  isUsingLogo?: boolean;
  /** 담당 서비스매니저의 UserID */
  nurseID?: string;
  /** 병원별 여러명의 서비스 매니저를 담기 위한 서비스매니저의 User ID 배열 */
  nurseIDs?: any[];
  /** 담당 서비스 매니저가 여럿인지, 단일이지 구분짓기 위한 플래그 */
  hospitalType?: string;
  /** 문자 유입 사용여부 플래그 */
  usingRegistUser?: boolean;
  /** 서비스 진행 여부 플래그 */
  isClosed?: boolean;
  /** 서비스 설정 모델 ObjectId */
  serviceSetting?: string;
  /** 현재 모바일에서 예약가능한 시트가 존재하는지 확인하기 위한 플래그 */
  hasActiveSheet?: boolean;
  /** 2차 프로덕트 사용여부. */
  isSecondEdition?: boolean;
  /** 홈케어 콘텐츠 모듈 사용 여부 */
  usingVideoContent?: boolean;
  /** 병원 이벤트 모듈 사용여부 */
  usingHospitalEvent?: boolean;
  /** 모바일 홈화면에 표시될 건강 관리 뉴스 카테고리. */
  healthContentCategory?: any[];
  /** 건강콘텐츠 사용 여부 */
  usingHealthContent?: boolean;
  /** 병원 소식 사용 여부 */
  usingHospitalContent?: boolean;
  /** 연동 설정 모델 ObjectId */
  integrationSetting?: string;
  /** 애프터닥 운영시간 종료 후 환자 채팅 시, 팝업 표시 여부 */
  usingAfterhoursPopup?: boolean;
  /** 애프터닥 운영시간 종료 후 환자 채팅 시, 표시할 팝업 내용 */
  afterhoursPopupContent?: string;
  /** 자동 가입문자 재발송 사용 여부 */
  usingAutoReservedSMS?: boolean;
  /** 자동 재가입 문자 발송에 사용될 콘텐츠 */
  autoReservedSMSMessage?: string;
  /** 자동 재가입 문자 발송까지 대기할 날 */
  autoReservedSMSDelayDay?: number;
  /** 자동 재가입 문자가 발송될 시간 */
  autoReservedSMSHour?: number;
  /** 예약 시트 2차 버전 사용 여부 */
  usingV2ReservationSheet?: boolean;
  /** SaaS 예약시트 사용 여부 */
  usingSaaSReservation?: boolean;
  /** SaaS 프로덕트 사용 여부 */
  isEnabledSaaS?: boolean;
  /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
  locale?: string;
  /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
  timezone?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface ChatRoom {
  /** 채팅방에 참여중인 서비스 ID */
  hserviceID?: string;
  /** 채팅방에 참여중인(Push notification을 받아야 하는.) 유저의 ID 배열 */
  users?: any[];
  /** 채팅의 주 대상이 되는(환자 or 의사) 유저의 ID */
  userID?: string;
  /** 채팅방 ID(_ID와 동일하고 _ID 사용 권장) */
  id?: string;
  /** 채팅방 _ID */
  _id: string;
  /** 채팅방 제목 */
  title?: string;
  /** 서비스매니저가 읽지 않은 채팅의 수 */
  n_UnreadCount?: number;
  /** 대상 유저가 읽지 않은 채팅의 수 */
  c_UnreadCount?: number;
  /** 채팅의 대상이 되는 유저가 처음 진입했는가에 대한 질의를 위한 플래그 */
  c_isFirstEnter?: boolean;
  /** 서비스 매니저의 첫 메세지 전송 여부 플래그 */
  c_isFirstNurseChat?: boolean;
  /** 대상 유저의 첫 메세지 구분 플래그 */
  c_isFirstUserChat?: boolean;
  /** 매니저의 첫 메세지 전송 이후를 확인하기 위한 플래그 */
  c_isSendedFirstNurseChat?: boolean;
  /** 해당 채팅방의 귀속 병원 ID */
  hospitalID?: string;
  /** 병원 계정과의 채팅방임을 구분짓는 플래그 */
  isDoctor?: boolean;
  /** 첫 메세지 전송을 통한 SMS 전송 여부 구분 플래그 */
  hasFirstSMS?: boolean;
  /** 마지막으로 전달된 메세지 모델 ID */
  lastMessage?: string;
  /** 마지막 메세지 전달 일시 */
  lastMessageUpdatedAt?: string;
  /** 채팅방 내에서의 총 메세지 수 */
  totalChatCount?: number;
  /** 마지막으로 환자가 전달한 채팅의 ObjectId */
  lastUserChat?: string;
  /** 마지막으로 환자가 전달한 채팅의 일시 */
  lastUserChatDate?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 ObjectId */
  lastNurseChat?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 일시 */
  lastNurseChatDate?: string;
  /** 참여 유저별 뱃지 카운트 정보 */
  badgeCountInfo?: Record<string, any>;
  /** 사용자 ID 별 필요한 정보의 집합 */
  info: {
    /**
     * 사용자 ID
     * @example "60b12345b1234c56789abcd1"
     */
    userID: string;
    /**
     * 채팅을 읽지 않은 갯수
     * @example 0
     */
    count: number;
    /**
     * 개인별 출력되는 채팅방 제목
     * @example "단체방"
     */
    title: string;
  }[];
  /** 1대1 채팅방 구분자 */
  isMultiUser?: boolean;
  /** 채팅방의 병원 응대 필요 (상담 요청) 여부 */
  isChatResponseRequired?: boolean;
  /** 병원 응대 필요 채팅 (상담 요청) 존재 여부 */
  hasUnreadChatResponseRequired?: boolean;
  /** 채팅방 삭제 여부 */
  isRemoved?: boolean;
  /** 채팅방 타입 정의 */
  roomType?: string;
  /** 카카오 상담톡을 위한 추가 정보 */
  ikakaoInfo?: Record<string, any>;
  /** 채팅방의 담당자 ID 배열 */
  counselors?: any[];
  /**
   * 상담 진행중 여부
   * @default false
   */
  isCounselInProgress?: boolean;
  /**
   * 번역 사용 여부
   * @default false
   */
  usingTranslation?: boolean;
  /** 언어 ObjectId */
  languageID?: string;
  /** 활성화 여부 */
  isActive?: boolean;
  /** 채팅방에 연결된 부모 서비스 ID. 연동된 내용이 없으면 hserviceID와 동일 */
  parentHServiceID: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface V2DepartmentModifier {
  /** 부서 이름 */
  title?: string;
  /** 병원 ID */
  hospitalID?: string;
  /** 정렬 순서 */
  sortNum?: string;
  /** 부서에 포함된 직원 ObjectId 목록 */
  employees?: any[];
  /** 수정자 ID */
  modifierID?: UserNameAndType;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 생성일시 */
  createdAt?: string;
  /** 수정일시 */
  updatedAt?: string;
  /** 마지막 부서 수정 일시 (일렉트론) */
  modifiedAt?: string;
  /** 삭제일시 */
  removedAt?: string;
}

export interface UserNameAndType {
  /** 유저 ID */
  _id: string;
  /** 이름 */
  name: string;
  /** 유저의 실제 이름 */
  realName: string;
  /** 유저 타입 */
  type: string;
  /** 유저의 직무 또는 직책 */
  jobType: string;
}

export interface GetServerSettingHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    AppVersion?: {
      Electron?: {
        version?: string;
        url?: string;
      } | null;
      ManagerApp: {
        Android?: string;
        min_Android?: string;
        iOS?: string;
        min_iOS?: string;
      };
      Android?: string;
      min_Android?: string;
      iOS?: string;
      min_iOS?: string;
    };
    electron?: {
      isShowHospitalMobileGuide?: boolean;
    } | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export type AuthJoinMQrData = any;

export type AuthLoginElData = any;

export interface AuthLoginMCheckphoneParams {
  /** 확인하기 위한 유저의 전화번호 */
  phone: string;
}

export type AuthLoginMCheckphoneData = any;

export type AuthLogoutMData = any;

export type AuthLoginHmData = any;

export type AuthLogoutHmData = any;

export type AuthPhoneMRequestData = any;

export type AuthPhoneMRequestChangephoneData = any;

export type AuthPhoneMRequestUnidentifyData = any;

export type AuthPhoneMVerifyData = any;

export type AuthPhoneMChangeData = any;

export type AuthPhoneMwRequestData = any;

export type AuthPhoneMwVerifyData = any;

export interface AuthPasswordMHaspasswordParams {
  /** 조회하고자 하는 유저 아이디 */
  userID?: string;
}

export type AuthPasswordMHaspasswordData = any;

export interface AuthShortlinkMUserinfoParams {
  /** (required) ShortLink에 포함된 마지막 path. ex)https://api.afterdoc.net/sj/{path} */
  path?: string;
}

export type AuthShortlinkMUserinfoData = any;

export interface AuthShortlinkMHserviceinfoParams {
  /** (required) ShortLink에 포함된 마지막 path. ex)https://api.afterdoc.net/sj/{path} */
  path?: string;
}

export type AuthShortlinkMHserviceinfoData = any;

export type AuthUserMwSuspendData = any;

export type ApiRegistPatientElCreateData = any;

export type ApiRegistPatientElSendsmsData = any;

export interface ApiUserElFindParams {
  /** (required) 병원ID */
  userID?: string;
  _id?: string;
}

export type ApiUserElFindData = ApiResponse & {
  data: User[];
};

export interface ApiUserElFindOneParams {
  /** (required) 병원ID */
  userID?: string;
}

export type ApiUserElFindOneData = ApiResponse & {
  data: UserHServicePhotoAuthorizationType;
};

export type ApiUserElUpdateData = any;

export interface ApiUserElCanchangephoneParams {
  /** (required) 전화번호를 변경하고자 하는 유저 ID */
  userID: string;
  /** (required) 변경하고자 하는 전화번호 */
  phone: string;
  /** (required) 국가 코드 Id */
  countryCode: string;
}

export type ApiUserElCanchangephoneData = any;

export type ApiUserElUpdateDashboardData = any;

export interface ApiUserMFindOneParams {
  /** (required) 병원ID */
  userID?: string;
}

export type ApiUserMFindOneData = any;

export type ApiUserMUpdateData = any;

export type ApiUserMUpdateDeviceinfoData = any;

export type ApiUserMPhoneCodeData = any;

export type ApiUserMPhoneVerifyData = any;

export type ApiUserMChangepasswordData = any;

export type ApiUserHmUpdateDeviceinfoData = any;

export interface ApiChatroomElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
}

export type ApiChatroomElFindData = any;

export interface ApiChatroomElCountResponserequiredParams {
  /** (required) 병원 ID */
  hospitalID?: string;
}

export type ApiChatroomElCountResponserequiredData = any;

export interface ApiChatroomElCountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
}

export type ApiChatroomElCountData = any;

export interface ApiChatroomElUnreadcountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 유저 아이디 */
  userID?: string;
  /** 관리자 채팅방 여부 */
  isDoctor?: boolean;
}

export type ApiChatroomElUnreadcountData = ApiResponse & {
  data: {
    /** userID */
    _id: string;
    /** 안 읽은 채팅 수. */
    total: number;
  }[];
};

export type ApiChatroomElCreateData = any;

export type ApiChatroomElUpdateData = any;

export type ApiChatroomElUpdateReadResponserequiredData = any;

export type ApiChatroomElUpdateReadData = any;

export type ApiChatroomElUpdateStatusResponserequiredAllData = any;

export type ApiChatroomElUpdateTitleData = any;

export type ApiChatroomElUserAddData = any;

export type ApiChatroomElUserRemoveData = any;

export type ApiChatroomElUserRemoveAllData = any;

export interface ApiChatroomMFindOneParams {
  /** (required) 채팅방 ID */
  chatRoomID?: string;
}

export type ApiChatroomMFindOneData = any;

export type ApiChatroomMUpdateReadData = any;

export interface ApiChatElFindParams {
  /** (required) 채팅방 ID */
  chatRoomID?: string;
}

export type ApiChatElFindData = any;

export interface ApiChatElCountParams {
  /** (required) 채팅방 ID */
  chatRoomID?: string;
}

export type ApiChatElCountData = any;

export type ApiChatElUpdateMarkerData = any;

export type ApiChatMCreateReservationData = any;

export type ApiChatMCreateHeventData = any;

export type ApiChatMCreateHaftercareData = any;

export interface ApiHospitalElFindParams {
  /** (required) 병원ID */
  _id?: string;
}

export type ApiHospitalElFindData = any;

export interface ApiHospitalElFindAddressParams {
  /** 검색 키워드 */
  keyword?: string;
  /** 현재 페이지 */
  currentPage?: string;
  /** 한 페이지에 출력될 row 갯수 */
  countPerPage?: string;
}

export type ApiHospitalElFindAddressData = any;

export type ApiHospitalElUpdateData = any;

export interface ApiHospitalElFindDoctorsParams {
  /** (required) 병원ID */
  hospitalID?: string;
}

export type ApiHospitalElFindDoctorsData = any;

export interface ApiHospitalElFindUsersParams {
  /** (required) 병원ID */
  hospitalID?: string;
}

export type ApiHospitalElFindUsersData = any;

export interface ApiHospitalMFindOneParams {
  /** 조회하고자 하는 병원 ID */
  hospitalID?: string;
}

export type ApiHospitalMFindOneData = any;

export interface ApiHospitalMFindDoctorsParams {
  /** 조회하고자 하는 병원 ID */
  hospitalID?: string;
}

export type ApiHospitalMFindDoctorsData = any;

export interface ApiHospitalMFindAfterhoursPopupParams {
  /** (required) 병원 ID */
  hospitalID?: string;
}

export type ApiHospitalMFindAfterhoursPopupData = any;

export interface ApiNoticeServicenoticeElCountParams {
  /** 수신 대상 유저의 ID */
  userID?: string;
  /** 발송된 병원의 ID */
  hospitalID?: string;
}

export type ApiNoticeServicenoticeElCountData = any;

export interface ApiNoticeServicenoticeElFindParams {
  /** 수신 대상 유저의 ID */
  userID?: string;
  /** 발송된 병원의 ID */
  hospitalID?: string;
}

export type ApiNoticeServicenoticeElFindData = any;

export type ApiNoticeServicenoticeElUpdateReadData = any;

export type ApiNoticeServicenoticeElUpdateReadAllData = any;

export interface ApiNoticeServicenoticeMCountParams {
  /** 수신 대상 유저의 ID */
  userID?: string;
  /** (required) 수신 대상 유저의 서비스 ID */
  hserviceID?: string;
  /** 발송된 병원의 ID */
  hospitalID?: string;
  /** 읽음 여부 구분 */
  isRead?: boolean;
}

export type ApiNoticeServicenoticeMCountData = any;

export interface ApiNoticeServicenoticeMFindParams {
  /** 수신 대상 유저의 ID */
  userID?: string;
  /** (required) 수신 대상 유저의 서비스 ID */
  hserviceID?: string;
  /** 발송된 병원의 ID */
  hospitalID?: string;
}

export type ApiNoticeServicenoticeMFindData = any;

export type ApiNoticeServicenoticeMUpdateReadData = any;

export type ApiNoticeServicenoticeMUpdateReadAllData = any;

export interface ApiNoticeServicenoticeHmCountParams {
  /** 수신 대상 유저의 ID */
  userID?: string;
  /** 발송된 병원의 ID */
  hospitalID?: string;
  /**
   * 알림 카테고리. 비워둘 시 전체 조회.
   * - PatientManagement : 고객관리 알림
   * - ReservationManagement : 예약관리 알림
   */
  category?: string;
  /** 읽음 여부 구분 */
  isRead?: boolean;
}

export type ApiNoticeServicenoticeHmCountData = any;

export interface ApiNoticeServicenoticeHmFindParams {
  /** 수신 대상 유저의 ID */
  userID?: string;
  /** 발송된 병원의 ID */
  hospitalID?: string;
  /**
   * 알림 내역을 가져올 시점. 예) 최근 3개월 알림 내역
   * @default "2023-02-15T00:00:00.000+0900"
   */
  startedAt?: string;
  /**
   * 알림 카테고리. 비워둘 시 전체 조회.
   * - PatientManagement : 고객관리 알림
   * - ReservationManagement : 예약관리 알림
   */
  category?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
}

export type ApiNoticeServicenoticeHmFindData = any;

export type ApiNoticeServicenoticeHmUpdateReadData = any;

export type ApiNoticeServicenoticeHmUpdateReadAllData = any;

export type ApiNoticeServicenoticeHmUpdateReadReservationData = any;

export interface ApiReservationsettingElFindParams {
  /** required. 병원 ID */
  hospitalID?: boolean;
}

export type ApiReservationsettingElFindData = any;

export type ApiReservationsettingElUpdateData = any;

export interface ApiReservationsheetElFindParams {
  /** reservation sheet id */
  _id?: string;
  /** removed flag */
  isRemoved?: boolean;
  /** reservation sheets from hospitalID */
  hospitalID?: string;
}

export type ApiReservationsheetElFindData = any;

export interface ApiReservationsheetElFindOneParams {
  /** reservation sheet id */
  _id?: string;
  /** removed flag */
  isRemoved?: boolean;
  /** reservation sheets from hospitalID */
  hospitalID?: string;
}

export type ApiReservationsheetElFindOneData = any;

export interface ApiReservationsheetElDetailParams {
  /** reservation sheet id. required */
  sheetID?: string;
  /** 조회하고자 하는 날짜. */
  date?: Date;
}

export type ApiReservationsheetElDetailData = any;

export type ApiReservationsheetElCreateData = any;

export type ApiReservationsheetElUpdateData = any;

export type ApiReservationsheetElRemoveData = any;

export type ApiReservationsheetElUpdateActivateData = any;

export interface ApiReservationsheetMFindParams {
  /** 예약시트 아이디. 특정 시트 정보를 얻고 싶을 때 사용. */
  _id?: string;
  /**
   * 조회하고자 하는 병원의 ID. 필수값
   * @default "613d614a25276223a9b1eea8"
   */
  hospitalID?: string;
  /**
   * 삭제 여부 플래그. 반드시 false로 넣어줘야 오동작을 방지할 수 있음.
   * @default false
   */
  isRemoved?: boolean;
  /**
   * 활성화 여부 - 병원에서 해당 시트에 대해 예약을 받을지 말지 결정하는 플래그. 반드시 true로 넣어줘야 오동작을 방지할 수 있음.
   * @default true
   */
  isActivate: boolean;
}

export type ApiReservationsheetMFindData = any;

export interface ApiReservationsheetMDetailParams {
  /** reservation sheet id */
  sheetID?: string;
  /** userID */
  userID?: string;
}

export type ApiReservationsheetMDetailData = any;

export interface ApiReservationsheetMDetailReservationidParams {
  /** reservation sheet id */
  sheetID?: string;
  /** reservation id */
  reservationID?: string;
}

export type ApiReservationsheetMDetailReservationidData = any;

export interface ApiReservationsheetMPossibledaysParams {
  /** reservation sheet id */
  sheetID?: string;
  /** reservation column id */
  columnID?: string;
  /**
   * reservation sheets from hospitalID
   * @default "613d614a25276223a9b1eea8"
   */
  hospitalID: string;
}

export type ApiReservationsheetMPossibledaysData = any;

export interface ApiReservationsheetMReservationlistParams {
  /** reservation sheet id */
  sheetID?: string;
  /** reservation column id */
  columnID?: string;
  /**
   * reservation sheets from hospitalID
   * @default "613d614a25276223a9b1eea8"
   */
  hospitalID: string;
  /** target date */
  date?: string;
}

export type ApiReservationsheetMReservationlistData = any;

export interface ApiReservationsheetHmFindParams {
  /** removed flag */
  isRemoved?: boolean;
  /** reservation sheets from hospitalID */
  hospitalID?: string;
}

export type ApiReservationsheetHmFindData = any;

export interface ApiReservationcolumnElFindParams {
  /** reservation column id */
  _id?: any;
  /** reservation sheet id */
  sheetID?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
}

export type ApiReservationcolumnElFindData = any;

export type ApiReservationcolumnElCreateData = any;

export type ApiReservationcolumnElUpdateData = any;

export type ApiReservationcolumnElUpdateTimeintervalsData = any;

export type ApiReservationcolumnElRemoveData = any;

export interface ApiReservationcolumnElDateParams {
  /** reservation column id */
  _id?: any;
  /** hospital id */
  hospitalID?: any;
  /** reservation sheet id */
  sheetID?: string;
  /** date */
  date?: string;
  /** 정렬하고자 하는 field, key 및 way 미입력 시 default값은 "createdAt" */
  key?: string;
  /** 정렬하고자 하는 방향. key 및 way 미입력 시 default값은 1 */
  way?: number;
}

export type ApiReservationcolumnElDateData = any;

export interface ApiReservationcolumnMDateParams {
  /** reservation sheet id */
  sheetID?: string;
  /**
   * 예약 가능한 일자 내 칼럼 조회를 위한 시작일. 필수 입력
   * @default "2022-10-05T00:00:00.000+0900"
   */
  startedAt?: string;
  /**
   * 예약 가능한 일자 내 칼럼 조회를 위한 종료일. 필수 입력
   * @default "2022-10-06T00:00:00.000+0900"
   */
  endedAt?: string;
  /**
   * 활성화 된 컬럼의 플래그. 오동작 방지를 위해 true 입력
   * @default true
   */
  isActivate?: boolean;
  /** 정렬하고자 하는 field, key 및 way 미입력 시 default값은 "createdAt" */
  key?: string;
  /** 정렬하고자 하는 방향. key 및 way 미입력 시 default값은 1 */
  way?: number;
}

export type ApiReservationcolumnMDateData = any;

export interface ApiReservationcolumnHmDateParams {
  /** reservation column id */
  _id?: any;
  /** hospital id (required) */
  hospitalID?: any;
  /** reservation sheet id (required) */
  sheetID?: string;
  /** date */
  date?: string;
  /** 정렬하고자 하는 field, key 및 way 미입력 시 default값은 "createdAt" */
  key?: string;
  /** 정렬하고자 하는 방향. key 및 way 미입력 시 default값은 1 */
  way?: number;
}

export type ApiReservationcolumnHmDateData = any;

export interface ApiReservationprogramElFindParams {
  /** ReservationSheet id */
  sheetID?: any;
  /** hospital id */
  hospitalID?: any;
}

export type ApiReservationprogramElFindData = any;

export type ApiReservationprogramElCreateData = any;

export type ApiReservationprogramElUpdateData = any;

export type ApiReservationprogramElRemoveData = any;

export interface ApiReservationprogramHmFindParams {
  /** ReservationSheet id */
  sheetID?: any;
  /** hospital id */
  hospitalID?: any;
}

export type ApiReservationprogramHmFindData = any;

export interface ApiReservationElCountParams {
  /** reservation id */
  _id?: any;
  /** reservation sheet id */
  sheetID?: string;
  /** reservation column id. 시트내 전체 내역을 조회하고 싶으면 넣지 말 것. */
  columnID?: string;
  /** user ID */
  userID?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 실 데이터를 위해 false 로 설정 */
  isOverride?: boolean;
  /** 예약현황 조회를 위한 조회 범위 시작 일시 */
  startedAt?: Date;
  /** 예약현황 조회를 위한 조회 범위 종료 일시 */
  endedAt?: Date;
  /** 테스트 계정 여부 플래그. */
  isTest?: string;
}

export type ApiReservationElCountData = any;

export interface ApiReservationElFindParams {
  /** reservation id */
  _id?: any;
  /** reservation sheet id */
  sheetID?: string;
  /** reservation column id. 시트내 전체 내역을 조회하고 싶으면 넣지 말 것. */
  columnID?: string;
  /** hserviceID */
  hserviceID?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 실 데이터를 위해 false 로 설정 */
  isOverride?: boolean;
  /** 예약현황 조회를 위한 조회 범위 시작 일시 */
  startedAt?: Date;
  /** 예약현황 조회를 위한 조회 범위 종료 일시 */
  endedAt?: Date;
  /** 테스트 계정 여부 플래그. */
  isTest?: string;
}

export type ApiReservationElFindData = any;

export type ApiReservationElCreateData = any;

export type ApiReservationElCreateRegistData = any;

export type ApiReservationElUpdateData = any;

export type ApiReservationElRemoveData = any;

export interface ApiReservationElLastParams {
  /** reservation sheet id */
  sheetID?: string;
  /** reservation column id */
  columnID?: string;
  /** user id */
  userID?: string;
}

export type ApiReservationElLastData = any;

export interface ApiReservationElFindNextParams {
  /** 병원 아이디 (required) */
  hospitalID?: string;
  /** 유저 아이디 (required) */
  userID?: string;
}

export type ApiReservationElFindNextData = any;

export interface ApiReservationElFindHistoryParams {
  /** reservation id */
  _id?: any;
  /** reservation sheet id */
  sheetID?: string;
  /** reservation column id. 시트내 전체 내역을 조회하고 싶으면 넣지 말 것. */
  columnID?: string;
  /** hserviceID */
  hserviceID?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 실 데이터를 위해 false 로 설정 */
  isOverride?: boolean;
  /** 예약현황 조회를 위한 조회 범위 시작 일시 */
  startedAt?: Date;
  /** 예약현황 조회를 위한 조회 범위 종료 일시 */
  endedAt?: Date;
}

export type ApiReservationElFindHistoryData = any;

export interface ApiReservationElFindParentParams {
  /** reservation parentID */
  parentID?: any;
  /** 예약 타입 정의 */
  type?: any;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiReservationElFindParentData = any;

export interface ApiReservationElFindScheduleParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 시트 ID 배열, 비워둘 경우 전체 조회 */
  "sheetID[]"?: string[];
  /** 예약현황 조회를 위한 조회 범위 시작 일시 */
  startedAt?: Date;
  /** 예약현황 조회를 위한 조회 범위 종료 일시 */
  endedAt?: Date;
  /** 예약 타입. 비워둘 경우 block 을 제외한 모든 예약( 2 이상 ) 탐색 */
  type?: number;
  /**
   * 삭제 여부 플래그. default - false
   * @default false
   */
  isRemoved?: string;
  /**
   * 수정 여부 플래그. default - false
   * @default false
   */
  isOverride?: string;
  /** 테스트 계정 여부 플래그. */
  isTest?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property. */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiReservationElFindScheduleData = any;

export interface ApiReservationMFindParams {
  /** 유저 아이디 (will be deprecated) */
  userID?: string;
  /** 서비스 아이디 (required) */
  hserviceID?: string;
  /** 시트 ID */
  sheetID?: string;
  /** 컬럼 ID */
  columnID?: string;
  /**
   * 모바일 예약 조회를 위한 조회 시작일. 기간으로 조회 시 시작일 ~ 종료일 모두 필요
   * @default "2023-10-29T00:00:00.000+0900"
   */
  startedAt?: string;
  /**
   * 모바일 예약 조회를 위한 조회 종료일. 기간으로 조회 시 시작일 ~ 종료일 모두 필요
   * @default "2023-12-02T23:59:59.999+0900"
   */
  endedAt?: string;
  /** skip */
  skip?: number;
  /** limit */
  limit?: number;
  /** 삭제 여부 플래그 */
  isRemoved?: number;
  /**
   * 실 데이터를 위해 false 로 설정 (required)
   * @default false
   */
  isOverride?: boolean;
}

export type ApiReservationMFindData = any;

export interface ApiReservationMFindLastParams {
  /** 유저 아이디 (will be deprecated) */
  userID?: string;
  /** 서비스 아이디 (required) */
  hserviceID?: string;
  /** sheetID (required) */
  sheetID?: string;
}

export type ApiReservationMFindLastData = any;

export interface ApiReservationMFindDateParams {
  /** hospital id */
  hospitalID?: string;
  /** reservation sheet id */
  sheetID?: string;
  /** reservation column id */
  columnID?: string;
  /**
   * 예약 조회를 위한 시간 범위중 시작 시간. 시작 시간은 반드시 해당 일의 0시0분0초로 한다.
   * @default "2022-10-05T00:00:00.000+0900"
   */
  startedAt?: string;
  /**
   * 예약 조회를 위한 시간 범위중 종료 시간. 종료 시간은 반드시 시작일로부터 1일 후로 한다.
   * @default "2022-10-06T00:00:00.000+0900"
   */
  endedAt?: string;
}

export type ApiReservationMFindDateData = any;

export interface ApiReservationMFindNextParams {
  /** 유저 아이디 (will be deprecated) */
  userID?: string;
  /** 서비스 아이디 (required) */
  hserviceID?: string;
}

export type ApiReservationMFindNextData = any;

export type ApiReservationMCreateData = any;

export type ApiReservationMUpdateData = any;

export type ApiReservationMRemoveData = any;

export interface ApiReservationMPossibledateParams {
  /**
   * 시트 ID. 필수
   * @default "630ffbc4c12643daba4c8a12"
   */
  sheetID?: string;
  /**
   * 컬럼 ID. 필수
   * @default "630ffbd7c12643daba4c8a14"
   */
  columnID?: string;
}

export type ApiReservationMPossibledateData = any;

export interface ApiReservationHmFindParams {
  /** reservation id */
  _id?: any;
  /** (required) 병원 ID */
  hospitalID?: string;
  /** reservation sheet id */
  sheetID?: string;
  /** reservation column id. 시트내 전체 내역을 조회하고 싶으면 넣지 말 것. */
  "columnID[]"?: string[];
  /** hserviceID */
  hserviceID?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 실 데이터를 위해 false 로 설정 */
  isOverride?: boolean;
  /**
   * (optional) 예약현황 조회를 위한 조회 범위 시작 일시
   * @default "2023-05-31T00:00:00.000+0900"
   */
  startedAt?: Date;
  /**
   * (optional) 예약현황 조회를 위한 조회 범위 종료 일시
   * @default "2023-05-31T23:59:59.999+0900"
   */
  endedAt?: Date;
  /** 예약 타입. 비워둘 경우 모든 예약 타입 탐색(ReservationBlock 포함) */
  type?: number;
}

export type ApiReservationHmFindData = any;

export type ApiReservationHmCreateData = any;

export type ApiReservationHmUpdateData = any;

export type ApiReservationHmRemoveData = any;

export interface ApiReservationHmFindHistoryParams {
  /** reservation id */
  _id?: any;
  /** reservation sheet id */
  sheetID?: string;
  /** reservation column id. 시트내 전체 내역을 조회하고 싶으면 넣지 말 것. */
  columnID?: string;
  /** hserviceID */
  hserviceID?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 실 데이터를 위해 false 로 설정 */
  isOverride?: boolean;
  /** 예약현황 조회를 위한 조회 범위 시작 일시 */
  startedAt?: Date;
  /** 예약현황 조회를 위한 조회 범위 종료 일시 */
  endedAt?: Date;
}

export type ApiReservationHmFindHistoryData = any;

export interface ApiReservationvacationElFindParams {
  /** reservation column id */
  _id?: any;
  /** hospital id */
  hospitalID?: string;
  /** 병원휴일만을 조회하기 위한 플래그 */
  isHospital?: string;
  /** 검색 범위의 시작 date. 전체 스트링 필요 */
  startDate?: Date;
  /** 검색 범위의 종료 date. 전체 스트링 필요 */
  endDate?: Date;
  /** 하루에 해당하는 날짜만 조회하기 위해 필요. true 인 경우, 해당 날짜만 검색. false인 경우, 해당 월 검색 */
  isDay?: boolean;
  /** 시트 아이디. isSheet 플래그와 함께 사용 */
  sheetID?: string;
  /** 시트만을 조회하고자 할 때, true */
  isSheet?: string;
  /** 컬럼 아이디. isColumn 플래그와 함께 사용 */
  columnID?: string;
  /** 컬럼만을 조회하고자 할 때, true */
  isColumn?: string;
}

export type ApiReservationvacationElFindData = any;

export interface ApiReservationvacationElFindHospitalParams {
  /** reservation column id */
  _id?: any;
  /** hospital id */
  hospitalID?: string;
  /** 검색 범위의 시작 date. 전체 스트링 필요 */
  startDate?: Date;
  /** 검색 범위의 종료 date. 전체 스트링 필요 */
  endDate?: Date;
}

export type ApiReservationvacationElFindHospitalData = any;

export interface ApiReservationvacationElFindSheetParams {
  /** reservation vacation id */
  _id?: any;
  /** hospital id */
  hospitalID?: string;
  /** sheet id */
  sheetID?: string;
  /** 검색 범위의 시작 date. 전체 스트링 필요 */
  startDate?: Date;
  /** 검색 범위의 종료 date. 전체 스트링 필요 */
  endDate?: Date;
}

export type ApiReservationvacationElFindSheetData = any;

export interface ApiReservationvacationElFindColumnParams {
  /** reservation vacation id */
  _id?: any;
  /** hospital id */
  hospitalID?: string;
  /** sheet id */
  sheetID?: string;
  /** column id */
  columnID?: string;
  /** 검색 범위의 시작 date. 전체 스트링 필요 */
  startDate?: Date;
  /** 검색 범위의 종료 date. 전체 스트링 필요 */
  endDate?: Date;
}

export type ApiReservationvacationElFindColumnData = any;

export type ApiReservationvacationElCreateData = any;

export type ApiReservationvacationElUpdateData = any;

export type ApiReservationvacationElRemoveData = any;

export interface ApiReservationvacationHmFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 병원 전체 대상 휴일 조회 여부. default true. 병원 전체 휴일 항목을 제외하고자 하면 false */
  isHospital?: string;
  /** (required) 시트 ID */
  sheetID?: string;
  /** 시트 휴일 조회 여부. default true. 시트 휴일 항목을 제외하고자 하면 false */
  isSheet?: string;
  /** (optional) 컬럼 ID 배열 */
  "columnID[]"?: string[];
  /** 담당자 휴일 조회 여부. default true, 담당자 휴일 항목을 제외하고자 하면 false */
  isColumn?: string;
  /**
   * 검색 범위의 시작 date. 전체 스트링 필요
   * @default "2023-06-01T00:00:00.000+0900"
   */
  startDate?: Date;
  /**
   * 검색 범위의 종료 date. 전체 스트링 필요
   * @default "2023-06-30T00:00:00.000+0900"
   */
  endDate?: Date;
}

export type ApiReservationvacationHmFindData = any;

export interface ApiReservationblockElFindParams {
  /** 병원 ID */
  hospitalID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiReservationblockElFindData = any;

export type ApiReservationblockElCreateData = any;

export type ApiReservationblockElUpdateData = any;

export type ApiReservationblockElRemoveData = any;

export interface ApiReservationblockHmFindParams {
  /** 병원 ID */
  hospitalID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiReservationblockHmFindData = any;

export type ApiReservationblockHmCreateData = any;

export type ApiReservationblockHmUpdateData = any;

export type ApiReservationblockHmRemoveData = any;

export interface ApiReservationsheetdatenoteElFindParams {
  /** reservation sheet id */
  sheetID?: any;
  /** 조회하고자 하는 일자 */
  date?: string;
}

export type ApiReservationsheetdatenoteElFindData = any;

export interface ApiReservationsheetdatenoteElFindOneParams {
  /** reservation sheet id */
  sheetID?: any;
  /** hospital id */
  hospitalID?: any;
  /** 조회하고자 하는 일자 */
  date?: string;
}

export type ApiReservationsheetdatenoteElFindOneData = any;

export type ApiReservationsheetdatenoteElUpdateData = any;

export interface ApiReservationusernoteElFindParams {
  /** reservation user note id */
  _id?: any;
  /** user id */
  userID?: string;
  /** hospital id */
  hospitalID?: string;
  /** 서비스 id */
  hserviceID?: string;
}

export type ApiReservationusernoteElFindData = any;

export type ApiReservationusernoteElUpdateData = any;

export interface ApiReservationusernoteHmFindParams {
  /** reservation user note id */
  _id?: any;
  /** user id */
  userID?: string;
  /** hospital id (required) */
  hospitalID?: string;
  /** 서비스 id (required) */
  hserviceID?: string;
}

export type ApiReservationusernoteHmFindData = any;

export interface ApiHreservationElFindParams {
  /** parent reservation id */
  parentID?: any;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiHreservationElFindData = any;

export interface ApiHreservationHmFindParams {
  /** parent reservation id */
  parentID?: any;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiHreservationHmFindData = any;

export interface ApiUsertagElFindParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 삭제 여부 flag */
  isRemoved?: string;
}

export type ApiUsertagElFindData = any;

export type ApiUsertagElCreateData = any;

export type ApiUsertagElUpdateData = any;

export type ApiUsertagElRemoveData = any;

export interface ApiVideocontentElParams {
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiVideocontentElData = any;

export type ApiVideocontentElCreateData = any;

export type ApiVideocontentElUpdateData = any;

export type ApiVideocontentElRemoveData = any;

export interface ApiServicesettingElFindParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 샘플 여부. */
  isSample?: boolean;
}

export type ApiServicesettingElFindData = any;

export interface ApiServicesettingElFindOneParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 샘플 여부. */
  isSample?: boolean;
}

export type ApiServicesettingElFindOneData = any;

export type ApiServicesettingElCreateData = any;

export type ApiServicesettingElUpdateData = any;

export interface ApiServicesettingHmFindOneParams {
  /** (required) 병원ID */
  hospitalID?: string;
}

export type ApiServicesettingHmFindOneData = any;

export interface ApiIntegrationsettingElFindParams {
  /** 병원 ID, 입력 시 문자열 배열 형태로 입력 */
  hospitalID?: string;
}

export type ApiIntegrationsettingElFindData = any;

export interface ApiIntegrationsettingElFindOneParams {
  /** (required) 병원 ID */
  hospitalID?: string;
}

export type ApiIntegrationsettingElFindOneData = any;

export type ApiIntegrationsettingElCreateData = any;

export type ApiIntegrationsettingElUpdateData = any;

export interface ApiVideocontenthospitalElParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 세부동작 영상 표시 여부 boolean flag */
  isDetail?: boolean;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiVideocontenthospitalElData = any;

export type ApiVideocontenthospitalElCreateData = any;

export interface ApiVideocontenthospitalElFindParams {
  /** REQUIRED 병원 ID */
  hospitalID?: string;
  /** 검색할 단어 (운동 제목, 관련질환, 운동 구성 제목, 운동 구성 영문 제목, 검색키워드) */
  keyword?: string;
  /** 세부동작 영상 표시 여부 boolean flag */
  isDetail?: boolean;
  /** 검색할 카테고리ID */
  categoryID?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiVideocontenthospitalElFindData = any;

export interface ApiVideocontenthospitalElDetailParams {
  /** (required) 병원-커스텀 운동콘텐츠의 ObjectID */
  vchID?: string;
}

export type ApiVideocontenthospitalElDetailData = any;

export type ApiVideocontenthospitalElUpdateData = any;

export type ApiVideocontenthospitalElRecommendData = any;

export type ApiVideocontenthospitalElRemoveData = any;

export interface ApiVideocontenthospitalElPlayParams {
  /** VideoContentHospital ID */
  vchID?: string;
  usingIntro?: string;
}

export type ApiVideocontenthospitalElPlayData = any;

export interface ApiVideocontenthospitalElPlaysubParams {
  /** videoFileID */
  _id?: string;
  usingIntro?: string;
  resolution?: string;
}

export type ApiVideocontenthospitalElPlaysubData = any;

export interface ApiVideocontentuserElParams {
  /** (required) 고객의 병원서비스 ID */
  hserviceID?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiVideocontentuserElData = any;

export interface ApiVideocontentuserElFindstatsParams {
  /** (required) 고객 병원서비스 ID */
  hserviceID?: string;
}

export type ApiVideocontentuserElFindstatsData = any;

export type ApiVideocontentuserElCreateData = any;

export interface ApiVideocontentuserElDetailParams {
  /** (required) 고객 운동콘텐츠의 ObjectID */
  vcuID?: string;
}

export type ApiVideocontentuserElDetailData = any;

export type ApiVideocontentuserElUpdateData = any;

export type ApiVideocontentuserElRemoveData = any;

export interface ApiVideocontentuserMParams {
  /** (will be deprecated) 유저 아이디 */
  userID?: string;
  /** (required) 서비스 ID */
  hserviceID?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiVideocontentuserMData = any;

export interface ApiVideocontentuserMDetailParams {
  /** (required) 고객 운동콘텐츠의 ObjectID */
  vcuID?: string;
}

export type ApiVideocontentuserMDetailData = any;

export interface ApiVideocontentuserMFindParams {
  /** (will be deprecated) 유저 ID */
  userID?: string;
  /** (required) 서비스 ID */
  hserviceID?: string;
  /** 검색할 운동콘텐츠 카테고리ID */
  categoryID?: string;
  /** 검색할 단어 (제목, 치료 부위) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property. updatedAt -1 로 지정 시 최근 운동콘텐츠(시청 또는 처방 수신) 순서대로 정렬 */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiVideocontentuserMFindData = any;

export interface ApiVideocontentuserMFindCountParams {
  /** (will be deprecated) 유저 ID */
  userID?: string;
  /** (required) 서비스 ID */
  hserviceID?: string;
  /** 검색할 운동콘텐츠 카테고리ID */
  categoryID?: string;
  /** 검색할 단어 (title, subtitle) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiVideocontentuserMFindCountData = any;

export interface ApiVideocontentuserMPlayParams {
  /** VideoContentUser ID */
  vcuID?: string;
  usingIntro?: string;
}

export type ApiVideocontentuserMPlayData = any;

export interface ApiVideocontentuserMPlaysubParams {
  /** videoFileID */
  _id?: string;
  usingIntro?: string;
  resolution?: string;
}

export type ApiVideocontentuserMPlaysubData = any;

export type ApiVideocontentuserMUpdateReadData = any;

export type ApiVideocontentuserMUpdateCvData = any;

export type ApiVideocontentuserMUpdatePvData = any;

export type ApiVideocontentuserMShareimageData = any;

export interface ApiHistoryuseractionElParams {
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiHistoryuseractionElData = any;

export interface ApiHistoryuseractionElFindParams {
  /** 사용자 ID */
  userID?: string;
  /** 사용자 타입 */
  type?: number;
  /** 병원서비스 ID */
  hserviceID?: string;
  /** 고객 운동콘텐츠 ID */
  vcuID?: string;
  /** 예약 담당자 Column ID */
  columnID?: string;
  /**
   * 로그 조회를 위한 검색 시작일 (gte)
   * @default "2022-10-05T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * 로그 조회를 위한 검색 종료일 (종료일을 포함, lte)
   * @default "2022-10-06T00:00:00.000+0900"
   */
  endDate?: string;
  /**
   * (required) 수행한 동작. 아래 중 하나의 action을 문자열로 입력
   * - send / view / completeView / share / guestReservation
   * - userReservation / hworkerReservation / anurseReservation / cancelReservation / modifyReservation
   */
  action?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiHistoryuseractionElFindData = any;

export type ApiHistoryuseractionElCreateData = any;

export type ApiHistoryuseractionElUpdateData = any;

export type ApiHistoryuseractionElRemoveData = any;

export type ApiHistoryuseractionMCreateData = any;

export interface ApiVideocontentcategoryElParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 대 카테고리 검색 여부 boolean flag */
  isTop?: boolean;
  /** 중 카테고리 검색 여부 boolean flag */
  isParent?: boolean;
  /** 부모 운동콘텐츠 카테고리 ID */
  parentCategoryIDs?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiVideocontentcategoryElData = any;

export type ApiVideocontentcategoryElCreateData = any;

export type ApiVideocontentcategoryElUpdateData = any;

export type ApiVideocontentcategoryElRemoveData = any;

export interface ApiVideocontentcategoryMParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 대 카테고리 검색 여부 boolean flag */
  isTop?: boolean;
  /** 중 카테고리 검색 여부 boolean flag */
  isParent?: boolean;
  /** 부모 운동콘텐츠 카테고리 ID */
  parentCategoryIDs?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiVideocontentcategoryMData = any;

export interface ApiDashboardDailyUserElParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 시작일
   * @default "2022-10-24T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 종료일
   * @default "2022-10-30T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardDailyUserElData = any;

export interface ApiDashboardDailyUserElFindtopParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 시작일
   * @default "2022-10-24T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 종료일
   * @default "2022-10-30T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * (required) limit option, 10 입력 시 Top 10
   * @default 10
   */
  limit?: number;
  /** (required) sort property. ex) shareCount */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardDailyUserElFindtopData = any;

export interface ApiDashboardDailyColumnElParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 시트 ID */
  sheetID?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 시작일
   * @default "2022-10-10T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 종료일
   * @default "2022-10-16T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property. */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardDailyColumnElData = any;

export interface ApiDashboardDailyColumnElFindtopParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 시트 ID */
  sheetID?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 시작일
   * @default "2022-10-23T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 종료일
   * @default "2022-10-29T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * (required) limit option, 10 입력 시 Top 10
   * @default 10
   */
  limit?: number;
  /** (required) sort property. ex) userReservationCount */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardDailyColumnElFindtopData = any;

export interface ApiDashboardDailyColumnprogramElParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 시트 ID */
  sheetID?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 시작일
   * @default "2022-10-10T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 종료일
   * @default "2022-10-16T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property. */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardDailyColumnprogramElData = any;

export interface ApiDashboardDailyColumnprogramElFindtopParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 시트 ID */
  sheetID?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 시작일
   * @default "2022-10-23T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 종료일
   * @default "2022-10-29T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * (required) limit option, 10 입력 시 Top 10
   * @default 10
   */
  limit?: number;
  /** (required) sort property. ex) userReservationCount */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardDailyColumnprogramElFindtopData = any;

export interface ApiDashboardWeeklyUserElParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작일자로 간주 */
  isSunday?: boolean;
  /**
   * (required) 주간 통계 조회를 위한 검색 시작일
   * @default "2022-10-23T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 주간 통계 조회를 위한 검색 종료일
   * @default "2022-10-29T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardWeeklyUserElData = any;

export interface ApiDashboardWeeklyUserElFindtopParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작으로 간주 */
  isSunday?: boolean;
  /**
   * (required) 주간 통계 조회를 위한 검색 시작일
   * @default "2022-10-23T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 주간 통계 조회를 위한 검색 종료일
   * @default "2022-10-29T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * (required) limit option, 10 입력 시 Top 10
   * @default 10
   */
  limit?: number;
  /** (required) sort property. ex) shareCount */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardWeeklyUserElFindtopData = any;

export interface ApiDashboardWeeklyColumnElParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 시트 ID */
  sheetID?: string;
  /** (required) 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작일자로 간주 */
  isSunday?: boolean;
  /**
   * (required) 주간 통계 조회를 위한 검색 시작일
   * @default "2022-10-23T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 주간 통계 조회를 위한 검색 종료일
   * @default "2022-10-29T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardWeeklyColumnElData = any;

export interface ApiDashboardWeeklyColumnElFindtopParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 시트 ID */
  sheetID?: string;
  /** (required) 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작으로 간주 */
  isSunday?: boolean;
  /**
   * (required) 주간 통계 조회를 위한 검색 시작일
   * @default "2022-10-23T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 주간 통계 조회를 위한 검색 종료일
   * @default "2022-10-29T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * (required) limit option, 10 입력 시 Top 10
   * @default 10
   */
  limit?: number;
  /** (required) sort property. ex) userReservationCount */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardWeeklyColumnElFindtopData = any;

export interface ApiDashboardWeeklyColumnprogramElParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 시트 ID */
  sheetID?: string;
  /** (required) 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작일자로 간주 */
  isSunday?: boolean;
  /**
   * (required) 주간 통계 조회를 위한 검색 시작일
   * @default "2022-10-23T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 주간 통계 조회를 위한 검색 종료일
   * @default "2022-10-29T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardWeeklyColumnprogramElData = any;

export interface ApiDashboardWeeklyColumnprogramElFindtopParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 시트 ID */
  sheetID?: string;
  /** (required) 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작으로 간주 */
  isSunday?: boolean;
  /**
   * (required) 주간 통계 조회를 위한 검색 시작일
   * @default "2022-10-23T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 주간 통계 조회를 위한 검색 종료일
   * @default "2022-10-29T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * (required) limit option, 10 입력 시 Top 10
   * @default 10
   */
  limit?: number;
  /** (required) sort property. ex) userReservationCount */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardWeeklyColumnprogramElFindtopData = any;

export interface ApiDashboardMonthlyUserElParams {
  /** 병원 ID */
  hospitalID?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 시작일
   * @default "2022-10-01T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 종료일
   * @default "2022-10-31T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardMonthlyUserElData = any;

export interface ApiDashboardMonthlyUserElFindtopParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 시작일
   * @default "2022-10-01T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 종료일
   * @default "2022-10-31T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * (required) limit option, 10 입력 시 Top 10
   * @default 10
   */
  limit?: number;
  /** (required) sort property. ex) shareCount */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardMonthlyUserElFindtopData = any;

export interface ApiDashboardMonthlyColumnElParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (optional) 시트 ID */
  sheetID?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 시작일
   * @default "2022-10-01T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 종료일
   * @default "2022-10-31T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property. */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardMonthlyColumnElData = any;

export interface ApiDashboardMonthlyColumnElFindtopParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 시트 ID */
  sheetID?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 시작일
   * @default "2022-10-01T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 종료일
   * @default "2022-10-31T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * (required) limit option, 10 입력 시 Top 10
   * @default 10
   */
  limit?: number;
  /** (required) sort property. ex) userReservationCount */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardMonthlyColumnElFindtopData = any;

export interface ApiDashboardMonthlyColumnprogramElParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (optional) 시트 ID */
  sheetID?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 시작일
   * @default "2022-10-01T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 종료일
   * @default "2022-10-31T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property. */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardMonthlyColumnprogramElData = any;

export interface ApiDashboardMonthlyColumnprogramElFindtopParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 시트 ID */
  sheetID?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 시작일
   * @default "2022-10-01T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 종료일
   * @default "2022-10-31T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * (required) limit option, 10 입력 시 Top 10
   * @default 10
   */
  limit?: number;
  /** (required) sort property. ex) userReservationCount */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardMonthlyColumnprogramElFindtopData = any;

export interface ApiDashboardHserviceElCountJoinuserParams {
  /** 병원 ID */
  hospitalID?: string;
  /**
   * 조회를 위한 검색 시작일
   * @default "2022-10-17T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * 조회를 위한 검색 종료일
   * @default "2022-10-31T00:00:00.000+0900"
   */
  endDate?: string;
}

export type ApiDashboardHserviceElCountJoinuserData = any;

export interface ApiDashboardDailyColumnprogramElSheetParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 시트 ID 배열 */
  "sheetID[]"?: string[];
  /**
   * (required) 일일 통계 조회를 위한 검색 시작일
   * @default "2022-10-10T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 종료일
   * @default "2022-10-16T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property. */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardDailyColumnprogramElSheetData = any;

export interface ApiDashboardWeeklyColumnprogramElSheetParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 시트 ID 배열 */
  "sheetID[]"?: string[];
  /** (required) 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작일자로 간주 */
  isSunday?: boolean;
  /**
   * (required) 주간 통계 조회를 위한 검색 시작일
   * @default "2022-10-23T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 주간 통계 조회를 위한 검색 종료일
   * @default "2022-10-29T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property. */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardWeeklyColumnprogramElSheetData = any;

export interface ApiDashboardMonthlyColumnprogramElSheetParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 시트 ID 배열 */
  "sheetID[]"?: string[];
  /**
   * (required) 월간 통계 조회를 위한 검색 시작일
   * @default "2022-10-01T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 종료일
   * @default "2022-10-31T00:00:00.000+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property. */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiDashboardMonthlyColumnprogramElSheetData = any;

export interface ApiTreatmentcategoryElParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 삭제 플래그 */
  isRemoved?: boolean;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiTreatmentcategoryElData = any;

export type ApiTreatmentcategoryElCreateData = any;

export type ApiTreatmentcategoryElUpdateData = any;

export type ApiTreatmentcategoryElRemoveData = any;

export interface ApiTreatmentCautionElParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 삭제 플래그 */
  isRemoved?: boolean;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiTreatmentCautionElData = any;

export type ApiTreatmentcautionElCreateData = any;

export type ApiTreatmentcautionElUpdateData = any;

export type ApiTreatmentcautionElRemoveData = any;

export interface ApiEventHospitalEventElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색어 (이벤트 제목) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiEventHospitalEventElFindData = any;

export interface ApiEventHospitalEventElFindSortParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색어 (이벤트 제목) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiEventHospitalEventElFindSortData = any;

export interface ApiEventHospitalEventElCountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색어 (이벤트 제목) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiEventHospitalEventElCountData = any;

export type ApiEventHospitalEventElCreateData = any;

export type ApiEventHospitalEventElUpdateData = any;

export type ApiEventHospitalEventElRemoveData = any;

export interface ApiEventHospitalEventMFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (not in use) 검색어 (이벤트명) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiEventHospitalEventMFindData = any;

export interface ApiEventHospitalEventMFindOneParams {
  /** (required) 병원 이벤트 _id */
  _id?: string;
}

export type ApiEventHospitalEventMFindOneData = any;

export interface ApiEventHospitalEventMFindDetailParams {
  /** (required) 병원 이벤트 ID */
  _id?: string;
}

export type ApiEventHospitalEventMFindDetailData = any;

export interface ApiEventHospitalAftercareElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색어 (상품명) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiEventHospitalAftercareElFindData = any;

export interface ApiEventHospitalAftercareElFindSortParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색어 (상품명) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiEventHospitalAftercareElFindSortData = any;

export interface ApiEventHospitalAftercareElCountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색어 (상품명) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiEventHospitalAftercareElCountData = any;

export type ApiEventHospitalAftercareElCreateData = any;

export type ApiEventHospitalAftercareElUpdateData = any;

export type ApiEventHospitalAftercareElRemoveData = any;

export interface ApiEventHospitalAftercareMFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (not in use) 검색어 (상품명) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiEventHospitalAftercareMFindData = any;

export interface ApiEventHospitalAftercareMFindDetailParams {
  /** (required) 병원 홈케어 상품 ID */
  _id?: string;
}

export type ApiEventHospitalAftercareMFindDetailData = any;

export type ApiHserviceElSuspendData = any;

export type ApiHserviceElUpdateData = any;

export interface ApiHserviceElFindSimpleParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색할 유저의 이름 혹은 전화번호 */
  keyword?: string;
  /** 테스트 계정 여부. 테스트 계정 미표기 시 {$ne\:true} 붙여서 조회 */
  isTest?: string;
  /** 예약만 등록 계정 여부. 예약만 등록 계정 미표기 시 {$ne\:true} 붙여서 조회 */
  isUnregisterdUser?: string;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiHserviceElFindSimpleData = any;

export interface ApiHserviceElFindDetailParams {
  /** 서비스 ID */
  _id?: string;
}

export type ApiHserviceElFindDetailData = any;

export interface ApiHserviceElFindTreatmentcategoryCountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** TreatmentCategory ID */
  treatmentCategoryID?: string;
  /** 카테고리 설정 여부 */
  isEmpty?: boolean;
  /**
   * 검색범위 시작일
   * @default "2022-10-01T00:00:00.000+0900"
   */
  startedAt?: string;
  /**
   * 검색범위 종료일
   * @default "2022-10-31T00:00:00.000+0900"
   */
  endedAt?: string;
}

export type ApiHserviceElFindTreatmentcategoryCountData = any;

export interface ApiHserviceElFindTreatmentcategoryParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** TreatmentCategory ID */
  treatmentCategoryID?: string;
  /**
   * 검색범위 시작일
   * @default "2022-10-01T00:00:00.000+0900"
   */
  startedAt?: string;
  /**
   * 검색범위 종료일
   * @default "2022-10-31T00:00:00.000+0900"
   */
  endedAt?: string;
  /** 종료여부 */
  isClosed?: boolean;
  /** 스킵 */
  skip?: number;
  /** 리밋 */
  limit?: number;
  /** 정렬 key */
  key?: string;
  /** 정렬 방향 */
  way?: number;
}

export type ApiHserviceElFindTreatmentcategoryData = any;

export interface ApiHserviceElFindUnjoinedParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 필터의 시작일시 */
  startedAt?: string;
  /** 필터의 종료일시 */
  endedAt?: string;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiHserviceElFindUnjoinedData = any;

export interface ApiHserviceElFindUnjoinedCountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 필터의 시작일시 */
  startedAt?: string;
  /** 필터의 종료일시 */
  endedAt?: string;
}

export type ApiHserviceElFindUnjoinedCountData = any;

export interface ApiHserviceElFindNeedsettingParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiHserviceElFindNeedsettingData = any;

export interface ApiHserviceElFindPatientsettingCountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
}

export type ApiHserviceElFindPatientsettingCountData = any;

export interface ApiHserviceElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색할 유저의 이름 */
  name?: string;
  /** 검색할 유저의 전화번호 */
  phone?: string;
  /** 국가 코드 ID */
  countryCode?: string;
  /** 검색할 유저의 생년월일 */
  birth?: string;
  /** 가입 여부 */
  isJoin?: boolean;
  /** 치료유형 ID 배열 */
  treatmentCategoryIDs?: string[];
  /** 태그 문자열 배열 */
  tag?: string;
  /** 담당의 ID */
  doctorID?: string;
  /** 테스트 계정 여부. 테스트 계정 미표기 시 {$ne\:true} 붙여서 조회 */
  isTest?: string;
  /** 등록일의 범위검색을 위한 시작 일시 */
  startedAt?: string;
  /** 등록일의 범위검색을 위한 종료 일시 */
  endedAt?: string;
  /** 연동사 종류 타입. 대소문자 구분 없음 */
  integrationType?: string;
  /** CRM 연동 여부 플래그 */
  isIntegrated?: string;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiHserviceElFindData = any;

export interface ApiHserviceElFindSpecificParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색할 유저의 전화번호 */
  phone?: string;
  /** 국가 코드 ID */
  countryCode?: string;
  /** 테스트 계정 여부. 테스트 계정 미표기 시 {$ne\:true} 붙여서 조회 */
  isTest?: string;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiHserviceElFindSpecificData = any;

export interface ApiHserviceElFindCountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색할 유저의 이름 */
  name?: string;
  /** 검색할 유저의 전화번호 */
  phone?: string;
  /** 검색할 유저의 생년월일 */
  birth?: string;
  /** 가입 여부 */
  isJoin?: boolean;
  /** 치료유형 ID 배열 */
  treatmentCategoryIDs?: string[];
  /** 태그 문자열 배열 */
  tag?: string;
  /** 담당의 ID */
  doctorID?: string;
  /** 테스트 계정 여부. 테스트 계정 미표기 시 {$ne\:true} 붙여서 조회 */
  isTest?: string;
  /** 등록일의 범위검색을 위한 시작 일시 */
  startedAt?: string;
  /** 등록일의 범위검색을 위한 종료 일시 */
  endedAt?: string;
  /** 연동사 종류 타입. 대소문자 구분 없음 */
  integrationType?: string;
  /** CRM 연동 여부 플래그 */
  isIntegrated?: string;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiHserviceElFindCountData = any;

export interface ApiHserviceElFindChatParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색할 유저의 이름 혹은 전화번호 */
  keyword?: string;
}

export type ApiHserviceElFindChatData = any;

export interface ApiHserviceElFindChatCountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색할 유저의 이름 혹은 전화번호 */
  keyword?: string;
}

export type ApiHserviceElFindChatCountData = any;

export type ApiHserviceElUpdateSettingData = any;

export type ApiHserviceElUpdateNeedvcuData = any;

export type ApiHserviceMSuspendData = any;

export type ApiHserviceMUpdateSelectData = any;

export interface ApiHserviceHmFindSimpleParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색할 유저의 이름 혹은 전화번호 */
  keyword?: string;
  /** 테스트 계정 여부. 테스트 계정 미표기 시 {$ne\:true} 붙여서 조회 */
  isTest?: string;
}

export type ApiHserviceHmFindSimpleData = any;

export type ApiMemoElCreateData = any;

export interface ApiMemoElFindParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemoElFindData = any;

export interface ApiMemoElFindManageParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemoElFindManageData = any;

export interface ApiMemoElFindNurseParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemoElFindNurseData = any;

export interface ApiMemoElFindPatientParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemoElFindPatientData = any;

export interface ApiMemoElFindLastParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemoElFindLastData = any;

export interface ApiMemoElFindManageCountParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemoElFindManageCountData = any;

export interface ApiMemoElFindNurseCountParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemoElFindNurseCountData = any;

export interface ApiMemoElFindPatientCountParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemoElFindPatientCountData = any;

export interface ApiMemoElFindManageLastParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemoElFindManageLastData = any;

export interface ApiMemoElFindNurseLastParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemoElFindNurseLastData = any;

export interface ApiMemoElFindPatientLastParams {
  /** 서비스 ID */
  hserviceID?: any;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiMemoElFindPatientLastData = any;

export type ApiMemoElUpdateData = any;

export type ApiMemoElRemoveData = any;

export type ApiMemoElUpdatePinData = any;

export type ApiMemoElReadData = any;

export interface ApiPurchaserecordElFindParams {
  /** (required) 병원서비스 ID */
  hserviceID?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiPurchaserecordElFindData = any;

export interface ApiPurchaserecordElCountParams {
  /** (required) 병원서비스 ID */
  hserviceID?: string;
}

export type ApiPurchaserecordElCountData = any;

export type ApiPurchaserecordElCreateData = any;

export type ApiPurchaserecordElUpdateData = any;

export type ApiPurchaserecordElRemoveData = any;

export interface ApiHospitalAccountElFindParams {
  /** 병원 ID */
  hospitalID?: any;
  /** 유저 ID */
  userID?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiHospitalAccountElFindData = any;

export type ApiHospitalAccountElCreateData = any;

export type ApiHospitalAccountElUpdateData = any;

export type ApiHospitalAccountElIdcheckData = any;

export type ApiHospitalAccountElRemoveData = any;

export interface ApiHospitalAuthorizationtypeElFindParams {
  /** 병원 ID */
  hospitalID?: any;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiHospitalAuthorizationtypeElFindData = any;

export type ApiHospitalAuthorizationtypeElUpdateData = any;

export type ApiHealthcontentsCategoryElCreateData = any;

export interface ApiHealthcontentsCategoryElFindParams {
  /** 카테고리 ID */
  _id?: any;
  /** 삭제 여부 플래그. default - false */
  isRemoved?: string;
}

export type ApiHealthcontentsCategoryElFindData = any;

export type ApiHealthcontentsCategoryElUpdateData = any;

export type ApiHealthcontentsCategoryElRemoveData = any;

export interface ApiHealthcontentsCategoryMFindParams {
  /** 카테고리 ID */
  _id?: any;
  /** 삭제 여부 플래그. default - false */
  isRemoved?: string;
}

export type ApiHealthcontentsCategoryMFindData = any;

export type ApiHealthcontentsContentElCreateData = any;

export interface ApiHealthcontentsContentElFindParams {
  /** 건강콘텐츠 ID */
  _id?: any;
  /** 건강콘텐츠 카테고리 ID */
  categoryID?: any;
  /** 삭제 여부 플래그. default - false */
  isRemoved?: string;
}

export type ApiHealthcontentsContentElFindData = any;

export type ApiHealthcontentsContentElUpdateData = any;

export type ApiHealthcontentsContentElRemoveData = any;

export interface ApiHealthcontentsContentMFindParams {
  /** 건강콘텐츠 ID */
  _id?: any;
  /** 건강콘텐츠 카테고리 ID */
  categoryID?: any;
  /** 삭제 여부 플래그. default - false */
  isRemoved?: string;
  /** 검색하고자 하는 콘텐츠의 제목 */
  title?: string;
  /** 스킵할 카운트 */
  skip?: number;
  /** 한번에 조회할 카운트 */
  limit?: number;
}

export type ApiHealthcontentsContentMFindData = any;

export interface ApiHealthcontentsContentMCountParams {
  /** 건강콘텐츠 ID */
  _id?: any;
  /** 건강콘텐츠 카테고리 ID */
  categoryID?: any;
  /** 삭제 여부 플래그. default - false */
  isRemoved?: string;
  /** 검색하고자 하는 콘텐츠의 제목 */
  title?: string;
}

export type ApiHealthcontentsContentMCountData = any;

export type ApiHealthcontentsBookmarkMCreateData = any;

export interface ApiHealthcontentsBookmarkMFindParams {
  /** 건강콘텐츠 ID */
  _id?: any;
  /** (will be deprecated) 유저 ID */
  userID?: any;
  /** (required) 서비스 ID */
  hserviceID?: any;
  /** 건강콘텐츠 카테고리 ID */
  categoryID?: any;
  /** 스킵할 카운트 */
  skip?: number;
  /** 한번에 조회할 카운트 */
  limit?: number;
}

export type ApiHealthcontentsBookmarkMFindData = any;

export type ApiHospitalcontentsContentElCreateData = any;

export interface ApiHospitalcontentsContentElFindParams {
  /** (required) 병원 ID */
  hospitalID?: any;
  /** 병원 소식 ID */
  _id?: any;
  /** 병원 소식 카테고리 ID */
  categoryID?: any;
  /** 삭제 여부 플래그. default - false */
  isRemoved?: string;
}

export type ApiHospitalcontentsContentElFindData = any;

export type ApiHospitalcontentsContentElRemoveData = any;

export type ApiHospitalcontentsContentElUpdateData = any;

export interface ApiHospitalcontentsContentMCountParams {
  /** (required) 병원 ID */
  hospitalID?: any;
  /** 병원 소식 ID */
  _id?: any;
  /** 병원 소식 카테고리 ID */
  categoryID?: any;
  /** 삭제 여부 플래그. default - false */
  isRemoved?: string;
  /** 검색하고자 하는 병원 소식의 제목 */
  title?: string;
}

export type ApiHospitalcontentsContentMCountData = any;

export interface ApiHospitalcontentsContentMFindParams {
  /** (required) 병원 ID */
  hospitalID?: any;
  /** 병원 소식 ID */
  _id?: any;
  /** 병원 소식 카테고리 ID */
  categoryID?: any;
  /** 삭제 여부 플래그. default - false */
  isRemoved?: string;
  /** 검색하고자 하는 병원 소식의 제목 */
  title?: string;
  /** 스킵할 카운트 */
  skip?: number;
  /** 한번에 조회할 카운트 */
  limit?: number;
}

export type ApiHospitalcontentsContentMFindData = any;

export type ApiHospitalcontentsCategoryElCreateData = any;

export interface ApiHospitalcontentsCategoryElFindParams {
  /** (required) 병원 ID */
  hospitalID?: any;
  /** 카테고리 ID */
  _id?: any;
  /** 삭제 여부 플래그. default - false */
  isRemoved?: string;
}

export type ApiHospitalcontentsCategoryElFindData = any;

export interface ApiHospitalcontentsCategoryElFindOneParams {
  /** (required) 병원 ID */
  hospitalID?: any;
}

export type ApiHospitalcontentsCategoryElFindOneData = any;

export type ApiHospitalcontentsCategoryElRemoveData = any;

export type ApiHospitalcontentsCategoryElUpdateData = any;

export interface ApiHospitalcontentsCategoryMFindParams {
  /** (required) 병원 ID */
  hospitalID?: any;
  /** 병원 소식 카테고리 ID */
  _id?: any;
  /** 삭제 여부 플래그. default - false */
  isRemoved?: string;
}

export type ApiHospitalcontentsCategoryMFindData = any;

export type ApiHospitalcontentsBookmarkMCreateData = any;

export interface ApiHospitalcontentsBookmarkMFindParams {
  /** 병원 소식 ID */
  _id?: any;
  /** (required) 서비스 ID */
  hserviceID?: any;
  /** 병원 소식 카테고리 ID */
  categoryID?: any;
  /** 스킵할 카운트 */
  skip?: number;
  /** 한번에 조회할 카운트 */
  limit?: number;
}

export type ApiHospitalcontentsBookmarkMFindData = any;

export type ApiShortlinkVideocontentMCreateData = any;

export type ApiShortlinkVideocontentMUpdateGrData = any;

export type ApiShortlinkEventMCreateData = any;

export type ApiShortlinkAftercareMCreateData = any;

export interface ApiShortlinkHserviceMFindOneParams {
  /** (required) 병원 서비스 ID */
  hserviceID?: string;
}

export type ApiShortlinkHserviceMFindOneData = any;

export interface SharedVideocontentParams {
  /** shared link path */
  path?: string;
}

export type SharedVideocontentData = any;

export interface SharedEventParams {
  /** shared link path */
  path?: string;
}

export type SharedEventData = any;

export interface SharedAftercareParams {
  /** shared link path */
  path?: string;
}

export type SharedAftercareData = any;

export interface ApiPushsettingElFindOneParams {
  /** 대상 유저 ID */
  userID?: any;
}

export type ApiPushsettingElFindOneData = any;

export type ApiPushsettingElUpdateData = any;

export interface ApiPushsettingMFindOneParams {
  /** 대상 유저 ID */
  userID?: any;
}

export type ApiPushsettingMFindOneData = any;

export type ApiPushsettingMUpdateData = any;

export interface ApiNoticeHospitalElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색어 (제목) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiNoticeHospitalElFindData = any;

export interface ApiNoticeHospitalElFindSimpleParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색어 (제목) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiNoticeHospitalElFindSimpleData = any;

export interface ApiNoticeHospitalElCountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색어 (공지사항 제목) */
  keyword?: string;
}

export type ApiNoticeHospitalElCountData = any;

export type ApiNoticeHospitalElCreateData = any;

export type ApiNoticeHospitalElUpdateData = any;

export type ApiNoticeHospitalElRemoveData = any;

export interface ApiNoticeHospitalMFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiNoticeHospitalMFindData = any;

export interface ApiNoticeHospitalMFindOneParams {
  /** (required) 병원 공지사항 ID */
  _id?: string;
}

export type ApiNoticeHospitalMFindOneData = any;

export interface ApiNoticeHospitalMFindDetailParams {
  /** (required) 병원 공지사항 ID */
  _id?: string;
  /** 팝업에서 진입 여부. 팝업에서 자세히 보기 또는 이미지를 눌러 접근 시 true 로 전송. */
  isPopup?: string;
  /** 팝업에서 진입했을 경우, 진입한 PopupID. isPopup을 true로 전송 시 필수 값 */
  hospitalNoticePopupID?: string;
}

export type ApiNoticeHospitalMFindDetailData = any;

export interface ApiPopupHospitalElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색어 (팝업 이름) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiPopupHospitalElFindData = any;

export interface ApiPopupHospitalElCountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색어 (공지사항 팝업 이름) */
  keyword?: string;
}

export type ApiPopupHospitalElCountData = any;

export type ApiPopupHospitalElCreateData = any;

export type ApiPopupHospitalElUpdateData = any;

export type ApiPopupHospitalElRemoveData = any;

export interface ApiPopupHospitalMFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 병원서비스 ID */
  hserviceID?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiPopupHospitalMFindData = any;

export type ApiPopupHospitalMIncViewData = any;

export interface ApiNotificationsoundElCountParams {
  isRemoved?: boolean;
}

export type ApiNotificationsoundElCountData = any;

export interface ApiNotificationsoundElParams {
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiNotificationsoundElData = any;

export type ApiNotificationsoundElCreateData = any;

export type ApiNotificationsoundElUpdateData = any;

export interface ApiV2ReservationElCountParams {
  /** 병원 ID */
  hospitalID?: string;
  /** 예약 그룹(부서) ID */
  groupID?: string;
  /** 예약 담당자(컬럼) ID */
  columnID?: string;
  /** (optional) 예약 상태 ID 배열. 비어있을 경우 전체 조회 */
  "statusID[]"?: string[];
  /** 삭제 여부 */
  isRemoved?: boolean;
  /**
   * 예약현황 조회를 위한 조회 범위 시작 일시
   * @default "2024-02-01T00:00:00+09:00"
   */
  startedAt?: Date;
  /**
   * 예약현황 조회를 위한 조회 범위 종료 일시
   * @default "2024-02-29T23:59:59+09:00"
   */
  endedAt?: Date;
  /** 테스트 계정 여부 플래그. */
  isTest?: string;
}

export type ApiV2ReservationElCountData = any;

export interface ApiV2ReservationElFindParams {
  /** 병원 ID */
  hospitalID?: string;
  /** 예약 그룹(부서) ID */
  groupID?: string;
  /** 예약 담당자(컬럼) ID */
  columnID?: string;
  /** (optional) 예약 상태 ID 배열. 비어있을 경우 전체 조회 */
  "statusID[]"?: string[];
  /** 삭제 여부 */
  isRemoved?: boolean;
  /**
   * 예약현황 조회를 위한 조회 범위 시작 일시
   * @default "2024-02-01T00:00:00+09:00"
   */
  startedAt?: Date;
  /**
   * 예약현황 조회를 위한 조회 범위 종료 일시
   * @default "2024-02-29T23:59:59+09:00"
   */
  endedAt?: Date;
  /** 테스트 계정 여부 플래그. */
  isTest?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiV2ReservationElFindData = any;

export interface ApiV2ReservationElFindHistoryParams {
  /** 병원 ID */
  hospitalID?: string;
  /** 예약 그룹(부서) ID */
  groupID?: string;
  /** 예약 담당자(컬럼) ID */
  columnID?: string;
  /** (optional) 예약 상태 ID 배열. 비어있을 경우 전체 조회 */
  "statusID[]"?: string[];
  /** 삭제 여부 */
  isRemoved?: boolean;
  /**
   * 예약현황 조회를 위한 조회 범위 시작 일시
   * @default "2024-02-01T00:00:00+09:00"
   */
  startedAt?: Date;
  /**
   * 예약현황 조회를 위한 조회 범위 종료 일시
   * @default "2024-02-29T23:59:59+09:00"
   */
  endedAt?: Date;
  /** 테스트 계정 여부 플래그. */
  isTest?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
}

export type ApiV2ReservationElFindHistoryData = any;

export interface ApiV2ReservationElFindNextParams {
  /** 병원 아이디 (required) */
  hospitalID?: string;
  /** 유저 아이디 (required) */
  userID?: string;
}

export type ApiV2ReservationElFindNextData = any;

export type ApiV2ReservationElCreateData = any;

export type ApiV2ReservationElCreateRegistData = any;

export type ApiV2ReservationElCreateUnregisteredData = any;

export type ApiV2ReservationElUpdateData = any;

export type ApiV2ReservationElRemoveData = any;

export type ApiV2ReservationElSendPushData = any;

export interface ApiV2ReservationMFindParams {
  /** (required) 유저 ID */
  userID?: string;
  /** (required) 병원 서비스 ID */
  hserviceID?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /**
   * 예약 조회를 위한 조회 범위 시작 일시
   * @default "2024-02-01T00:00:00+09:00"
   */
  startedAt?: Date;
  /**
   * 예약 조회를 위한 조회 범위 종료 일시
   * @default "2024-02-29T23:59:59+09:00"
   */
  endedAt?: Date;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiV2ReservationMFindData = any;

export interface ApiV2ReservationMFindOneParams {
  /** (required) 예약 ID */
  _id?: string;
}

export type ApiV2ReservationMFindOneData = any;

export interface ApiV2ReservationMFindDateParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 담당자 ID */
  columnID?: string;
  /**
   * 예약 조회를 위한 날짜
   * @default "2024-02-01T00:00:00+09:00"
   */
  date?: string;
}

export type ApiV2ReservationMFindDateData = any;

export interface ApiV2ReservationMFindLastParams {
  /** (required) 유저 ID */
  userID?: string;
  /** (required) 서비스 ID */
  hserviceID?: string;
  /** (optional) 프로그램 ID */
  programID?: string;
}

export type ApiV2ReservationMFindLastData = any;

export interface ApiV2ReservationMFindNextParams {
  /** (required) 유저 아이디 */
  userID?: string;
  /** (required) 서비스 아이디 */
  hserviceID?: string;
}

export type ApiV2ReservationMFindNextData = any;

export interface ApiV2ReservationMPossibledateParams {
  /** (required) 예약 담당자 ID */
  columnID?: string;
}

export type ApiV2ReservationMPossibledateData = any;

export interface ApiV2ReservationMPossibletimeParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 담당자 ID */
  columnID?: string;
  /** (required) 프로그램 ID */
  programID?: string;
  /**
   * 예약 조회를 위한 날짜
   * @default "2024-05-24"
   */
  date?: string;
}

export type ApiV2ReservationMPossibletimeData = any;

export type ApiV2ReservationMCreateData = any;

export type ApiV2ReservationMUpdateData = any;

export type ApiV2ReservationMCancelData = any;

export interface ApiV2ReservationcellElFindParams {
  /** required. 병원 ID */
  hospitalID?: boolean;
  /** (optional) 예약 컬럼(담당자) ID 배열. */
  "columnID[]"?: string[];
  /** required. 조회 날짜 */
  date?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2ReservationcellElFindData = any;

export type ApiV2ReservationcellElCreateData = any;

export type ApiV2ReservationcellElUpdateData = any;

export type ApiV2ReservationcellElRemoveData = any;

export interface ApiV2ReservationblockElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (optional) 예약 컬럼(담당자) ID 배열. */
  "columnID[]"?: string[];
  /** (required) YYYY-MM-DD 형태의 조회 날짜 */
  date?: string;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2ReservationblockElFindData = any;

export type ApiV2ReservationblockElCreateData = any;

export type ApiV2ReservationblockElUpdateData = any;

export type ApiV2ReservationblockElRemoveData = any;

export interface ApiV2ReservationblockMFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 예약 컬럼(담당자) ID. */
  columnID?: string;
  /** (required) YYYY-MM-DD 형태의 조회 날짜 */
  date?: string;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2ReservationblockMFindData = any;

export interface ApiV2ReservationsettingElFindOneParams {
  /** required. 병원 ID */
  hospitalID?: string;
}

export type ApiV2ReservationsettingElFindOneData = any;

export type ApiV2ReservationsettingElUpdateData = any;

export interface ApiV2ReservationsettingMFindOneParams {
  /** (required) 병원 ID */
  hospitalID?: string;
}

export type ApiV2ReservationsettingMFindOneData = any;

export interface ApiV2ReservationstatusElFindParams {
  /** required. 병원 ID */
  hospitalID?: boolean;
  /** 생성 일자. json parse 처리됨. */
  createdAt?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 삭제 일자. json parse 처리됨. 입력될 경우, removedAt이 없는 케이스도 포함되도록 쿼리 수정 */
  removedAt?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2ReservationstatusElFindData = any;

export type ApiV2ReservationstatusElCreateData = any;

export type ApiV2ReservationstatusElUpdateData = any;

export type ApiV2ReservationstatusElRemoveData = any;

export type ApiV2ReservationstatusElSendPushData = any;

export interface ApiV2ReservationgroupElFindParams {
  /** required. 병원 ID */
  hospitalID?: boolean;
  /** 생성 일자. json parse 처리됨. */
  createdAt?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 삭제 일자. json parse 처리됨. 입력될 경우, removedAt이 없는 케이스도 포함되도록 쿼리 수정 */
  removedAt?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2ReservationgroupElFindData = any;

export interface ApiV2ReservationgroupElFindOneParams {
  /** required. group ID */
  _id?: boolean;
}

export type ApiV2ReservationgroupElFindOneData = any;

export interface ApiV2ReservationgroupElFindRemovedParams {
  /** required. 병원 ID */
  hospitalID?: boolean;
  /** (optional) 예약 그룹(부서) ID 배열. 값이 모두 비어있을 경우 빈 배열 return. */
  "groupID[]"?: string[];
}

export type ApiV2ReservationgroupElFindRemovedData = any;

export type ApiV2ReservationgroupElCreateData = any;

export type ApiV2ReservationgroupElUpdateData = any;

export type ApiV2ReservationgroupElRemoveData = any;

export type ApiV2ReservationgroupElUpdateSortData = any;

export interface ApiV2ReservationcolumnElFindParams {
  /** required. 병원 ID */
  hospitalID?: boolean;
  /** (optional) 예약 그룹(부서) ID 배열. 비어있을 경우 전체 조회 */
  "groupID[]"?: string[];
  /** 생성 일자. json parse 처리됨. */
  createdAt?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 삭제 일자. json parse 처리됨. 입력될 경우, removedAt이 없는 케이스도 포함되도록 쿼리 수정 */
  removedAt?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2ReservationcolumnElFindData = any;

export interface ApiV2ReservationcolumnElFindRemovedParams {
  /** required. 병원 ID */
  hospitalID?: boolean;
  /** (optional) 예약 컬럼(담당자) ID 배열. 값이 모두 비어있을 경우 빈 배열 return. */
  "columnID[]"?: string[];
}

export type ApiV2ReservationcolumnElFindRemovedData = any;

export type ApiV2ReservationcolumnElCreateData = any;

export type ApiV2ReservationcolumnElUpdateData = any;

export type ApiV2ReservationcolumnElRemoveData = any;

export type ApiV2ReservationcolumnElUpdateSortData = any;

export interface ApiV2ReservationcolumnMDateParams {
  /** (required) 병원 ID */
  hospitalID?: boolean;
  /** (required) 앱 예약 가능한 프로그램 ID */
  programID?: boolean;
  /**
   * (현재 미사용) 예약 가능한 일자 내 칼럼 조회를 위한 시작일
   * @default "2024-05-20T00:00:00.000+0900"
   */
  startedAt?: string;
  /**
   * (현재 미사용) 예약 가능한 일자 내 칼럼 조회를 위한 종료일
   * @default "2024-06-02T00:00:00.000+0900"
   */
  endedAt?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2ReservationcolumnMDateData = any;

export interface ApiV2ReservationcolumnMActiveParams {
  /** (required) 병원 ID */
  hospitalID?: boolean;
}

export type ApiV2ReservationcolumnMActiveData = any;

export interface ApiV2ReservationprogramElFindParams {
  /** required. 병원 ID */
  hospitalID?: boolean;
  /** 생성 일자. json parse 처리됨. */
  createdAt?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 삭제 일자. json parse 처리됨. 입력될 경우, removedAt이 없는 케이스도 포함되도록 쿼리 수정 */
  removedAt?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2ReservationprogramElFindData = any;

export type ApiV2ReservationprogramElCreateData = any;

export type ApiV2ReservationprogramElUpdateData = any;

export type ApiV2ReservationprogramElRemoveData = any;

export type ApiV2ReservationprogramElSendPushData = any;

export interface ApiV2ReservationprogramMFindParams {
  /** (required) 병원 ID */
  hospitalID?: boolean;
  /** 정렬하고자 하는 field, key 및 way 미입력 시 default값은 "createdAt" */
  key?: string;
  /** 정렬하고자 하는 방향. key 및 way 미입력 시 default값은 1 */
  way?: number;
}

export type ApiV2ReservationprogramMFindData = any;

export interface ApiV2ReservationusernoteElFindParams {
  /** required. 병원 ID */
  hospitalID?: string;
  /** required. 병원서비스 ID */
  hserviceID?: string;
  /** required. 유저 ID */
  userID?: string;
}

export type ApiV2ReservationusernoteElFindData = any;

export type ApiV2ReservationusernoteElUpdateData = any;

export interface ApiV2ReservationusernoteElFindDateParams {
  /** 병원 ID */
  hospitalID: string;
  /** 시작 날짜시간 */
  startedAt: string;
  /** 종료 날짜시간 */
  endedAt: string;
  /** (optional) 예약 그룹 ID 배열. 비어있을 경우 전체 조회 */
  "groupID[]"?: string[];
  /** (optional) 예약 담당자 ID 배열. 비어있을 경우 전체 조회 */
  "columnID[]"?: string[];
  /** (optional) 예약 상태 ID 배열. 비어있을 경우 전체 조회 */
  "statusID[]"?: string[];
}

export type ApiV2ReservationusernoteElFindDateData = any;

export interface ApiV2ReservationdatenoteElFindParams {
  /** required. 병원 ID */
  hospitalID?: string;
  /** 조회 하고자 하는 일자 */
  date?: string;
}

export type ApiV2ReservationdatenoteElFindData = any;

export interface ApiV2ReservationdatenoteElFindDateParams {
  /** required. 병원 ID */
  hospitalID?: string;
  /** required. 조회 하고자 하는 시작일자 */
  startDate?: string;
  /** required. 조회 하고자 하는 종료일자 */
  endDate?: string;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2ReservationdatenoteElFindDateData = any;

export type ApiV2ReservationdatenoteElUpdateData = any;

export interface ApiV2HreservationElFindParams {
  /** 기준이 되는 예약 _id */
  reservationID?: any;
  /** 병원 ID */
  hospitalID?: any;
  /** 조회할 요소. userName / groupTitle / columnTitle / writerName(modifierName) */
  filterkey?: any;
  /** 수정자 검색 시 검색할 유저 그룹군. 고객 1000, 직원 2000, 애프터닥 3000 */
  "userTypes[]"?: string[];
  /** filterkey 에 대한 검색어 */
  keyword?: any;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2HreservationElFindData = any;

export interface ApiV2HreservationElCountParams {
  /** 기준이 되는 예약 _id */
  reservationID?: any;
  /** 병원 ID */
  hospitalID?: any;
  /** 조회할 요소. userName / groupTitle / columnTitle / writerName(modifierName) */
  filterkey?: any;
  /** 수정자 검색 시 검색할 유저 그룹군. 고객 1000, 직원 2000, 애프터닥 3000 */
  "userTypes[]"?: string[];
  /** filterkey 에 대한 검색어 */
  keyword?: any;
}

export type ApiV2HreservationElCountData = any;

export interface ApiV2DepartmentElFindParams {
  /** required. 병원 ID */
  hospitalID?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 삭제 일자. json parse 처리됨. 입력될 경우, removedAt이 없는 케이스도 포함되도록 쿼리 수정 */
  removedAt?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2DepartmentElFindData = ApiResponse & {
  data: V2DepartmentModifier[];
};

export interface ApiV2DepartmentElFindOneParams {
  /** required. department ID */
  _id?: boolean;
}

export type ApiV2DepartmentElFindOneData = ApiResponse & {
  data: V2DepartmentModifier;
};

export type ApiV2DepartmentElCreateData = any;

export type ApiV2DepartmentElUpdateData = any;

export type ApiV2DepartmentElUpdateSortData = any;

export type ApiV2DepartmentElRemoveData = any;

export interface ApiV2EmployeeElFindParams {
  /** required. 병원 ID */
  hospitalID?: boolean;
  /** (optional) 부서 ID 배열. 비어있을 경우 전체 조회 */
  "departmentID[]"?: string[];
  /** 검색어 (직원명) */
  keyword?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 삭제 일자. json parse 처리됨. 입력될 경우, removedAt이 없는 케이스도 포함되도록 쿼리 수정 */
  removedAt?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2EmployeeElFindData = any;

export type ApiV2EmployeeElCreateData = any;

export type ApiV2EmployeeElUpdateData = any;

export type ApiV2EmployeeElUpdateSortData = any;

export type ApiV2EmployeeElRemoveData = any;

export interface ApiV2WorkcodeElFindParams {
  /** required. 병원 ID */
  hospitalID?: string;
  /** 생성 일자. json parse 처리됨. */
  createdAt?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 삭제 일자. json parse 처리됨. 입력될 경우, removedAt이 없는 케이스도 포함되도록 쿼리 수정 */
  removedAt?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2WorkcodeElFindData = any;

export interface ApiV2WorkcodeElFindScheduleParams {
  /** required. 병원 ID */
  hospitalID?: string;
  /** required. 조회 하고자 하는 시작일자 */
  startDate?: string;
  /** required. 조회 하고자 하는 종료일자 */
  endDate?: string;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2WorkcodeElFindScheduleData = any;

export type ApiV2WorkcodeElCreateData = any;

export type ApiV2WorkcodeElUpdateData = any;

export type ApiV2WorkcodeElRemoveData = any;

export type ApiV2WorkcodeElSendPushData = any;

export interface ApiV2WorkrecordElFindDateParams {
  /** required. 병원 ID */
  hospitalID?: string;
  /** required. 조회 하고자 하는 시작일자 */
  startDate?: string;
  /** required. 조회 하고자 하는 종료일자 */
  endDate?: string;
  /** (optional) 근무 코드 ID 배열. 비어있을 경우 전체 조회 */
  "workCodeID[]"?: string[];
  /** (optional) 직원 ID 배열. 비어있을 경우 전체 조회 */
  "employeeID[]"?: string[];
  /** 삭제 여부. json parse */
  isRemoved?: string;
  /** 직접 설정 여부. json parse */
  isCustomized?: string;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2WorkrecordElFindDateData = any;

export interface ApiV2WorkrecordElFindScheduleParams {
  /** required. 병원 ID */
  hospitalID?: string;
  /** required. 조회 하고자 하는 시작일자 */
  startDate?: string;
  /** required. 조회 하고자 하는 종료일자 */
  endDate?: string;
  /** 삭제 여부. json parse */
  isRemoved?: string;
  /** 직접 설정 여부. json parse */
  isCustomized?: string;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2WorkrecordElFindScheduleData = any;

export type ApiV2WorkrecordElUpdateData = any;

export type ApiV2WorkrecordElUpdateBatchData = any;

export type ApiV2WorkrecordElRemoveData = any;

export type ApiV2WorkrecordElSendPushData = any;

export interface ApiV2WorkholidayElFindDateParams {
  /** required. 병원 ID */
  hospitalID?: string;
  /** required. 조회 하고자 하는 시작일자 */
  startDate?: string;
  /** required. 조회 하고자 하는 종료일자 */
  endDate?: string;
  /** 삭제 여부 */
  isRemoved?: string;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2WorkholidayElFindDateData = any;

export type ApiV2WorkholidayElCreateData = any;

export type ApiV2WorkholidayElUpdateData = any;

export type ApiV2WorkholidayElRemoveData = any;

export interface ApiV2WorkholidayMFindDateParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 조회 하고자 하는 시작일자 */
  startDate?: string;
  /** (required) 조회 하고자 하는 종료일자 */
  endDate?: string;
  /** 삭제 여부 */
  isRemoved?: string;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiV2WorkholidayMFindDateData = any;

export interface ApiStatsV2ReservationDailyElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 예약 컬럼(담당자) ID 배열 */
  "columnID[]"?: string[];
  /** 예약 상태 ID 배열 */
  "statusID[]"?: string[];
  /** 예약 프로그램 ID 배열 */
  "programID[]"?: string[];
  /**
   * (required) 일일 통계 조회를 위한 검색 시작일
   * @default "2024-05-01T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 종료일
   * @default "2024-05-01T23:59:59.999+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property. */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiStatsV2ReservationDailyElFindData = any;

export interface ApiStatsV2ReservationDailyElFindHospitalParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 시작일
   * @default "2024-05-01T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 일일 통계 조회를 위한 검색 종료일
   * @default "2024-05-01T23:59:59.999+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiStatsV2ReservationDailyElFindHospitalData = any;

export interface ApiStatsV2ReservationMonthlyElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 예약 컬럼(담당자) ID 배열 */
  "columnID[]"?: string[];
  /** 예약 상태 ID 배열 */
  "statusID[]"?: string[];
  /** 예약 프로그램 ID 배열 */
  "programID[]"?: string[];
  /**
   * (required) 월별 통계 조회를 위한 검색 시작일
   * @default "2024-05-01T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 월별 통계 조회를 위한 검색 종료일
   * @default "2024-05-31T23:59:59.999+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property. */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiStatsV2ReservationMonthlyElFindData = any;

export interface ApiStatsV2ReservationMonthlyElFindHospitalParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /**
   * (required) 월별 통계 조회를 위한 검색 시작일
   * @default "2024-05-01T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 월별 통계 조회를 위한 검색 종료일
   * @default "2024-05-31T23:59:59.999+0900"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiStatsV2ReservationMonthlyElFindHospitalData = any;

export interface ApiStatsV2WorkrecordDailyElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /**
   * (required) 통계 조회를 위한 검색 시작일
   * @default "2024-04-01T00:00:00.000+0900"
   */
  startDate?: string;
  /**
   * (required) 통계 조회를 위한 검색 종료일
   * @default "2024-04-30T23:59:59.999+0900"
   */
  endDate?: string;
}

export type ApiStatsV2WorkrecordDailyElFindData = any;

export interface ApiSiAlHserviceElFindSimpleParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색할 유저의 전능 스마트닥터 고객번호 */
  customerNumber?: string;
  /** 검색할 유저의 이름 혹은 전화번호 */
  keyword?: string;
  /** 테스트 계정 여부. 테스트 계정 미표기 시 {$ne\:true} 붙여서 조회 */
  isTest?: string;
}

export type ApiSiAlHserviceElFindSimpleData = any;

export type PublicServersettingMFindData = any;

export type PublicServersettingHmFindData = any;

export interface ApiPushRequestElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /**
   * (required) 푸시 콘텐츠 타입
   * @default "HospitalEvent"
   */
  type?: string;
  /** (optional) 특정 병원 이벤트로 조회 시 입력 */
  hospitalEventID?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiPushRequestElFindData = any;

export type ApiPushRequestElCreateData = any;

export interface ApiPushResponseElFindParams {
  /** (required) 병원 서비스 ID */
  hserviceID?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiPushResponseElFindData = any;

export type ApiUseractionHospitaleventMCreateData = any;

export type AdminHealthcontentPushElCreateData = any;

export interface AdminHealthcontentPushElFindParams {
  /** 건강 콘텐츠 푸시 히스토리 ID */
  _id?: any;
  /** 삭제 여부 플래그. default - false */
  isRemoved?: string;
}

export type AdminHealthcontentPushElFindData = any;

export type AdminHealthcontentPushElRemoveData = any;

export type AdminHealthcontentContentElCreateData = any;

export interface AdminHealthcontentContentElFindParams {
  /** 건강콘텐츠 ID */
  _id?: any;
  /** 건강콘텐츠 카테고리 ID */
  categoryID?: any;
  /** 삭제 여부 플래그. default - false */
  isRemoved?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type AdminHealthcontentContentElFindData = any;

export type AdminHealthcontentContentElRemoveData = any;

export type AdminHealthcontentContentElUpdateData = any;

export interface AdminHealthcontentCategoryElFindParams {
  /** 카테고리 ID */
  _id?: any;
  /**
   * 삭제 여부 플래그. default - false
   * @default false
   */
  isRemoved?: string;
}

export type AdminHealthcontentCategoryElFindData = any;

export type AdminHomecareVideocontentHlsvideoElCreateData = any;

export interface AdminHomecareVideocontentHlsvideoElFindParams {
  /** 검색할 단어 (파일 제목) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type AdminHomecareVideocontentHlsvideoElFindData = any;

export type AdminHomecareVideocontentHlsvideoElUpdateData = any;

export type AdminHomecareVideocontentHlsvideoElCountData = any;

export type AdminHomecareVideocontentVideocontentglobalsettingElCreateData = any;

export interface AdminHomecareVideocontentVideocontentglobalsettingElFindParams {
  /** 아무것도 입력하지 않고 전송. 기본값 도큐먼트 단 하나. */
  _id?: string;
}

export type AdminHomecareVideocontentVideocontentglobalsettingElFindData = any;

export type AdminHomecareVideocontentVideocontentglobalsettingElUpdateData = any;

export type AdminHomecareVideocontentVideocontentElCreateData = any;

export interface AdminHomecareVideocontentVideocontentElFindParams {
  /** 검색할 단어 (title, subtitle) */
  keyword?: string;
  /** 검색할 대 카테고리 (videoContentCategoryID) */
  videoContentCategoryID?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type AdminHomecareVideocontentVideocontentElFindData = any;

export type AdminHomecareVideocontentVideocontentElUpdateData = any;

export type AdminHomecareVideocontentVideocontentElRemoveData = any;

export interface AdminHomecareVideocontentVideocontentElCountParams {
  /** 메인/서브 타이틀 검색에 사용할 검색 키워드. */
  keyword?: string;
  /** 운동콘텐츠 카테고리 ObjectId. 비워둘 경우 전체 조회. hidden 포함 */
  videoContentCategoryID?: string;
}

export type AdminHomecareVideocontentVideocontentElCountData = any;

export interface AdminHomecareVideocontentVideocontenthospitalElFindParams {
  /** 검색할 단어 (title, subtitle) */
  keyword?: string;
  /** 검색할 대 카테고리 (videoContentCategoryID) */
  videoContentCategoryID?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type AdminHomecareVideocontentVideocontenthospitalElFindData = any;

export type AdminHomecareVideocontentVideocontenthospitalElCreateData = any;

export type AdminHomecareVideocontentVideocontenthospitalElUpdateData = any;

export type AdminHomecareVideocontentVideocontenthospitalElCopyAllData = any;

export interface AdminHomecareVideocontentVideocontenthospitalElCopyGlobalcategoryParams {
  /** 운동콘텐츠 카테고리 대 ID */
  topCategoryID?: string;
}

export type AdminHomecareVideocontentVideocontenthospitalElCopyGlobalcategoryData = any;

export interface AdminHomecareVideocontentVideocontenthospitalElCopyHospitalcategoryParams {
  /** 병원 ID */
  hospitalID?: string;
  /** 운동콘텐츠 카테고리 대 ID */
  topCategoryID?: string;
}

export type AdminHomecareVideocontentVideocontenthospitalElCopyHospitalcategoryData = any;

export interface AdminHomecareVideocontentVideocontenthospitalElCopyHospitalParams {
  /** 병원 ID */
  hospitalID: string;
}

export type AdminHomecareVideocontentVideocontenthospitalElCopyHospitalData = any;

export type AdminHomecareVideocontentVideocontentcategoryElCreateData = any;

export interface AdminHomecareVideocontentVideocontentcategoryElFindParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 대 카테고리 검색 여부 boolean flag */
  isTop?: boolean;
  /** 중 카테고리 검색 여부 boolean flag */
  isParent?: boolean;
  /** 부모 운동콘텐츠 카테고리 ID */
  parentCategoryIDs?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type AdminHomecareVideocontentVideocontentcategoryElFindData = any;

export interface AdminHomecareVideocontentVideocontentcategoryElFindOneParams {
  /** (required) 운동콘텐츠 카테고리 ObjectId */
  _id?: string;
}

export type AdminHomecareVideocontentVideocontentcategoryElFindOneData = any;

export interface AdminHomecareVideocontentVideocontentcategoryElFindTopParams {
  /** (optional) 병원ID */
  hospitalID?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type AdminHomecareVideocontentVideocontentcategoryElFindTopData = any;

export interface AdminHomecareVideocontentVideocontentcategoryElFindLastParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 대 카테고리 검색 여부 boolean flag */
  isTop?: boolean;
  /** 중 카테고리 검색 여부 boolean flag */
  isParent?: boolean;
  /** 부모 운동콘텐츠 카테고리 ID */
  parentCategoryIDs?: string;
}

export type AdminHomecareVideocontentVideocontentcategoryElFindLastData = any;

export interface AdminHomecareVideocontentVideocontentcategoryElFindConditioningParams {
  /** 컨디셔닝 카테고리 여부 */
  isConditioning?: boolean;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type AdminHomecareVideocontentVideocontentcategoryElFindConditioningData = any;

export type AdminHomecareVideocontentVideocontentcategoryElUpdateData = any;

export type AdminHomecareVideocontentVideocontentcategoryElUpdateHiddenData = any;

export type AdminHomecareVideocontentVideocontentcategoryElUpdateTypenameData = any;

export interface AdminHospitalElFindParams {
  /** 병원 ID */
  _id?: string;
  /** 검색할 단어 (name, shortName) */
  keyword?: string;
}

export type AdminHospitalElFindData = any;

export interface AdminHospitalElFindNurseParams {
  /** 아무것도 입력하지 않고 전송. */
  _id?: string;
}

export type AdminHospitalElFindNurseData = any;

export type AdminHospitalElCreateData = any;

export interface AdminHospitalElCountParams {
  /** 병원명 / 짧은 병원명 검색에 사용할 검색 키워드. */
  keyword?: string;
}

export type AdminHospitalElCountData = any;

export type AdminHospitalElUpdateData = any;

export interface AdminHospitalElFindDoctorParams {
  /** 병원 ObjectId */
  hospitalID?: string;
}

export type AdminHospitalElFindDoctorData = any;

export interface AdminHospitalElCountDoctorParams {
  /** 병원 ObjectId */
  hospitalID?: string;
}

export type AdminHospitalElCountDoctorData = any;

export type AdminHospitalElCreateDoctorData = any;

export type AdminHospitalElUpdateDoctorData = any;

export interface AdminHserviceElFindIsclosedParams {
  /** 조회할 병원 ID */
  hospitalID?: string;
}

export type AdminHserviceElFindIsclosedData = any;

export type AdminHserviceElUpdateSuspendAllData = any;

export type AdminNurseElFindData = any;

export type AdminNurseElCreateData = any;

export type AdminNurseElUpdateData = any;

export type AdminNurseElCountData = any;

export interface AdminServicesettingElFindParams {
  /**
   * 서비스 설정 예시 값 제외
   * @default false
   */
  isSample?: boolean;
  /** 카테고리 대 ID */
  topCategory?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type AdminServicesettingElFindData = any;

export interface AdminServicesettingElFindOneParams {
  /** (required) 병원ID */
  hospitalID?: string;
}

export type AdminServicesettingElFindOneData = any;

export interface AdminServicesettingElFindUsingvcParams {
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type AdminServicesettingElFindUsingvcData = any;

export type AdminServicesettingElCreateData = any;

export type AdminServicesettingElCreateSampleData = any;

export type AdminServicesettingElCountData = any;

export type AdminServicesettingElUpdateData = any;

export type AdminServicesettingElUpdateSampleData = any;

export interface AdminAuthorizationtypeElFindParams {
  /** 병원 ID */
  hospitalID?: any;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type AdminAuthorizationtypeElFindData = any;

export type AdminSettingVersionElFindData = any;

export type AdminSettingVersionElUpdateData = any;

export interface AdminIntegrationsettingElFindOneParams {
  /** (required) 병원ID */
  hospitalID?: string;
}

export type AdminIntegrationsettingElFindOneData = any;

export type AdminIntegrationsettingElCreateData = any;

export type AdminIntegrationsettingElUpdateData = any;

export interface AdminAnsweringchatElFindParams {
  /** (optional) 병원 ID */
  hospitalID?: string;
  /**
   * - (optional) 발송 상태.
   * - 발송 대기 중 pending
   * - 발송 중 processing
   * - 발송완료 done
   * - 발송취소 canceled
   */
  status?: string;
}

export type AdminAnsweringchatElFindData = any;

export interface AdminAnsweringchatElCountParams {
  /** (optional) 병원 ID */
  hospitalID?: string;
  /**
   * - (optional) 발송 상태.
   * - 발송 대기 중 pending
   * - 발송 중 processing
   * - 발송완료 done
   * - 발송취소 canceled
   */
  status?: string;
}

export type AdminAnsweringchatElCountData = any;

export interface AdminAnsweringchatsettingElFindParams {
  /** (optional) 병원 ID */
  hospitalID?: string;
}

export type AdminAnsweringchatsettingElFindData = any;

export type AdminAnsweringchatsettingElCreateData = any;

export type AdminAnsweringchatsettingElUpdateData = any;

export type AdminMonitoringHospitalElFindData = any;

export interface AdminEventHospitalEventElFindParams {
  /** 이벤트 ID */
  _id?: string;
  /** (optional) 병원 아이디 배열 */
  "hospitalID[]"?: string[];
  /** 검색할 단어 (title) */
  keyword?: string;
}

export type AdminEventHospitalEventElFindData = any;

export interface AdminEventHospitalEventElFindOneParams {
  /** (required) 이벤트 ID */
  hospitalEventID?: string;
}

export type AdminEventHospitalEventElFindOneData = any;

export interface ApiReservedsmsElCountParams {
  /** 병원ID */
  hospitalID?: string;
  /** 유저ID */
  userID?: string;
  /** 서비스 ID */
  hserviceID?: string;
  /** 병원 이름 검색을 위한 문자열 */
  keyword?: string;
}

export type ApiReservedsmsElCountData = any;

export interface ApiReservedsmsElFindParams {
  /** 병원ID 배열 */
  hospitalID?: string;
  /** 유저ID */
  userID?: string;
  /** 서비스 ID */
  hserviceID?: string;
  /** 병원 이름 검색을 위한 문자열 */
  keyword?: string;
}

export type ApiReservedsmsElFindData = any;

export interface AdminCaCareservedchatElCountParams {
  /** 병원ID */
  hospitalID?: string;
  /** 유저ID */
  userID?: string;
  /** 서비스 ID */
  hserviceID?: string;
  /** 병원 이름 검색을 위한 문자열 */
  keyword?: string;
}

export type AdminCaCareservedchatElCountData = any;

export interface AdminCaCareservedchatElFindParams {
  /** 병원ID 배열 */
  hospitalID?: string;
  /** 유저ID */
  userID?: string;
  /** 서비스 ID */
  hserviceID?: string;
  /** 병원 이름 검색을 위한 문자열 */
  keyword?: string;
}

export type AdminCaCareservedchatElFindData = any;

export type AdminCaCareservedchatElCreateData = any;

export type AdminCaCareservedchatElCreatemanyData = any;

export interface AdminStatsEventHospitalEventElFindParams {
  /** 병원명 검색 키워드 */
  hospitalName?: string;
  /** 이벤트명 검색 키워드 */
  title?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option (hospitalName, title, ...) */
  key?: string;
  /** way option */
  way?: number;
}

export type AdminStatsEventHospitalEventElFindData = any;

export interface AdminStatsEventHospitalEventElCountParams {
  /** 병원명 검색 키워드 */
  hospitalName?: string;
  /** 이벤트명 검색 키워드 */
  title?: string;
}

export type AdminStatsEventHospitalEventElCountData = any;

export interface AdminStatsEventHospitalEventpushElFindParams {
  /** 병원명 검색 키워드 */
  hospitalName?: string;
  /** 이벤트명 검색 키워드 (body.body 검색) */
  eventName?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option (hospitalName, title, ...) */
  key?: string;
  /** way option */
  way?: number;
}

export type AdminStatsEventHospitalEventpushElFindData = any;

export interface AdminStatsEventHospitalEventpushElCountParams {
  /** 병원명 검색 키워드 */
  hospitalName?: string;
  /** 이벤트명 검색 키워드 (body.body 검색) */
  eventName?: string;
}

export type AdminStatsEventHospitalEventpushElCountData = any;

export type PublicEmailSendData = any;

export interface ApiPublicEmailSendLogsListParams {
  /** 건너뛸 로그 수 */
  skip?: number;
  /** 조회할 로그 수. 기본값 100, 최대 500 */
  limit?: number;
  /** 조회 기준 일수. 기본값 7, 최대 31 */
  lookbackDays?: number;
}

export type ApiPublicEmailSendLogsListData = any;

export interface ApiPublicEmailSendLogsDetailParams {
  /** PublicEmailSendLog ID */
  _id: string;
}

export type ApiPublicEmailSendLogsDetailData = any;

export type PublicRegistKakaoConsultData = any;

export type PublicRegistKakaoFriendData = any;

export type GetServerSettingHandlerData = GetServerSettingHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v2 = {
    /**
     * No description
     *
     * @tags Auth-Join
     * @name AuthJoinMQr
     * @summary 모바일 유저 QR 회원가입
     * @request POST:/v2/auth/join/m/qr
     * @secure
     * @response `200` `AuthJoinMQrData` \{User\} 로그인 된 유저 정보. 비밀번호는 미포함
     */
    authJoinMQr: (
      data: {
        /** 생성하고자 하는 유저의 이름 */
        name?: string;
        /** 생성하고자 하는 유저의 생년월일 */
        birth?: string;
        /** 생성하고자 하는 유저의 전화번호 */
        phone?: string;
        /** 비밀번호 전문 */
        password?: string;
        /** 의사 아이디 */
        doctorID?: string;
        /** 가입하고자 하는 병원 ID */
        hospitalID?: string;
        /** 생성된 사용자의 Device Info {deviceName,appVersion,OS,version} */
        deviceInfo?: string;
        /** 유저의 Type. 1000고정 */
        type?: string;
        /** fcm에서 발급된 리보트 노티피케이션 토큰 */
        fcmToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthJoinMQrData, any>({
        path: `/v2/auth/join/m/qr`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-Login
     * @name AuthLoginEl
     * @summary 일렉트론 유저 아이디/패스워드 로그인
     * @request POST:/v2/auth/login/el
     * @secure
     * @response `200` `AuthLoginElData` \{User\} 로그인 된 유저 정보. 비밀번호는 미포함
     */
    authLoginEl: (
      data: {
        /** 로그인 하고자 하는 유저의 아이디 */
        id?: string;
        /** 비밀번호 전문 */
        password?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthLoginElData, any>({
        path: `/v2/auth/login/el`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-Login
     * @name AuthLoginMCheckphone
     * @summary 모바일 유저 전화번호를 이용한 가입여부 확인
     * @request GET:/v2/auth/login/m/checkphone
     * @secure
     * @response `200` `AuthLoginMCheckphoneData` \{HService\} 로그인 하려는 유저 정보. 비밀번호는 미포함
     */
    authLoginMCheckphone: (query: AuthLoginMCheckphoneParams, params: RequestParams = {}) =>
      this.request<AuthLoginMCheckphoneData, any>({
        path: `/v2/auth/login/m/checkphone`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-Logout
     * @name AuthLogoutM
     * @summary 모바일 유저 로그아웃
     * @request POST:/v2/auth/logout/m
     * @secure
     * @response `200` `AuthLogoutMData` \{User\} 로그인 된 유저 정보. 비밀번호는 미포함
     */
    authLogoutM: (
      data: {
        /** 해당 디바이스에서 사용중이던 fcmToken */
        fcmToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthLogoutMData, any>({
        path: `/v2/auth/logout/m`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-Login
     * @name AuthLoginHm
     * @summary 유저 아이디/패스워드 로그인 (애프터닥 관리자 앱)
     * @request POST:/v2/auth/login/hm
     * @secure
     * @response `200` `AuthLoginHmData` \{User\} 로그인 된 유저 정보. 비밀번호는 미포함
     */
    authLoginHm: (
      data: {
        /** 로그인 하고자 하는 유저의 아이디 */
        id?: string;
        /** 비밀번호 전문 */
        password?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthLoginHmData, any>({
        path: `/v2/auth/login/hm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-Logout
     * @name AuthLogoutHm
     * @summary 유저 로그아웃 (애프터닥 관리자 앱)
     * @request POST:/v2/auth/logout/hm
     * @secure
     * @response `200` `AuthLogoutHmData` \{User\} 로그아웃 된 유저 정보. 비밀번호는 미포함
     */
    authLogoutHm: (
      data: {
        /** 해당 디바이스에서 사용중이던 fcmToken */
        fcmToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthLogoutHmData, any>({
        path: `/v2/auth/logout/hm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-Phone
     * @name AuthPhoneMRequest
     * @summary 전화번호 인증 코드 요청
     * @request POST:/v2/auth/phone/m/request
     * @secure
     * @response `200` `AuthPhoneMRequestData` \{PhoneVerify\} 전화번호 인증을 위한 Verify 객체
     */
    authPhoneMRequest: (
      data: {
        /** 인증을 위한 전화번호 */
        phone?: string;
        /** 비밀번호 찾기인 경우 true */
        isFind?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthPhoneMRequestData, any>({
        path: `/v2/auth/phone/m/request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-Phone
     * @name AuthPhoneMRequestChangephone
     * @summary 전화번호 인증 코드 요청 (전화번호 변경 - 미 로그인)
     * @request POST:/v2/auth/phone/m/request/changephone
     * @secure
     * @response `200` `AuthPhoneMRequestChangephoneData` \{PhoneVerify\} 전화번호 인증을 위한 Verify 객체
     */
    authPhoneMRequestChangephone: (
      data: {
        /** 기존 전화번호 */
        oldPhone?: string;
        /** 인증을 위한 전화번호 */
        phone?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthPhoneMRequestChangephoneData, any>({
        path: `/v2/auth/phone/m/request/changephone`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-Phone
     * @name AuthPhoneMRequestUnidentify
     * @summary 전화번호 인증 코드 요청(전화번호 로그인 시, 증명되지 않은 인증을 위함)
     * @request POST:/v2/auth/phone/m/request/unidentify
     * @secure
     * @response `200` `AuthPhoneMRequestUnidentifyData` \{PhoneVerify\} 전화번호 인증을 위한 Verify 객체
     */
    authPhoneMRequestUnidentify: (
      data: {
        /** 인증을 위한 전화번호 */
        phone?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthPhoneMRequestUnidentifyData, any>({
        path: `/v2/auth/phone/m/request/unidentify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-Phone
     * @name AuthPhoneMVerify
     * @summary 전화번호 인증
     * @request POST:/v2/auth/phone/m/verify
     * @secure
     * @response `200` `AuthPhoneMVerifyData` \{PhoneVerify\} 전화번호 인증을 위한 Verify 객체
     */
    authPhoneMVerify: (
      data: {
        /** 인증을 위한 전화번호 ID */
        phoneID?: string;
        /** 인증번호 */
        code?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthPhoneMVerifyData, any>({
        path: `/v2/auth/phone/m/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-Phone
     * @name AuthPhoneMChange
     * @summary 미 로그인 시 전화번호 변경
     * @request POST:/v2/auth/phone/m/change
     * @secure
     * @response `200` `AuthPhoneMChangeData` \{User\} 변경된 유저 객체
     */
    authPhoneMChange: (
      data: {
        /** 인증을 진행한 전화번호 ID */
        phoneID?: string;
        /** 변경하기 위한 전화번호 */
        phone?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthPhoneMChangeData, any>({
        path: `/v2/auth/phone/m/change`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-Phone
     * @name AuthPhoneMwRequest
     * @summary 전화번호 인증 코드 요청 (구글 계정 삭제용 모바일 페이지)
     * @request POST:/v2/auth/phone/mw/request
     * @secure
     * @response `200` `AuthPhoneMwRequestData` \{PhoneVerify\} 전화번호 인증을 위한 Verify 객체
     */
    authPhoneMwRequest: (
      data: {
        /** 인증을 위한 전화번호 */
        phone?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthPhoneMwRequestData, any>({
        path: `/v2/auth/phone/mw/request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-Phone
     * @name AuthPhoneMwVerify
     * @summary 전화번호 인증 (구글 계정 삭제용 모바일 페이지)
     * @request POST:/v2/auth/phone/mw/verify
     * @secure
     * @response `200` `AuthPhoneMwVerifyData` \[\{PhoneVerify\}\] 전화번호 인증을 위한 Verify 객체 배열
     */
    authPhoneMwVerify: (
      data: {
        /** 인증을 위한 전화번호 ID */
        phoneID?: string;
        /** 인증번호 */
        code?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthPhoneMwVerifyData, any>({
        path: `/v2/auth/phone/mw/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-Password
     * @name AuthPasswordMHaspassword
     * @summary 비밀번호 유무 조회
     * @request GET:/v2/auth/password/m/haspassword
     * @secure
     * @response `200` `AuthPasswordMHaspasswordData` true 혹은 false (모델 리턴 X)
     */
    authPasswordMHaspassword: (query: AuthPasswordMHaspasswordParams, params: RequestParams = {}) =>
      this.request<AuthPasswordMHaspasswordData, any>({
        path: `/v2/auth/password/m/haspassword`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-ShortLink
     * @name AuthShortlinkMUserinfo
     * @summary ShortLink path 를 이용한 유저 정보 조회
     * @request GET:/v2/auth/shortlink/m/userinfo
     * @secure
     * @response `200` `AuthShortlinkMUserinfoData` \{User\} 유저 모델 객체
     */
    authShortlinkMUserinfo: (query: AuthShortlinkMUserinfoParams, params: RequestParams = {}) =>
      this.request<AuthShortlinkMUserinfoData, any>({
        path: `/v2/auth/shortlink/m/userinfo`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-ShortLink
     * @name AuthShortlinkMHserviceinfo
     * @summary ShortLink path 를 이용한 HService 정보 조회
     * @request GET:/v2/auth/shortlink/m/hserviceinfo
     * @secure
     * @response `200` `AuthShortlinkMHserviceinfoData` \{HService\} 유저 모델 객체
     */
    authShortlinkMHserviceinfo: (query: AuthShortlinkMHserviceinfoParams, params: RequestParams = {}) =>
      this.request<AuthShortlinkMHserviceinfoData, any>({
        path: `/v2/auth/shortlink/m/hserviceinfo`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth-User
     * @name AuthUserMwSuspend
     * @summary 유저에 의한 유저 전체 서비스 중단
     * @request POST:/v2/auth/user/mw/suspend
     * @secure
     * @response `200` `AuthUserMwSuspendData` \{User\} 수정된 유저 정보.
     */
    authUserMwSuspend: (
      data: {
        /** 중단하고자 하는 유저의 유저 아이디 */
        userID?: string;
        /** 인증번호 인증 완료 후 발급된 phoneVerify ID */
        phoneVerifyID?: string;
        /** 중단 사유 */
        closeReason?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthUserMwSuspendData, any>({
        path: `/v2/auth/user/mw/suspend`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Regist
     * @name ApiRegistPatientElCreate
     * @summary 병원 앱에서의 유저 가입문자 발송
     * @request POST:/v2/api/regist/patient/el/create
     * @secure
     * @response `200` `ApiRegistPatientElCreateData` \{User\} 로그인 된 유저 정보. 비밀번호는 미포함
     */
    apiRegistPatientElCreate: (
      data: {
        /** 생성하고자 하는 유저의 이름 */
        name?: string;
        /** 생성하고자 하는 유저의 전화번호 */
        phone?: string;
        /** 생성하고자 하는 유저의 국가코드 */
        countryCode?: string;
        /** 가입하고자 하는 병원 ID */
        hospitalID?: string;
        /** 유저의 Type. 1000고정 */
        type?: string;
        /**
         * 유저의 Type. 1000고정
         * @default "Some Message {{Link}}"
         */
        message?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiRegistPatientElCreateData, any>({
        path: `/v2/api/regist/patient/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Regist
     * @name ApiRegistPatientElSendsms
     * @summary 병원 앱에서의 유저 가입문자 발송
     * @request POST:/v2/api/regist/patient/el/sendsms
     * @secure
     * @response `200` `ApiRegistPatientElSendsmsData` \{User\} 로그인 된 유저 정보. 비밀번호는 미포함
     */
    apiRegistPatientElSendsms: (
      data: {
        /** SMS를 발송하고자 하는 유저의 아이디 */
        userID?: string;
        /**
         * 유저의 Type. 1000고정
         * @default "Some Message {{Link}}"
         */
        message?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiRegistPatientElSendsmsData, any>({
        path: `/v2/api/regist/patient/el/sendsms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ApiUserElFind
     * @summary 병원 유저 정보 조회
     * @request GET:/v2/api/user/el/find
     * @secure
     * @response `200` `ApiUserElFindData` \[\{User\}\] User 객체 배열 조회
     */
    apiUserElFind: (query: ApiUserElFindParams, params: RequestParams = {}) =>
      this.request<ApiUserElFindData, any>({
        path: `/v2/api/user/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ApiUserElFindOne
     * @summary 병원 유저 정보 조회
     * @request GET:/v2/api/user/el/find/one
     * @secure
     * @response `200` `ApiUserElFindOneData` \{User\} 객체 조회
     */
    apiUserElFindOne: (query: ApiUserElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiUserElFindOneData, any>({
        path: `/v2/api/user/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ApiUserElUpdate
     * @summary 병원 유저 정보 수정
     * @request POST:/v2/api/user/el/update
     * @secure
     * @response `200` `ApiUserElUpdateData` \{User\} 모델 객체
     */
    apiUserElUpdate: (
      data: {
        /** 수정하고자 하는 유저의 오브젝트 아이디 */
        userID?: string;
        /** 언어 (ko, en) */
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiUserElUpdateData, any>({
        path: `/v2/api/user/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ApiUserElCanchangephone
     * @summary 유저 전화번호 변경 가능여부 확인
     * @request GET:/v2/api/user/el/canchangephone
     * @secure
     * @response `200` `ApiUserElCanchangephoneData` 변경 가능여부 true / false
     */
    apiUserElCanchangephone: (query: ApiUserElCanchangephoneParams, params: RequestParams = {}) =>
      this.request<ApiUserElCanchangephoneData, any>({
        path: `/v2/api/user/el/canchangephone`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ApiUserElUpdateDashboard
     * @summary 유저 대시보드 접근권한 수정
     * @request POST:/v2/api/user/el/update/dashboard
     * @secure
     * @response `200` `ApiUserElUpdateDashboardData` \{User\} 모델 객체
     */
    apiUserElUpdateDashboard: (
      data: {
        /** 수정하고자 하는 유저의 오브젝트 아이디 */
        userID?: string;
        /** 대시보드 접근 여부 */
        canReadDashboard?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiUserElUpdateDashboardData, any>({
        path: `/v2/api/user/el/update/dashboard`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ApiUserMFindOne
     * @summary 모바일 유저 정보 조회
     * @request GET:/v2/api/user/m/find/one
     * @secure
     * @response `200` `ApiUserMFindOneData` \{User\} 객체 조회
     */
    apiUserMFindOne: (query: ApiUserMFindOneParams, params: RequestParams = {}) =>
      this.request<ApiUserMFindOneData, any>({
        path: `/v2/api/user/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ApiUserMUpdate
     * @summary 유저 정보 수정
     * @request POST:/v2/api/user/m/update
     * @secure
     * @response `200` `ApiUserMUpdateData` \{User\} 모델 객체
     */
    apiUserMUpdate: (
      data: {
        /** 수정하고자 하는 유저의 오브젝트 아이디 */
        userID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiUserMUpdateData, any>({
        path: `/v2/api/user/m/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ApiUserMUpdateDeviceinfo
     * @summary 유저 디바이스 정보 수정
     * @request POST:/v2/api/user/m/update/deviceinfo
     * @secure
     * @response `200` `ApiUserMUpdateDeviceinfoData` \{User\} 모델 객체
     */
    apiUserMUpdateDeviceinfo: (
      data: {
        /** 사용중인 fcm token */
        fcmToken?: string;
        /** 디바이스 정보 */
        deviceInfo?: {
          /** OS 이름 */
          OS?: string;
          /** 디바이스 이름 */
          deviceName?: string;
          /** OS 버전 */
          version?: string;
          /** App 버전 */
          appVersion?: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiUserMUpdateDeviceinfoData, any>({
        path: `/v2/api/user/m/update/deviceinfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ApiUserMPhoneCode
     * @summary 로그인 된 유저의 전화번호 인증번호 요청
     * @request POST:/v2/api/user/m/phone/code
     * @secure
     * @response `200` `ApiUserMPhoneCodeData` \{VerifyPhone\} 모델 객체
     */
    apiUserMPhoneCode: (
      data: {
        /** 수정하고자 하는 유저의 오브젝트 아이디 */
        phone?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiUserMPhoneCodeData, any>({
        path: `/v2/api/user/m/phone/code`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ApiUserMPhoneVerify
     * @summary 로그인 된 유저의 전화번호 인증번호 요청
     * @request POST:/v2/api/user/m/phone/verify
     * @secure
     * @response `200` `ApiUserMPhoneVerifyData` \{VerifyPhone\} 모델 객체
     */
    apiUserMPhoneVerify: (
      data: {
        /** 코드 요청으로부터 전달받은 전화번호 아이디 */
        phoneID?: string;
        /** 문자로 수신받은 코드 */
        code?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiUserMPhoneVerifyData, any>({
        path: `/v2/api/user/m/phone/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ApiUserMChangepassword
     * @summary 로그인 된 유저의 비밀번호 변경
     * @request POST:/v2/api/user/m/changepassword
     * @secure
     * @response `200` `ApiUserMChangepasswordData` \{User\} 모델 객체
     */
    apiUserMChangepassword: (
      data: {
        /** 새로운 비밀번호 */
        password?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiUserMChangepasswordData, any>({
        path: `/v2/api/user/m/changepassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ApiUserHmUpdateDeviceinfo
     * @summary 디바이스 정보 수정 (애프터닥 관리자 앱)
     * @request POST:/v2/api/user/hm/update/deviceinfo
     * @secure
     * @response `200` `ApiUserHmUpdateDeviceinfoData` \{User\} 모델 객체
     */
    apiUserHmUpdateDeviceinfo: (
      data: {
        /** 사용중인 fcm token */
        fcmToken?: string;
        /** 디바이스 정보 */
        deviceInfo?: {
          /** OS 이름 */
          OS?: string;
          /** 디바이스 이름 */
          deviceName?: string;
          /** OS 버전 */
          version?: string;
          /** App 버전 */
          appVersion?: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiUserHmUpdateDeviceinfoData, any>({
        path: `/v2/api/user/hm/update/deviceinfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomElFind
     * @summary 채팅방 정보 조회
     * @request GET:/v2/api/chatroom/el/find
     * @secure
     * @response `200` `ApiChatroomElFindData` \{ChatRoom\} 채팅방 모델
     */
    apiChatroomElFind: (query: ApiChatroomElFindParams, params: RequestParams = {}) =>
      this.request<ApiChatroomElFindData, any>({
        path: `/v2/api/chatroom/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomElCountResponserequired
     * @summary 병원내 채팅방 중, 상담 요청에 대한 신규 채팅이 발생했는지 확인하기 위한 API
     * @request GET:/v2/api/chatroom/el/count/responserequired
     * @secure
     * @response `200` `ApiChatroomElCountResponserequiredData` unread response required counts
     */
    apiChatroomElCountResponserequired: (query: ApiChatroomElCountResponserequiredParams, params: RequestParams = {}) =>
      this.request<ApiChatroomElCountResponserequiredData, any>({
        path: `/v2/api/chatroom/el/count/responserequired`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomElCount
     * @summary 채팅방 정보 조회
     * @request GET:/v2/api/chatroom/el/count
     * @secure
     * @response `200` `ApiChatroomElCountData` \{ChatRoom\} 채팅방 모델
     */
    apiChatroomElCount: (query: ApiChatroomElCountParams, params: RequestParams = {}) =>
      this.request<ApiChatroomElCountData, any>({
        path: `/v2/api/chatroom/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomElUnreadcount
     * @summary 읽지않은 채팅 정보 조회
     * @request GET:/v2/api/chatroom/el/unreadcount
     * @secure
     * @response `200` `ApiChatroomElUnreadcountData` 안 읽은 채팅 수
     */
    apiChatroomElUnreadcount: (query: ApiChatroomElUnreadcountParams, params: RequestParams = {}) =>
      this.request<ApiChatroomElUnreadcountData, any>({
        path: `/v2/api/chatroom/el/unreadcount`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomElCreate
     * @summary 채팅방 생성
     * @request POST:/v2/api/chatroom/el/create
     * @secure
     * @response `200` `ApiChatroomElCreateData` \{ChatRoom\} 생성된 채팅방
     */
    apiChatroomElCreate: (
      data: {
        /** 채팅방을 생성한 주체가 되 유저 */
        userID?: string;
        /** 채팅방 제목 */
        title?: string;
        /** 채팅에 참여할 유저의 ID 배열 */
        users?: string[];
        /** 채팅방이 소속된 병원 */
        hospitalID?: string;
        /**
         * 환자와의 채팅방 구분 플래그. default true
         * @default true
         */
        isDoctor?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElCreateData, any>({
        path: `/v2/api/chatroom/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomElUpdate
     * @summary 채팅방 수정
     * @request POST:/v2/api/chatroom/el/update
     * @secure
     * @response `200` `ApiChatroomElUpdateData` \{ChatRoom\} 수정된 채팅방
     */
    apiChatroomElUpdate: (
      data: {
        /** 수정하고자 하는 채팅방의 ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUpdateData, any>({
        path: `/v2/api/chatroom/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomElUpdateReadResponserequired
     * @summary 채팅방 수정 - 응대필요 N 뱃지 읽음
     * @request POST:/v2/api/chatroom/el/update/read/responserequired
     * @secure
     * @response `200` `ApiChatroomElUpdateReadResponserequiredData` update chatroom document
     */
    apiChatroomElUpdateReadResponserequired: (
      data: {
        /** 채팅방 ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUpdateReadResponserequiredData, any>({
        path: `/v2/api/chatroom/el/update/read/responserequired`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomElUpdateRead
     * @summary 채팅방 수정 - 읽음
     * @request POST:/v2/api/chatroom/el/update/read
     * @secure
     * @response `200` `ApiChatroomElUpdateReadData` update chatroom document
     */
    apiChatroomElUpdateRead: (
      data: {
        /** 채팅방 ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUpdateReadData, any>({
        path: `/v2/api/chatroom/el/update/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomElUpdateStatusResponserequiredAll
     * @summary 상담 요청 채팅방 목록 모두 대응 완료 처리
     * @request POST:/v2/api/chatroom/el/update/status/responserequired/all
     * @secure
     * @response `200` `ApiChatroomElUpdateStatusResponserequiredAllData` update chatroom document
     */
    apiChatroomElUpdateStatusResponserequiredAll: (
      data: {
        /** (required) 병원 ID */
        hospitalID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUpdateStatusResponserequiredAllData, any>({
        path: `/v2/api/chatroom/el/update/status/responserequired/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomElUpdateTitle
     * @summary 채팅방 수정
     * @request POST:/v2/api/chatroom/el/update/title
     * @secure
     * @response `200` `ApiChatroomElUpdateTitleData` \{ChatRoom\} 수정된 채팅방
     */
    apiChatroomElUpdateTitle: (
      data: {
        /** 수정하고자 하는 채팅방의 ID */
        _id?: string;
        /** 수정하고자 하는 채팅방의 타이틀 */
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUpdateTitleData, any>({
        path: `/v2/api/chatroom/el/update/title`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomElUserAdd
     * @summary 채팅방 유저 추가
     * @request POST:/v2/api/chatroom/el/user/add
     * @secure
     * @response `200` `ApiChatroomElUserAddData` \{ChatRoom\} 수정된 채팅방
     */
    apiChatroomElUserAdd: (
      data: {
        /** 채팅방 ID */
        _id?: string;
        /** 추가하고자 하는 유저의 아이디 배열 */
        userIDs?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUserAddData, any>({
        path: `/v2/api/chatroom/el/user/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomElUserRemove
     * @summary 채팅방 유저 추가
     * @request POST:/v2/api/chatroom/el/user/remove
     * @secure
     * @response `200` `ApiChatroomElUserRemoveData` \{ChatRoom\} 수정된 채팅방
     */
    apiChatroomElUserRemove: (
      data: {
        /** 수정하고자 하는 채팅방 ID */
        _id?: string;
        /** 제거하고자 하는 유저의 아이디 배열 */
        userIDs?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUserRemoveData, any>({
        path: `/v2/api/chatroom/el/user/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomElUserRemoveAll
     * @summary 고객 채팅방 모두 나가기. 병원 직원만 사용 가능한 API
     * @request POST:/v2/api/chatroom/el/user/remove/all
     * @secure
     * @response `200` `ApiChatroomElUserRemoveAllData` \[\{ChatRoom\}\] 수정된 채팅방 목록
     */
    apiChatroomElUserRemoveAll: (
      data: {
        /** 채팅방 모두 나가기를 수행할 병원 */
        hospitalID?: string;
        /** 제거하고자 하는 유저의 아이디 배열 */
        userIDs?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUserRemoveAllData, any>({
        path: `/v2/api/chatroom/el/user/remove/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomMFindOne
     * @summary 채팅방 정보 조회
     * @request GET:/v2/api/chatroom/m/find/one
     * @secure
     * @response `200` `ApiChatroomMFindOneData` \{ChatRoom\} 채팅방 모델
     */
    apiChatroomMFindOne: (query: ApiChatroomMFindOneParams, params: RequestParams = {}) =>
      this.request<ApiChatroomMFindOneData, any>({
        path: `/v2/api/chatroom/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatRoom
     * @name ApiChatroomMUpdateRead
     * @summary 채팅방 읽음 요청
     * @request POST:/v2/api/chatroom/m/update/read
     * @secure
     * @response `200` `ApiChatroomMUpdateReadData` \{ChatRoom\} 수정된 채팅방
     */
    apiChatroomMUpdateRead: (
      data: {
        /** 수정하고자 하는 채팅방의 ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomMUpdateReadData, any>({
        path: `/v2/api/chatroom/m/update/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chat
     * @name ApiChatElFind
     * @summary 채팅방 내 채팅내역 조회
     * @request GET:/v2/api/chat/el/find
     * @secure
     * @response `200` `ApiChatElFindData` response of Service Setting Models
     */
    apiChatElFind: (query: ApiChatElFindParams, params: RequestParams = {}) =>
      this.request<ApiChatElFindData, any>({
        path: `/v2/api/chat/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chat
     * @name ApiChatElCount
     * @summary 채팅방 내 전체 채팅내역 수 조회
     * @request GET:/v2/api/chat/el/count
     * @secure
     * @response `200` `ApiChatElCountData` response of Service Setting Models
     */
    apiChatElCount: (query: ApiChatElCountParams, params: RequestParams = {}) =>
      this.request<ApiChatElCountData, any>({
        path: `/v2/api/chat/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chat
     * @name ApiChatElUpdateMarker
     * @summary 채팅 마커 업데이트
     * @request POST:/v2/api/chat/el/update/marker
     * @secure
     * @response `200` `ApiChatElUpdateMarkerData` \{Chat\} 생성된 채팅 객체
     */
    apiChatElUpdateMarker: (
      data: {
        /** 채팅마커를 수정하고자 하는 채팅 객체의 ID */
        _id?: string;
        markers?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatElUpdateMarkerData, any>({
        path: `/v2/api/chat/el/update/marker`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chat
     * @name ApiChatMCreateReservation
     * @summary 모바일 앱 메인 페이지에서 "예약 > 채팅으로 예약" 선택 시 채팅 생성
     * @request POST:/v2/api/chat/m/create/reservation
     * @secure
     * @response `200` `ApiChatMCreateReservationData` \{Chat\} 생성된 채팅 객체
     */
    apiChatMCreateReservation: (
      data: {
        /** 채팅 예약을 수행하는 hserviceID */
        hserviceID?: string;
        /** 채팅방 ID */
        chatRoomID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatMCreateReservationData, any>({
        path: `/v2/api/chat/m/create/reservation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chat
     * @name ApiChatMCreateHevent
     * @summary 모바일 앱 이벤트 페이지에서 "채팅 상담 진행하기" 선택 시 채팅 생성
     * @request POST:/v2/api/chat/m/create/hevent
     * @secure
     * @response `200` `ApiChatMCreateHeventData` \{Chat\} 생성된 채팅 객체
     */
    apiChatMCreateHevent: (
      data: {
        /** 채팅 상담 진행하기를 수행하는 hserviceID */
        hserviceID?: string;
        /** 채팅방 ID */
        chatRoomID?: string;
        /** 병원 이벤트 ID */
        heventID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatMCreateHeventData, any>({
        path: `/v2/api/chat/m/create/hevent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chat
     * @name ApiChatMCreateHaftercare
     * @summary 모바일 앱 - 홈케어 상품 페이지에서 "채팅 상담 진행하기" 선택 시 채팅 생성
     * @request POST:/v2/api/chat/m/create/haftercare
     * @secure
     * @response `200` `ApiChatMCreateHaftercareData` \{Chat\} 생성된 채팅 객체
     */
    apiChatMCreateHaftercare: (
      data: {
        /** 채팅 상담 진행하기를 수행하는 hserviceID */
        hserviceID?: string;
        /** 채팅방 ID */
        chatRoomID?: string;
        /** 병원 홈케어 상품 ID */
        haftercareID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatMCreateHaftercareData, any>({
        path: `/v2/api/chat/m/create/haftercare`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hospital
     * @name ApiHospitalElFind
     * @summary 병원정보 설정(Hospital) 조회
     * @request GET:/v2/api/hospital/el/find
     * @secure
     * @response `200` `ApiHospitalElFindData` 병원 정보 목록
     */
    apiHospitalElFind: (query: ApiHospitalElFindParams, params: RequestParams = {}) =>
      this.request<ApiHospitalElFindData, any>({
        path: `/v2/api/hospital/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hospital
     * @name ApiHospitalElFindAddress
     * @summary 병원 주소정보 조회
     * @request GET:/v2/api/hospital/el/find/address
     * @secure
     * @response `200` `ApiHospitalElFindAddressData` response of Service Setting Models
     */
    apiHospitalElFindAddress: (query: ApiHospitalElFindAddressParams, params: RequestParams = {}) =>
      this.request<ApiHospitalElFindAddressData, any>({
        path: `/v2/api/hospital/el/find/address`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hospital
     * @name ApiHospitalElUpdate
     * @summary 병원정보(Hospital) 수정
     * @request POST:/v2/api/hospital/el/update
     * @secure
     * @response `200` `ApiHospitalElUpdateData` update hospital document
     */
    apiHospitalElUpdate: (
      data: {
        /** Hospital Object ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalElUpdateData, any>({
        path: `/v2/api/hospital/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hospital
     * @name ApiHospitalElFindDoctors
     * @summary 병원내 의사정보 조회
     * @request GET:/v2/api/hospital/el/find/doctors
     * @secure
     * @response `200` `ApiHospitalElFindDoctorsData` response of Service Setting Models
     */
    apiHospitalElFindDoctors: (query: ApiHospitalElFindDoctorsParams, params: RequestParams = {}) =>
      this.request<ApiHospitalElFindDoctorsData, any>({
        path: `/v2/api/hospital/el/find/doctors`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hospital
     * @name ApiHospitalElFindUsers
     * @summary 병원내 유저정보 조회
     * @request GET:/v2/api/hospital/el/find/users
     * @secure
     * @response `200` `ApiHospitalElFindUsersData` response of Service Setting Models
     */
    apiHospitalElFindUsers: (query: ApiHospitalElFindUsersParams, params: RequestParams = {}) =>
      this.request<ApiHospitalElFindUsersData, any>({
        path: `/v2/api/hospital/el/find/users`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hospital
     * @name ApiHospitalMFindOne
     * @summary 병원 정보 조회
     * @request GET:/v2/api/hospital/m/find/one
     * @secure
     * @response `200` `ApiHospitalMFindOneData` \{Hospital\} 병원 모델 객체
     */
    apiHospitalMFindOne: (query: ApiHospitalMFindOneParams, params: RequestParams = {}) =>
      this.request<ApiHospitalMFindOneData, any>({
        path: `/v2/api/hospital/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hospital
     * @name ApiHospitalMFindDoctors
     * @summary 병원 내 의사 정보 조회
     * @request GET:/v2/api/hospital/m/find/doctors
     * @secure
     * @response `200` `ApiHospitalMFindDoctorsData` \[\{User\}\] 병원 모델 객체
     */
    apiHospitalMFindDoctors: (query: ApiHospitalMFindDoctorsParams, params: RequestParams = {}) =>
      this.request<ApiHospitalMFindDoctorsData, any>({
        path: `/v2/api/hospital/m/find/doctors`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hospital
     * @name ApiHospitalMFindAfterhoursPopup
     * @summary 병원별 애프터닥 운영시간 종료 후 환자 채팅 시 팝업 표시 HTML 파일 (모바일)
     * @request GET:/v2/api/hospital/m/find/afterhours/popup
     * @secure
     * @response `200` `ApiHospitalMFindAfterhoursPopupData` HTML File Response
     */
    apiHospitalMFindAfterhoursPopup: (query: ApiHospitalMFindAfterhoursPopupParams, params: RequestParams = {}) =>
      this.request<ApiHospitalMFindAfterhoursPopupData, any>({
        path: `/v2/api/hospital/m/find/afterhours/popup`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceNotice
     * @name ApiNoticeServicenoticeElCount
     * @summary ServiceNotice 조회
     * @request GET:/v2/api/notice/servicenotice/el/count
     * @secure
     * @response `200` `ApiNoticeServicenoticeElCountData` \[\{ServiceNotice\}\] 서비스 알림 목록
     */
    apiNoticeServicenoticeElCount: (query: ApiNoticeServicenoticeElCountParams, params: RequestParams = {}) =>
      this.request<ApiNoticeServicenoticeElCountData, any>({
        path: `/v2/api/notice/servicenotice/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceNotice
     * @name ApiNoticeServicenoticeElFind
     * @summary ServiceNotice 조회
     * @request GET:/v2/api/notice/servicenotice/el/find
     * @secure
     * @response `200` `ApiNoticeServicenoticeElFindData` \[\{ServiceNotice\}\] 서비스 알림 목록
     */
    apiNoticeServicenoticeElFind: (query: ApiNoticeServicenoticeElFindParams, params: RequestParams = {}) =>
      this.request<ApiNoticeServicenoticeElFindData, any>({
        path: `/v2/api/notice/servicenotice/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceNotice
     * @name ApiNoticeServicenoticeElUpdateRead
     * @summary 서비스 알림 읽음처리
     * @request POST:/v2/api/notice/servicenotice/el/update/read
     * @secure
     * @response `200` `ApiNoticeServicenoticeElUpdateReadData` \{ServiceNotice\} 수정된 알림
     */
    apiNoticeServicenoticeElUpdateRead: (
      data: {
        /** 서비스 알림 ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeServicenoticeElUpdateReadData, any>({
        path: `/v2/api/notice/servicenotice/el/update/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description - 유저 기준 서비스 알림 모두읽음 처리 - userID 전달
     *
     * @tags ServiceNotice
     * @name ApiNoticeServicenoticeElUpdateReadAll
     * @summary 유저 기준 서비스 알림 모두읽음 처리
     * @request POST:/v2/api/notice/servicenotice/el/update/read/all
     * @secure
     * @response `200` `ApiNoticeServicenoticeElUpdateReadAllData` \{ServiceNotice\} 수정된 알림
     */
    apiNoticeServicenoticeElUpdateReadAll: (
      data: {
        /** 서비스 알림 모두읽음 처리할 userID */
        userID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeServicenoticeElUpdateReadAllData, any>({
        path: `/v2/api/notice/servicenotice/el/update/read/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceNotice
     * @name ApiNoticeServicenoticeMCount
     * @summary ServiceNotice 조회
     * @request GET:/v2/api/notice/servicenotice/m/count
     * @secure
     * @response `200` `ApiNoticeServicenoticeMCountData` \[\{ServiceNotice\}\] 서비스 알림 목록
     */
    apiNoticeServicenoticeMCount: (query: ApiNoticeServicenoticeMCountParams, params: RequestParams = {}) =>
      this.request<ApiNoticeServicenoticeMCountData, any>({
        path: `/v2/api/notice/servicenotice/m/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceNotice
     * @name ApiNoticeServicenoticeMFind
     * @summary ServiceNotice 조회
     * @request GET:/v2/api/notice/servicenotice/m/find
     * @secure
     * @response `200` `ApiNoticeServicenoticeMFindData` \[\{ServiceNotice\}\] 서비스 알림 목록
     */
    apiNoticeServicenoticeMFind: (query: ApiNoticeServicenoticeMFindParams, params: RequestParams = {}) =>
      this.request<ApiNoticeServicenoticeMFindData, any>({
        path: `/v2/api/notice/servicenotice/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceNotice
     * @name ApiNoticeServicenoticeMUpdateRead
     * @summary 서비스 알림 읽음처리
     * @request POST:/v2/api/notice/servicenotice/m/update/read
     * @secure
     * @response `200` `ApiNoticeServicenoticeMUpdateReadData` \{ServiceNotice\} 수정된 알림
     */
    apiNoticeServicenoticeMUpdateRead: (
      data: {
        /** 서비스 알림 ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeServicenoticeMUpdateReadData, any>({
        path: `/v2/api/notice/servicenotice/m/update/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description - 유저 기준 서비스 알림 모두읽음 처리 (mobile) - userID 전달
     *
     * @tags ServiceNotice
     * @name ApiNoticeServicenoticeMUpdateReadAll
     * @summary 유저 기준 서비스 알림 모두읽음 처리 (mobile)
     * @request POST:/v2/api/notice/servicenotice/m/update/read/all
     * @secure
     * @response `200` `ApiNoticeServicenoticeMUpdateReadAllData` \{ServiceNotice\} updateMany 영향 받은 결과값 Object \{ n, nModified, ok \}
     */
    apiNoticeServicenoticeMUpdateReadAll: (
      data: {
        /** (required) 서비스 알림 모두읽음 처리할 userID */
        userID?: string;
        /** (required) 서비스 알림 모두읽음 처리할 hserviceID */
        hserviceID?: string;
        /** 병원 ID */
        hospitalID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeServicenoticeMUpdateReadAllData, any>({
        path: `/v2/api/notice/servicenotice/m/update/read/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceNotice
     * @name ApiNoticeServicenoticeHmCount
     * @summary ServiceNotice 갯수 조회 (애프터닥 관리자 앱)
     * @request GET:/v2/api/notice/servicenotice/hm/count
     * @secure
     * @response `200` `ApiNoticeServicenoticeHmCountData` 서비스 알림 수
     */
    apiNoticeServicenoticeHmCount: (query: ApiNoticeServicenoticeHmCountParams, params: RequestParams = {}) =>
      this.request<ApiNoticeServicenoticeHmCountData, any>({
        path: `/v2/api/notice/servicenotice/hm/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceNotice
     * @name ApiNoticeServicenoticeHmFind
     * @summary ServiceNotice 조회 (애프터닥 관리자 앱)
     * @request GET:/v2/api/notice/servicenotice/hm/find
     * @secure
     * @response `200` `ApiNoticeServicenoticeHmFindData` \[\{ServiceNotice\}\] 서비스 알림 목록
     */
    apiNoticeServicenoticeHmFind: (query: ApiNoticeServicenoticeHmFindParams, params: RequestParams = {}) =>
      this.request<ApiNoticeServicenoticeHmFindData, any>({
        path: `/v2/api/notice/servicenotice/hm/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceNotice
     * @name ApiNoticeServicenoticeHmUpdateRead
     * @summary 서비스 알림 읽음처리 (애프터닥 관리자 앱)
     * @request POST:/v2/api/notice/servicenotice/hm/update/read
     * @secure
     * @response `200` `ApiNoticeServicenoticeHmUpdateReadData` \{ServiceNotice\} 수정된 알림
     */
    apiNoticeServicenoticeHmUpdateRead: (
      data: {
        /** 서비스 알림 ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeServicenoticeHmUpdateReadData, any>({
        path: `/v2/api/notice/servicenotice/hm/update/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description - 유저 기준 서비스 알림 모두읽음 처리 (애프터닥 관리자 앱) - userID 전달
     *
     * @tags ServiceNotice
     * @name ApiNoticeServicenoticeHmUpdateReadAll
     * @summary 유저 기준 서비스 알림 모두읽음 처리 (애프터닥 관리자 앱)
     * @request POST:/v2/api/notice/servicenotice/hm/update/read/all
     * @secure
     * @response `200` `ApiNoticeServicenoticeHmUpdateReadAllData` \{ServiceNotice\} 수정된 알림
     */
    apiNoticeServicenoticeHmUpdateReadAll: (
      data: {
        /** 서비스 알림 모두읽음 처리할 userID */
        userID?: string;
        /**
         * 알림 카테고리. 비워둘 시 전체 조회.
         * - PatientManagement : 고객관리 알림
         * - ReservationManagement : 예약관리 알림
         */
        category?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeServicenoticeHmUpdateReadAllData, any>({
        path: `/v2/api/notice/servicenotice/hm/update/read/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceNotice
     * @name ApiNoticeServicenoticeHmUpdateReadReservation
     * @summary 예약 정보를 통한 서비스 알림 읽음처리 (애프터닥 관리자 앱)
     * @request POST:/v2/api/notice/servicenotice/hm/update/read/reservation
     * @secure
     * @response `200` `ApiNoticeServicenoticeHmUpdateReadReservationData` \{ServiceNotice\} 수정된 알림
     */
    apiNoticeServicenoticeHmUpdateReadReservation: (
      data: {
        /** 서브 카테고리 문자열 값 */
        subCategory?: string;
        /** 병원 직원 유저 ID */
        userID?: string;
        /** 예약 ID */
        reservationID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeServicenoticeHmUpdateReadReservationData, any>({
        path: `/v2/api/notice/servicenotice/hm/update/read/reservation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSetting
     * @name ApiReservationsettingElFind
     * @summary 병원예약설정 객체의 조회. 정보가 없는 경우에 한하여 디폴트 정보를 생성 후 리턴
     * @request GET:/v2/api/reservationsetting/el/find
     * @secure
     * @response `200` `ApiReservationsettingElFindData` response of Reservation Sheet List
     */
    apiReservationsettingElFind: (query: ApiReservationsettingElFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationsettingElFindData, any>({
        path: `/v2/api/reservationsetting/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSetting
     * @name ApiReservationsettingElUpdate
     * @summary 병원예약설정 객체의 업데이트
     * @request POST:/v2/api/reservationsetting/el/update
     * @secure
     * @response `200` `ApiReservationsettingElUpdateData` reseponse of login
     */
    apiReservationsettingElUpdate: (
      data: {
        _id?: string;
        hospitalID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationsettingElUpdateData, any>({
        path: `/v2/api/reservationsetting/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSheet
     * @name ApiReservationsheetElFind
     * @summary 예약시트 객체의 조회
     * @request GET:/v2/api/reservationsheet/el/find
     * @secure
     * @response `200` `ApiReservationsheetElFindData` response of Reservation Sheet List
     */
    apiReservationsheetElFind: (query: ApiReservationsheetElFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationsheetElFindData, any>({
        path: `/v2/api/reservationsheet/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSheet
     * @name ApiReservationsheetElFindOne
     * @summary 예약시트 객체의 조회
     * @request GET:/v2/api/reservationsheet/el/find/one
     * @secure
     * @response `200` `ApiReservationsheetElFindOneData` response of Reservation Sheet List
     */
    apiReservationsheetElFindOne: (query: ApiReservationsheetElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiReservationsheetElFindOneData, any>({
        path: `/v2/api/reservationsheet/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSheet
     * @name ApiReservationsheetElDetail
     * @summary 예약시트내 디테일 정보 조회
     * @request GET:/v2/api/reservationsheet/el/detail
     * @secure
     * @response `200` `ApiReservationsheetElDetailData` response of Reservation Sheet List
     */
    apiReservationsheetElDetail: (query: ApiReservationsheetElDetailParams, params: RequestParams = {}) =>
      this.request<ApiReservationsheetElDetailData, any>({
        path: `/v2/api/reservationsheet/el/detail`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 아래 모든 정보는 hospitalID 를 제외하고 옵셔널. isActive 는 디폴트 false. 생성시 isActive 값은 변경 불가.
     *
     * @tags ReservationSheet
     * @name ApiReservationsheetElCreate
     * @summary 예약시트 객체의 생성
     * @request POST:/v2/api/reservationsheet/el/create
     * @secure
     * @response `200` `ApiReservationsheetElCreateData` reseponse of login
     */
    apiReservationsheetElCreate: (
      data: {
        hospitalID?: string;
        title?: string;
        possibleRange?: number;
        blockedDay?: number[];
        possibleTimes?: Record<string, any>[];
        impossibleTimes?: Record<string, any>[];
        canCancel?: boolean;
        cancelDuration?: number;
        timeInterval?: number;
        programIDs?: string[];
        reservationMessage?: string;
        reservationNotiTime?: Date;
        reservationNoti?: string;
        reservationStatusColor?: Record<string, any>;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationsheetElCreateData, any>({
        path: `/v2/api/reservationsheet/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSheet
     * @name ApiReservationsheetElUpdate
     * @summary 예약시트 객체의 업데이트
     * @request POST:/v2/api/reservationsheet/el/update
     * @secure
     * @response `200` `ApiReservationsheetElUpdateData` reseponse of login
     */
    apiReservationsheetElUpdate: (
      data: {
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationsheetElUpdateData, any>({
        path: `/v2/api/reservationsheet/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSheet
     * @name ApiReservationsheetElRemove
     * @summary 예약시트 객체의 삭제
     * @request POST:/v2/api/reservationsheet/el/remove
     * @secure
     * @response `200` `ApiReservationsheetElRemoveData` reseponse of login
     */
    apiReservationsheetElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationsheetElRemoveData, any>({
        path: `/v2/api/reservationsheet/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSheet
     * @name ApiReservationsheetElUpdateActivate
     * @summary 예약시트 객체의 isActivate 업데이트
     * @request POST:/v2/api/reservationsheet/el/update/activate
     * @secure
     * @response `200` `ApiReservationsheetElUpdateActivateData` reseponse of login
     */
    apiReservationsheetElUpdateActivate: (
      data: {
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationsheetElUpdateActivateData, any>({
        path: `/v2/api/reservationsheet/el/update/activate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSheet
     * @name ApiReservationsheetMFind
     * @summary 예약시트 객체의 목록 조회(Array)
     * @request GET:/v2/api/reservationsheet/m/find
     * @secure
     * @response `200` `ApiReservationsheetMFindData` \[\{ReservationSheet\}\] 시트 객체 배열
     */
    apiReservationsheetMFind: (query: ApiReservationsheetMFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationsheetMFindData, any>({
        path: `/v2/api/reservationsheet/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSheet
     * @name ApiReservationsheetMDetail
     * @summary 예약시트내 디테일 정보 조회
     * @request GET:/v2/api/reservationsheet/m/detail
     * @deprecated
     * @secure
     * @response `200` `ApiReservationsheetMDetailData` response of Reservation Sheet List
     */
    apiReservationsheetMDetail: (query: ApiReservationsheetMDetailParams, params: RequestParams = {}) =>
      this.request<ApiReservationsheetMDetailData, any>({
        path: `/v2/api/reservationsheet/m/detail`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSheet
     * @name ApiReservationsheetMDetailReservationid
     * @summary 예약시트내 디테일 정보 조회
     * @request GET:/v2/api/reservationsheet/m/detail/reservationid
     * @deprecated
     * @secure
     * @response `200` `ApiReservationsheetMDetailReservationidData` response of Reservation Sheet List
     */
    apiReservationsheetMDetailReservationid: (
      query: ApiReservationsheetMDetailReservationidParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationsheetMDetailReservationidData, any>({
        path: `/v2/api/reservationsheet/m/detail/reservationid`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSheet
     * @name ApiReservationsheetMPossibledays
     * @summary 예약컬럼의 예약 가능한 일자 조회
     * @request GET:/v2/api/reservationsheet/m/possibledays
     * @deprecated
     * @secure
     * @response `200` `ApiReservationsheetMPossibledaysData` response of Reservation Sheet List
     */
    apiReservationsheetMPossibledays: (query: ApiReservationsheetMPossibledaysParams, params: RequestParams = {}) =>
      this.request<ApiReservationsheetMPossibledaysData, any>({
        path: `/v2/api/reservationsheet/m/possibledays`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSheet
     * @name ApiReservationsheetMReservationlist
     * @summary 예약컬럼 내 예약 내역 조회
     * @request GET:/v2/api/reservationsheet/m/reservationlist
     * @deprecated
     * @secure
     * @response `200` `ApiReservationsheetMReservationlistData` response of Reservation Sheet List
     */
    apiReservationsheetMReservationlist: (
      query: ApiReservationsheetMReservationlistParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationsheetMReservationlistData, any>({
        path: `/v2/api/reservationsheet/m/reservationlist`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationSheet
     * @name ApiReservationsheetHmFind
     * @summary 예약시트 객체의 조회 (애프터닥 관리자 앱)
     * @request GET:/v2/api/reservationsheet/hm/find
     * @secure
     * @response `200` `ApiReservationsheetHmFindData` response of Reservation Sheet List
     */
    apiReservationsheetHmFind: (query: ApiReservationsheetHmFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationsheetHmFindData, any>({
        path: `/v2/api/reservationsheet/hm/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationColumn
     * @name ApiReservationcolumnElFind
     * @summary 예약컬럼 객체의 조회
     * @request GET:/v2/api/reservationcolumn/el/find
     * @secure
     * @response `200` `ApiReservationcolumnElFindData` response of Reservation Column List
     */
    apiReservationcolumnElFind: (query: ApiReservationcolumnElFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationcolumnElFindData, any>({
        path: `/v2/api/reservationcolumn/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationColumn
     * @name ApiReservationcolumnElCreate
     * @summary 예약컬럼 객체의 생성
     * @request POST:/v2/api/reservationcolumn/el/create
     * @secure
     * @response `200` `ApiReservationcolumnElCreateData` reseponse of login
     */
    apiReservationcolumnElCreate: (
      data: {
        title?: string;
        sheetID?: string;
        hospitalID?: string;
        isActivate?: boolean;
        startedAt?: string;
        endedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationcolumnElCreateData, any>({
        path: `/v2/api/reservationcolumn/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationColumn
     * @name ApiReservationcolumnElUpdate
     * @summary 예약시트 객체의 업데이트
     * @request POST:/v2/api/reservationcolumn/el/update
     * @secure
     * @response `200` `ApiReservationcolumnElUpdateData` reseponse of login
     */
    apiReservationcolumnElUpdate: (
      data: {
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationcolumnElUpdateData, any>({
        path: `/v2/api/reservationcolumn/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationColumn
     * @name ApiReservationcolumnElUpdateTimeintervals
     * @summary 예약 컬럼 객체의 시간 구분선 업데이트
     * @request POST:/v2/api/reservationcolumn/el/update/timeintervals
     * @secure
     * @response `200` `ApiReservationcolumnElUpdateTimeintervalsData` \[\{ReservationColumn\}\] 수정된 예약 컬럼 객체 배열
     */
    apiReservationcolumnElUpdateTimeintervals: (
      data: {
        /** 수정하려는 Column의 ObjectId */
        _id?: string;
        /** \'h:mm\' 형태의 시간 배열 */
        boldTimeIntervals?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationcolumnElUpdateTimeintervalsData, any>({
        path: `/v2/api/reservationcolumn/el/update/timeintervals`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationColumn
     * @name ApiReservationcolumnElRemove
     * @summary 예약컬럼 객체의 삭제
     * @request POST:/v2/api/reservationcolumn/el/remove
     * @secure
     * @response `200` `ApiReservationcolumnElRemoveData` reseponse of login
     */
    apiReservationcolumnElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationcolumnElRemoveData, any>({
        path: `/v2/api/reservationcolumn/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationColumn
     * @name ApiReservationcolumnElDate
     * @summary 예약컬럼 객체의 일자별 조회
     * @request GET:/v2/api/reservationcolumn/el/date
     * @secure
     * @response `200` `ApiReservationcolumnElDateData` \[\{ReservationColumn\}\] ReservationColumn 모델 객체
     */
    apiReservationcolumnElDate: (query: ApiReservationcolumnElDateParams, params: RequestParams = {}) =>
      this.request<ApiReservationcolumnElDateData, any>({
        path: `/v2/api/reservationcolumn/el/date`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationColumn
     * @name ApiReservationcolumnMDate
     * @summary 예약컬럼 객체의 일자별 조회
     * @request GET:/v2/api/reservationcolumn/m/date
     * @secure
     * @response `200` `ApiReservationcolumnMDateData` \[\{ReservationColumn\}\] 컬럼 객체 배열
     */
    apiReservationcolumnMDate: (query: ApiReservationcolumnMDateParams, params: RequestParams = {}) =>
      this.request<ApiReservationcolumnMDateData, any>({
        path: `/v2/api/reservationcolumn/m/date`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationColumn
     * @name ApiReservationcolumnHmDate
     * @summary 예약컬럼 객체의 일자별 조회 (애프터닥 관리자 앱)
     * @request GET:/v2/api/reservationcolumn/hm/date
     * @secure
     * @response `200` `ApiReservationcolumnHmDateData` \[\{ReservationColumn\}\] ReservationColumn 모델 객체
     */
    apiReservationcolumnHmDate: (query: ApiReservationcolumnHmDateParams, params: RequestParams = {}) =>
      this.request<ApiReservationcolumnHmDateData, any>({
        path: `/v2/api/reservationcolumn/hm/date`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationProgram
     * @name ApiReservationprogramElFind
     * @summary 예약 프로그램 객체의 조회. sheetID, hospitalID 필수 입력
     * @request GET:/v2/api/reservationprogram/el/find
     * @secure
     * @response `200` `ApiReservationprogramElFindData` response of Reservation Column List
     */
    apiReservationprogramElFind: (query: ApiReservationprogramElFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationprogramElFindData, any>({
        path: `/v2/api/reservationprogram/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationProgram
     * @name ApiReservationprogramElCreate
     * @summary 예약 프로그램 객체의 생성
     * @request POST:/v2/api/reservationprogram/el/create
     * @secure
     * @response `200` `ApiReservationprogramElCreateData` reseponse of login
     */
    apiReservationprogramElCreate: (
      data: {
        sheetID?: string;
        hospitalID?: string;
        title?: string;
        duration?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationprogramElCreateData, any>({
        path: `/v2/api/reservationprogram/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationProgram
     * @name ApiReservationprogramElUpdate
     * @summary 예약 프로그램 객체의 업데이트
     * @request POST:/v2/api/reservationprogram/el/update
     * @secure
     * @response `200` `ApiReservationprogramElUpdateData` reseponse of login
     */
    apiReservationprogramElUpdate: (
      data: {
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationprogramElUpdateData, any>({
        path: `/v2/api/reservationprogram/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationProgram
     * @name ApiReservationprogramElRemove
     * @summary 예약 프로그램 객체의 삭제
     * @request POST:/v2/api/reservationprogram/el/remove
     * @secure
     * @response `200` `ApiReservationprogramElRemoveData` reseponse of login
     */
    apiReservationprogramElRemove: (
      data: {
        _id?: string;
        sheetID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationprogramElRemoveData, any>({
        path: `/v2/api/reservationprogram/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationProgram
     * @name ApiReservationprogramHmFind
     * @summary 예약 프로그램 객체의 조회. sheetID, hospitalID 필수 입력 (애프터닥 관리자 앱)
     * @request GET:/v2/api/reservationprogram/hm/find
     * @secure
     * @response `200` `ApiReservationprogramHmFindData` response of Reservation Column List
     */
    apiReservationprogramHmFind: (query: ApiReservationprogramHmFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationprogramHmFindData, any>({
        path: `/v2/api/reservationprogram/hm/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationElCount
     * @summary 예약 객체의 수 조회
     * @request GET:/v2/api/reservation/el/count
     * @secure
     * @response `200` `ApiReservationElCountData` Number 예약 수
     */
    apiReservationElCount: (query: ApiReservationElCountParams, params: RequestParams = {}) =>
      this.request<ApiReservationElCountData, any>({
        path: `/v2/api/reservation/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationElFind
     * @summary 예약 객체의 조회
     * @request GET:/v2/api/reservation/el/find
     * @secure
     * @response `200` `ApiReservationElFindData` response of Reservation List
     */
    apiReservationElFind: (query: ApiReservationElFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationElFindData, any>({
        path: `/v2/api/reservation/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationElCreate
     * @summary 예약 객체의 생성
     * @request POST:/v2/api/reservation/el/create
     * @secure
     * @response `200` `ApiReservationElCreateData` \{Reservation\} 예약 컬렉션 객체
     */
    apiReservationElCreate: (
      data: {
        /** (required) 예약 시트 id */
        sheetID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /** (required) 병원 id */
        hospitalID?: string;
        /** (required) 예약을 받을 고객의 id */
        userID?: string;
        /** (required) 서비스 id */
        hserviceID?: string;
        isUnregisteredUser?: string;
        /** (optional) 예약을 받을 고객의 이름 */
        userName?: string;
        /** (optional) 프로그램 id */
        programID?: string;
        /** (optional) 치료내역 수정 시 입력 */
        noteContent?: string;
        /**
         * (optional) 예약 시작 시간
         * @default "2022-09-06T12:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (optional) 예약 종료 시간
         * @default "2022-09-06T12:20:00.000+0900"
         */
        endedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationElCreateData, any>({
        path: `/v2/api/reservation/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationElCreateRegist
     * @summary 예약 객체의 생성
     * @request POST:/v2/api/reservation/el/create/regist
     * @secure
     * @response `200` `ApiReservationElCreateRegistData` reseponse of login
     */
    apiReservationElCreateRegist: (
      data: {
        name?: string;
        phone?: string;
        message?: string;
        sheetID?: string;
        columnID?: string;
        hospitalID?: string;
        userName?: string;
        programID?: string;
        /** @default "2022-09-06T12:00:00.000+0900" */
        startedAt?: string;
        /** @default "2022-09-06T12:20:00.000+0900" */
        endedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationElCreateRegistData, any>({
        path: `/v2/api/reservation/el/create/regist`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationElUpdate
     * @summary 예약 객체의 업데이트
     * @request POST:/v2/api/reservation/el/update
     * @secure
     * @response `200` `ApiReservationElUpdateData` \{Reservation\} 예약 컬렉션 객체
     */
    apiReservationElUpdate: (
      data: {
        /** (required) 예약 _id */
        _id?: string;
        /** (required) 예약 시트 id */
        sheetID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /** (required) 병원 id */
        hospitalID?: string;
        /** (required) 서비스 id */
        hserviceID?: string;
        /** (optional) 프로그램 id */
        programID?: string;
        /** (optional) 치료내역 수정 시 입력 */
        noteContent?: string;
        /**
         * (optional) 예약 시작 시간
         * @default "2023-07-14T12:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (optional) 예약 종료 시간
         * @default "2023-07-14T12:30:00.000+0900"
         */
        endedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationElUpdateData, any>({
        path: `/v2/api/reservation/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationElRemove
     * @summary 예약 객체의 삭제
     * @request POST:/v2/api/reservation/el/remove
     * @secure
     * @response `200` `ApiReservationElRemoveData` \{Reservation\} 예약 컬렉션 객체
     */
    apiReservationElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationElRemoveData, any>({
        path: `/v2/api/reservation/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationElLast
     * @summary 마지막 예약 객체의 조회
     * @request GET:/v2/api/reservation/el/last
     * @secure
     * @response `200` `ApiReservationElLastData` response of Reservation List
     */
    apiReservationElLast: (query: ApiReservationElLastParams, params: RequestParams = {}) =>
      this.request<ApiReservationElLastData, any>({
        path: `/v2/api/reservation/el/last`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationElFindNext
     * @summary 다음 예약 객체의 조회
     * @request GET:/v2/api/reservation/el/find/next
     * @secure
     * @response `200` `ApiReservationElFindNextData` \{Reservation\} 예약 컬렉션 객체
     */
    apiReservationElFindNext: (query: ApiReservationElFindNextParams, params: RequestParams = {}) =>
      this.request<ApiReservationElFindNextData, any>({
        path: `/v2/api/reservation/el/find/next`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationElFindHistory
     * @summary 치료 예약에 대한 히스토리 조회
     * @request GET:/v2/api/reservation/el/find/history
     * @secure
     * @response `200` `ApiReservationElFindHistoryData` response of Reservation List
     */
    apiReservationElFindHistory: (query: ApiReservationElFindHistoryParams, params: RequestParams = {}) =>
      this.request<ApiReservationElFindHistoryData, any>({
        path: `/v2/api/reservation/el/find/history`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationElFindParent
     * @summary parentID 를 사용한 예약 객체의 조회
     * @request GET:/v2/api/reservation/el/find/parent
     * @secure
     * @response `200` `ApiReservationElFindParentData` \[\{Reservation\}\] Reservation 객체 배열
     */
    apiReservationElFindParent: (query: ApiReservationElFindParentParams, params: RequestParams = {}) =>
      this.request<ApiReservationElFindParentData, any>({
        path: `/v2/api/reservation/el/find/parent`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationElFindSchedule
     * @summary 예약 일정에 대한 예약 객체 조회
     * @request GET:/v2/api/reservation/el/find/schedule
     * @secure
     * @response `200` `ApiReservationElFindScheduleData` \[\{Reservation\}\] response of Reservation Collection array
     */
    apiReservationElFindSchedule: (query: ApiReservationElFindScheduleParams, params: RequestParams = {}) =>
      this.request<ApiReservationElFindScheduleData, any>({
        path: `/v2/api/reservation/el/find/schedule`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationMFind
     * @summary 예약 객체의 조회
     * @request GET:/v2/api/reservation/m/find
     * @secure
     * @response `200` `ApiReservationMFindData` \[\{Reservation\}\] 예약 컬렉션 배열
     */
    apiReservationMFind: (query: ApiReservationMFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationMFindData, any>({
        path: `/v2/api/reservation/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationMFindLast
     * @summary 마지막 예약 객체의 조회
     * @request GET:/v2/api/reservation/m/find/last
     * @secure
     * @response `200` `ApiReservationMFindLastData` \{Reservation\} 예약 컬렉션 객체
     */
    apiReservationMFindLast: (query: ApiReservationMFindLastParams, params: RequestParams = {}) =>
      this.request<ApiReservationMFindLastData, any>({
        path: `/v2/api/reservation/m/find/last`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationMFindDate
     * @summary 컬럼,시트를 기준으로 startedAt, endedAt 사이 이미 예약된 객체 목록 조회
     * @request GET:/v2/api/reservation/m/find/date
     * @secure
     * @response `200` `ApiReservationMFindDateData` \[\{Reservation\}\] 예약 컬렉션 배열
     */
    apiReservationMFindDate: (query: ApiReservationMFindDateParams, params: RequestParams = {}) =>
      this.request<ApiReservationMFindDateData, any>({
        path: `/v2/api/reservation/m/find/date`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationMFindNext
     * @summary 다음 예약 객체의 조회
     * @request GET:/v2/api/reservation/m/find/next
     * @secure
     * @response `200` `ApiReservationMFindNextData` \{Reservation\} 예약 컬렉션 객체
     */
    apiReservationMFindNext: (query: ApiReservationMFindNextParams, params: RequestParams = {}) =>
      this.request<ApiReservationMFindNextData, any>({
        path: `/v2/api/reservation/m/find/next`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationMCreate
     * @summary 예약 객체의 생성
     * @request POST:/v2/api/reservation/m/create
     * @secure
     * @response `200` `ApiReservationMCreateData` \{Reservation\} 예약 컬렉션 객체
     */
    apiReservationMCreate: (
      data: {
        sheetID?: string;
        columnID?: string;
        hospitalID?: string;
        userID?: string;
        hserviceID?: string;
        programID?: string;
        /** @default "2022-09-06T12:00:00.000+09:00" */
        startedAt?: string;
        /** @default "2022-09-06T12:20:00.000+09:00" */
        endedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationMCreateData, any>({
        path: `/v2/api/reservation/m/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationMUpdate
     * @summary 예약 객체의 업데이트
     * @request POST:/v2/api/reservation/m/update
     * @secure
     * @response `200` `ApiReservationMUpdateData` \{Reservation\} 예약 컬렉션 객체
     */
    apiReservationMUpdate: (
      data: {
        _id: string;
        sheetID?: string;
        columnID?: string;
        hospitalID?: string;
        userID?: string;
        programID?: string;
        hserviceID?: string;
        /** @default "2022-09-06T12:00:00.000+09:00" */
        startedAt?: string;
        /** @default "2022-09-06T12:20:00.000+09:00" */
        endedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationMUpdateData, any>({
        path: `/v2/api/reservation/m/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationMRemove
     * @summary 예약 객체의 삭제
     * @request POST:/v2/api/reservation/m/remove
     * @secure
     * @response `200` `ApiReservationMRemoveData` \{Reservation\} 예약 컬렉션 객체
     */
    apiReservationMRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationMRemoveData, any>({
        path: `/v2/api/reservation/m/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationMPossibledate
     * @summary 컬럼 아이디와 시트 아이디에 따른 예약 가능한 날짜의 조회
     * @request GET:/v2/api/reservation/m/possibledate
     * @secure
     * @response `200` `ApiReservationMPossibledateData` \[string\] 날짜 포맷 문자열 배열 ex)['2022.01.01T00:00:00.000Z', ...]
     */
    apiReservationMPossibledate: (query: ApiReservationMPossibledateParams, params: RequestParams = {}) =>
      this.request<ApiReservationMPossibledateData, any>({
        path: `/v2/api/reservation/m/possibledate`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationHmFind
     * @summary 예약 객체의 조회 (애프터닥 관리자 앱)
     * @request GET:/v2/api/reservation/hm/find
     * @secure
     * @response `200` `ApiReservationHmFindData` response of Reservation List
     */
    apiReservationHmFind: (query: ApiReservationHmFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationHmFindData, any>({
        path: `/v2/api/reservation/hm/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationHmCreate
     * @summary 예약 객체의 생성 (애프터닥 관리자 앱)
     * @request POST:/v2/api/reservation/hm/create
     * @secure
     * @response `200` `ApiReservationHmCreateData` \{Reservation\} 예약 컬렉션 객체
     */
    apiReservationHmCreate: (
      data: {
        /** (required) 예약 시트 id */
        sheetID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /** (required) 병원 id */
        hospitalID?: string;
        /** (required) 예약을 받을 고객의 id */
        userID?: string;
        /** (required) 서비스 id */
        hserviceID?: string;
        isUnregisteredUser?: string;
        /** (optional) 예약을 받을 고객의 이름 */
        userName?: string;
        /** (optional) 프로그램 id */
        programID?: string;
        /** (optional) 치료내역 수정 시 입력 */
        noteContent?: string;
        /**
         * (optional) 예약 시작 시간
         * @default "2022-09-06T12:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (optional) 예약 종료 시간
         * @default "2022-09-06T12:20:00.000+0900"
         */
        endedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationHmCreateData, any>({
        path: `/v2/api/reservation/hm/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationHmUpdate
     * @summary 예약 객체의 업데이트 (애프터닥 관리자 앱)
     * @request POST:/v2/api/reservation/hm/update
     * @secure
     * @response `200` `ApiReservationHmUpdateData` \{Reservation\} 예약 컬렉션 객체
     */
    apiReservationHmUpdate: (
      data: {
        /** (required) 예약 _id */
        _id?: string;
        /** (required) 예약 시트 id */
        sheetID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /** (required) 병원 id */
        hospitalID?: string;
        /** (required) 서비스 id */
        hserviceID?: string;
        /** (optional) 프로그램 id */
        programID?: string;
        /** (optional) 치료내역 수정 시 입력 */
        noteContent?: string;
        /**
         * (optional) 예약 시작 시간
         * @default "2023-07-14T12:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (optional) 예약 종료 시간
         * @default "2023-07-14T12:30:00.000+0900"
         */
        endedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationHmUpdateData, any>({
        path: `/v2/api/reservation/hm/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationHmRemove
     * @summary 예약 객체의 삭제 (애프터닥 관리자 앱)
     * @request POST:/v2/api/reservation/hm/remove
     * @secure
     * @response `200` `ApiReservationHmRemoveData` \{Reservation\} 예약 컬렉션 객체
     */
    apiReservationHmRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationHmRemoveData, any>({
        path: `/v2/api/reservation/hm/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reservation
     * @name ApiReservationHmFindHistory
     * @summary 치료 예약에 대한 히스토리 조회 (애프터닥 관리자 앱)
     * @request GET:/v2/api/reservation/hm/find/history
     * @secure
     * @response `200` `ApiReservationHmFindHistoryData` response of Reservation List
     */
    apiReservationHmFindHistory: (query: ApiReservationHmFindHistoryParams, params: RequestParams = {}) =>
      this.request<ApiReservationHmFindHistoryData, any>({
        path: `/v2/api/reservation/hm/find/history`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationVacation
     * @name ApiReservationvacationElFind
     * @summary 휴무 객체의 조회. hospitalID만 required 나머지는 필요에 의해 사용. date는 default가 오늘.
     * @request GET:/v2/api/reservationvacation/el/find
     * @secure
     * @response `200` `ApiReservationvacationElFindData` response of Reservation Column List
     */
    apiReservationvacationElFind: (query: ApiReservationvacationElFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationvacationElFindData, any>({
        path: `/v2/api/reservationvacation/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationVacation
     * @name ApiReservationvacationElFindHospital
     * @summary 휴무 객체의 조회. hospitalID를 이용하여 병원 내 모든 휴가객체를 기간에 맞춰 검색
     * @request GET:/v2/api/reservationvacation/el/find/hospital
     * @secure
     * @response `200` `ApiReservationvacationElFindHospitalData` response of Reservation Column List
     */
    apiReservationvacationElFindHospital: (
      query: ApiReservationvacationElFindHospitalParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationvacationElFindHospitalData, any>({
        path: `/v2/api/reservationvacation/el/find/hospital`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationVacation
     * @name ApiReservationvacationElFindSheet
     * @summary 휴무 객체의 조회. hospitalID를 이용하여 병원 내 모든 휴가객체를 기간에 맞춰 검색
     * @request GET:/v2/api/reservationvacation/el/find/sheet
     * @secure
     * @response `200` `ApiReservationvacationElFindSheetData` response of Reservation Column List
     */
    apiReservationvacationElFindSheet: (query: ApiReservationvacationElFindSheetParams, params: RequestParams = {}) =>
      this.request<ApiReservationvacationElFindSheetData, any>({
        path: `/v2/api/reservationvacation/el/find/sheet`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationVacation
     * @name ApiReservationvacationElFindColumn
     * @summary 휴무 객체의 조회. hospitalID를 이용하여 병원 내 모든 휴가객체를 기간에 맞춰 검색
     * @request GET:/v2/api/reservationvacation/el/find/column
     * @secure
     * @response `200` `ApiReservationvacationElFindColumnData` response of Reservation Column List
     */
    apiReservationvacationElFindColumn: (query: ApiReservationvacationElFindColumnParams, params: RequestParams = {}) =>
      this.request<ApiReservationvacationElFindColumnData, any>({
        path: `/v2/api/reservationvacation/el/find/column`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationVacation
     * @name ApiReservationvacationElCreate
     * @summary 휴무 객체의 생성
     * @request POST:/v2/api/reservationvacation/el/create
     * @secure
     * @response `200` `ApiReservationvacationElCreateData` ReservationVacation 객체
     */
    apiReservationvacationElCreate: (
      data: {
        hospitalID?: string;
        isHospital?: boolean;
        isSheet?: boolean;
        sheetID?: string;
        isColumn?: boolean;
        columnID?: string;
        isDaybreak?: boolean;
        startDate?: string;
        endDate?: string;
        startTime?: string;
        endTime?: string;
        isRoutine?: boolean;
        isWeekly?: boolean;
        isBiweekly?: boolean;
        weeklyDay?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationvacationElCreateData, any>({
        path: `/v2/api/reservationvacation/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationVacation
     * @name ApiReservationvacationElUpdate
     * @summary 휴무 객체의 업데이트
     * @request POST:/v2/api/reservationvacation/el/update
     * @secure
     * @response `200` `ApiReservationvacationElUpdateData` reseponse of login
     */
    apiReservationvacationElUpdate: (
      data: {
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationvacationElUpdateData, any>({
        path: `/v2/api/reservationvacation/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationVacation
     * @name ApiReservationvacationElRemove
     * @summary 휴무 객체의 삭제
     * @request POST:/v2/api/reservationvacation/el/remove
     * @secure
     * @response `200` `ApiReservationvacationElRemoveData` reseponse of login
     */
    apiReservationvacationElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationvacationElRemoveData, any>({
        path: `/v2/api/reservationvacation/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationVacation
     * @name ApiReservationvacationHmFind
     * @summary 휴무 객체의 조회. hospitalID만 required 나머지는 필요에 의해 사용. date는 default가 오늘.  (애프터닥 관리자 앱)
     * @request GET:/v2/api/reservationvacation/hm/find
     * @secure
     * @response `200` `ApiReservationvacationHmFindData` response of Reservation Vacation List
     */
    apiReservationvacationHmFind: (query: ApiReservationvacationHmFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationvacationHmFindData, any>({
        path: `/v2/api/reservationvacation/hm/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationBlock
     * @name ApiReservationblockElFind
     * @summary 예약금지 조회
     * @request GET:/v2/api/reservationblock/el/find
     * @secure
     * @response `200` `ApiReservationblockElFindData` \{Memo\} 모델 객체
     */
    apiReservationblockElFind: (query: ApiReservationblockElFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationblockElFindData, any>({
        path: `/v2/api/reservationblock/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationBlock
     * @name ApiReservationblockElCreate
     * @summary 예약금지 객체의 생성
     * @request POST:/v2/api/reservationblock/el/create
     * @secure
     * @response `200` `ApiReservationblockElCreateData` reseponse of login
     */
    apiReservationblockElCreate: (
      data: {
        hospitalID?: string;
        sheetID?: string;
        columnID?: string;
        /** @default "2022-09-06T12:00:00.000+0900" */
        startedAt?: string;
        /** @default "2022-09-06T12:20:00.000+0900" */
        endedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationblockElCreateData, any>({
        path: `/v2/api/reservationblock/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationBlock
     * @name ApiReservationblockElUpdate
     * @summary 예약 객체의 업데이트
     * @request POST:/v2/api/reservationblock/el/update
     * @secure
     * @response `200` `ApiReservationblockElUpdateData` reseponse of login
     */
    apiReservationblockElUpdate: (
      data: {
        _id: string;
        sheetID?: string;
        columnID?: string;
        hospitalID?: string;
        startedAt: string;
        endedAt: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationblockElUpdateData, any>({
        path: `/v2/api/reservationblock/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationBlock
     * @name ApiReservationblockElRemove
     * @summary 예약금지 객체의 삭제
     * @request POST:/v2/api/reservationblock/el/remove
     * @secure
     * @response `200` `ApiReservationblockElRemoveData` reseponse of login
     */
    apiReservationblockElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationblockElRemoveData, any>({
        path: `/v2/api/reservationblock/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationBlock
     * @name ApiReservationblockHmFind
     * @summary 예약금지 조회 (애프터닥 관리자 앱)
     * @request GET:/v2/api/reservationblock/hm/find
     * @secure
     * @response `200` `ApiReservationblockHmFindData` \{Memo\} 모델 객체
     */
    apiReservationblockHmFind: (query: ApiReservationblockHmFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationblockHmFindData, any>({
        path: `/v2/api/reservationblock/hm/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationBlock
     * @name ApiReservationblockHmCreate
     * @summary 예약금지 객체의 생성 (애프터닥 관리자 앱)
     * @request POST:/v2/api/reservationblock/hm/create
     * @secure
     * @response `200` `ApiReservationblockHmCreateData` reseponse of login
     */
    apiReservationblockHmCreate: (
      data: {
        hospitalID?: string;
        sheetID?: string;
        columnID?: string;
        /** @default "2022-09-06T12:00:00.000+0900" */
        startedAt?: string;
        /** @default "2022-09-06T12:20:00.000+0900" */
        endedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationblockHmCreateData, any>({
        path: `/v2/api/reservationblock/hm/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationBlock
     * @name ApiReservationblockHmUpdate
     * @summary 예약 객체의 업데이트 (애프터닥 관리자 앱)
     * @request POST:/v2/api/reservationblock/hm/update
     * @secure
     * @response `200` `ApiReservationblockHmUpdateData` reseponse of login
     */
    apiReservationblockHmUpdate: (
      data: {
        _id: string;
        sheetID?: string;
        columnID?: string;
        hospitalID?: string;
        startedAt: string;
        endedAt: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationblockHmUpdateData, any>({
        path: `/v2/api/reservationblock/hm/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservationBlock
     * @name ApiReservationblockHmRemove
     * @summary 예약금지 객체의 삭제 (애프터닥 관리자 앱)
     * @request POST:/v2/api/reservationblock/hm/remove
     * @secure
     * @response `200` `ApiReservationblockHmRemoveData` reseponse of login
     */
    apiReservationblockHmRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationblockHmRemoveData, any>({
        path: `/v2/api/reservationblock/hm/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 시트별, 일자별 유일. sheetID, date 두가지의 값을 이용하여 조회
     *
     * @tags ReservationSheetDateNote
     * @name ApiReservationsheetdatenoteElFind
     * @summary 시트의 일자별 노트
     * @request GET:/v2/api/reservationsheetdatenote/el/find
     * @secure
     * @response `200` `ApiReservationsheetdatenoteElFindData` response of ReservationSheetNote List
     */
    apiReservationsheetdatenoteElFind: (query: ApiReservationsheetdatenoteElFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationsheetdatenoteElFindData, any>({
        path: `/v2/api/reservationsheetdatenote/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 시트별, 일자별 유일. sheetID, date 두가지의 값을 이용하여 조회
     *
     * @tags ReservationSheetDateNote
     * @name ApiReservationsheetdatenoteElFindOne
     * @summary 시트의 일자별 노트
     * @request GET:/v2/api/reservationsheetdatenote/el/find/one
     * @secure
     * @response `200` `ApiReservationsheetdatenoteElFindOneData` response of ReservationSheetNote List
     */
    apiReservationsheetdatenoteElFindOne: (
      query: ApiReservationsheetdatenoteElFindOneParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationsheetdatenoteElFindOneData, any>({
        path: `/v2/api/reservationsheetdatenote/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description hospiatlID, sheetID, date 세가지를 기준으로 upsert 동작.
     *
     * @tags ReservationSheetDateNote
     * @name ApiReservationsheetdatenoteElUpdate
     * @summary 시트의 일자별 노트 업데이트
     * @request POST:/v2/api/reservationsheetdatenote/el/update
     * @secure
     * @response `200` `ApiReservationsheetdatenoteElUpdateData` \{ReservationSheetDateNote\} ReservationSheetDateNote 객체
     */
    apiReservationsheetdatenoteElUpdate: (
      data: {
        /** required */
        sheetID?: string;
        /** required */
        hospitalID?: string;
        /** @default "2022-12-25T00:00:00.000+0900" */
        date?: Date;
        /** required */
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationsheetdatenoteElUpdateData, any>({
        path: `/v2/api/reservationsheetdatenote/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 싱글톤처럼 동작. _id, userID, hospitalID 혹은 hserviceID를 기준으로 조회. 배열형태로 리턴되나, 단일 객체여야 함. 만약 오류로 인하여 배열이 리턴된 경우 0번 인덱스 이용.
     *
     * @tags ReservationUserNote
     * @name ApiReservationusernoteElFind
     * @summary 유저의 예약 노트.
     * @request GET:/v2/api/reservationusernote/el/find
     * @secure
     * @response `200` `ApiReservationusernoteElFindData` response of ReservationUserNote List
     */
    apiReservationusernoteElFind: (query: ApiReservationusernoteElFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationusernoteElFindData, any>({
        path: `/v2/api/reservationusernote/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description userID, hospiatlID, hserviceID 세가지를 기준으로 upsert 동작
     *
     * @tags ReservationUserNote
     * @name ApiReservationusernoteElUpdate
     * @summary 유저의 예약 노트 업데이트
     * @request POST:/v2/api/reservationusernote/el/update
     * @secure
     * @response `200` `ApiReservationusernoteElUpdateData` reseponse of login
     */
    apiReservationusernoteElUpdate: (
      data: {
        userID?: string;
        hospitalID?: string;
        hserviceID?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiReservationusernoteElUpdateData, any>({
        path: `/v2/api/reservationusernote/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 싱글톤처럼 동작. _id, userID, hospitalID 혹은 hserviceID를 기준으로 조회. 배열형태로 리턴되나, 단일 객체여야 함. 만약 오류로 인하여 배열이 리턴된 경우 0번 인덱스 이용.
     *
     * @tags ReservationUserNote
     * @name ApiReservationusernoteHmFind
     * @summary 유저의 예약 노트 (애프터닥 관리자 앱)
     * @request GET:/v2/api/reservationusernote/hm/find
     * @secure
     * @response `200` `ApiReservationusernoteHmFindData` response of ReservationUserNote List
     */
    apiReservationusernoteHmFind: (query: ApiReservationusernoteHmFindParams, params: RequestParams = {}) =>
      this.request<ApiReservationusernoteHmFindData, any>({
        path: `/v2/api/reservationusernote/hm/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags h_Reservation
     * @name ApiHreservationElFind
     * @summary parentID 를 통한 예약 객체 히스토리 조회
     * @request GET:/v2/api/hreservation/el/find
     * @secure
     * @response `200` `ApiHreservationElFindData` response of h_Reservation List
     */
    apiHreservationElFind: (query: ApiHreservationElFindParams, params: RequestParams = {}) =>
      this.request<ApiHreservationElFindData, any>({
        path: `/v2/api/hreservation/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags h_Reservation
     * @name ApiHreservationHmFind
     * @summary parentID 를 통한 예약 객체 히스토리 조회 (애프터닥 관리자 앱)
     * @request GET:/v2/api/hreservation/hm/find
     * @secure
     * @response `200` `ApiHreservationHmFindData` response of h_Reservation List
     */
    apiHreservationHmFind: (query: ApiHreservationHmFindParams, params: RequestParams = {}) =>
      this.request<ApiHreservationHmFindData, any>({
        path: `/v2/api/hreservation/hm/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTag
     * @name ApiUsertagElFind
     * @summary 고객 태그 조회
     * @request GET:/v2/api/usertag/el/find
     * @secure
     * @response `200` `ApiUsertagElFindData` response of Service Setting Models
     */
    apiUsertagElFind: (query: ApiUsertagElFindParams, params: RequestParams = {}) =>
      this.request<ApiUsertagElFindData, any>({
        path: `/v2/api/usertag/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTag
     * @name ApiUsertagElCreate
     * @summary 유저 태그 생성
     * @request POST:/v2/api/usertag/el/create
     * @secure
     * @response `200` `ApiUsertagElCreateData` create videocontent document
     */
    apiUsertagElCreate: (
      data: {
        /** 병원 ID */
        hospitalID?: string;
        /** 태그 이름 */
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiUsertagElCreateData, any>({
        path: `/v2/api/usertag/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTag
     * @name ApiUsertagElUpdate
     * @summary 유저 태그 삭제
     * @request POST:/v2/api/usertag/el/update
     * @secure
     * @response `200` `ApiUsertagElUpdateData` create videocontent document
     */
    apiUsertagElUpdate: (
      data: {
        /** 수정하고자 하는 tag의 아이디 */
        _id?: string;
        /** 병원 ID */
        hospitalID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiUsertagElUpdateData, any>({
        path: `/v2/api/usertag/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTag
     * @name ApiUsertagElRemove
     * @summary 유저 태그 삭제
     * @request POST:/v2/api/usertag/el/remove
     * @secure
     * @response `200` `ApiUsertagElRemoveData` create videocontent document
     */
    apiUsertagElRemove: (
      data: {
        /** 태그 ID */
        _id?: string;
        /** 병원 ID */
        hospitalID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiUsertagElRemoveData, any>({
        path: `/v2/api/usertag/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContent
     * @name ApiVideocontentEl
     * @summary 운동콘텐츠 목록 조회
     * @request GET:/v2/api/videocontent/el
     * @secure
     * @response `200` `ApiVideocontentElData` \[\{VideoContent\}\] 운동콘텐츠 컬렉션 객체 배열
     */
    apiVideocontentEl: (query: ApiVideocontentElParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentElData, any>({
        path: `/v2/api/videocontent/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContent
     * @name ApiVideocontentElCreate
     * @summary 운동콘텐츠 신규 생성
     * @request POST:/v2/api/videocontent/el/create
     * @secure
     * @response `200` `ApiVideocontentElCreateData` \{VideoContent\} 운동콘텐츠 컬렉션 객체
     */
    apiVideocontentElCreate: (
      data: {
        /** 운동콘텐츠 제목 */
        title?: string;
        /** 운동콘텐츠 부제목 */
        subtitle?: string;
        categories?: string[];
        searchKeyword?: string[];
        /** 운동종류 ex) 마사지, 스트레칭, ... */
        exerciseType?: string;
        /** 자극부위 ex) 흉쇄유돌근, 사각근, ... */
        stimulateMuscles?: string;
        /** 자극부위 이미지 ID. */
        stimulateMusclesImageID?: string;
        /** 운동 정보 */
        description?: string;
        /** 관련 질환. ex) 거북목, 족저근막염, ... */
        relatedDiseases?: string;
        exerciseSet?: {
          /** 운동 구성 제목 */
          title?: string;
          /** 운동 구성 제목(영문) */
          titleEn?: string;
          /** 운동 구성 설명 */
          description?: string;
          /** 운동 구성 썸네일 이미지 ObjectId */
          thumbnailFileID?: string;
          /** 운동 챕터 timestamp (단위 - ms, 밀리초) */
          timestamp?: number;
        }[];
        material?: {
          /** 준비물 명칭 */
          name?: string;
          /** 준비물 썸네일 이미지 ObjectId */
          thumbnailFileID?: string;
        }[];
        /** 주의사항 */
        precaution?: string;
        /** 일주일 중 실천할 횟수 (주 n회) */
        default_DoPerWeek?: number;
        /** 처방기간 (n주 동안 진행) */
        default_Duration?: number;
        /** 기본 운동 콘텐츠 코멘트 */
        default_Message?: string;
        /** 운동 처방 대표 썸네일 파일 ObjectId */
        thumbnailFileID?: string;
        /** 실제 영상 정보가 있는 HLSVideo의 ObjectId */
        videoFileID?: string;
        /** 운동 콘텐츠가 세부동작인지 아닌지를 체크하는 boolean flag. 세부동작일 경우 true */
        isDetail?: boolean;
        /**
         * 총 운동 재생시간 (ISODate 타입)
         * @default "1970-01-01T09:02:30.000+09:00"
         */
        totalVideoLengthDatetime?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontentElCreateData, any>({
        path: `/v2/api/videocontent/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContent
     * @name ApiVideocontentElUpdate
     * @summary 운동콘텐츠 수정
     * @request POST:/v2/api/videocontent/el/update
     * @secure
     * @response `200` `ApiVideocontentElUpdateData` \{VideoContent\} 운동콘텐츠 컬렉션 객체
     */
    apiVideocontentElUpdate: (
      data: {
        /** 업데이트 할 운동콘텐츠 ObjectId */
        vcID?: string;
        /** 운동콘텐츠 제목 */
        title?: string;
        categories?: string[];
        /** 운동종류 ex) 마사지, 스트레칭, ... */
        exerciseType?: string;
        /** 자극부위 ex) 흉쇄유돌근, 사각근, ... */
        stimulateMuscles?: string;
        /** 운동 정보 */
        description?: string;
        /** 관련 질환. ex) 거북목, 족저근막염, ... */
        relatedDiseases?: string;
        exerciseSet?: {
          /** 세부동작 제목 */
          title?: string;
          /** 세부동작 설명 */
          description?: string;
          /** 세부동작 썸네일 이미지 ObjectId */
          thumbnailFileID?: string;
          /** 운동 챕터 timestamp (단위 - ms, 밀리초) */
          timestamp?: number;
        }[];
        material?: {
          /** 준비물 명칭 */
          name?: string;
          /** 준비물 썸네일 이미지 ObjectId */
          thumbnailFileID?: string;
        }[];
        /** 주의사항 */
        precaution?: string;
        /** 일주일 중 실천할 횟수 (주 n회) */
        default_DoPerWeek?: number;
        /** 처방기간 (n주 동안 진행) */
        default_Duration?: number;
        /** 기본 운동 콘텐츠 코멘트 */
        default_Message?: string;
        /** 운동 처방 대표 썸네일 파일 ObjectId */
        thumbnailFileID?: string;
        /** 실제 영상 정보가 있는 HLSVideo의 ObjectId */
        videoFileID?: string;
        /** 운동 콘텐츠가 세부동작인지 아닌지를 체크하는 boolean flag. 세부동작일 경우 true */
        isDetail?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontentElUpdateData, any>({
        path: `/v2/api/videocontent/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContent
     * @name ApiVideocontentElRemove
     * @summary 운동콘텐츠 삭제
     * @request POST:/v2/api/videocontent/el/remove
     * @secure
     * @response `200` `ApiVideocontentElRemoveData` \{VideoContent\} 운동콘텐츠 컬렉션 객체
     */
    apiVideocontentElRemove: (
      data: {
        /** 삭제할 운동콘텐츠 ObjectId */
        vcID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontentElRemoveData, any>({
        path: `/v2/api/videocontent/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceSetting
     * @name ApiServicesettingElFind
     * @summary 서비스 설정(ServiceSetting) 조회
     * @request GET:/v2/api/servicesetting/el/find
     * @secure
     * @response `200` `ApiServicesettingElFindData` response of Service Setting Models
     */
    apiServicesettingElFind: (query: ApiServicesettingElFindParams, params: RequestParams = {}) =>
      this.request<ApiServicesettingElFindData, any>({
        path: `/v2/api/servicesetting/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceSetting
     * @name ApiServicesettingElFindOne
     * @summary 서비스 설정(ServiceSetting) 조회
     * @request GET:/v2/api/servicesetting/el/find/one
     * @secure
     * @response `200` `ApiServicesettingElFindOneData` response of Service Setting Models
     */
    apiServicesettingElFindOne: (query: ApiServicesettingElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiServicesettingElFindOneData, any>({
        path: `/v2/api/servicesetting/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceSetting
     * @name ApiServicesettingElCreate
     * @summary 서비스 설정(ServiceSetting) 생성
     * @request POST:/v2/api/servicesetting/el/create
     * @secure
     * @response `200` `ApiServicesettingElCreateData` update treatmentcategory document
     */
    apiServicesettingElCreate: (
      data: {
        name?: string;
        /** 치료 카테고리 오브젝트. 미작성된 경우 생성하고자 하는 오브젝트 삽입 */
        treatmentCategories?: Record<string, any>[];
        /** 초진, 재진 구분 사용 여부 */
        usingFirstVisit?: boolean;
        /** 초진일 입력 여부 */
        usingStartDate?: boolean;
        /** 가입 직후 최초 영상 카테고리별 자동 전달을 사용할 카테고리 아이디 */
        usingAutoSendVideo?: string[];
        /** 디폴트 이행기간, object array */
        videoContentDuration?: string[];
        /** 운동콘텐츠 전송 시 사용할 기본 코멘트 */
        defaultVCMessage?: string;
        /** 해당 설정이 소속된 병원의 ID */
        hospitalID?: string;
        /** 자동발송에 사용할 첫 번째 병원 운동콘텐츠 ObjectId */
        selectedFirstVCH?: string;
        /** 자동발송에 두 번째 병원 운동콘텐츠 ObjectId */
        selectedSecondVCH?: string;
        /** 기본 콘텐츠 전송 시 함께 전달될 문구 */
        firstVCUMessage?: string;
        /** 두 번째 기본 콘텐츠 전송 시 함께 전달될 문구. 예 - 1일 3시간 뒤 */
        secondVCUMessage?: string;
        /**
         * 첫 번째 콘텐츠 발송시간 기준, 두 번째(또는 다음) 콘텐츠 발송시간
         * @default "1970-01-01T03:00:00.000Z"
         */
        sendVCInterval?: string;
        /** 운동콘텐츠 뱃지 출력을 위한 최소 공유 횟수 */
        vcuBadge?: number;
        /** 삭제 여부 */
        isRemoved?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiServicesettingElCreateData, any>({
        path: `/v2/api/servicesetting/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceSetting
     * @name ApiServicesettingElUpdate
     * @summary 서비스 설정(ServiceSetting) 수정
     * @request POST:/v2/api/servicesetting/el/update
     * @secure
     * @response `200` `ApiServicesettingElUpdateData` update treatmentcategory document
     */
    apiServicesettingElUpdate: (
      data: {
        /** Service Setting Object ID */
        _id?: string;
        /** 수정하고자 하는 병원 ID */
        hospitalID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiServicesettingElUpdateData, any>({
        path: `/v2/api/servicesetting/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceSetting
     * @name ApiServicesettingHmFindOne
     * @summary 서비스 설정(ServiceSetting) 조회 (애프터닥 관리자 앱)
     * @request GET:/v2/api/servicesetting/hm/find/one
     * @secure
     * @response `200` `ApiServicesettingHmFindOneData` \{ServiceSetting\} 객체
     */
    apiServicesettingHmFindOne: (query: ApiServicesettingHmFindOneParams, params: RequestParams = {}) =>
      this.request<ApiServicesettingHmFindOneData, any>({
        path: `/v2/api/servicesetting/hm/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags IntegrationSetting
     * @name ApiIntegrationsettingElFind
     * @summary 연동 설정(IntegrationSetting) 조회
     * @request GET:/v2/api/integrationsetting/el/find
     * @secure
     * @response `200` `ApiIntegrationsettingElFindData` \[\{IntegrationSetting\}\] 연동 정보 객체 배열
     */
    apiIntegrationsettingElFind: (query: ApiIntegrationsettingElFindParams, params: RequestParams = {}) =>
      this.request<ApiIntegrationsettingElFindData, any>({
        path: `/v2/api/integrationsetting/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags IntegrationSetting
     * @name ApiIntegrationsettingElFindOne
     * @summary 연동 설정(IntegrationSetting) 단일 조회
     * @request GET:/v2/api/integrationsetting/el/find/one
     * @secure
     * @response `200` `ApiIntegrationsettingElFindOneData` \{IntegrationSetting\} 연동 정보 객체
     */
    apiIntegrationsettingElFindOne: (query: ApiIntegrationsettingElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiIntegrationsettingElFindOneData, any>({
        path: `/v2/api/integrationsetting/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags IntegrationSetting
     * @name ApiIntegrationsettingElCreate
     * @summary 연동 설정(IntegrationSetting) 생성
     * @request POST:/v2/api/integrationsetting/el/create
     * @secure
     * @response `200` `ApiIntegrationsettingElCreateData` \{IntegrationSetting\} 생성된 연동 정보 객체
     */
    apiIntegrationsettingElCreate: (
      data: {
        /** (required) 병원 ID */
        hospitalID?: string;
        /** 연동 시, 연동사 접근을 위한 access token key 값 */
        clientToken?: string;
        /** 연동사에 대한 정보 */
        integrationType?: string;
        /** 예약 생성 시 기본 라벨, 예약 취소 시 기본 라벨에 대한 정보 외 기타. */
        customObject?: Record<string, any>;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiIntegrationsettingElCreateData, any>({
        path: `/v2/api/integrationsetting/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags IntegrationSetting
     * @name ApiIntegrationsettingElUpdate
     * @summary 연동 설정(IntegrationSetting) 수정
     * @request POST:/v2/api/integrationsetting/el/update
     * @secure
     * @response `200` `ApiIntegrationsettingElUpdateData` \{IntegrationSetting\} 수정된 연동 정보 객체
     */
    apiIntegrationsettingElUpdate: (
      data: {
        /** 연동 설정 ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiIntegrationsettingElUpdateData, any>({
        path: `/v2/api/integrationsetting/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 기본 정렬 순서는 운동 콘텐츠 제목 가나다순. 1. 적합 라벨이 붙은 운동 콘텐츠의 가나다순 2. 적합 라벨이 없는 운동 콘텐츠의 가나다순 3. 적합 라벨이 붙은 세부동작 영상의 가나다순 4. 적합 라벨이 없는 세부동작 영상의 가나다순
     *
     * @tags VideoContentHospital
     * @name ApiVideocontenthospitalEl
     * @summary 병원-커스텀 운동콘텐츠 목록 조회
     * @request GET:/v2/api/videocontenthospital/el
     * @secure
     * @response `200` `ApiVideocontenthospitalElData` \[\{VideoContentHospital\}\] 병원-커스텀 운동콘텐츠 컬렉션 객체 배열
     */
    apiVideocontenthospitalEl: (query: ApiVideocontenthospitalElParams, params: RequestParams = {}) =>
      this.request<ApiVideocontenthospitalElData, any>({
        path: `/v2/api/videocontenthospital/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentHospital
     * @name ApiVideocontenthospitalElCreate
     * @summary 병원-커스텀 운동콘텐츠 신규 생성
     * @request POST:/v2/api/videocontenthospital/el/create
     * @secure
     * @response `200` `ApiVideocontenthospitalElCreateData` \{VideoContentHospital\} 병원-커스텀 운동콘텐츠 컬렉션 객체
     */
    apiVideocontenthospitalElCreate: (
      data: {
        /** 병원-커스텀 운동콘텐츠의 베이스가 될 운동콘텐츠 ID */
        vcID?: string;
        /** 병원 ID */
        hospitalID?: string;
        /** 일주일 중 실천할 횟수 (주 n회) */
        doPerWeek?: number;
        /** 처방기간 (n주 동안 진행) */
        duration?: number;
        /** 운동콘텐츠 코멘트 */
        message?: string;
        /** 적합 라벨링을 유무를 체크하는 boolean flag. '적합'일 경우 true */
        isRecommend?: boolean;
        /** 자동 발송에 사용할 운동 콘텐츠인지 여부를 체크하는 boolean flag. */
        isDefault?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontenthospitalElCreateData, any>({
        path: `/v2/api/videocontenthospital/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 검색어가 일치하는 운동 콘텐츠 표기. 1. 적합 라벨이 붙은 운동 콘텐츠의 가나다순 2. 적합 라벨이 없는 운동 콘텐츠의 가나다순 3. 적합 라벨이 붙은 세부동작 영상의 가나다순 4. 적합 라벨이 없는 세부동작 영상의 가나다순
     *
     * @tags VideoContentHospital
     * @name ApiVideocontenthospitalElFind
     * @summary 병원-커스텀 운동콘텐츠 검색
     * @request GET:/v2/api/videocontenthospital/el/find
     * @secure
     * @response `200` `ApiVideocontenthospitalElFindData` \[\{VideoContentHospital\}\] 병원-커스텀 운동콘텐츠 컬렉션 객체 배열
     */
    apiVideocontenthospitalElFind: (query: ApiVideocontenthospitalElFindParams, params: RequestParams = {}) =>
      this.request<ApiVideocontenthospitalElFindData, any>({
        path: `/v2/api/videocontenthospital/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentHospital
     * @name ApiVideocontenthospitalElDetail
     * @summary 병원-커스텀 운동콘텐츠 상세 조회
     * @request GET:/v2/api/videocontenthospital/el/detail
     * @secure
     * @response `200` `ApiVideocontenthospitalElDetailData` \{VideoContentHospital\} 병원-커스텀 운동콘텐츠 컬렉션 객체
     */
    apiVideocontenthospitalElDetail: (query: ApiVideocontenthospitalElDetailParams, params: RequestParams = {}) =>
      this.request<ApiVideocontenthospitalElDetailData, any>({
        path: `/v2/api/videocontenthospital/el/detail`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description body에서 사용하지 않는 값은 삭제.
     *
     * @tags VideoContentHospital
     * @name ApiVideocontenthospitalElUpdate
     * @summary 병원-커스텀 운동콘텐츠 수정
     * @request POST:/v2/api/videocontenthospital/el/update
     * @secure
     * @response `200` `ApiVideocontenthospitalElUpdateData` \{VideoContentHospital\} 병원-커스텀 운동콘텐츠 컬렉션 객체
     */
    apiVideocontenthospitalElUpdate: (
      data: {
        /** (required) 병원-커스텀 운동콘텐츠 ID */
        vchID?: string;
        /** 일주일 중 실천할 횟수 (주 n회) */
        doPerWeek?: number;
        /** 처방기간 (n주 동안 진행) */
        duration?: number;
        /** 운동콘텐츠 코멘트 */
        message?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontenthospitalElUpdateData, any>({
        path: `/v2/api/videocontenthospital/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description body에서 사용하지 않는 값은 삭제하고 사용(required 제외)
     *
     * @tags VideoContentHospital
     * @name ApiVideocontenthospitalElRecommend
     * @summary 병원-커스텀 운동콘텐츠 적합 라벨링 수정
     * @request POST:/v2/api/videocontenthospital/el/recommend
     * @secure
     * @response `200` `ApiVideocontenthospitalElRecommendData` \{VideoContentHospital\} 병원-커스텀 운동콘텐츠 컬렉션 객체
     */
    apiVideocontenthospitalElRecommend: (
      data: {
        /** (required) 병원-커스텀 운동콘텐츠 ID */
        vchID?: string;
        /** 적합 라벨링을 유무를 체크하는 boolean flag. '적합'일 경우 true */
        isRecommend?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontenthospitalElRecommendData, any>({
        path: `/v2/api/videocontenthospital/el/recommend`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentHospital
     * @name ApiVideocontenthospitalElRemove
     * @summary 병원-커스텀 운동콘텐츠 삭제
     * @request POST:/v2/api/videocontenthospital/el/remove
     * @secure
     * @response `200` `ApiVideocontenthospitalElRemoveData` \{VideoContentHospital\} 병원-커스텀 운동콘텐츠 컬렉션 객체
     */
    apiVideocontenthospitalElRemove: (
      data: {
        /** 병원-커스텀 운동콘텐츠 ID */
        vchID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontenthospitalElRemoveData, any>({
        path: `/v2/api/videocontenthospital/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentHospital
     * @name ApiVideocontenthospitalElPlay
     * @summary VideoContentHospital 내 vchID의 재생 URL
     * @request GET:/v2/api/videocontenthospital/el/play
     * @secure
     * @response `200` `ApiVideocontenthospitalElPlayData` list of m3u8 file
     */
    apiVideocontenthospitalElPlay: (query: ApiVideocontenthospitalElPlayParams, params: RequestParams = {}) =>
      this.request<ApiVideocontenthospitalElPlayData, any>({
        path: `/v2/api/videocontenthospital/el/play`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentHospital
     * @name ApiVideocontenthospitalElPlaysub
     * @summary VideoContentHospital 내 videoFileID의 Detail 재생 URL
     * @request GET:/v2/api/videocontenthospital/el/playsub
     * @secure
     * @response `200` `ApiVideocontenthospitalElPlaysubData` detail list of m3u8 file
     */
    apiVideocontenthospitalElPlaysub: (query: ApiVideocontenthospitalElPlaysubParams, params: RequestParams = {}) =>
      this.request<ApiVideocontenthospitalElPlaysubData, any>({
        path: `/v2/api/videocontenthospital/el/playsub`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserEl
     * @summary 고객별 운동콘텐츠 목록 조회
     * @request GET:/v2/api/videocontentuser/el
     * @secure
     * @response `200` `ApiVideocontentuserElData` \[\{VideoContentUser\}\] 고객 운동콘텐츠 컬렉션 객체 배열
     */
    apiVideocontentuserEl: (query: ApiVideocontentuserElParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentuserElData, any>({
        path: `/v2/api/videocontentuser/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 고객 운동콘텐츠를 모두 조회한다. 조회해올 때 가져오는 값은, \ 공유 수(shareCount), \ 공유를 통한 신환 예약 (guestReservationCount) \ 조회 수 - 이행 완료 수(viewCount) \ 처방 기간(duration) \ 일주일 중 실천 횟수(doPerWeek) \ 이행률 = 이행 완료 수 / (처방 기간 x 일주일 중 실천 횟수)
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserElFindstats
     * @summary 고객 운동콘텐츠 통계 조회
     * @request GET:/v2/api/videocontentuser/el/findstats
     * @secure
     * @response `200` `ApiVideocontentuserElFindstatsData` \[\{VideoContentUser\}\] 고객 운동콘텐츠 컬렉션 객체 배열
     */
    apiVideocontentuserElFindstats: (query: ApiVideocontentuserElFindstatsParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentuserElFindstatsData, any>({
        path: `/v2/api/videocontentuser/el/findstats`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserElCreate
     * @summary 고객 운동콘텐츠 신규 생성
     * @request POST:/v2/api/videocontentuser/el/create
     * @secure
     * @response `200` `ApiVideocontentuserElCreateData` \[\{VideoContentUser\}\] 고객 운동콘텐츠 컬렉션 객체 배열
     */
    apiVideocontentuserElCreate: (
      data: {
        vchIDs?: {
          /** 고객에게 처방 내릴 병원-커스텀 운동콘텐츠 ID */
          vchID?: string;
          /** 일주일 중 실천할 횟수 (주 n회) */
          doPerWeek?: number;
          /** 처방기간 (n주 동안 진행) */
          duration?: number;
        }[];
        /** 병원 ID */
        hospitalID?: string;
        targetUsers?: {
          /** 고객의 유저 ID */
          userID?: string;
          /** 고객의 병원서비스 ID */
          hserviceID?: string;
        }[];
        /** 자동 발송일 경우 true로 작성. 이 때, lastVCUEndDate 를 업데이트 하지 않음. */
        isAutoSend?: boolean;
        /** 고객 운동콘텐츠 코멘트 */
        message?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontentuserElCreateData, any>({
        path: `/v2/api/videocontentuser/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description ## 이행률 = 이행 완료 수 / (처방 기간 x 일주일 중 실천 횟수) - 이행 완료 수 : completeViewCount - 처방 기간 : duration - 일주일 중 실천 횟수 : doPerWeek
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserElDetail
     * @summary 고객 운동콘텐츠의 상세 조회
     * @request GET:/v2/api/videocontentuser/el/detail
     * @secure
     * @response `200` `ApiVideocontentuserElDetailData` \{VideoContentUser\} 고객 운동콘텐츠 컬렉션 객체
     */
    apiVideocontentuserElDetail: (query: ApiVideocontentuserElDetailParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentuserElDetailData, any>({
        path: `/v2/api/videocontentuser/el/detail`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description body에서 사용하지 않는 값은 삭제.
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserElUpdate
     * @summary 고객 운동콘텐츠 수정
     * @request POST:/v2/api/videocontentuser/el/update
     * @secure
     * @response `200` `ApiVideocontentuserElUpdateData` \{VideoContentUser\} 고객 운동콘텐츠 컬렉션 객체
     */
    apiVideocontentuserElUpdate: (
      data: {
        /** 고객 운동콘텐츠 ID */
        vcuID?: string;
        /** 일주일 중 실천할 횟수 (주 n회) */
        doPerWeek?: number;
        /** 처방기간 (n주 동안 진행) */
        duration?: number;
        /** 고객 운동콘텐츠 코멘트 */
        message?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontentuserElUpdateData, any>({
        path: `/v2/api/videocontentuser/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserElRemove
     * @summary 고객 운동콘텐츠 삭제
     * @request POST:/v2/api/videocontentuser/el/remove
     * @secure
     * @response `200` `ApiVideocontentuserElRemoveData` \{VideoContentUser\} 고객 운동콘텐츠 컬렉션 객체
     */
    apiVideocontentuserElRemove: (
      data: {
        /** 고객 운동콘텐츠 ID */
        vcuID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontentuserElRemoveData, any>({
        path: `/v2/api/videocontentuser/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserM
     * @summary 고객별 홈케어 콘텐츠 목록 조회 (mobile)
     * @request GET:/v2/api/videocontentuser/m
     * @secure
     * @response `200` `ApiVideocontentuserMData` \[\{VideoContentUser\}\] 고객 운동콘텐츠 컬렉션 객체 배열
     */
    apiVideocontentuserM: (query: ApiVideocontentuserMParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentuserMData, any>({
        path: `/v2/api/videocontentuser/m`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description ## 이행률 = 이행 완료 수 / (처방 기간 x 일주일 중 실천 횟수) - 이행 완료 수 : completeViewCount - 처방 기간 : duration - 일주일 중 실천 횟수 : doPerWeek
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserMDetail
     * @summary 고객 운동콘텐츠 상세 조회 (mobile)
     * @request GET:/v2/api/videocontentuser/m/detail
     * @secure
     * @response `200` `ApiVideocontentuserMDetailData` \{VideoContentUser\} 고객 운동콘텐츠 컬렉션 객체
     */
    apiVideocontentuserMDetail: (query: ApiVideocontentuserMDetailParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentuserMDetailData, any>({
        path: `/v2/api/videocontentuser/m/detail`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description ### 고객에게 전송된 홈케어 콘텐츠 검색 결과 목록을 조회. - hserviceID 필수. - categoryID를 비워둘 경우 전체 조회. - keyword 입력 시 title / subtitle / categoryName 내용 검색
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserMFind
     * @summary 고객 홈케어 콘텐츠 검색
     * @request GET:/v2/api/videocontentuser/m/find
     * @secure
     * @response `200` `ApiVideocontentuserMFindData` \[\{VideoContentUser\}\] 고객 운동콘텐츠 컬렉션 객체 배열
     */
    apiVideocontentuserMFind: (query: ApiVideocontentuserMFindParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentuserMFindData, any>({
        path: `/v2/api/videocontentuser/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description ### 고객에게 전송된 홈케어 콘텐츠 검색 결과 갯수를 조회. - hserviceID 필수. - categoryID를 비워둘 경우 전체 조회. - keyword 입력 시 title / subtitle / categoryName 내용 검색
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserMFindCount
     * @summary 고객 홈케어 콘텐츠 검색 결과 갯수
     * @request GET:/v2/api/videocontentuser/m/find/count
     * @secure
     * @response `200` `ApiVideocontentuserMFindCountData` VideoContentUser 컬렉션 문서 수 (Number)
     */
    apiVideocontentuserMFindCount: (query: ApiVideocontentuserMFindCountParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentuserMFindCountData, any>({
        path: `/v2/api/videocontentuser/m/find/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserMPlay
     * @summary VideoContentUser 내 vcuID의 재생 URL
     * @request GET:/v2/api/videocontentuser/m/play
     * @secure
     * @response `200` `ApiVideocontentuserMPlayData` list of m3u8 file
     */
    apiVideocontentuserMPlay: (query: ApiVideocontentuserMPlayParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentuserMPlayData, any>({
        path: `/v2/api/videocontentuser/m/play`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserMPlaysub
     * @summary VideoContentUser 내 videoFileID의 Detail 재생 URL
     * @request GET:/v2/api/videocontentuser/m/playsub
     * @secure
     * @response `200` `ApiVideocontentuserMPlaysubData` detail list of m3u8 file
     */
    apiVideocontentuserMPlaysub: (query: ApiVideocontentuserMPlaysubParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentuserMPlaysubData, any>({
        path: `/v2/api/videocontentuser/m/playsub`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description - 최초 열람 시 해당 API 호출. - isRead를 true로 발송
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserMUpdateRead
     * @summary 고객 운동콘텐츠 최초 열람 플래그 수정
     * @request POST:/v2/api/videocontentuser/m/update/read
     * @secure
     * @response `200` `ApiVideocontentuserMUpdateReadData` \{VideoContentUser\} 고객 운동콘텐츠 컬렉션 객체
     */
    apiVideocontentuserMUpdateRead: (
      data: {
        /** (required) 고객 운동콘텐츠의 ObjectID */
        vcuID?: string;
        /** (required) 최초 열람 여부를 체크하는 boolean flag. */
        isRead?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontentuserMUpdateReadData, any>({
        path: `/v2/api/videocontentuser/m/update/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description - 운동콘텐츠 재생 시점이 90% 이후 해당 API 호출. - completeViewCount가 1 증가한 고객 운동콘텐츠 상세 조회
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserMUpdateCv
     * @summary 고객 운동콘텐츠 이행 완료 카운트 증가
     * @request POST:/v2/api/videocontentuser/m/update/cv
     * @secure
     * @response `200` `ApiVideocontentuserMUpdateCvData` \{VideoContentUser\} 고객 운동콘텐츠 컬렉션 객체
     */
    apiVideocontentuserMUpdateCv: (
      data: {
        /** (required) 고객에게 처방된 고객 운동콘텐츠의 ObjectID */
        vcuID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontentuserMUpdateCvData, any>({
        path: `/v2/api/videocontentuser/m/update/cv`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description - 운동콘텐츠 재생 시점이 30% 이후 해당 API 호출. - partViewCount가 1 증가한 고객 운동콘텐츠 상세 조회
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserMUpdatePv
     * @summary 고객 운동콘텐츠 부분 시청 완료 카운트 증가
     * @request POST:/v2/api/videocontentuser/m/update/pv
     * @secure
     * @response `200` `ApiVideocontentuserMUpdatePvData` \{VideoContentUser\} 고객 운동콘텐츠 컬렉션 객체
     */
    apiVideocontentuserMUpdatePv: (
      data: {
        /** (required) 고객에게 처방된 고객 운동콘텐츠의 ObjectID */
        vcuID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontentuserMUpdatePvData, any>({
        path: `/v2/api/videocontentuser/m/update/pv`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentUser
     * @name ApiVideocontentuserMShareimage
     * @summary 고객 운동콘텐츠 상세 페이지 내 배너 이미지 또는 이행완료 후 팝업 이미지 조회 (mobile)
     * @request GET:/v2/api/videocontentuser/m/shareimage
     * @secure
     * @response `200` `ApiVideocontentuserMShareimageData` \{VideoContentGlobalSetting\} 운동콘텐츠 공통 설정 객체
     */
    apiVideocontentuserMShareimage: (params: RequestParams = {}) =>
      this.request<ApiVideocontentuserMShareimageData, any>({
        path: `/v2/api/videocontentuser/m/shareimage`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HistoryUserAction
     * @name ApiHistoryuseractionEl
     * @summary 히스토리 유저액션 로그 목록 조회
     * @request GET:/v2/api/historyuseraction/el
     * @secure
     * @response `200` `ApiHistoryuseractionElData` \[\{HistoryUserAction\}\] 히스토리 유저액션 컬렉션 객체 배열
     */
    apiHistoryuseractionEl: (query: ApiHistoryuseractionElParams, params: RequestParams = {}) =>
      this.request<ApiHistoryuseractionElData, any>({
        path: `/v2/api/historyuseraction/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 전달된 userID && type && hserviceID && vcuID && columnID 가 `action` 한 목록 조회. \ 시작일 startDate, 종료일 endDate 설정하여 기간 설정\ 기본 정렬은 createdAt 내림차순. - **required** - action
     *
     * @tags HistoryUserAction
     * @name ApiHistoryuseractionElFind
     * @summary 히스토리 유저액션 로그 검색
     * @request GET:/v2/api/historyuseraction/el/find
     * @secure
     * @response `200` `ApiHistoryuseractionElFindData` \[\{HistoryUserAction\}\] 히스토리 유저액션 컬렉션 객체 배열
     */
    apiHistoryuseractionElFind: (query: ApiHistoryuseractionElFindParams, params: RequestParams = {}) =>
      this.request<ApiHistoryuseractionElFindData, any>({
        path: `/v2/api/historyuseraction/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description ## 요약 ### 히스토리 유저액션 로그 신규 생성 시 - userID, type, hospitalID, hserviceID(optional), action, vcID, vchID, vcuID(optional) 전달 - action : send, view ### 예약 히스토리 로그 신규 생성 시 - userID, type, hospitalID, hserviceID, action, reservationID, columnID, sheetID, programID, startedAt, endedAt 전달 - action : reservation, cancelReservation ## 공통 ### 유저 관련 정보 - 현재 로그인된 유저의 ID 및 유저 타입. userID가 있는 경우 입력. 게스트는 빈 칸 입력. - **required** - type - optional - userID ### 병원 관련 정보 - 병원 관련된 병원 ID 전송. hserviceID는 있는 경우 입력. - **required** - hospitalID - optional - hserviceID ### 사용자 수행 동작 - 사용자가 수행한 동작을 아래 옵션중 하나 선택하여 문자열로 입력. - **send** (병원 관계자가 고객에게 운동콘텐츠를 `전송`) - **view** (병원 관계자 운동콘텐츠를 `재생` 또는 고객이 `운동 시작` 버튼을 눌러 운동콘텐츠 플레이 화면으로 진입) - **completeView** (고객이 운동콘텐츠를 90% 이상 `시청`) - **share** (고객이 `운동 공유` 버튼 선택) - **guestReservation** (외부 공유된 URL에서 게스트가 `예약 문의하기` 버튼 선택) - **userReservation** (고객이 `예약`한 경우) - **cancelReservation** (고객이 `예약 취소`한 경우) - **required** - action ## 운동콘텐츠 로그 ### 운동콘텐츠 ID - 재생한 영상에 포함된 vcID, vchID, vcuID를 입력. - optional - vcID, vchID, vcuID ## 예약 로그 ### 예약 관련 ID 및 치료 시간 정보 - 예약 ID 및 column, sheet, programID 와 실제 예약 시작 시간 ~ 치료 종료 시간을 입력. - optional - reservationID, columnID, sheetID, programID, startedAt, endedAt
     *
     * @tags HistoryUserAction
     * @name ApiHistoryuseractionElCreate
     * @summary 히스토리 유저액션 로그 신규 생성
     * @request POST:/v2/api/historyuseraction/el/create
     * @deprecated
     * @secure
     * @response `200` `ApiHistoryuseractionElCreateData` \{HistoryUserAction\} 히스토리 유저액션 컬렉션 객체
     */
    apiHistoryuseractionElCreate: (
      data: {
        /** 유저 ID */
        userID?: string;
        /** (required) 유저 타입 */
        type?: number;
        /** (required) 병원 ID */
        hospitalID?: string;
        /** 병원서비스 ID */
        hserviceID?: string;
        /** (required) 고객이 수행한 동작 (send/view/completeView/share/guestReservation/userReservation/cancelReservation) */
        action?: string;
        /** 운동콘텐츠 ID */
        vcID?: string;
        /** 병원 운동콘텐츠 ID */
        vchID?: string;
        /** 고객 운동콘텐츠 ID */
        vcuID?: string;
        /** 예약 ID */
        reservationID?: string;
        /** 예약이 진행된 Column ID */
        columnID?: string;
        /** 예약이 진행된 Sheet ID */
        sheetID?: string;
        /** 예약된 치료 프로그램 ID */
        programID?: string;
        /**
         * 실제 예약 시간
         * @default "2022-10-04T12:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * 실제 치료가 종료되는 시간
         * @default "2022-10-04T12:20:00.000+0900"
         */
        endedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHistoryuseractionElCreateData, any>({
        path: `/v2/api/historyuseraction/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HistoryUserAction
     * @name ApiHistoryuseractionElUpdate
     * @summary 고객 히스토리 로그 수정
     * @request POST:/v2/api/historyuseraction/el/update
     * @deprecated
     * @secure
     * @response `200` `ApiHistoryuseractionElUpdateData` \{HistoryUserAction\} 히스토리 유저액션 로그 컬렉션 객체
     */
    apiHistoryuseractionElUpdate: (
      data: {
        /** (required) 히스토리 유저액션 로그 ID */
        vcuaID?: string;
        /** 유저 타입 */
        userType?: number;
        /** 사용자가 수행한 동작 (send/view/share/reservation) */
        action?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHistoryuseractionElUpdateData, any>({
        path: `/v2/api/historyuseraction/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HistoryUserAction
     * @name ApiHistoryuseractionElRemove
     * @summary 히스토리 유저액션 로그 삭제
     * @request POST:/v2/api/historyuseraction/el/remove
     * @deprecated
     * @secure
     * @response `200` `ApiHistoryuseractionElRemoveData` \{HistoryUserAction\} 히스토리 유저액션 로그 컬렉션 객체
     */
    apiHistoryuseractionElRemove: (
      data: {
        /** (required) 히스토리 유저액션 로그 ID */
        vcuaID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHistoryuseractionElRemoveData, any>({
        path: `/v2/api/historyuseraction/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description ## 요약 ### 운동콘텐츠 히스토리 로그 신규 생성 시 (mobile) - userID, type, hospitalID, hserviceID, action, vcID, vchID, vcuID 전달 - action : view, completeView, share ### 예약 히스토리 로그 신규 생성 시 (mobile) - userID, type, hospitalID, hserviceID, action, reservationID, columnID, writerID, writerType, sheetID, programID, startedAt, endedAt 전달 - action : reservation, cancelReservation ### 운동콘텐츠 히스토리 로그 신규 생성 시 (shortlink - guest) - type, hospitalID, action, vcID, vchID, vcuID 전달 - action : view, guestReservation ## 공통 ### 유저 관련 정보 - 현재 로그인된 유저의 ID 및 유저 타입. userID가 있는 경우 입력. 게스트는 빈 칸 입력. - **required** - type - optional - userID ### 병원 관련 정보 - 병원 관련된 병원 ID 전송. hserviceID는 있는 경우 입력. - **required** - hospitalID - optional - hserviceID ### 사용자 수행 동작 - 사용자가 수행한 동작을 아래 옵션중 하나 선택하여 문자열로 입력. - **send** (병원 관계자가 고객에게 운동콘텐츠를 `전송`) - **view** (병원 관계자 운동콘텐츠를 `재생` 또는 고객이 `운동 시작` 버튼을 눌러 운동콘텐츠 플레이 화면으로 진입) - **completeView** (고객이 운동콘텐츠를 90% 이상 `시청`) - **share** (고객이 `운동 공유` 버튼 선택) - **guestReservation** (외부 공유된 URL에서 게스트가 `예약 문의하기` 버튼 선택) - **userReservation** (고객이 `예약`한 경우) - **cancelReservation** (고객이 `예약 취소`한 경우) - **required** - action ## 운동콘텐츠 로그 ### 운동콘텐츠 ID - 재생한 영상에 포함된 vcID, vchID, vcuID를 입력. - optional - vcID, vchID, vcuID ## 예약 로그 ### 예약 관련 ID 및 치료 시간 정보 - 예약 ID 및 column, sheet, programID 와 예약의 주체를 구분하기 위한 writerID, writerType, 실제 예약 시작 시간 ~ 치료 종료 시간을 입력. - writerType의 값에 따라 예약의 성질이 달라짐. - 1000 : 유저(환자)가 직접 애프터닥 앱으로 환자 예약을 예약 - 2000 : 병원관계자가 일렉트론에서 환자 예약을 예약 - required - reservationID, columnID, writerID, writerType, sheetID, programID, startedAt, endedAt
     *
     * @tags HistoryUserAction
     * @name ApiHistoryuseractionMCreate
     * @summary 히스토리 유저 액션 로그 신규 생성 (mobile)
     * @request POST:/v2/api/historyuseraction/m/create
     * @deprecated
     * @secure
     * @response `200` `ApiHistoryuseractionMCreateData` \{HistoryUserAction\} 히스토리 유저액션 로그 컬렉션 객체
     */
    apiHistoryuseractionMCreate: (
      data: {
        /** 유저 ID */
        userID?: string;
        /** (required) 유저 타입 */
        type?: number;
        /** (required) 병원 ID */
        hospitalID?: string;
        /** 병원서비스 ID */
        hserviceID?: string;
        /** (required) 고객이 수행한 동작 (send/view/completeView/share/guestReservation) */
        action?: string;
        /**
         * 시청 시작 시간을 ISODate 형태로 입력. 예시값은 1분 39초
         * @default "1970-01-01T00:01:39.000Z"
         */
        viewStartDatetime?: string;
        /** 운동콘텐츠 ID */
        vcID?: string;
        /** 병원 운동콘텐츠 ID */
        vchID?: string;
        /** 고객 운동콘텐츠 ID */
        vcuID?: string;
        /** 예약 ID */
        reservationID?: string;
        /** 예약이 진행된 Column ID */
        columnID?: string;
        /** 예약 작성자 ID */
        writerID?: string;
        /** 예약 작성자 타입 */
        writerType?: number;
        /** 예약이 진행된 Sheet ID */
        sheetID?: string;
        /** 예약된 치료 프로그램 ID */
        programID?: string;
        /**
         * 실제 예약 시간
         * @default "2022-10-04T12:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * 실제 치료가 종료되는 시간
         * @default "2022-10-04T12:20:00.000+0900"
         */
        endedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHistoryuseractionMCreateData, any>({
        path: `/v2/api/historyuseraction/m/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description - isTop, hospitalID 필수. - isTop 이 true 일 경우, 카테고리 대 조회(통증 및 재활, 여성건강, 소아청소년 성장...) - isTop 이 false 이고 parentCategoryIDs가 있는 경우, 해당 부모 카테고리에 속한 운동콘텐츠들을 조회 (통증 및 재활에 속하는 고객 운동콘텐츠들)
     *
     * @tags VideoContentCategory
     * @name ApiVideocontentcategoryEl
     * @summary 운동콘텐츠 카테고리 목록 조회
     * @request GET:/v2/api/videocontentcategory/el
     * @secure
     * @response `200` `ApiVideocontentcategoryElData` \[\{VideoContentCategory\}\] 운동콘텐츠 카테고리 컬렉션 객체 배열
     */
    apiVideocontentcategoryEl: (query: ApiVideocontentcategoryElParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentcategoryElData, any>({
        path: `/v2/api/videocontentcategory/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentCategory
     * @name ApiVideocontentcategoryElCreate
     * @summary 운동콘텐츠 카테고리 신규 생성
     * @request POST:/v2/api/videocontentcategory/el/create
     * @secure
     * @response `200` `ApiVideocontentcategoryElCreateData` \{VideoContentCategory\} 운동콘텐츠 카테고리 컬렉션 객체
     */
    apiVideocontentcategoryElCreate: (
      data: {
        /** 운동콘텐츠 카테고리 명칭 */
        categoryName?: string;
        /** 병원의 ObjectId */
        hospitalID?: string;
        /** 카테고리의 정렬 순서(비워둘 시 기본값 9999) */
        sortNum?: number;
        /** 카테고리 대 여부 boolean */
        isTop?: boolean;
        /** 카테고리 중 여부 boolean */
        isParent?: boolean;
        parentCategoryIDs?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontentcategoryElCreateData, any>({
        path: `/v2/api/videocontentcategory/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentCategory
     * @name ApiVideocontentcategoryElUpdate
     * @summary 운동콘텐츠 카테고리 수정
     * @request POST:/v2/api/videocontentcategory/el/update
     * @secure
     * @response `200` `ApiVideocontentcategoryElUpdateData` \{VideoContentCategory\} 운동콘텐츠 카테고리 컬렉션 객체
     */
    apiVideocontentcategoryElUpdate: (
      data: {
        /** 업데이트 할 운동콘텐츠 카테고리 ObjectId */
        vccID?: string;
        /** 운동콘텐츠 카테고리 명칭 */
        categoryName?: string;
        /** 카테고리의 정렬 순서 */
        sortNum?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontentcategoryElUpdateData, any>({
        path: `/v2/api/videocontentcategory/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoContentCategory
     * @name ApiVideocontentcategoryElRemove
     * @summary 운동콘텐츠 카테고리 삭제
     * @request POST:/v2/api/videocontentcategory/el/remove
     * @secure
     * @response `200` `ApiVideocontentcategoryElRemoveData` \{VideoContentCategory\} 운동콘텐츠 카테고리 컬렉션 객체 배열
     */
    apiVideocontentcategoryElRemove: (
      data: {
        /** 삭제할 운동콘텐츠 카테고리 ObjectId */
        vccID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontentcategoryElRemoveData, any>({
        path: `/v2/api/videocontentcategory/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description - isTop, hospitalID 필수. - isTop 이 true 일 경우, 카테고리 대 조회(통증 및 재활, 여성건강, 소아청소년 성장...) - isTop 이 false 이고 parentCategoryIDs가 있는 경우, 해당 부모 카테고리에 속한 운동콘텐츠들을 조회 (통증 및 재활에 속하는 고객 운동콘텐츠들)
     *
     * @tags VideoContentCategory
     * @name ApiVideocontentcategoryM
     * @summary 운동콘텐츠 카테고리 조회 (mobile)
     * @request GET:/v2/api/videocontentcategory/m
     * @secure
     * @response `200` `ApiVideocontentcategoryMData` \[\{VideoContentCategory\}\] 운동콘텐츠 카테고리 컬렉션 객체 배열
     */
    apiVideocontentcategoryM: (query: ApiVideocontentcategoryMParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentcategoryMData, any>({
        path: `/v2/api/videocontentcategory/m`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 일일 유저(환자)별 Action 횟수 조회. \ - 운동콘텐츠 전송 횟수 - 운동콘텐츠 시청 횟수 - 운동콘텐츠 이행완료 횟수 - 운동콘텐츠 공유 횟수 - 운동콘텐츠 비회원 예약 시도 횟수 - 애프터닥 앱에서 직접 예약한 횟수 - **required** - hospitalID, startDate, endDate
     *
     * @tags Dashboard
     * @name ApiDashboardDailyUserEl
     * @summary 일일 유저(환자)별 운동콘텐츠 관련 Action 횟수 조회
     * @request GET:/v2/api/dashboard/daily/user/el
     * @secure
     * @response `200` `ApiDashboardDailyUserElData` \[\{Stats_DailyUsers\}\] Stats_DailyUsers 컬렉션 객체 배열
     */
    apiDashboardDailyUserEl: (query: ApiDashboardDailyUserElParams, params: RequestParams = {}) =>
      this.request<ApiDashboardDailyUserElData, any>({
        path: `/v2/api/dashboard/daily/user/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 일일 유저(환자)별, 지정한 Action 횟수 순으로 정렬한 유저 목록 조회. ### startDate, endDate 일 단위에 해당하는 시작일, 종료일을 입력. ### limit limit에 값을 입력하여 상위 n명을 조회. limit=10일 경우, Top 10 조회 ### key 정렬할 횟수 명칭을 key 에 입력하여 정렬. \ - viewCount, completeViewCount, shareCount, guestReservationCount, userReservationCount... ex) 외부 공유 횟수 목록 기준 높은 수로 정렬 시, key에 shareCount, way에 -1 입력. - **required** - hospitalID, startDate, endDate, limit, key
     *
     * @tags Dashboard
     * @name ApiDashboardDailyUserElFindtop
     * @summary 일일 유저(환자)별 운동콘텐츠 관련 Action 순위 조회
     * @request GET:/v2/api/dashboard/daily/user/el/findtop
     * @secure
     * @response `200` `ApiDashboardDailyUserElFindtopData` \[\{Stats_DailyUsers\}\] Stats_DailyUsers 컬렉션 객체 배열
     */
    apiDashboardDailyUserElFindtop: (query: ApiDashboardDailyUserElFindtopParams, params: RequestParams = {}) =>
      this.request<ApiDashboardDailyUserElFindtopData, any>({
        path: `/v2/api/dashboard/daily/user/el/findtop`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 일일 담당자(Column)별 Action 횟수 조회. \ - 예약 건수 - 예약 취소 건수 - 예약 시간 - **required** - hospitalID, sheetID, startDate, endDate
     *
     * @tags Dashboard
     * @name ApiDashboardDailyColumnEl
     * @summary 일일 담당자(Column)별 예약 관련 Action 횟수 조회
     * @request GET:/v2/api/dashboard/daily/column/el
     * @secure
     * @response `200` `ApiDashboardDailyColumnElData` \[\{Stats_DailyColumns\}\] Stats_DailyColumns 컬렉션 객체 배열
     */
    apiDashboardDailyColumnEl: (query: ApiDashboardDailyColumnElParams, params: RequestParams = {}) =>
      this.request<ApiDashboardDailyColumnElData, any>({
        path: `/v2/api/dashboard/daily/column/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 일일 담당자(Column)별, 지정한 Action 횟수 순으로 정렬한 유저 목록 조회. ### startDate, endDate 일 단위에 해당하는 시작일, 종료일을 입력. ### limit limit에 값을 입력하여 상위 n명을 조회. limit=10일 경우, Top 10 조회 ### key 정렬할 횟수 명칭을 key 에 입력하여 정렬. \ - userReservationCount, cancelReservationCount, duration... ex) 예약 건수 기준 높은 수로 정렬 시, key에 userReservationCount, way에 -1 입력. - **required** - hospitalID, sheetID, startDate, endDate, limit, key
     *
     * @tags Dashboard
     * @name ApiDashboardDailyColumnElFindtop
     * @summary 일일 담당자(Column)별 예약 관련 Action 순위 조회
     * @request GET:/v2/api/dashboard/daily/column/el/findtop
     * @secure
     * @response `200` `ApiDashboardDailyColumnElFindtopData` \[\{Stats_DailyColumns\}\] Stats_DailyColumns 컬렉션 객체 배열
     */
    apiDashboardDailyColumnElFindtop: (query: ApiDashboardDailyColumnElFindtopParams, params: RequestParams = {}) =>
      this.request<ApiDashboardDailyColumnElFindtopData, any>({
        path: `/v2/api/dashboard/daily/column/el/findtop`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 일일 담당자(Column) 및 프로그램별 Action 횟수 조회. \ - 예약 건수 - 예약 취소 건수 - 예약 시간 - **required** - hospitalID, sheetID, startDate, endDate
     *
     * @tags Dashboard
     * @name ApiDashboardDailyColumnprogramEl
     * @summary 일일 담당자(Column) 및 프로그램별 예약 관련 Action 횟수 조회
     * @request GET:/v2/api/dashboard/daily/columnprogram/el
     * @secure
     * @response `200` `ApiDashboardDailyColumnprogramElData` \[\{Stats_DailyColumnPrograms\}\] Stats_DailyColumnPrograms 컬렉션 객체 배열
     */
    apiDashboardDailyColumnprogramEl: (query: ApiDashboardDailyColumnprogramElParams, params: RequestParams = {}) =>
      this.request<ApiDashboardDailyColumnprogramElData, any>({
        path: `/v2/api/dashboard/daily/columnprogram/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 일일 담당자(Column) 및 프로그램별, 지정한 Action 횟수 순으로 정렬한 유저 목록 조회. ### startDate, endDate 일 단위에 해당하는 시작일, 종료일을 입력. ### limit limit에 값을 입력하여 상위 n명을 조회. limit=10일 경우, Top 10 조회 ### key 정렬할 횟수 명칭을 key 에 입력하여 정렬. \ - userReservationCount, cancelReservationCount, duration... ex) 예약 건수 기준 높은 수로 정렬 시, key에 userReservationCount, way에 -1 입력. - **required** - hospitalID, sheetID, startDate, endDate, limit, key
     *
     * @tags Dashboard
     * @name ApiDashboardDailyColumnprogramElFindtop
     * @summary 일일 담당자(Column) 및 프로그램별 예약 관련 Action 순위 조회
     * @request GET:/v2/api/dashboard/daily/columnprogram/el/findtop
     * @secure
     * @response `200` `ApiDashboardDailyColumnprogramElFindtopData` \[\{Stats_DailyColumnPrograms\}\] Stats_DailyColumnPrograms 컬렉션 객체 배열
     */
    apiDashboardDailyColumnprogramElFindtop: (
      query: ApiDashboardDailyColumnprogramElFindtopParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiDashboardDailyColumnprogramElFindtopData, any>({
        path: `/v2/api/dashboard/daily/columnprogram/el/findtop`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 주간 유저(환자)별 Action 횟수 조회. \ 한 주의 시작요일 bool 값을 반드시 포함. ### isSunday 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작일자로 간주 - 운동콘텐츠 전송 횟수 - 운동콘텐츠 시청 횟수 - 운동콘텐츠 이행완료 횟수 - 운동콘텐츠 공유 횟수 - 운동콘텐츠 비회원 예약 시도 횟수 - 애프터닥 앱에서 직접 예약한 횟수 - **required** - hospitalID, isSunday, startDate, endDate
     *
     * @tags Dashboard
     * @name ApiDashboardWeeklyUserEl
     * @summary 주간 유저(환자)별 운동콘텐츠 관련 Action 횟수 조회
     * @request GET:/v2/api/dashboard/weekly/user/el
     * @secure
     * @response `200` `ApiDashboardWeeklyUserElData` \[\{Stats_WeeklyUsers\}\] Stats_WeeklyUsers 통계 컬렉션 객체 배열
     */
    apiDashboardWeeklyUserEl: (query: ApiDashboardWeeklyUserElParams, params: RequestParams = {}) =>
      this.request<ApiDashboardWeeklyUserElData, any>({
        path: `/v2/api/dashboard/weekly/user/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 주간 유저(환자)별, 설정한 액션 횟수의 크기 순으로 정렬한 유저 목록 조회. 한 주의 시작요일 bool 값을 반드시 포함. ### isSunday 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작일자로 간주 ### startDate, endDate 주 단위에 해당하는 시작일, 종료일을 입력. ### limit limit에 값을 입력하여 상위 n명을 조회. limit=10일 경우, Top 10 조회 ### key 정렬할 횟수 명칭을 key 에 입력하여 정렬. \ - sendCount, viewCount, shareCount, reservationCount, userReservationCount... ex) 외부 공유 횟수 목록 기준 높은 수로 정렬 시, key에 shareCount, way에 -1 입력. - **required** - hospitalID, isSunday, startDate, endDate, limit, key
     *
     * @tags Dashboard
     * @name ApiDashboardWeeklyUserElFindtop
     * @summary 주간 유저(환자)별 운동콘텐츠 관련 Action 순위 조회
     * @request GET:/v2/api/dashboard/weekly/user/el/findtop
     * @secure
     * @response `200` `ApiDashboardWeeklyUserElFindtopData` \[\{Stats_WeeklyUsers\}\] Stats_WeeklyUsers 통계 컬렉션 객체 배열
     */
    apiDashboardWeeklyUserElFindtop: (query: ApiDashboardWeeklyUserElFindtopParams, params: RequestParams = {}) =>
      this.request<ApiDashboardWeeklyUserElFindtopData, any>({
        path: `/v2/api/dashboard/weekly/user/el/findtop`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 주간 담당자(Column)별 Action 횟수 조회. \ 한 주의 시작요일 bool 값을 반드시 포함. ### isSunday 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작일자로 간주 - 예약 건수 - 예약 취소 건수 - 예약 시간 - **required** - hospitalID, startDate, endDate
     *
     * @tags Dashboard
     * @name ApiDashboardWeeklyColumnEl
     * @summary 주간 담당자(Column)별 예약 관련 Action 횟수 조회
     * @request GET:/v2/api/dashboard/weekly/column/el
     * @secure
     * @response `200` `ApiDashboardWeeklyColumnElData` \[\{Stats_WeeklyColumns\}\] Stats_WeeklyColumns 통계 컬렉션 객체 배열
     */
    apiDashboardWeeklyColumnEl: (query: ApiDashboardWeeklyColumnElParams, params: RequestParams = {}) =>
      this.request<ApiDashboardWeeklyColumnElData, any>({
        path: `/v2/api/dashboard/weekly/column/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 주간 담당자(Column)별, 설정한 액션 횟수의 크기 순으로 정렬한 유저 목록 조회. \ 한 주의 시작요일 bool 값을 반드시 포함. ### isSunday 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작일자로 간주 ### startDate, endDate 주 단위에 해당하는 시작일, 종료일을 입력. ### limit limit에 값을 입력하여 상위 n명을 조회. limit=10일 경우, Top 10 조회 ### key 정렬할 횟수 명칭을 key 에 입력하여 정렬. \ - userReservationCount, cancelReservationCount, duration... ex) 예약 건수 기준 높은 수로 정렬 시, key에 userReservationCount, way에 -1 입력. - **required** - hospitalID, isSunday, startDate, endDate, limit, key
     *
     * @tags Dashboard
     * @name ApiDashboardWeeklyColumnElFindtop
     * @summary 주간 담당자(Column) 예약 관련 Action 순위 조회
     * @request GET:/v2/api/dashboard/weekly/column/el/findtop
     * @secure
     * @response `200` `ApiDashboardWeeklyColumnElFindtopData` \[\{Stats_WeeklyColumns\}\] Stats_WeeklyColumns 통계 컬렉션 객체 배열
     */
    apiDashboardWeeklyColumnElFindtop: (query: ApiDashboardWeeklyColumnElFindtopParams, params: RequestParams = {}) =>
      this.request<ApiDashboardWeeklyColumnElFindtopData, any>({
        path: `/v2/api/dashboard/weekly/column/el/findtop`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 주간 담당자(Column) 및 프로그램별 Action 횟수 조회. \ 한 주의 시작요일 bool 값을 반드시 포함. ### isSunday 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작일자로 간주 - 예약 건수 - 예약 취소 건수 - 예약 시간 - **required** - hospitalID, startDate, endDate
     *
     * @tags Dashboard
     * @name ApiDashboardWeeklyColumnprogramEl
     * @summary 주간 담당자(Column) 및 프로그램별 예약 관련 Action 횟수 조회
     * @request GET:/v2/api/dashboard/weekly/columnprogram/el
     * @secure
     * @response `200` `ApiDashboardWeeklyColumnprogramElData` \[\{Stats_WeeklyColumnPrograms\}\] Stats_WeeklyColumnPrograms 통계 컬렉션 객체 배열
     */
    apiDashboardWeeklyColumnprogramEl: (query: ApiDashboardWeeklyColumnprogramElParams, params: RequestParams = {}) =>
      this.request<ApiDashboardWeeklyColumnprogramElData, any>({
        path: `/v2/api/dashboard/weekly/columnprogram/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 주간 담당자(Column) 및 프로그램별, 설정한 액션 횟수의 크기 순으로 정렬한 유저 목록 조회. \ 한 주의 시작요일 bool 값을 반드시 포함. ### isSunday 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작일자로 간주 ### startDate, endDate 주 단위에 해당하는 시작일, 종료일을 입력. ### limit limit에 값을 입력하여 상위 n명을 조회. limit=10일 경우, Top 10 조회 ### key 정렬할 횟수 명칭을 key 에 입력하여 정렬. \ - userReservationCount, cancelReservationCount, duration... ex) 예약 건수 기준 높은 수로 정렬 시, key에 userReservationCount, way에 -1 입력. - **required** - hospitalID, isSunday, startDate, endDate, limit, key
     *
     * @tags Dashboard
     * @name ApiDashboardWeeklyColumnprogramElFindtop
     * @summary 주간 담당자(Column) 및 프로그램별 예약 관련 Action 순위 조회
     * @request GET:/v2/api/dashboard/weekly/columnprogram/el/findtop
     * @secure
     * @response `200` `ApiDashboardWeeklyColumnprogramElFindtopData` \[\{Stats_WeeklyColumnPrograms\}\] Stats_WeeklyColumnPrograms 통계 컬렉션 객체 배열
     */
    apiDashboardWeeklyColumnprogramElFindtop: (
      query: ApiDashboardWeeklyColumnprogramElFindtopParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiDashboardWeeklyColumnprogramElFindtopData, any>({
        path: `/v2/api/dashboard/weekly/columnprogram/el/findtop`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 월간 유저(환자)별 Action 횟수 조회. \ - 운동콘텐츠 전송 횟수 - 운동콘텐츠 시청 횟수 - 운동콘텐츠 이행완료 횟수 - 운동콘텐츠 공유 횟수 - 운동콘텐츠 비회원 예약 시도 횟수 - 애프터닥 앱에서 직접 예약한 횟수 - **required** - hospitalID, startDate, endDate
     *
     * @tags Dashboard
     * @name ApiDashboardMonthlyUserEl
     * @summary 월간 유저(환자)별 운동콘텐츠 관련 Action 횟수 조회
     * @request GET:/v2/api/dashboard/monthly/user/el
     * @secure
     * @response `200` `ApiDashboardMonthlyUserElData` \[\{Stats_MonthlyUsers\}\] Stats_MonthlyUsers 컬렉션 객체 배열
     */
    apiDashboardMonthlyUserEl: (query: ApiDashboardMonthlyUserElParams, params: RequestParams = {}) =>
      this.request<ApiDashboardMonthlyUserElData, any>({
        path: `/v2/api/dashboard/monthly/user/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 월간 유저(환자)별, 지정한 Action 횟수 순으로 정렬한 유저 목록 조회. ### startDate, endDate 월 단위에 해당하는 시작일, 종료일을 입력. ### limit limit에 값을 입력하여 상위 n명을 조회. limit=10일 경우, Top 10 조회 ### key 정렬할 횟수 명칭을 key 에 입력하여 정렬. \ ex) 외부 공유 횟수 목록 기준 높은 수로 정렬 시, key에 shareCount, way에 -1 입력. - **required** - hospitalID, startDate, endDate, limit, key
     *
     * @tags Dashboard
     * @name ApiDashboardMonthlyUserElFindtop
     * @summary 월간 유저(환자)별 운동콘텐츠 관련 Action 순위 조회
     * @request GET:/v2/api/dashboard/monthly/user/el/findtop
     * @secure
     * @response `200` `ApiDashboardMonthlyUserElFindtopData` \[\{Stats_MonthlyUsers\}\] Stats_MonthlyUsers 컬렉션 객체 배열
     */
    apiDashboardMonthlyUserElFindtop: (query: ApiDashboardMonthlyUserElFindtopParams, params: RequestParams = {}) =>
      this.request<ApiDashboardMonthlyUserElFindtopData, any>({
        path: `/v2/api/dashboard/monthly/user/el/findtop`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 월간 담당자(Column)별 Action 횟수 조회. \ - 예약 건수 - 예약 취소 건수 - 예약 시간 - **required** - hospitalID, startDate, endDate
     *
     * @tags Dashboard
     * @name ApiDashboardMonthlyColumnEl
     * @summary 월간 담당자(Column)별 예약 관련 Action 횟수 조회
     * @request GET:/v2/api/dashboard/monthly/column/el
     * @secure
     * @response `200` `ApiDashboardMonthlyColumnElData` \[\{Stats_MonthlyColumns\}\] Stats_MonthlyColumns 컬렉션 객체 배열
     */
    apiDashboardMonthlyColumnEl: (query: ApiDashboardMonthlyColumnElParams, params: RequestParams = {}) =>
      this.request<ApiDashboardMonthlyColumnElData, any>({
        path: `/v2/api/dashboard/monthly/column/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 월간 담당자(Column)별, 지정한 Action 횟수 순으로 정렬한 유저 목록 조회. ### startDate, endDate 월 단위에 해당하는 시작일, 종료일을 입력. ### limit limit에 값을 입력하여 상위 n명을 조회. limit=10일 경우, Top 10 조회 ### key 정렬할 횟수 명칭을 key 에 입력하여 정렬. \ - userReservationCount, cancelReservationCount, duration... ex) 예약 건수 기준 높은 수로 정렬 시, key에 userReservationCount, way에 -1 입력. - **required** - hospitalID, sheetID, startDate, endDate, limit, key
     *
     * @tags Dashboard
     * @name ApiDashboardMonthlyColumnElFindtop
     * @summary 월간 담당자(Column)별 예약 관련 Action 순위 조회
     * @request GET:/v2/api/dashboard/monthly/column/el/findtop
     * @secure
     * @response `200` `ApiDashboardMonthlyColumnElFindtopData` \[\{Stats_MonthlyColumns\}\] Stats_MonthlyColumns 컬렉션 객체 배열
     */
    apiDashboardMonthlyColumnElFindtop: (query: ApiDashboardMonthlyColumnElFindtopParams, params: RequestParams = {}) =>
      this.request<ApiDashboardMonthlyColumnElFindtopData, any>({
        path: `/v2/api/dashboard/monthly/column/el/findtop`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 월간 담당자(Column) 및 프로그램별 Action 횟수 조회. \ - 예약 건수 - 예약 취소 건수 - 예약 시간 - **required** - hospitalID, startDate, endDate
     *
     * @tags Dashboard
     * @name ApiDashboardMonthlyColumnprogramEl
     * @summary 월간 담당자(Column) 및 프로그램별 예약 관련 Action 횟수 조회
     * @request GET:/v2/api/dashboard/monthly/columnprogram/el
     * @secure
     * @response `200` `ApiDashboardMonthlyColumnprogramElData` \[\{Stats_MonthlyColumnPrograms\}\] Stats_MonthlyColumnPrograms 컬렉션 객체 배열
     */
    apiDashboardMonthlyColumnprogramEl: (query: ApiDashboardMonthlyColumnprogramElParams, params: RequestParams = {}) =>
      this.request<ApiDashboardMonthlyColumnprogramElData, any>({
        path: `/v2/api/dashboard/monthly/columnprogram/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 월간 담당자(Column) 및 프로그램별, 지정한 Action 횟수 순으로 정렬한 유저 목록 조회. ### startDate, endDate 월 단위에 해당하는 시작일, 종료일을 입력. ### limit limit에 값을 입력하여 상위 n명을 조회. limit=10일 경우, Top 10 조회 ### key 정렬할 횟수 명칭을 key 에 입력하여 정렬. \ - userReservationCount, cancelReservationCount, duration... ex) 예약 건수 기준 높은 수로 정렬 시, key에 userReservationCount, way에 -1 입력. - **required** - hospitalID, sheetID, startDate, endDate, limit, key
     *
     * @tags Dashboard
     * @name ApiDashboardMonthlyColumnprogramElFindtop
     * @summary 월간 담당자(Column) 및 프로그램별 예약 관련 Action 순위 조회
     * @request GET:/v2/api/dashboard/monthly/columnprogram/el/findtop
     * @secure
     * @response `200` `ApiDashboardMonthlyColumnprogramElFindtopData` \[\{Stats_MonthlyColumnPrograms\}\] Stats_MonthlyColumnPrograms 컬렉션 객체 배열
     */
    apiDashboardMonthlyColumnprogramElFindtop: (
      query: ApiDashboardMonthlyColumnprogramElFindtopParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiDashboardMonthlyColumnprogramElFindtopData, any>({
        path: `/v2/api/dashboard/monthly/columnprogram/el/findtop`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 입력된 병원ID에 대해 시작일~종료일 사이에 \ 모바일 앱을 실행하고, \ 이용중단을 하지 않은 유저 수 조회. - **required** - hospitalID, startDate, endDate
     *
     * @tags Dashboard
     * @name ApiDashboardHserviceElCountJoinuser
     * @summary 기간별 가입 고객 수 조회
     * @request GET:/v2/api/dashboard/hservice/el/count/joinuser
     * @secure
     * @response `200` `ApiDashboardHserviceElCountJoinuserData` HService 컬렉션 문서 수 (Number)
     */
    apiDashboardHserviceElCountJoinuser: (
      query: ApiDashboardHserviceElCountJoinuserParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiDashboardHserviceElCountJoinuserData, any>({
        path: `/v2/api/dashboard/hservice/el/count/joinuser`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 일일 담당자(Column) 및 프로그램별 Action 횟수 조회. \ - 예약 건수 - 예약 취소 건수 - 예약 시간 - **required** - hospitalID, sheetID, startDate, endDate
     *
     * @tags Dashboard-Reservation
     * @name ApiDashboardDailyColumnprogramElSheet
     * @summary 일일 담당자(Column) 및 프로그램별 예약 관련 Action 횟수 조회
     * @request GET:/v2/api/dashboard/daily/columnprogram/el/sheet
     * @secure
     * @response `200` `ApiDashboardDailyColumnprogramElSheetData` \[\{Stats_DailyColumnPrograms\}\] Stats_DailyColumnPrograms 컬렉션 객체 배열
     */
    apiDashboardDailyColumnprogramElSheet: (
      query: ApiDashboardDailyColumnprogramElSheetParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiDashboardDailyColumnprogramElSheetData, any>({
        path: `/v2/api/dashboard/daily/columnprogram/el/sheet`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 주간 담당자(Column) 및 프로그램별 Action 횟수 조회. \ 한 주의 시작요일 bool 값을 반드시 포함. ### isSunday 한 주의 시작 요일. true시 일요일, false시 월요일을 한 주의 시작일자로 간주 - 예약 건수 - 예약 취소 건수 - 예약 시간 - **required** - hospitalID, startDate, endDate
     *
     * @tags Dashboard-Reservation
     * @name ApiDashboardWeeklyColumnprogramElSheet
     * @summary 주간 담당자(Column) 및 프로그램별 예약 관련 Action 횟수 조회
     * @request GET:/v2/api/dashboard/weekly/columnprogram/el/sheet
     * @secure
     * @response `200` `ApiDashboardWeeklyColumnprogramElSheetData` \[\{Stats_WeeklyColumnPrograms\}\] Stats_WeeklyColumnPrograms 통계 컬렉션 객체 배열
     */
    apiDashboardWeeklyColumnprogramElSheet: (
      query: ApiDashboardWeeklyColumnprogramElSheetParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiDashboardWeeklyColumnprogramElSheetData, any>({
        path: `/v2/api/dashboard/weekly/columnprogram/el/sheet`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 월간 담당자(Column) 및 프로그램별 Action 횟수 조회. \ - 예약 건수 - 예약 취소 건수 - 예약 시간 - **required** - hospitalID, startDate, endDate
     *
     * @tags Dashboard-Reservation
     * @name ApiDashboardMonthlyColumnprogramElSheet
     * @summary 월간 담당자(Column) 및 프로그램별 예약 관련 Action 횟수 조회
     * @request GET:/v2/api/dashboard/monthly/columnprogram/el/sheet
     * @secure
     * @response `200` `ApiDashboardMonthlyColumnprogramElSheetData` \[\{Stats_MonthlyColumnPrograms\}\] Stats_MonthlyColumnPrograms 컬렉션 객체 배열
     */
    apiDashboardMonthlyColumnprogramElSheet: (
      query: ApiDashboardMonthlyColumnprogramElSheetParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiDashboardMonthlyColumnprogramElSheetData, any>({
        path: `/v2/api/dashboard/monthly/columnprogram/el/sheet`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TreatmentCategory
     * @name ApiTreatmentcategoryEl
     * @summary 병원별 고객 유형(치료 유형) 카테고리 조회
     * @request GET:/v2/api/treatmentcategory/el
     * @secure
     * @response `200` `ApiTreatmentcategoryElData` response of Hospital customized treatmentCategory List
     */
    apiTreatmentcategoryEl: (query: ApiTreatmentcategoryElParams, params: RequestParams = {}) =>
      this.request<ApiTreatmentcategoryElData, any>({
        path: `/v2/api/treatmentcategory/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TreatmentCategory
     * @name ApiTreatmentcategoryElCreate
     * @summary 고객 유형(치료 유형) 신규 생성
     * @request POST:/v2/api/treatmentcategory/el/create
     * @secure
     * @response `200` `ApiTreatmentcategoryElCreateData` create treatmentcategory document
     */
    apiTreatmentcategoryElCreate: (
      data: {
        /** 고객 유형(치료 유형) 명칭 */
        categoryName?: string;
        /** 병원의 ObjectId */
        hospitalID?: string;
        /** 카테고리의 정렬 순서(비워둘 시 기본값 9999) */
        sortNum?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiTreatmentcategoryElCreateData, any>({
        path: `/v2/api/treatmentcategory/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TreatmentCategory
     * @name ApiTreatmentcategoryElUpdate
     * @summary 고객 유형(치료 유형) 수정
     * @request POST:/v2/api/treatmentcategory/el/update
     * @secure
     * @response `200` `ApiTreatmentcategoryElUpdateData` update treatmentcategory document
     */
    apiTreatmentcategoryElUpdate: (
      data: {
        /** 업데이트 할 고객 유형(치료 유형) ObjectId */
        tcID?: string;
        /** 고객 유형(치료 유형) 명칭 */
        categoryName?: string;
        /** 카테고리의 정렬 순서 */
        sortNum?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiTreatmentcategoryElUpdateData, any>({
        path: `/v2/api/treatmentcategory/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TreatmentCategory
     * @name ApiTreatmentcategoryElRemove
     * @summary 고객 유형(치료 유형) 삭제
     * @request POST:/v2/api/treatmentcategory/el/remove
     * @secure
     * @response `200` `ApiTreatmentcategoryElRemoveData` remove treatmentcategory document
     */
    apiTreatmentcategoryElRemove: (
      data: {
        /** 삭제할 고객 유형(치료 유형) ObjectId */
        tcID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiTreatmentcategoryElRemoveData, any>({
        path: `/v2/api/treatmentcategory/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TreatmentCaution
     * @name ApiTreatmentCautionEl
     * @summary 병원별 치료시 유의사항 조회
     * @request GET:/v2/api/treatmentCaution/el
     * @secure
     * @response `200` `ApiTreatmentCautionElData` response of TreatmentCaution List
     */
    apiTreatmentCautionEl: (query: ApiTreatmentCautionElParams, params: RequestParams = {}) =>
      this.request<ApiTreatmentCautionElData, any>({
        path: `/v2/api/treatmentCaution/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TreatmentCaution
     * @name ApiTreatmentcautionElCreate
     * @summary 치료시 유의사항 생성
     * @request POST:/v2/api/treatmentcaution/el/create
     * @secure
     * @response `200` `ApiTreatmentcautionElCreateData` create treatmentcaution document
     */
    apiTreatmentcautionElCreate: (
      data: {
        /** 병원의 ObjectId */
        hospitalID?: string;
        /** 치료시 유의사항에 사용될 File ID 배열 */
        fileIDs?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiTreatmentcautionElCreateData, any>({
        path: `/v2/api/treatmentcaution/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TreatmentCaution
     * @name ApiTreatmentcautionElUpdate
     * @summary 치료시 유의사항 수정
     * @request POST:/v2/api/treatmentcaution/el/update
     * @secure
     * @response `200` `ApiTreatmentcautionElUpdateData` create treatmentcaution document
     */
    apiTreatmentcautionElUpdate: (
      data: {
        /** 수정하고자 하는 TreatmentCaution의 아이디 */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiTreatmentcautionElUpdateData, any>({
        path: `/v2/api/treatmentcaution/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TreatmentCaution
     * @name ApiTreatmentcautionElRemove
     * @summary 치료시 유의사항 삭제 (isRemoved 플래그 변경)
     * @request POST:/v2/api/treatmentcaution/el/remove
     * @secure
     * @response `200` `ApiTreatmentcautionElRemoveData` create treatmentcaution document
     */
    apiTreatmentcautionElRemove: (
      data: {
        /** 수정하고자 하는 TreatmentCaution의 아이디 */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiTreatmentcautionElRemoveData, any>({
        path: `/v2/api/treatmentcaution/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalEvent
     * @name ApiEventHospitalEventElFind
     * @summary 병원별 이벤트 목록 조회 (상단 고정 여부, 활성화 여부, 업데이트 일시 내림차순 정렬)
     * @request GET:/v2/api/event/hospital/event/el/find
     * @secure
     * @response `200` `ApiEventHospitalEventElFindData` \[\{HospitalEvent\}\] 정렬된 HospitalEvent 컬렉션 객체 배열
     */
    apiEventHospitalEventElFind: (query: ApiEventHospitalEventElFindParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalEventElFindData, any>({
        path: `/v2/api/event/hospital/event/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalEvent
     * @name ApiEventHospitalEventElFindSort
     * @summary 병원별 이벤트 목록 조회 (사용자 정의 정렬)
     * @request GET:/v2/api/event/hospital/event/el/find/sort
     * @secure
     * @response `200` `ApiEventHospitalEventElFindSortData` \[\{HospitalEvent\}\] 사용자 정의 정렬된 HospitalEvent 컬렉션 객체 배열
     */
    apiEventHospitalEventElFindSort: (query: ApiEventHospitalEventElFindSortParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalEventElFindSortData, any>({
        path: `/v2/api/event/hospital/event/el/find/sort`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalEvent
     * @name ApiEventHospitalEventElCount
     * @summary 병원별 이벤트 목록 수 조회
     * @request GET:/v2/api/event/hospital/event/el/count
     * @secure
     * @response `200` `ApiEventHospitalEventElCountData` \[\{HospitalEvent\}\] 선택한 HospitalID 대한 HospitalEvent 수
     */
    apiEventHospitalEventElCount: (query: ApiEventHospitalEventElCountParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalEventElCountData, any>({
        path: `/v2/api/event/hospital/event/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalEvent
     * @name ApiEventHospitalEventElCreate
     * @summary 병원별 이벤트 생성
     * @request POST:/v2/api/event/hospital/event/el/create
     * @secure
     * @response `200` `ApiEventHospitalEventElCreateData` \{HospitalEvent\} 생성된 병원 이벤트 객체
     */
    apiEventHospitalEventElCreate: (
      data: {
        /** (required) 이벤트 이름 */
        title?: string;
        /** (required) 기본가 */
        price?: number;
        /** (required) 할인가, saleType이 price인 경우 기준점 */
        salePrice?: number;
        /** (required) 할인율, saleType이 rate인 경우 기준점 */
        saleRate?: number;
        /** (required) 할인가격 적용 방식. 정액 할인액(price), 정률 할인의 할인율(rate) */
        saleType?: string;
        /** (required) 대표 이미지 FileID */
        representImage?: string;
        /**
         * (required) 이벤트 기간 시작 날짜
         * @default "2023-04-17T00:00:00.000+0900"
         */
        startDate?: string;
        /**
         * (required) 이벤트 기간 종료 날짜
         * @default "2023-04-23T00:00:00.000+0900"
         */
        endDate?: string;
        /** (required) 병원 ObjectId */
        hospitalID?: string;
        /** (required) 이벤트 상세정보 타입 .. 텍스트 팝업 (text), 이미지 팝업 (image) */
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalEventElCreateData, any>({
        path: `/v2/api/event/hospital/event/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalEvent
     * @name ApiEventHospitalEventElUpdate
     * @summary 병원별 이벤트 업데이트
     * @request POST:/v2/api/event/hospital/event/el/update
     * @secure
     * @response `200` `ApiEventHospitalEventElUpdateData` \{HospitalEvent\} 업데이트된 HospitalEvent 객체
     */
    apiEventHospitalEventElUpdate: (
      data: {
        /** (required) 수정할 이벤트 ObjectId */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalEventElUpdateData, any>({
        path: `/v2/api/event/hospital/event/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalEvent
     * @name ApiEventHospitalEventElRemove
     * @summary 병원별 이벤트 삭제
     * @request POST:/v2/api/event/hospital/event/el/remove
     * @secure
     * @response `200` `ApiEventHospitalEventElRemoveData` \{HospitalEvent\} 삭제된 HospitalEvent 객체
     */
    apiEventHospitalEventElRemove: (
      data: {
        /** (required) 삭제할 이벤트 ObjectId */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalEventElRemoveData, any>({
        path: `/v2/api/event/hospital/event/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalEvent
     * @name ApiEventHospitalEventMFind
     * @summary 병원별 활성화된 이벤트 목록 조회 (모바일)
     * @request GET:/v2/api/event/hospital/event/m/find
     * @secure
     * @response `200` `ApiEventHospitalEventMFindData` \[\{HospitalEvent\}\] 정렬된 활성화 상태의 HospitalEvent 컬렉션 객체 배열
     */
    apiEventHospitalEventMFind: (query: ApiEventHospitalEventMFindParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalEventMFindData, any>({
        path: `/v2/api/event/hospital/event/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalEvent
     * @name ApiEventHospitalEventMFindOne
     * @summary 병원별 이벤트 상세 조회 (모바일)
     * @request GET:/v2/api/event/hospital/event/m/find/one
     * @secure
     * @response `200` `ApiEventHospitalEventMFindOneData` \{HospitalEvent\} 병원 이벤트 객체
     */
    apiEventHospitalEventMFindOne: (query: ApiEventHospitalEventMFindOneParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalEventMFindOneData, any>({
        path: `/v2/api/event/hospital/event/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalEvent
     * @name ApiEventHospitalEventMFindDetail
     * @summary 병원별 이벤트 상세 조회 - WebView (모바일)
     * @request GET:/v2/api/event/hospital/event/m/find/detail
     * @secure
     * @response `200` `ApiEventHospitalEventMFindDetailData` HTML File Response
     */
    apiEventHospitalEventMFindDetail: (query: ApiEventHospitalEventMFindDetailParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalEventMFindDetailData, any>({
        path: `/v2/api/event/hospital/event/m/find/detail`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalAftercare
     * @name ApiEventHospitalAftercareElFind
     * @summary 병원별 홈케어 상품 목록 조회 (상단 고정 여부, 활성화 여부, 업데이트 일시 내림차순 정렬)
     * @request GET:/v2/api/event/hospital/aftercare/el/find
     * @secure
     * @response `200` `ApiEventHospitalAftercareElFindData` \[\{HospitalAftercare\}\] 정렬된 HospitalAftercare 컬렉션 객체 배열
     */
    apiEventHospitalAftercareElFind: (query: ApiEventHospitalAftercareElFindParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalAftercareElFindData, any>({
        path: `/v2/api/event/hospital/aftercare/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalAftercare
     * @name ApiEventHospitalAftercareElFindSort
     * @summary 병원별 홈케어 상품 목록 조회 (사용자 정의 정렬)
     * @request GET:/v2/api/event/hospital/aftercare/el/find/sort
     * @secure
     * @response `200` `ApiEventHospitalAftercareElFindSortData` \[\{HospitalAftercare\}\] 사용자 정의 정렬된 HospitalAftercare 컬렉션 객체 배열
     */
    apiEventHospitalAftercareElFindSort: (
      query: ApiEventHospitalAftercareElFindSortParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalAftercareElFindSortData, any>({
        path: `/v2/api/event/hospital/aftercare/el/find/sort`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalAftercare
     * @name ApiEventHospitalAftercareElCount
     * @summary 병원별 홈케어 상품 목록 수 조회
     * @request GET:/v2/api/event/hospital/aftercare/el/count
     * @secure
     * @response `200` `ApiEventHospitalAftercareElCountData` \[\{HospitalAftercare\}\] 선택한 HospitalID 대한 HospitalAftercare 수
     */
    apiEventHospitalAftercareElCount: (query: ApiEventHospitalAftercareElCountParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalAftercareElCountData, any>({
        path: `/v2/api/event/hospital/aftercare/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalAftercare
     * @name ApiEventHospitalAftercareElCreate
     * @summary 병원별 홈케어 상품 생성
     * @request POST:/v2/api/event/hospital/aftercare/el/create
     * @secure
     * @response `200` `ApiEventHospitalAftercareElCreateData` \{HospitalAftercare\} 생성된 병원 홈케어 상품 객체
     */
    apiEventHospitalAftercareElCreate: (
      data: {
        /** (required) 홈케어 상품 이름 */
        title?: string;
        /** (required) 기본가 */
        price?: number;
        /** (required) 할인가, saleType이 price인 경우 기준점 */
        salePrice?: number;
        /** (required) 할인율, saleType이 rate인 경우 기준점 */
        saleRate?: number;
        /** (required) 할인가격 적용 방식. 정액 할인액(price), 정률 할인의 할인율(rate) */
        saleType?: string;
        /** (required) 대표 이미지 FileID */
        representImage?: string;
        /**
         * (required) 홈케어 상품 판매 기간 시작 날짜
         * @default "2023-04-17T00:00:00.000+0900"
         */
        startDate?: string;
        /**
         * (required) 홈케어 상품 판매 기간 종료 날짜
         * @default "2023-04-23T00:00:00.000+0900"
         */
        endDate?: string;
        /** (required) 병원 ObjectId */
        hospitalID?: string;
        /** (required) 홈케어 상품 상세정보 타입 .. 텍스트 팝업 (text), 이미지 팝업 (image) */
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalAftercareElCreateData, any>({
        path: `/v2/api/event/hospital/aftercare/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalAftercare
     * @name ApiEventHospitalAftercareElUpdate
     * @summary 병원별 홈케어 상품 업데이트
     * @request POST:/v2/api/event/hospital/aftercare/el/update
     * @secure
     * @response `200` `ApiEventHospitalAftercareElUpdateData` \{HospitalAftercare\} 업데이트된 HospitalAftercare 객체
     */
    apiEventHospitalAftercareElUpdate: (
      data: {
        /** (required) 수정할 홈케어 상품 ObjectId */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalAftercareElUpdateData, any>({
        path: `/v2/api/event/hospital/aftercare/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalAftercare
     * @name ApiEventHospitalAftercareElRemove
     * @summary 병원별 홈케어상품 삭제
     * @request POST:/v2/api/event/hospital/aftercare/el/remove
     * @secure
     * @response `200` `ApiEventHospitalAftercareElRemoveData` \{HospitalAftercare\} 삭제된 HospitalAftercare 객체
     */
    apiEventHospitalAftercareElRemove: (
      data: {
        /** (required) 삭제할 홈케어 상품 ObjectId */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalAftercareElRemoveData, any>({
        path: `/v2/api/event/hospital/aftercare/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalAftercare
     * @name ApiEventHospitalAftercareMFind
     * @summary 병원별 활성화된 홈케어 상품 목록 조회 (모바일)
     * @request GET:/v2/api/event/hospital/aftercare/m/find
     * @secure
     * @response `200` `ApiEventHospitalAftercareMFindData` \[\{HospitalAftercare\}\] 정렬된 활성화 상태의 HospitalAftercare 컬렉션 객체 배열
     */
    apiEventHospitalAftercareMFind: (query: ApiEventHospitalAftercareMFindParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalAftercareMFindData, any>({
        path: `/v2/api/event/hospital/aftercare/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalAftercare
     * @name ApiEventHospitalAftercareMFindDetail
     * @summary 병원별 홈케어 상품 상세 조회 (모바일)
     * @request GET:/v2/api/event/hospital/aftercare/m/find/detail
     * @secure
     * @response `200` `ApiEventHospitalAftercareMFindDetailData` HTML File Response
     */
    apiEventHospitalAftercareMFindDetail: (
      query: ApiEventHospitalAftercareMFindDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalAftercareMFindDetailData, any>({
        path: `/v2/api/event/hospital/aftercare/m/find/detail`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElSuspend
     * @summary 병원 앱에서의 유저 서비스 중단
     * @request POST:/v2/api/hservice/el/suspend
     * @secure
     * @response `200` `ApiHserviceElSuspendData` \{HService\} 중단된 서비스 정보.
     */
    apiHserviceElSuspend: (
      data: {
        /** 중단하고자 하는 유저의 서비스 아이디 */
        hserviceID?: string;
        /** 중단하고자 하는 이유 */
        closeReason?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHserviceElSuspendData, any>({
        path: `/v2/api/hservice/el/suspend`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElUpdate
     * @summary 병원 앱에서의 유저 서비스 정보 수정
     * @request POST:/v2/api/hservice/el/update
     * @secure
     * @response `200` `ApiHserviceElUpdateData` \{HService\} 수정된 서비스 정보.
     */
    apiHserviceElUpdate: (
      data: {
        /** 수정하고자 하는 유저의 서비스 아이디 */
        hserviceID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHserviceElUpdateData, any>({
        path: `/v2/api/hservice/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElFindSimple
     * @summary 환자 간편 조회
     * @request GET:/v2/api/hservice/el/find/simple
     * @secure
     * @response `200` `ApiHserviceElFindSimpleData` \[\{HService\}\] HService 컬렉션 객체 배열
     */
    apiHserviceElFindSimple: (query: ApiHserviceElFindSimpleParams, params: RequestParams = {}) =>
      this.request<ApiHserviceElFindSimpleData, any>({
        path: `/v2/api/hservice/el/find/simple`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElFindDetail
     * @summary 서비스 상세 조회
     * @request GET:/v2/api/hservice/el/find/detail
     * @secure
     * @response `200` `ApiHserviceElFindDetailData` \{HService\} HService 컬렉션 객체 배열
     */
    apiHserviceElFindDetail: (query: ApiHserviceElFindDetailParams, params: RequestParams = {}) =>
      this.request<ApiHserviceElFindDetailData, any>({
        path: `/v2/api/hservice/el/find/detail`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElFindTreatmentcategoryCount
     * @summary 환자 수 조회
     * @request GET:/v2/api/hservice/el/find/treatmentcategory/count
     * @secure
     * @response `200` `ApiHserviceElFindTreatmentcategoryCountData` Number HService 컬렉션 객체 수
     */
    apiHserviceElFindTreatmentcategoryCount: (
      query: ApiHserviceElFindTreatmentcategoryCountParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiHserviceElFindTreatmentcategoryCountData, any>({
        path: `/v2/api/hservice/el/find/treatmentcategory/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElFindTreatmentcategory
     * @summary 환자 조회
     * @request GET:/v2/api/hservice/el/find/treatmentcategory
     * @secure
     * @response `200` `ApiHserviceElFindTreatmentcategoryData` \[\{HService\}\] HService 컬렉션 객체 배열
     */
    apiHserviceElFindTreatmentcategory: (query: ApiHserviceElFindTreatmentcategoryParams, params: RequestParams = {}) =>
      this.request<ApiHserviceElFindTreatmentcategoryData, any>({
        path: `/v2/api/hservice/el/find/treatmentcategory`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElFindUnjoined
     * @summary 미가입 환자 간편 조회
     * @request GET:/v2/api/hservice/el/find/unjoined
     * @secure
     * @response `200` `ApiHserviceElFindUnjoinedData` \[\{HService\}\] HService 컬렉션 객체 배열
     */
    apiHserviceElFindUnjoined: (query: ApiHserviceElFindUnjoinedParams, params: RequestParams = {}) =>
      this.request<ApiHserviceElFindUnjoinedData, any>({
        path: `/v2/api/hservice/el/find/unjoined`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElFindUnjoinedCount
     * @summary 미가입 환자 수 조회
     * @request GET:/v2/api/hservice/el/find/unjoined/count
     * @secure
     * @response `200` `ApiHserviceElFindUnjoinedCountData` 미가입 환자 수
     */
    apiHserviceElFindUnjoinedCount: (query: ApiHserviceElFindUnjoinedCountParams, params: RequestParams = {}) =>
      this.request<ApiHserviceElFindUnjoinedCountData, any>({
        path: `/v2/api/hservice/el/find/unjoined/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElFindNeedsetting
     * @summary 고객정보 미설정 환자 조회
     * @request GET:/v2/api/hservice/el/find/needsetting
     * @secure
     * @response `200` `ApiHserviceElFindNeedsettingData` \[\{HService\}\] HService 컬렉션 객체 배열
     */
    apiHserviceElFindNeedsetting: (query: ApiHserviceElFindNeedsettingParams, params: RequestParams = {}) =>
      this.request<ApiHserviceElFindNeedsettingData, any>({
        path: `/v2/api/hservice/el/find/needsetting`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElFindPatientsettingCount
     * @summary 고객정보 미설정 환자 수 조회
     * @request GET:/v2/api/hservice/el/find/patientsetting/count
     * @secure
     * @response `200` `ApiHserviceElFindPatientsettingCountData` 미가입 환자 수
     */
    apiHserviceElFindPatientsettingCount: (
      query: ApiHserviceElFindPatientsettingCountParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiHserviceElFindPatientsettingCountData, any>({
        path: `/v2/api/hservice/el/find/patientsetting/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElFind
     * @summary 환자 조회
     * @request GET:/v2/api/hservice/el/find
     * @secure
     * @response `200` `ApiHserviceElFindData` \[\{HService\}\] HService 컬렉션 객체 배열
     */
    apiHserviceElFind: (query: ApiHserviceElFindParams, params: RequestParams = {}) =>
      this.request<ApiHserviceElFindData, any>({
        path: `/v2/api/hservice/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElFindSpecific
     * @summary 정확한 휴대폰 번호로만 환자 조회
     * @request GET:/v2/api/hservice/el/find/specific
     * @secure
     * @response `200` `ApiHserviceElFindSpecificData` \[\{HService\}\] HService 컬렉션 객체 배열
     */
    apiHserviceElFindSpecific: (query: ApiHserviceElFindSpecificParams, params: RequestParams = {}) =>
      this.request<ApiHserviceElFindSpecificData, any>({
        path: `/v2/api/hservice/el/find/specific`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElFindCount
     * @summary 환자 조회
     * @request GET:/v2/api/hservice/el/find/count
     * @secure
     * @response `200` `ApiHserviceElFindCountData` \[\{HService\}\] HService 컬렉션 객체 배열
     */
    apiHserviceElFindCount: (query: ApiHserviceElFindCountParams, params: RequestParams = {}) =>
      this.request<ApiHserviceElFindCountData, any>({
        path: `/v2/api/hservice/el/find/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElFindChat
     * @summary 환자 간편 조회
     * @request GET:/v2/api/hservice/el/find/chat
     * @secure
     * @response `200` `ApiHserviceElFindChatData` \[\{HService\}\] HService 컬렉션 객체 배열
     */
    apiHserviceElFindChat: (query: ApiHserviceElFindChatParams, params: RequestParams = {}) =>
      this.request<ApiHserviceElFindChatData, any>({
        path: `/v2/api/hservice/el/find/chat`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElFindChatCount
     * @summary 환자 간편 조회
     * @request GET:/v2/api/hservice/el/find/chat/count
     * @secure
     * @response `200` `ApiHserviceElFindChatCountData` \[\{HService\}\] HService 컬렉션 객체 배열
     */
    apiHserviceElFindChatCount: (query: ApiHserviceElFindChatCountParams, params: RequestParams = {}) =>
      this.request<ApiHserviceElFindChatCountData, any>({
        path: `/v2/api/hservice/el/find/chat/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElUpdateSetting
     * @summary 병원 앱에서의 유저 서비스 정보 수정
     * @request POST:/v2/api/hservice/el/update/setting
     * @secure
     * @response `200` `ApiHserviceElUpdateSettingData` \{HService\} 수정된 서비스 정보.
     */
    apiHserviceElUpdateSetting: (
      data: {
        /** 업데이트 하고자 하는 유저의 서비스 아이디 */
        hserviceID?: string;
        /** 해당 서비스의 담당의 ID */
        doctorID?: string;
        /** 치료유형의 카테고리 아이디 */
        treatmentCategoryIDs?: string;
        /** 관리방향 */
        memo?: string;
        memoFileIDs?: string[];
        /** 운동콘텐츠(기초) 발송 */
        videoContentCategoryIDs?: string;
        userTagIDs?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHserviceElUpdateSettingData, any>({
        path: `/v2/api/hservice/el/update/setting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceElUpdateNeedvcu
     * @summary 운동처방 필요 플래그 수정
     * @request POST:/v2/api/hservice/el/update/needvcu
     * @secure
     * @response `200` `ApiHserviceElUpdateNeedvcuData` \{HService\} 수정된 서비스 정보.
     */
    apiHserviceElUpdateNeedvcu: (
      data: {
        /** 수정하고자 하는 유저의 서비스 아이디 */
        hserviceID?: string;
        /** 수정하고자 하는 유저의 홈케어콘텐츠 필요 여부 */
        needVCU?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHserviceElUpdateNeedvcuData, any>({
        path: `/v2/api/hservice/el/update/needvcu`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceMSuspend
     * @summary 유저에 의한 유저 서비스 중단
     * @request POST:/v2/api/hservice/m/suspend
     * @secure
     * @response `200` `ApiHserviceMSuspendData` \{User\} 수정된 유저 정보.
     */
    apiHserviceMSuspend: (
      data: {
        /** 중단하고자 하는 유저의 서비스 아이디 */
        hserviceID?: string;
        /** 중단하고자 하는 이유 */
        closeReason?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHserviceMSuspendData, any>({
        path: `/v2/api/hservice/m/suspend`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceMUpdateSelect
     * @summary 다중 HService 생성 상태일 때 단일 서비스 선택
     * @request POST:/v2/api/hservice/m/update/select
     * @secure
     * @response `200` `ApiHserviceMUpdateSelectData` \{User\} 수정된 유저 정보.
     */
    apiHserviceMUpdateSelect: (
      data: {
        /** 사용자 ObjectId */
        userID?: string;
        /** 최종 사용할 병원 서비스 ObjectId */
        hserviceID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHserviceMUpdateSelectData, any>({
        path: `/v2/api/hservice/m/update/select`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HService
     * @name ApiHserviceHmFindSimple
     * @summary 환자 간편 조회 (애프터닥 관리자 앱)
     * @request GET:/v2/api/hservice/hm/find/simple
     * @secure
     * @response `200` `ApiHserviceHmFindSimpleData` \[\{HService\}\] HService 컬렉션 객체 배열
     */
    apiHserviceHmFindSimple: (query: ApiHserviceHmFindSimpleParams, params: RequestParams = {}) =>
      this.request<ApiHserviceHmFindSimpleData, any>({
        path: `/v2/api/hservice/hm/find/simple`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElCreate
     * @summary 메모 생성
     * @request POST:/v2/api/memo/el/create
     * @secure
     * @response `200` `ApiMemoElCreateData` \{PushSetting\} 생성된 객체
     */
    apiMemoElCreate: (
      data: {
        hospitalID?: string;
        hserviceID?: string;
        userID?: string;
        content?: string;
        type?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiMemoElCreateData, any>({
        path: `/v2/api/memo/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElFind
     * @summary 메모 조회
     * @request GET:/v2/api/memo/el/find
     * @secure
     * @response `200` `ApiMemoElFindData` \{Memo\} 모델 객체
     */
    apiMemoElFind: (query: ApiMemoElFindParams, params: RequestParams = {}) =>
      this.request<ApiMemoElFindData, any>({
        path: `/v2/api/memo/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElFindManage
     * @summary 메모 조회
     * @request GET:/v2/api/memo/el/find/manage
     * @secure
     * @response `200` `ApiMemoElFindManageData` \{Memo\} 모델 객체
     */
    apiMemoElFindManage: (query: ApiMemoElFindManageParams, params: RequestParams = {}) =>
      this.request<ApiMemoElFindManageData, any>({
        path: `/v2/api/memo/el/find/manage`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElFindNurse
     * @summary 메모 조회
     * @request GET:/v2/api/memo/el/find/nurse
     * @secure
     * @response `200` `ApiMemoElFindNurseData` \{Memo\} 모델 객체
     */
    apiMemoElFindNurse: (query: ApiMemoElFindNurseParams, params: RequestParams = {}) =>
      this.request<ApiMemoElFindNurseData, any>({
        path: `/v2/api/memo/el/find/nurse`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElFindPatient
     * @summary 메모 조회
     * @request GET:/v2/api/memo/el/find/patient
     * @secure
     * @response `200` `ApiMemoElFindPatientData` \{Memo\} 모델 객체
     */
    apiMemoElFindPatient: (query: ApiMemoElFindPatientParams, params: RequestParams = {}) =>
      this.request<ApiMemoElFindPatientData, any>({
        path: `/v2/api/memo/el/find/patient`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElFindLast
     * @summary 메모 조회
     * @request GET:/v2/api/memo/el/find/last
     * @secure
     * @response `200` `ApiMemoElFindLastData` \{Memo\} 모델 객체
     */
    apiMemoElFindLast: (query: ApiMemoElFindLastParams, params: RequestParams = {}) =>
      this.request<ApiMemoElFindLastData, any>({
        path: `/v2/api/memo/el/find/last`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElFindManageCount
     * @summary 메모 조회
     * @request GET:/v2/api/memo/el/find/manage/count
     * @secure
     * @response `200` `ApiMemoElFindManageCountData` \{Memo\} 모델 객체
     */
    apiMemoElFindManageCount: (query: ApiMemoElFindManageCountParams, params: RequestParams = {}) =>
      this.request<ApiMemoElFindManageCountData, any>({
        path: `/v2/api/memo/el/find/manage/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElFindNurseCount
     * @summary 메모 조회
     * @request GET:/v2/api/memo/el/find/nurse/count
     * @secure
     * @response `200` `ApiMemoElFindNurseCountData` \{Memo\} 모델 객체
     */
    apiMemoElFindNurseCount: (query: ApiMemoElFindNurseCountParams, params: RequestParams = {}) =>
      this.request<ApiMemoElFindNurseCountData, any>({
        path: `/v2/api/memo/el/find/nurse/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElFindPatientCount
     * @summary 메모 조회
     * @request GET:/v2/api/memo/el/find/patient/count
     * @secure
     * @response `200` `ApiMemoElFindPatientCountData` \{Memo\} 모델 객체
     */
    apiMemoElFindPatientCount: (query: ApiMemoElFindPatientCountParams, params: RequestParams = {}) =>
      this.request<ApiMemoElFindPatientCountData, any>({
        path: `/v2/api/memo/el/find/patient/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElFindManageLast
     * @summary 메모 조회
     * @request GET:/v2/api/memo/el/find/manage/last
     * @secure
     * @response `200` `ApiMemoElFindManageLastData` \{Memo\} 모델 객체
     */
    apiMemoElFindManageLast: (query: ApiMemoElFindManageLastParams, params: RequestParams = {}) =>
      this.request<ApiMemoElFindManageLastData, any>({
        path: `/v2/api/memo/el/find/manage/last`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElFindNurseLast
     * @summary 메모 조회
     * @request GET:/v2/api/memo/el/find/nurse/last
     * @secure
     * @response `200` `ApiMemoElFindNurseLastData` \{Memo\} 모델 객체
     */
    apiMemoElFindNurseLast: (query: ApiMemoElFindNurseLastParams, params: RequestParams = {}) =>
      this.request<ApiMemoElFindNurseLastData, any>({
        path: `/v2/api/memo/el/find/nurse/last`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElFindPatientLast
     * @summary 메모 조회
     * @request GET:/v2/api/memo/el/find/patient/last
     * @secure
     * @response `200` `ApiMemoElFindPatientLastData` \{Memo\} 모델 객체
     */
    apiMemoElFindPatientLast: (query: ApiMemoElFindPatientLastParams, params: RequestParams = {}) =>
      this.request<ApiMemoElFindPatientLastData, any>({
        path: `/v2/api/memo/el/find/patient/last`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElUpdate
     * @summary 메모 수정
     * @request POST:/v2/api/memo/el/update
     * @secure
     * @response `200` `ApiMemoElUpdateData` \{PushSetting\} 생성된 객체
     */
    apiMemoElUpdate: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiMemoElUpdateData, any>({
        path: `/v2/api/memo/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElRemove
     * @summary 메모 삭제
     * @request POST:/v2/api/memo/el/remove
     * @secure
     * @response `200` `ApiMemoElRemoveData` \{PushSetting\} 생성된 객체
     */
    apiMemoElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiMemoElRemoveData, any>({
        path: `/v2/api/memo/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElUpdatePin
     * @summary 메모 수정
     * @request POST:/v2/api/memo/el/update/pin
     * @secure
     * @response `200` `ApiMemoElUpdatePinData` \{Memo\} 업데이트된 객체
     */
    apiMemoElUpdatePin: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiMemoElUpdatePinData, any>({
        path: `/v2/api/memo/el/update/pin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memo
     * @name ApiMemoElRead
     * @summary 메모 읽음
     * @request POST:/v2/api/memo/el/read
     * @secure
     * @response `200` `ApiMemoElReadData` \{PushSetting\} 생성된 객체
     */
    apiMemoElRead: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiMemoElReadData, any>({
        path: `/v2/api/memo/el/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PurchaseRecord
     * @name ApiPurchaserecordElFind
     * @summary 환자에게 발생한 재내원/재구매/패키지 구매내역 조회
     * @request GET:/v2/api/purchaserecord/el/find
     * @secure
     * @response `200` `ApiPurchaserecordElFindData` \[\{PurchaseRecord\}\] 선택한 HServiceID에 대한 PurchaseRecord 컬렉션 객체 배열
     */
    apiPurchaserecordElFind: (query: ApiPurchaserecordElFindParams, params: RequestParams = {}) =>
      this.request<ApiPurchaserecordElFindData, any>({
        path: `/v2/api/purchaserecord/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PurchaseRecord
     * @name ApiPurchaserecordElCount
     * @summary 환자에게 발생한 재내원/재구매/패키지 구매내역 건수 조회
     * @request GET:/v2/api/purchaserecord/el/count
     * @secure
     * @response `200` `ApiPurchaserecordElCountData` 선택한 HServiceID에 대한 PurchaseRecord 컬렉션 객체 수
     */
    apiPurchaserecordElCount: (query: ApiPurchaserecordElCountParams, params: RequestParams = {}) =>
      this.request<ApiPurchaserecordElCountData, any>({
        path: `/v2/api/purchaserecord/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PurchaseRecord
     * @name ApiPurchaserecordElCreate
     * @summary 환자에게 발생한 재내원/재구매/패키지 구매내역 수정
     * @request POST:/v2/api/purchaserecord/el/create
     * @secure
     * @response `200` `ApiPurchaserecordElCreateData` \{PurchaseRecord\} 구매내역 객체
     */
    apiPurchaserecordElCreate: (
      data: {
        /** 구매내역 구분1 */
        purchaseType?: string;
        /** 구매내역 상세구분(구분2) */
        detailType?: string;
        /**
         * 구매 발생한 일시
         * @default "2023-03-15T08:00:00.000Z"
         */
        purchaseDate?: string;
        /** 구매 항목 */
        name?: string;
        /** 금액 (실제 지불한 금액) */
        price?: string;
        /** 잔여횟수 (패키지 - 남은 횟수) */
        remainCount?: string;
        /** 소진 금액 (패키지) */
        deductionPrice?: string;
        /** 비고 */
        note?: string;
        /** 취소 사유 */
        cancellationReason?: string;
        /** 연관된 병원 이벤트 ID. detailType이 이벤트 또는 이벤트_푸시일때 포함 */
        hospitalEventID?: string;
        /** 연관된 푸시 알림 ID. detailType이 이벤트_푸시 일때 포함 */
        requestPushNotificationID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPurchaserecordElCreateData, any>({
        path: `/v2/api/purchaserecord/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PurchaseRecord
     * @name ApiPurchaserecordElUpdate
     * @summary 환자에게 발생한 재내원/재구매/패키지 구매내역 수정
     * @request POST:/v2/api/purchaserecord/el/update
     * @secure
     * @response `200` `ApiPurchaserecordElUpdateData` \{PurchaseRecord\} 구매내역 객체
     */
    apiPurchaserecordElUpdate: (
      data: {
        /** 수정할 구매내역 ObjectID */
        _id?: string;
        /** 구분 */
        purchaseType?: string;
        /** 구매내역 상세구분(구분2) */
        detailType?: string;
        /**
         * 구매 발생한 일시
         * @default "2023-03-15T08:00:00.000Z"
         */
        purchaseDate?: string;
        /** 구매 항목 */
        name?: string;
        /** 금액 (실제 지불한 금액) */
        price?: string;
        /** 잔여횟수 (패키지 - 남은 횟수) */
        remainCount?: string;
        /** 소진 금액 (패키지) */
        deductionPrice?: string;
        /** 비고 */
        note?: string;
        /** 취소 사유 */
        cancellationReason?: string;
        /** 연관된 병원 이벤트 ID. detailType이 이벤트 또는 이벤트_푸시일때 포함 */
        hospitalEventID?: string;
        /** 연관된 푸시 알림 ID. detailType이 이벤트_푸시 일때 포함 */
        requestPushNotificationID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPurchaserecordElUpdateData, any>({
        path: `/v2/api/purchaserecord/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PurchaseRecord
     * @name ApiPurchaserecordElRemove
     * @summary 환자에게 발생한 재내원/재구매/패키지 구매내역 삭제
     * @request POST:/v2/api/purchaserecord/el/remove
     * @secure
     * @response `200` `ApiPurchaserecordElRemoveData` \{PurchaseRecord\} 삭제된 구매내역 객체
     */
    apiPurchaserecordElRemove: (
      data: {
        /** 삭제할 구매내역 ObjectId */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPurchaserecordElRemoveData, any>({
        path: `/v2/api/purchaserecord/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 병원 내 계정 조회.
     *
     * @tags HospitalAccount
     * @name ApiHospitalAccountElFind
     * @summary 병원 내 계정 조회
     * @request GET:/v2/api/hospital/account/el/find
     * @secure
     * @response `200` `ApiHospitalAccountElFindData` \[\{User\}\] 병원에 소속된 계정
     */
    apiHospitalAccountElFind: (query: ApiHospitalAccountElFindParams, params: RequestParams = {}) =>
      this.request<ApiHospitalAccountElFindData, any>({
        path: `/v2/api/hospital/account/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 병원 계정 생성
     *
     * @tags HospitalAccount
     * @name ApiHospitalAccountElCreate
     * @summary [Deprecated] 병원 계정 생성 -> POST /v3/api/hospitals/accounts 으로 이전
     * @request POST:/v2/api/hospital/account/el/create
     * @deprecated
     * @secure
     * @response `200` `ApiHospitalAccountElCreateData` \{User\} 생성된 유저 객체
     */
    apiHospitalAccountElCreate: (
      data: {
        hospitalID?: string;
        id?: string;
        password?: string;
        authorizationTypeID?: string;
        jobType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalAccountElCreateData, any>({
        path: `/v2/api/hospital/account/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalAccount
     * @name ApiHospitalAccountElUpdate
     * @summary 병원 내 계정 수정
     * @request POST:/v2/api/hospital/account/el/update
     * @secure
     * @response `200` `ApiHospitalAccountElUpdateData` \{User\} 유저 객체
     */
    apiHospitalAccountElUpdate: (
      data: {
        /** 수정하고자 하는 유저 Object ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalAccountElUpdateData, any>({
        path: `/v2/api/hospital/account/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalAccount
     * @name ApiHospitalAccountElIdcheck
     * @summary 병원 내 계정 수정
     * @request POST:/v2/api/hospital/account/el/idcheck
     * @secure
     * @response `200` `ApiHospitalAccountElIdcheckData` \{User\} 유저 객체
     */
    apiHospitalAccountElIdcheck: (
      data: {
        /** 수정하고자 하는 유저 Object ID */
        _id?: string;
        /** 중복 체크를 진행하고자 하는 ID */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalAccountElIdcheckData, any>({
        path: `/v2/api/hospital/account/el/idcheck`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalAccount
     * @name ApiHospitalAccountElRemove
     * @summary 병원 내 계정 수정
     * @request POST:/v2/api/hospital/account/el/remove
     * @secure
     * @response `200` `ApiHospitalAccountElRemoveData` \{User\} 유저 객체
     */
    apiHospitalAccountElRemove: (
      data: {
        /** 삭제하고자 하는 유저 Object ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalAccountElRemoveData, any>({
        path: `/v2/api/hospital/account/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 병원 내 권한 목록 조회.
     *
     * @tags HospitalAuthorizationType
     * @name ApiHospitalAuthorizationtypeElFind
     * @summary 병원 내 권한 목록
     * @request GET:/v2/api/hospital/authorizationtype/el/find
     * @secure
     * @response `200` `ApiHospitalAuthorizationtypeElFindData` \[\{AuthorizationType\}\] 병원에 소속된 계정
     */
    apiHospitalAuthorizationtypeElFind: (query: ApiHospitalAuthorizationtypeElFindParams, params: RequestParams = {}) =>
      this.request<ApiHospitalAuthorizationtypeElFindData, any>({
        path: `/v2/api/hospital/authorizationtype/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalAuthorizationType
     * @name ApiHospitalAuthorizationtypeElUpdate
     * @summary 권한설정(AuthorizationType) 수정
     * @request POST:/v2/api/hospital/authorizationtype/el/update
     * @secure
     * @response `200` `ApiHospitalAuthorizationtypeElUpdateData` \{AuthorizationType\} 권한설정 객체
     */
    apiHospitalAuthorizationtypeElUpdate: (
      data: {
        /** AuthorizationType Object ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalAuthorizationtypeElUpdateData, any>({
        path: `/v2/api/hospital/authorizationtype/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthContentCategory
     * @name ApiHealthcontentsCategoryElCreate
     * @summary 건강콘텐츠 카테고리 객체의 생성
     * @request POST:/v2/api/healthcontents/category/el/create
     * @secure
     * @response `200` `ApiHealthcontentsCategoryElCreateData` \{HealthContentCategory\} 생성된 객체
     */
    apiHealthcontentsCategoryElCreate: (
      data: {
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHealthcontentsCategoryElCreateData, any>({
        path: `/v2/api/healthcontents/category/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthContentCategory
     * @name ApiHealthcontentsCategoryElFind
     * @summary 예약 객체의 조회
     * @request GET:/v2/api/healthcontents/category/el/find
     * @secure
     * @response `200` `ApiHealthcontentsCategoryElFindData` \[\{HealthContentCategory\}\] 건강콘텐츠 카테고리 객체 배열
     */
    apiHealthcontentsCategoryElFind: (query: ApiHealthcontentsCategoryElFindParams, params: RequestParams = {}) =>
      this.request<ApiHealthcontentsCategoryElFindData, any>({
        path: `/v2/api/healthcontents/category/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthContentCategory
     * @name ApiHealthcontentsCategoryElUpdate
     * @summary 건강콘텐츠 카테고리의 업데이트
     * @request POST:/v2/api/healthcontents/category/el/update
     * @secure
     * @response `200` `ApiHealthcontentsCategoryElUpdateData` \{HealthContentCategory\} 업데이트 된 건강콘텐츠 카테고리 객체
     */
    apiHealthcontentsCategoryElUpdate: (
      data: {
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHealthcontentsCategoryElUpdateData, any>({
        path: `/v2/api/healthcontents/category/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthContentCategory
     * @name ApiHealthcontentsCategoryElRemove
     * @summary 건강콘텐츠 카테고리 객체의 삭제
     * @request POST:/v2/api/healthcontents/category/el/remove
     * @secure
     * @response `200` `ApiHealthcontentsCategoryElRemoveData` \{HealthContentCategory\} 삭제된 건강콘텐츠 카테고리 객체
     */
    apiHealthcontentsCategoryElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHealthcontentsCategoryElRemoveData, any>({
        path: `/v2/api/healthcontents/category/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthContentCategory
     * @name ApiHealthcontentsCategoryMFind
     * @summary 건강콘텐츠 카테고리  조회
     * @request GET:/v2/api/healthcontents/category/m/find
     * @secure
     * @response `200` `ApiHealthcontentsCategoryMFindData` \[\{HealthContentCategory\}\] 건강콘텐츠 카테고리 객체 배열
     */
    apiHealthcontentsCategoryMFind: (query: ApiHealthcontentsCategoryMFindParams, params: RequestParams = {}) =>
      this.request<ApiHealthcontentsCategoryMFindData, any>({
        path: `/v2/api/healthcontents/category/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthContent
     * @name ApiHealthcontentsContentElCreate
     * @summary 건강콘텐츠 카테고리 객체의 생성
     * @request POST:/v2/api/healthcontents/content/el/create
     * @secure
     * @response `200` `ApiHealthcontentsContentElCreateData` \{HealthContent\} 생성된 객체
     */
    apiHealthcontentsContentElCreate: (
      data: {
        title?: string;
        categoryIDs?: string[];
        summary?: string;
        thumbnailURL?: string;
        contentURL?: string;
        reference?: string;
        /** @default "2022-09-06T12:00:00.000+0900" */
        date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHealthcontentsContentElCreateData, any>({
        path: `/v2/api/healthcontents/content/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthContent
     * @name ApiHealthcontentsContentElFind
     * @summary 건강콘텐츠 객체의 조회
     * @request GET:/v2/api/healthcontents/content/el/find
     * @secure
     * @response `200` `ApiHealthcontentsContentElFindData` \[\{HealthContent\}\] 건강콘텐츠 객체 배열
     */
    apiHealthcontentsContentElFind: (query: ApiHealthcontentsContentElFindParams, params: RequestParams = {}) =>
      this.request<ApiHealthcontentsContentElFindData, any>({
        path: `/v2/api/healthcontents/content/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthContent
     * @name ApiHealthcontentsContentElUpdate
     * @summary 건강콘텐츠 업데이트
     * @request POST:/v2/api/healthcontents/content/el/update
     * @secure
     * @response `200` `ApiHealthcontentsContentElUpdateData` \{HealthContent\} 업데이트 된 건강콘텐츠 객체
     */
    apiHealthcontentsContentElUpdate: (
      data: {
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHealthcontentsContentElUpdateData, any>({
        path: `/v2/api/healthcontents/content/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthContent
     * @name ApiHealthcontentsContentElRemove
     * @summary 건강콘텐츠 카테고리 객체의 삭제
     * @request POST:/v2/api/healthcontents/content/el/remove
     * @secure
     * @response `200` `ApiHealthcontentsContentElRemoveData` \{HealthContent\} 삭제된 건강콘텐츠 객체
     */
    apiHealthcontentsContentElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHealthcontentsContentElRemoveData, any>({
        path: `/v2/api/healthcontents/content/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthContent
     * @name ApiHealthcontentsContentMFind
     * @summary 건강콘텐츠 객체의 조회. 카테고리 조회 시 카테고리 아이디 입력. 미 입력시 전체 조회
     * @request GET:/v2/api/healthcontents/content/m/find
     * @secure
     * @response `200` `ApiHealthcontentsContentMFindData` \[\{HealthContent\}\] 건강콘텐츠 객체 배열
     */
    apiHealthcontentsContentMFind: (query: ApiHealthcontentsContentMFindParams, params: RequestParams = {}) =>
      this.request<ApiHealthcontentsContentMFindData, any>({
        path: `/v2/api/healthcontents/content/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthContent
     * @name ApiHealthcontentsContentMCount
     * @summary 건강콘텐츠 객체의 총 수 조회. 카테고리 조회 시 카테고리 아이디 입력. 미 입력시 전체 카운트 조회
     * @request GET:/v2/api/healthcontents/content/m/count
     * @secure
     * @response `200` `ApiHealthcontentsContentMCountData` 건강콘텐츠 객체 카운트 리턴
     */
    apiHealthcontentsContentMCount: (query: ApiHealthcontentsContentMCountParams, params: RequestParams = {}) =>
      this.request<ApiHealthcontentsContentMCountData, any>({
        path: `/v2/api/healthcontents/content/m/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthContentBookmark
     * @name ApiHealthcontentsBookmarkMCreate
     * @summary 건강콘텐츠 북마크 객체의 생성. 수정 URL 대신 생성 URL로 수정 대체
     * @request POST:/v2/api/healthcontents/bookmark/m/create
     * @secure
     * @response `200` `ApiHealthcontentsBookmarkMCreateData` \{HealthContentBookmark\} 생성된 건강콘텐츠 북마크 객체
     */
    apiHealthcontentsBookmarkMCreate: (
      data: {
        /** (will be deprecated) 유저 ID */
        userID?: string;
        /** (required) 서비스 ID */
        hserviceID?: string;
        healthContentID?: string;
        isBookmark?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHealthcontentsBookmarkMCreateData, any>({
        path: `/v2/api/healthcontents/bookmark/m/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthContentBookmark
     * @name ApiHealthcontentsBookmarkMFind
     * @summary 북마크된 건강콘텐츠 객체의 조회
     * @request GET:/v2/api/healthcontents/bookmark/m/find
     * @secure
     * @response `200` `ApiHealthcontentsBookmarkMFindData` \[\{HealthContent\}\] 북마크 된 건강콘텐츠 객체 배열
     */
    apiHealthcontentsBookmarkMFind: (query: ApiHealthcontentsBookmarkMFindParams, params: RequestParams = {}) =>
      this.request<ApiHealthcontentsBookmarkMFindData, any>({
        path: `/v2/api/healthcontents/bookmark/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContent
     * @name ApiHospitalcontentsContentElCreate
     * @summary 병원 소식 객체의 생성
     * @request POST:/v2/api/hospitalcontents/content/el/create
     * @secure
     * @response `200` `ApiHospitalcontentsContentElCreateData` \{HospitalContent\} 생성된 병원 소식 객체
     */
    apiHospitalcontentsContentElCreate: (
      data: {
        hospitalID?: string;
        title?: string;
        categoryIDs?: string[];
        summary?: string;
        thumbnailURL?: string;
        contentURL?: string;
        reference?: string;
        /** @default "2023-10-06T12:00:00.000+0900" */
        date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalcontentsContentElCreateData, any>({
        path: `/v2/api/hospitalcontents/content/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContent
     * @name ApiHospitalcontentsContentElFind
     * @summary 병원 소식 객체의 조회
     * @request GET:/v2/api/hospitalcontents/content/el/find
     * @secure
     * @response `200` `ApiHospitalcontentsContentElFindData` \[\{HospitalContent\}\] 병원 소식 객체 배열
     */
    apiHospitalcontentsContentElFind: (query: ApiHospitalcontentsContentElFindParams, params: RequestParams = {}) =>
      this.request<ApiHospitalcontentsContentElFindData, any>({
        path: `/v2/api/hospitalcontents/content/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContent
     * @name ApiHospitalcontentsContentElRemove
     * @summary 병원 소식 객체의 삭제
     * @request POST:/v2/api/hospitalcontents/content/el/remove
     * @secure
     * @response `200` `ApiHospitalcontentsContentElRemoveData` \{HospitalContent\} 삭제된 병원 소식 객체
     */
    apiHospitalcontentsContentElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalcontentsContentElRemoveData, any>({
        path: `/v2/api/hospitalcontents/content/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContent
     * @name ApiHospitalcontentsContentElUpdate
     * @summary 병원 소식 업데이트
     * @request POST:/v2/api/hospitalcontents/content/el/update
     * @secure
     * @response `200` `ApiHospitalcontentsContentElUpdateData` \{HospitalContent\} 업데이트 된 병원 소식 객체
     */
    apiHospitalcontentsContentElUpdate: (
      data: {
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalcontentsContentElUpdateData, any>({
        path: `/v2/api/hospitalcontents/content/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContent
     * @name ApiHospitalcontentsContentMCount
     * @summary 병원 소식 객체의 총 수 조회. 카테고리 조회 시 카테고리 아이디 입력. 미 입력시 전체 카운트 조회
     * @request GET:/v2/api/hospitalcontents/content/m/count
     * @secure
     * @response `200` `ApiHospitalcontentsContentMCountData` 병원 소식 수
     */
    apiHospitalcontentsContentMCount: (query: ApiHospitalcontentsContentMCountParams, params: RequestParams = {}) =>
      this.request<ApiHospitalcontentsContentMCountData, any>({
        path: `/v2/api/hospitalcontents/content/m/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContent
     * @name ApiHospitalcontentsContentMFind
     * @summary 병원 소식 객체의 조회. 카테고리 조회 시 카테고리 아이디 입력. 미 입력시 전체 조회
     * @request GET:/v2/api/hospitalcontents/content/m/find
     * @secure
     * @response `200` `ApiHospitalcontentsContentMFindData` \[\{HospitalContent\}\] 병원 소식 객체 배열
     */
    apiHospitalcontentsContentMFind: (query: ApiHospitalcontentsContentMFindParams, params: RequestParams = {}) =>
      this.request<ApiHospitalcontentsContentMFindData, any>({
        path: `/v2/api/hospitalcontents/content/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContentCategory
     * @name ApiHospitalcontentsCategoryElCreate
     * @summary 병원 소식 카테고리 객체의 생성
     * @request POST:/v2/api/hospitalcontents/category/el/create
     * @secure
     * @response `200` `ApiHospitalcontentsCategoryElCreateData` \{HospitalContentCategory\} 생성된 병원 소식 카테고리 객체
     */
    apiHospitalcontentsCategoryElCreate: (
      data: {
        /** (required) 병원 ID */
        hospitalID?: string;
        /** (required) 병원 소식 카테고리 이름 */
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalcontentsCategoryElCreateData, any>({
        path: `/v2/api/hospitalcontents/category/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContentCategory
     * @name ApiHospitalcontentsCategoryElFind
     * @summary 병원 소식 카테고리 객체의 조회
     * @request GET:/v2/api/hospitalcontents/category/el/find
     * @secure
     * @response `200` `ApiHospitalcontentsCategoryElFindData` \[\{HospitalContentCategory\}\] 병원 소식 카테고리 객체 배열
     */
    apiHospitalcontentsCategoryElFind: (query: ApiHospitalcontentsCategoryElFindParams, params: RequestParams = {}) =>
      this.request<ApiHospitalcontentsCategoryElFindData, any>({
        path: `/v2/api/hospitalcontents/category/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContentCategory
     * @name ApiHospitalcontentsCategoryElFindOne
     * @summary 병원 소식 기본 카테고리 유무 조회. 없을 경우 생성
     * @request GET:/v2/api/hospitalcontents/category/el/find/one
     * @secure
     * @response `200` `ApiHospitalcontentsCategoryElFindOneData` \{HospitalContentCategory\} 병원 소식 카테고리 객체
     */
    apiHospitalcontentsCategoryElFindOne: (
      query: ApiHospitalcontentsCategoryElFindOneParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalcontentsCategoryElFindOneData, any>({
        path: `/v2/api/hospitalcontents/category/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContentCategory
     * @name ApiHospitalcontentsCategoryElRemove
     * @summary 병원 소식 카테고리 객체의 삭제
     * @request POST:/v2/api/hospitalcontents/category/el/remove
     * @secure
     * @response `200` `ApiHospitalcontentsCategoryElRemoveData` \{HospitalContentCategory\} 삭제된 병원 소식 카테고리 객체
     */
    apiHospitalcontentsCategoryElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalcontentsCategoryElRemoveData, any>({
        path: `/v2/api/hospitalcontents/category/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContentCategory
     * @name ApiHospitalcontentsCategoryElUpdate
     * @summary 병원 소식 카테고리의 업데이트
     * @request POST:/v2/api/hospitalcontents/category/el/update
     * @secure
     * @response `200` `ApiHospitalcontentsCategoryElUpdateData` \{HospitalContentCategory\} 업데이트 된 병원 소식 카테고리 객체
     */
    apiHospitalcontentsCategoryElUpdate: (
      data: {
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalcontentsCategoryElUpdateData, any>({
        path: `/v2/api/hospitalcontents/category/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContentCategory
     * @name ApiHospitalcontentsCategoryMFind
     * @summary 병원 소식 카테고리 조회
     * @request GET:/v2/api/hospitalcontents/category/m/find
     * @secure
     * @response `200` `ApiHospitalcontentsCategoryMFindData` \[\{HospitalContentCategory\}\] 병원 소식 카테고리 객체 배열
     */
    apiHospitalcontentsCategoryMFind: (query: ApiHospitalcontentsCategoryMFindParams, params: RequestParams = {}) =>
      this.request<ApiHospitalcontentsCategoryMFindData, any>({
        path: `/v2/api/hospitalcontents/category/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContentBookmark
     * @name ApiHospitalcontentsBookmarkMCreate
     * @summary 병원 소식 북마크 객체의 생성. 수정 URL 대신 생성 URL로 수정 대체
     * @request POST:/v2/api/hospitalcontents/bookmark/m/create
     * @secure
     * @response `200` `ApiHospitalcontentsBookmarkMCreateData` \{HospitalContentBookmark\} 생성된 병원 소식 북마크 객체
     */
    apiHospitalcontentsBookmarkMCreate: (
      data: {
        /** (required) 서비스 ID */
        hserviceID?: string;
        hospitalContentID?: string;
        isBookmark?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHospitalcontentsBookmarkMCreateData, any>({
        path: `/v2/api/hospitalcontents/bookmark/m/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalContentBookmark
     * @name ApiHospitalcontentsBookmarkMFind
     * @summary 북마크된 병원 소식 객체의 조회
     * @request GET:/v2/api/hospitalcontents/bookmark/m/find
     * @secure
     * @response `200` `ApiHospitalcontentsBookmarkMFindData` \[\{HospitalContent\}\] 북마크 된 병원 소식 객체 배열
     */
    apiHospitalcontentsBookmarkMFind: (query: ApiHospitalcontentsBookmarkMFindParams, params: RequestParams = {}) =>
      this.request<ApiHospitalcontentsBookmarkMFindData, any>({
        path: `/v2/api/hospitalcontents/bookmark/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShortLink
     * @name ApiShortlinkVideocontentMCreate
     * @summary 비디오 콘텐츠 공유링크 생성
     * @request POST:/v2/api/shortlink/videocontent/m/create
     * @secure
     * @response `200` `ApiShortlinkVideocontentMCreateData` \{ShortLink\} 생성된 객체
     */
    apiShortlinkVideocontentMCreate: (
      data: {
        vcuID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiShortlinkVideocontentMCreateData, any>({
        path: `/v2/api/shortlink/videocontent/m/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description - ShortLink 페이지 내에서 '예약 문의하기' 버튼을 누를 때 함께 호출. - guestReservation 값이 1 증가한 고객 운동콘텐츠 상세 조회
     *
     * @tags ShortLink
     * @name ApiShortlinkVideocontentMUpdateGr
     * @summary 고객 운동콘텐츠 예약 시도 카운트 증가
     * @request POST:/v2/api/shortlink/videocontent/m/update/gr
     * @secure
     * @response `200` `ApiShortlinkVideocontentMUpdateGrData` \{VideoContentUser\} 고객 운동콘텐츠 컬렉션 객체
     */
    apiShortlinkVideocontentMUpdateGr: (
      data: {
        /** (required) 고객 운동콘텐츠의 ObjectID */
        vcuID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiShortlinkVideocontentMUpdateGrData, any>({
        path: `/v2/api/shortlink/videocontent/m/update/gr`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShortLink
     * @name ApiShortlinkEventMCreate
     * @summary 이벤트 - 이벤트 공유링크 생성
     * @request POST:/v2/api/shortlink/event/m/create
     * @secure
     * @response `200` `ApiShortlinkEventMCreateData` \{ShortLink\} 이벤트 - 이벤트에 대한 생성된 객체
     */
    apiShortlinkEventMCreate: (
      data: {
        heventID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiShortlinkEventMCreateData, any>({
        path: `/v2/api/shortlink/event/m/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShortLink
     * @name ApiShortlinkAftercareMCreate
     * @summary 이벤트 - 홈케어 상품 공유링크 생성
     * @request POST:/v2/api/shortlink/aftercare/m/create
     * @secure
     * @response `200` `ApiShortlinkAftercareMCreateData` \{ShortLink\} 이벤트 - 홈케어 상품에 대한 생성된 객체
     */
    apiShortlinkAftercareMCreate: (
      data: {
        haftercareID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiShortlinkAftercareMCreateData, any>({
        path: `/v2/api/shortlink/aftercare/m/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShortLink
     * @name ApiShortlinkHserviceMFindOne
     * @summary hserviceID 기준 shortlink 최초 생성건 조회
     * @request GET:/v2/api/shortlink/hservice/m/find/one
     * @secure
     * @response `200` `ApiShortlinkHserviceMFindOneData` \{ShortLink\} ShortLink 최초 생성 객체 (최초 가입 문자의 ShortLink)
     */
    apiShortlinkHserviceMFindOne: (query: ApiShortlinkHserviceMFindOneParams, params: RequestParams = {}) =>
      this.request<ApiShortlinkHserviceMFindOneData, any>({
        path: `/v2/api/shortlink/hservice/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shared
     * @name SharedVideocontent
     * @summary 공유된 비디오 콘텐츠 접근
     * @request GET:/v2/shared/videocontent
     * @secure
     * @response `200` `SharedVideocontentData` HTML File Response
     */
    sharedVideocontent: (query: SharedVideocontentParams, params: RequestParams = {}) =>
      this.request<SharedVideocontentData, any>({
        path: `/v2/shared/videocontent`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shared
     * @name SharedEvent
     * @summary 공유된 이벤트 페이지 접근
     * @request GET:/v2/shared/event
     * @secure
     * @response `200` `SharedEventData` HTML File Response
     */
    sharedEvent: (query: SharedEventParams, params: RequestParams = {}) =>
      this.request<SharedEventData, any>({
        path: `/v2/shared/event`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shared
     * @name SharedAftercare
     * @summary 공유된 상품 페이지 접근
     * @request GET:/v2/shared/aftercare
     * @secure
     * @response `200` `SharedAftercareData` HTML File Response
     */
    sharedAftercare: (query: SharedAftercareParams, params: RequestParams = {}) =>
      this.request<SharedAftercareData, any>({
        path: `/v2/shared/aftercare`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PushSetting
     * @name ApiPushsettingElFindOne
     * @summary 병원 유저 푸쉬 설정 조회
     * @request GET:/v2/api/pushsetting/el/find/one
     * @secure
     * @response `200` `ApiPushsettingElFindOneData` \{HospitalPushSetting\} 모델 객체
     */
    apiPushsettingElFindOne: (query: ApiPushsettingElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiPushsettingElFindOneData, any>({
        path: `/v2/api/pushsetting/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PushSetting
     * @name ApiPushsettingElUpdate
     * @summary 알림설정 수정 요청
     * @request POST:/v2/api/pushsetting/el/update
     * @secure
     * @response `200` `ApiPushsettingElUpdateData` \{PushSetting\} 생성된 객체
     */
    apiPushsettingElUpdate: (
      data: {
        userID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPushsettingElUpdateData, any>({
        path: `/v2/api/pushsetting/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PushSetting
     * @name ApiPushsettingMFindOne
     * @summary 모바일 유저 푸쉬 설정 조회
     * @request GET:/v2/api/pushsetting/m/find/one
     * @secure
     * @response `200` `ApiPushsettingMFindOneData` \{PatientPushSetting\} 모델 객체
     */
    apiPushsettingMFindOne: (query: ApiPushsettingMFindOneParams, params: RequestParams = {}) =>
      this.request<ApiPushsettingMFindOneData, any>({
        path: `/v2/api/pushsetting/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PushSetting
     * @name ApiPushsettingMUpdate
     * @summary 알림설정 수정 요청
     * @request POST:/v2/api/pushsetting/m/update
     * @secure
     * @response `200` `ApiPushsettingMUpdateData` \{PushSetting\} 생성된 객체
     */
    apiPushsettingMUpdate: (
      data: {
        _id?: string;
        userID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPushsettingMUpdateData, any>({
        path: `/v2/api/pushsetting/m/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalNotice
     * @name ApiNoticeHospitalElFind
     * @summary 병원별 공지사항 목록 조회
     * @request GET:/v2/api/notice/hospital/el/find
     * @secure
     * @response `200` `ApiNoticeHospitalElFindData` \[\{HospitalNotice\}\] 선택한 HospitalID 대한 HospitalNotice 컬렉션 객체 배열
     */
    apiNoticeHospitalElFind: (query: ApiNoticeHospitalElFindParams, params: RequestParams = {}) =>
      this.request<ApiNoticeHospitalElFindData, any>({
        path: `/v2/api/notice/hospital/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description _id, title, hospitalID, index, isRemoved 출력
     *
     * @tags HospitalNotice
     * @name ApiNoticeHospitalElFindSimple
     * @summary 병원별 공지사항 목록 간편 조회
     * @request GET:/v2/api/notice/hospital/el/find/simple
     * @secure
     * @response `200` `ApiNoticeHospitalElFindSimpleData` \[\{HospitalNotice\}\] 선택한 HospitalID 대한 HospitalNotice 컬렉션 객체 배열
     */
    apiNoticeHospitalElFindSimple: (query: ApiNoticeHospitalElFindSimpleParams, params: RequestParams = {}) =>
      this.request<ApiNoticeHospitalElFindSimpleData, any>({
        path: `/v2/api/notice/hospital/el/find/simple`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalNotice
     * @name ApiNoticeHospitalElCount
     * @summary 병원별 공지사항 목록 수 조회
     * @request GET:/v2/api/notice/hospital/el/count
     * @secure
     * @response `200` `ApiNoticeHospitalElCountData` 선택한 HospitalID 대한 HospitalNotice 수
     */
    apiNoticeHospitalElCount: (query: ApiNoticeHospitalElCountParams, params: RequestParams = {}) =>
      this.request<ApiNoticeHospitalElCountData, any>({
        path: `/v2/api/notice/hospital/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 특정 그룹에 푸시 발송 시, [userTagIDs, doctorID, treatmentCategories, isFirstVisit] 를 배열로 전달. \ isFirstVisit 은 수신할 경우 항상 length 2의 boolean 배열. [초진여부, 재진여부] 형태
     *
     * @tags HospitalNotice
     * @name ApiNoticeHospitalElCreate
     * @summary 병원별 공지사항 생성
     * @request POST:/v2/api/notice/hospital/el/create
     * @secure
     * @response `200` `ApiNoticeHospitalElCreateData` \{HospitalNotice\} 생성된 병원 공지사항 객체
     */
    apiNoticeHospitalElCreate: (
      data: {
        /** (required) 공지사항 제목 */
        title?: string;
        /** (required) 공지사항 내용 */
        content?: string;
        /** (required) 푸시 발송 여부 */
        isSendMessage?: boolean;
        /** (required) 병원 내 고객에게 전체 발송 여부. false 시 필터 필요 */
        isSendToHospital?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeHospitalElCreateData, any>({
        path: `/v2/api/notice/hospital/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalNotice
     * @name ApiNoticeHospitalElUpdate
     * @summary 병원별 공지사항 업데이트
     * @request POST:/v2/api/notice/hospital/el/update
     * @secure
     * @response `200` `ApiNoticeHospitalElUpdateData` \{HospitalNotice\} 업데이트된 HospitalNotice 객체
     */
    apiNoticeHospitalElUpdate: (
      data: {
        /** (required) 수정할 공지사항 ObjectId */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeHospitalElUpdateData, any>({
        path: `/v2/api/notice/hospital/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalNotice
     * @name ApiNoticeHospitalElRemove
     * @summary 병원별 공지사항 삭제
     * @request POST:/v2/api/notice/hospital/el/remove
     * @secure
     * @response `200` `ApiNoticeHospitalElRemoveData` \{HospitalNotice\} 삭제된 HospitalNotice 객체
     */
    apiNoticeHospitalElRemove: (
      data: {
        /** (required) 삭제할 공지사항 ObjectId */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeHospitalElRemoveData, any>({
        path: `/v2/api/notice/hospital/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalNotice
     * @name ApiNoticeHospitalMFind
     * @summary 병원별 공지사항 목록 간편 조회 (모바일)
     * @request GET:/v2/api/notice/hospital/m/find
     * @secure
     * @response `200` `ApiNoticeHospitalMFindData` \[\{HospitalNotice\}\] 선택한 HospitalID 대한 HospitalNotice 컬렉션 객체 배열
     */
    apiNoticeHospitalMFind: (query: ApiNoticeHospitalMFindParams, params: RequestParams = {}) =>
      this.request<ApiNoticeHospitalMFindData, any>({
        path: `/v2/api/notice/hospital/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalNotice
     * @name ApiNoticeHospitalMFindOne
     * @summary 병원별 공지사항 상세 조회 (모바일)
     * @request GET:/v2/api/notice/hospital/m/find/one
     * @secure
     * @response `200` `ApiNoticeHospitalMFindOneData` \{HospitalNotice\} HospitalNotice 컬렉션 객체
     */
    apiNoticeHospitalMFindOne: (query: ApiNoticeHospitalMFindOneParams, params: RequestParams = {}) =>
      this.request<ApiNoticeHospitalMFindOneData, any>({
        path: `/v2/api/notice/hospital/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalNotice
     * @name ApiNoticeHospitalMFindDetail
     * @summary 병원별 공지사항 상세 조회 (모바일)
     * @request GET:/v2/api/notice/hospital/m/find/detail
     * @secure
     * @response `200` `ApiNoticeHospitalMFindDetailData` HTML File Response
     */
    apiNoticeHospitalMFindDetail: (query: ApiNoticeHospitalMFindDetailParams, params: RequestParams = {}) =>
      this.request<ApiNoticeHospitalMFindDetailData, any>({
        path: `/v2/api/notice/hospital/m/find/detail`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalNoticePopup
     * @name ApiPopupHospitalElFind
     * @summary 병원별 공지사항 팝업 목록 조회
     * @request GET:/v2/api/popup/hospital/el/find
     * @secure
     * @response `200` `ApiPopupHospitalElFindData` \[\{HospitalNoticePopup\}\] 선택한 HospitalID 대한 HospitalNoticePopup 컬렉션 객체 배열
     */
    apiPopupHospitalElFind: (query: ApiPopupHospitalElFindParams, params: RequestParams = {}) =>
      this.request<ApiPopupHospitalElFindData, any>({
        path: `/v2/api/popup/hospital/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalNoticePopup
     * @name ApiPopupHospitalElCount
     * @summary 병원별 공지사항 팝업 목록 수 조회
     * @request GET:/v2/api/popup/hospital/el/count
     * @secure
     * @response `200` `ApiPopupHospitalElCountData` 선택한 HospitalID 대한 HospitalNoticePopup 수
     */
    apiPopupHospitalElCount: (query: ApiPopupHospitalElCountParams, params: RequestParams = {}) =>
      this.request<ApiPopupHospitalElCountData, any>({
        path: `/v2/api/popup/hospital/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalNoticePopup
     * @name ApiPopupHospitalElCreate
     * @summary 병원별 공지사항 팝업 생성
     * @request POST:/v2/api/popup/hospital/el/create
     * @secure
     * @response `200` `ApiPopupHospitalElCreateData` \{HospitalNoticePopup\} 생성된 병원 공지사항 팝업 객체
     */
    apiPopupHospitalElCreate: (
      data: {
        /** (required) 팝업 이름 */
        name?: string;
        /**
         * (required) 팝업 기간 시작 날짜
         * @default "2023-04-10T00:00:00.000+0900"
         */
        startDate?: string;
        /**
         * (required) 팝업 기간 종료 날짜
         * @default "2023-04-16T00:00:00.000+0900"
         */
        endDate?: string;
        /** (required) 병원 ObjectId */
        hospitalID?: string;
        /** (required) 병원 공지사항 ObjectId */
        hospitalNoticeID?: string;
        /** (required) 팝업 종류 .. 텍스트 팝업 (text), 이미지 팝업 (image) */
        popupType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPopupHospitalElCreateData, any>({
        path: `/v2/api/popup/hospital/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalNoticePopup
     * @name ApiPopupHospitalElUpdate
     * @summary 병원별 공지사항 팝업 업데이트
     * @request POST:/v2/api/popup/hospital/el/update
     * @secure
     * @response `200` `ApiPopupHospitalElUpdateData` \{HospitalNoticePopup\} 업데이트된 HospitalNoticePopup 객체
     */
    apiPopupHospitalElUpdate: (
      data: {
        /** (required) 수정할 공지사항 팝업 ObjectId */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPopupHospitalElUpdateData, any>({
        path: `/v2/api/popup/hospital/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalNoticePopup
     * @name ApiPopupHospitalElRemove
     * @summary 병원별 공지사항 팝업 삭제
     * @request POST:/v2/api/popup/hospital/el/remove
     * @secure
     * @response `200` `ApiPopupHospitalElRemoveData` \{HospitalNoticePopup\} 삭제된 HospitalNoticePopup 객체
     */
    apiPopupHospitalElRemove: (
      data: {
        /** (required) 삭제할 공지사항 팝업 ObjectId */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPopupHospitalElRemoveData, any>({
        path: `/v2/api/popup/hospital/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 전체 공지사항 팝업 + 현재 로그인한 HService의 [담당의 / 고객태그 / 치료유형 / 초,재진] 설정값에 맞는 공지사항 출력
     *
     * @tags HospitalNoticePopup
     * @name ApiPopupHospitalMFind
     * @summary 병원별 공지사항 팝업 목록 조회 (모바일)
     * @request GET:/v2/api/popup/hospital/m/find
     * @secure
     * @response `200` `ApiPopupHospitalMFindData` \[\{HospitalNoticePopup\}\] 선택한 HospitalID, HserviceID에 대한 HospitalNoticePopup 컬렉션 객체 배열
     */
    apiPopupHospitalMFind: (query: ApiPopupHospitalMFindParams, params: RequestParams = {}) =>
      this.request<ApiPopupHospitalMFindData, any>({
        path: `/v2/api/popup/hospital/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HospitalNoticePopup
     * @name ApiPopupHospitalMIncView
     * @summary 병원별 공지사항 팝업 노출 수 증가 (모바일)
     * @request POST:/v2/api/popup/hospital/m/inc/view
     * @secure
     * @response `200` `ApiPopupHospitalMIncViewData` \{HospitalNoticePopup\} _id에 대한 HospitalNoticePopup 컬렉션 객체
     */
    apiPopupHospitalMIncView: (
      data: {
        /** (required) 병원 공지 팝업 ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPopupHospitalMIncViewData, any>({
        path: `/v2/api/popup/hospital/m/inc/view`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ElectronNotificationSound
     * @name ApiNotificationsoundElCount
     * @summary 일렉트론 알림 소리 목록 카운트 조회
     * @request GET:/v2/api/notificationsound/el/count
     * @secure
     * @response `200` `ApiNotificationsoundElCountData` \[\{ElectronNotificationSound\}\] 일렉트론 알림 소리 컬렉션 내 도큐먼트 수
     */
    apiNotificationsoundElCount: (query: ApiNotificationsoundElCountParams, params: RequestParams = {}) =>
      this.request<ApiNotificationsoundElCountData, any>({
        path: `/v2/api/notificationsound/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ElectronNotificationSound
     * @name ApiNotificationsoundEl
     * @summary 일렉트론 알림 소리 목록 조회
     * @request GET:/v2/api/notificationsound/el
     * @secure
     * @response `200` `ApiNotificationsoundElData` \[\{ElectronNotificationSound\}\] 일렉트론 알림 소리 컬렉션 객체 배열
     */
    apiNotificationsoundEl: (query: ApiNotificationsoundElParams, params: RequestParams = {}) =>
      this.request<ApiNotificationsoundElData, any>({
        path: `/v2/api/notificationsound/el`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ElectronNotificationSound
     * @name ApiNotificationsoundElCreate
     * @summary 일렉트론 알림 소리 생성
     * @request POST:/v2/api/notificationsound/el/create
     * @secure
     * @response `200` `ApiNotificationsoundElCreateData` \{ElectronNotificationSound\} 일렉트론 알림 소리 객체
     */
    apiNotificationsoundElCreate: (
      data: {
        name?: string;
        fileID?: string;
        path?: string;
        isDefault?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNotificationsoundElCreateData, any>({
        path: `/v2/api/notificationsound/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ElectronNotificationSound
     * @name ApiNotificationsoundElUpdate
     * @summary 일렉트론 알림 소리 수정
     * @request POST:/v2/api/notificationsound/el/update
     * @secure
     * @response `200` `ApiNotificationsoundElUpdateData` \{ElectronNotificationSound\} 업데이트된 ElectronNotificationSound 객체
     */
    apiNotificationsoundElUpdate: (
      data: {
        /** (required) 수정할 소리 ObjectId */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNotificationsoundElUpdateData, any>({
        path: `/v2/api/notificationsound/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationElCount
     * @summary 예약 객체 수 조회
     * @request GET:/v2/api/v2reservation/el/count
     * @secure
     * @response `200` `ApiV2ReservationElCountData` \[\{v2Reservation\}\] v2Reservation 객체 배열
     */
    apiV2ReservationElCount: (query: ApiV2ReservationElCountParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationElCountData, any>({
        path: `/v2/api/v2reservation/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationElFind
     * @summary 예약 객체의 조회
     * @request GET:/v2/api/v2reservation/el/find
     * @secure
     * @response `200` `ApiV2ReservationElFindData` \[\{v2Reservation\}\] v2Reservation 객체 배열
     */
    apiV2ReservationElFind: (query: ApiV2ReservationElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationElFindData, any>({
        path: `/v2/api/v2reservation/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationElFindHistory
     * @summary 치료 예약에 대한 히스토리 조회 (예약 일정)
     * @request GET:/v2/api/v2reservation/el/find/history
     * @secure
     * @response `200` `ApiV2ReservationElFindHistoryData` \[\{v2Reservation\}\] v2Reservation 객체 배열
     */
    apiV2ReservationElFindHistory: (query: ApiV2ReservationElFindHistoryParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationElFindHistoryData, any>({
        path: `/v2/api/v2reservation/el/find/history`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationElFindNext
     * @summary 다음 예약 객체의 조회
     * @request GET:/v2/api/v2reservation/el/find/next
     * @secure
     * @response `200` `ApiV2ReservationElFindNextData` \{v2Reservation\} 조회 시점 기준 가장 가까운 다음 예약 컬렉션 객체
     */
    apiV2ReservationElFindNext: (query: ApiV2ReservationElFindNextParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationElFindNextData, any>({
        path: `/v2/api/v2reservation/el/find/next`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationElCreate
     * @summary v2 예약 객체의 생성
     * @request POST:/v2/api/v2reservation/el/create
     * @secure
     * @response `200` `ApiV2ReservationElCreateData` \{v2Reservation\} 생성된 예약 컬렉션 객체
     */
    apiV2ReservationElCreate: (
      data: {
        /** (required) 병원 id */
        hospitalID?: string;
        /** (required) 예약을 받을 고객의 id */
        userID?: string;
        /** (required) 병원서비스 id */
        hserviceID?: string;
        /**
         * (required) 예약 시작 시간
         * @default "2024-02-23T09:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (required) 예약 종료 시간
         * @default "2024-02-23T09:30:00.000+0900"
         */
        endedAt?: string;
        /** (required) 예약 그룹(부서) id */
        groupID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /** (required) 프로그램 id */
        programID?: string;
        /** (required) 예약 상태 id */
        statusID?: string;
        /** (optional) 환자에 대한 치료내역 수정 시 입력 */
        userNoteContent?: string;
        /** (optional) 예약건에 대한 예약 메모 입력 */
        note?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationElCreateData, any>({
        path: `/v2/api/v2reservation/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationElCreateRegist
     * @summary 고객 생성 및 v2 예약 객체의 생성
     * @request POST:/v2/api/v2reservation/el/create/regist
     * @secure
     * @response `200` `ApiV2ReservationElCreateRegistData` \{v2Reservation\} 생성된 예약 컬렉션 객체
     */
    apiV2ReservationElCreateRegist: (
      data: {
        /** (required) 고객 이름 */
        name?: string;
        /** (required) 고객 휴대폰번호 */
        phone?: string;
        /** (required) 가입 문자 발송시 발송할 메시지 */
        message?: string;
        /** (required) 병원 id */
        hospitalID?: string;
        /**
         * (required) 예약 시작 시간
         * @default "2024-02-23T09:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (required) 예약 종료 시간
         * @default "2024-02-23T09:30:00.000+0900"
         */
        endedAt?: string;
        /** (required) 예약 그룹(부서) id */
        groupID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /** (required) 프로그램 id */
        programID?: string;
        /** (required) 예약 상태 id */
        statusID?: string;
        /** (optional) 환자에 대한 치료내역 수정 시 입력 */
        userNoteContent?: string;
        /** (optional) 예약건에 대한 예약 메모 입력 */
        note?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationElCreateRegistData, any>({
        path: `/v2/api/v2reservation/el/create/regist`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationElCreateUnregistered
     * @summary 예약만 등록하는 v2 예약 객체의 생성
     * @request POST:/v2/api/v2reservation/el/create/unregistered
     * @secure
     * @response `200` `ApiV2ReservationElCreateUnregisteredData` \{v2Reservation\} 생성된 예약 컬렉션 객체
     */
    apiV2ReservationElCreateUnregistered: (
      data: {
        /** (required) 고객 이름 */
        name?: string;
        /** (required) 병원 id */
        hospitalID?: string;
        /**
         * (required) 예약 시작 시간
         * @default "2024-02-23T09:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (required) 예약 종료 시간
         * @default "2024-02-23T09:30:00.000+0900"
         */
        endedAt?: string;
        /** (required) 예약 그룹(부서) id */
        groupID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /** (required) 프로그램 id */
        programID?: string;
        /** (required) 예약 상태 id */
        statusID?: string;
        /** (optional) 환자에 대한 치료내역 수정 시 입력 */
        userNoteContent?: string;
        /** (optional) 예약건에 대한 예약 메모 입력 */
        note?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationElCreateUnregisteredData, any>({
        path: `/v2/api/v2reservation/el/create/unregistered`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationElUpdate
     * @summary v2 예약 객체의 수정. statusID를 isCancelStatus 값이 true인 항목으로 변경 시 취소됨
     * @request POST:/v2/api/v2reservation/el/update
     * @secure
     * @response `200` `ApiV2ReservationElUpdateData` \{v2Reservation\} 수정된 예약 컬렉션 객체
     */
    apiV2ReservationElUpdate: (
      data: {
        /** (required) 예약 id */
        _id?: string;
        /** (required) 병원 id */
        hospitalID?: string;
        /** (required) 병원서비스 id */
        hserviceID?: string;
        /** (required) 예약을 받을 고객의 id */
        userID?: string;
        /** (required) 예약 그룹(부서) id */
        groupID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /**
         * (optional) 예약 시작 시간
         * @default "2024-02-23T09:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (optional) 예약 종료 시간
         * @default "2024-02-23T09:30:00.000+0900"
         */
        endedAt?: string;
        /** (optional) 프로그램 id */
        programID?: string;
        /** (optional) 예약 상태 id */
        statusID?: string;
        /** (optional) 환자에 대한 치료내역 수정 시 입력 */
        userNoteContent?: string;
        /** (optional) 예약건에 대한 예약 메모 입력 */
        note?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationElUpdateData, any>({
        path: `/v2/api/v2reservation/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationElRemove
     * @summary 예약 객체의 삭제
     * @request POST:/v2/api/v2reservation/el/remove
     * @secure
     * @response `200` `ApiV2ReservationElRemoveData` \{v2Reservation\} 삭제된 예약 컬렉션 객체
     */
    apiV2ReservationElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationElRemoveData, any>({
        path: `/v2/api/v2reservation/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationElSendPush
     * @summary v2 예약 푸시 발송
     * @request POST:/v2/api/v2reservation/el/send/push
     * @secure
     * @response `200` `ApiV2ReservationElSendPushData` result of send push
     */
    apiV2ReservationElSendPush: (
      data: {
        /** (required) 발송할 Push Action 명. create, update, cancel, remove */
        action?: string;
        /** (required) 예약 ID */
        reservationID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationElSendPushData, any>({
        path: `/v2/api/v2reservation/el/send/push`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationMFind
     * @summary 예약 객체의 조회 (모바일)
     * @request GET:/v2/api/v2reservation/m/find
     * @secure
     * @response `200` `ApiV2ReservationMFindData` \[\{v2Reservation\}\] v2Reservation 객체 배열
     */
    apiV2ReservationMFind: (query: ApiV2ReservationMFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMFindData, any>({
        path: `/v2/api/v2reservation/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationMFindOne
     * @summary 예약 객체 단일 조회 (모바일)
     * @request GET:/v2/api/v2reservation/m/find/one
     * @secure
     * @response `200` `ApiV2ReservationMFindOneData` \{v2Reservation\} v2Reservation 객체
     */
    apiV2ReservationMFindOne: (query: ApiV2ReservationMFindOneParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMFindOneData, any>({
        path: `/v2/api/v2reservation/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationMFindDate
     * @summary 컬럼 ID 및 특정 일에 대한 다른 유효 예약건들 조회 (모바일)
     * @request GET:/v2/api/v2reservation/m/find/date
     * @secure
     * @response `200` `ApiV2ReservationMFindDateData` \[\{v2Reservation\}\] 취소 및 삭제되지 않은 v2Reservation 객체 배열
     */
    apiV2ReservationMFindDate: (query: ApiV2ReservationMFindDateParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMFindDateData, any>({
        path: `/v2/api/v2reservation/m/find/date`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationMFindLast
     * @summary 마지막 예약 객체의 조회
     * @request GET:/v2/api/v2reservation/m/find/last
     * @secure
     * @response `200` `ApiV2ReservationMFindLastData` \{v2Reservation\} v2 예약 객체
     */
    apiV2ReservationMFindLast: (query: ApiV2ReservationMFindLastParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMFindLastData, any>({
        path: `/v2/api/v2reservation/m/find/last`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationMFindNext
     * @summary 다음 예약 객체의 조회
     * @request GET:/v2/api/v2reservation/m/find/next
     * @secure
     * @response `200` `ApiV2ReservationMFindNextData` \{v2Reservation\} 예약 컬렉션 객체
     */
    apiV2ReservationMFindNext: (query: ApiV2ReservationMFindNextParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMFindNextData, any>({
        path: `/v2/api/v2reservation/m/find/next`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationMPossibledate
     * @summary 예약 가능 날짜의 조회 (모바일)
     * @request GET:/v2/api/v2reservation/m/possibledate
     * @secure
     * @response `200` `ApiV2ReservationMPossibledateData` \[\{Date\}\] 예약 가능한 날짜 배열
     */
    apiV2ReservationMPossibledate: (query: ApiV2ReservationMPossibledateParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMPossibledateData, any>({
        path: `/v2/api/v2reservation/m/possibledate`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationMPossibletime
     * @summary 컬럼 ID 및 특정 일에 대한 다른 유효 예약건들 조회 (모바일)
     * @request GET:/v2/api/v2reservation/m/possibletime
     * @secure
     * @response `200` `ApiV2ReservationMPossibletimeData` 예약 가능 시간 배열 (hh\:mm 형태)
     */
    apiV2ReservationMPossibletime: (query: ApiV2ReservationMPossibletimeParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMPossibletimeData, any>({
        path: `/v2/api/v2reservation/m/possibletime`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationMCreate
     * @summary v2 예약 생성 (모바일)
     * @request POST:/v2/api/v2reservation/m/create
     * @secure
     * @response `200` `ApiV2ReservationMCreateData` \{v2Reservation\} 생성된 예약 컬렉션 객체
     */
    apiV2ReservationMCreate: (
      data: {
        /** (required) 병원 id */
        hospitalID?: string;
        /** (required) 예약을 받을 고객의 id */
        userID?: string;
        /** (required) 병원서비스 id */
        hserviceID?: string;
        /**
         * (required) 예약 시작 시간
         * @default "2024-02-23T09:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (required) 예약 종료 시간
         * @default "2024-02-23T09:30:00.000+0900"
         */
        endedAt?: string;
        /** (required) 예약 그룹(부서) id */
        groupID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /** (required) 프로그램 id */
        programID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationMCreateData, any>({
        path: `/v2/api/v2reservation/m/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationMUpdate
     * @summary v2 예약 수정 (모바일)
     * @request POST:/v2/api/v2reservation/m/update
     * @secure
     * @response `200` `ApiV2ReservationMUpdateData` \{v2Reservation\} 수정된 예약 컬렉션 객체
     */
    apiV2ReservationMUpdate: (
      data: {
        /** (required) 예약 id */
        _id?: string;
        /** (required) 병원 id */
        hospitalID?: string;
        /** (required) 병원서비스 id */
        hserviceID?: string;
        /** (required) 예약을 받을 고객의 id */
        userID?: string;
        /** (required) 예약 그룹(부서) id */
        groupID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /**
         * (required) 예약 시작 시간
         * @default "2024-02-23T09:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (required) 예약 종료 시간
         * @default "2024-02-23T09:30:00.000+0900"
         */
        endedAt?: string;
        /** (optional) 프로그램 id */
        programID?: string;
        /** (optional) 예약 상태 id */
        statusID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationMUpdateData, any>({
        path: `/v2/api/v2reservation/m/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Reservation
     * @name ApiV2ReservationMCancel
     * @summary v2 예약 취소 (모바일)
     * @request POST:/v2/api/v2reservation/m/cancel
     * @secure
     * @response `200` `ApiV2ReservationMCancelData` \{v2Reservation\} 취소된 예약 컬렉션 객체
     */
    apiV2ReservationMCancel: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationMCancelData, any>({
        path: `/v2/api/v2reservation/m/cancel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationCell
     * @name ApiV2ReservationcellElFind
     * @summary 병원 예약 셀 목록 조회. date를 기준으로 하루 단위 조회
     * @request GET:/v2/api/v2reservationcell/el/find
     * @secure
     * @response `200` `ApiV2ReservationcellElFindData` \[\{v2ReservationCell\}\] v2ReservationCell 컬렉션 객체 배열
     */
    apiV2ReservationcellElFind: (query: ApiV2ReservationcellElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationcellElFindData, any>({
        path: `/v2/api/v2reservationcell/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationCell
     * @name ApiV2ReservationcellElCreate
     * @summary 병원 예약 셀 색상 생성
     * @request POST:/v2/api/v2reservationcell/el/create
     * @secure
     * @response `200` `ApiV2ReservationcellElCreateData` \{v2ReservationCell\} 생성된 v2ReservationCell 컬렉션 객체
     */
    apiV2ReservationcellElCreate: (
      data: {
        /** 병원 ID */
        hospitalID?: string;
        /** 해당 셀 색상이 지정된 날짜. startof(day) 로 치환됨 */
        date?: string;
        /** 메모 내용 */
        note?: string;
        /** 셀 내에 색상이 칠해질 담당자 목록 (x축) */
        columns?: string[];
        /** 셀이 칠해질 시작 시간 (y1) */
        startedAt?: string;
        /** 셀이 칠해질 종료 시간 (y2) */
        endedAt?: string;
        /** 예약 셀 색상 index */
        paletteIndex?: number;
        /** 커스텀 예약 셀 색상 index */
        customPaletteIndex?: number;
        /** 사용자 지정 색상 사용 여부 */
        usingCustomColor?: string;
        /** 사용자 지정 색상 Hex Code */
        customColorCode?: string;
        /** 정렬 순서. date 기준 순서 */
        sortNum?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationcellElCreateData, any>({
        path: `/v2/api/v2reservationcell/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationCell
     * @name ApiV2ReservationcellElUpdate
     * @summary 병원 예약 셀 색상 수정
     * @request POST:/v2/api/v2reservationcell/el/update
     * @secure
     * @response `200` `ApiV2ReservationcellElUpdateData` \{v2ReservationCell\} 수정된 v2ReservationCell 컬렉션 객체
     */
    apiV2ReservationcellElUpdate: (
      data: {
        /** (required) 예약 셀 색상 _id */
        _id?: string;
        /** 메모 내용 */
        note?: string;
        /** 셀 내에 색상이 칠해질 담당자 목록 (x축) */
        columns?: string[];
        /** 셀이 칠해질 시작 시간 (y1) */
        startedAt?: string;
        /** 셀이 칠해질 종료 시간 (y2) */
        endedAt?: string;
        /** 예약 셀 색상 index */
        paletteIndex?: number;
        /** 커스텀 예약 셀 색상 index */
        customPaletteIndex?: number;
        /** 사용자 지정 색상 사용 여부 */
        usingCustomColor?: string;
        /** 사용자 지정 색상 Hex Code */
        customColorCode?: string;
        /** 정렬 순서. date 기준 순서 */
        sortNum?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationcellElUpdateData, any>({
        path: `/v2/api/v2reservationcell/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationCell
     * @name ApiV2ReservationcellElRemove
     * @summary 병원 예약 셀 색상 삭제
     * @request POST:/v2/api/v2reservationcell/el/remove
     * @secure
     * @response `200` `ApiV2ReservationcellElRemoveData` \{v2ReservationCell\} 삭제된 v2ReservationCell 컬렉션 객체
     */
    apiV2ReservationcellElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationcellElRemoveData, any>({
        path: `/v2/api/v2reservationcell/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationBlock
     * @name ApiV2ReservationblockElFind
     * @summary 병원 예약 금지 목록 조회
     * @request GET:/v2/api/v2reservationblock/el/find
     * @secure
     * @response `200` `ApiV2ReservationblockElFindData` \[\{v2ReservationBlock\}\] v2ReservationBlock 컬렉션 객체 배열
     */
    apiV2ReservationblockElFind: (query: ApiV2ReservationblockElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationblockElFindData, any>({
        path: `/v2/api/v2reservationblock/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationBlock
     * @name ApiV2ReservationblockElCreate
     * @summary 병원 예약 금지 생성
     * @request POST:/v2/api/v2reservationblock/el/create
     * @secure
     * @response `200` `ApiV2ReservationblockElCreateData` \{v2ReservationBlock\} 생성된 v2ReservationBlock 컬렉션 객체
     */
    apiV2ReservationblockElCreate: (
      data: {
        /** (required) 병원 ID */
        hospitalID?: string;
        /** (required) 예약 금지로 설정될 담당자 목록 */
        columns?: string[];
        /** (required) 예약 금지의 반복 일정 여부 */
        isRoutine?: boolean;
        /** 반복 주기에 대한 단위 기간 (monthly, weekly, daily) */
        routineTimeUnit?: string;
        /** 반복 주기에 대한 빈도 */
        routineRepeatNum?: number;
        /** 매월 반복 중 n번째 주 */
        routineWeekOfMonth?: string;
        /** 반복 요일 표시. */
        routineWeekDays?: number[];
        /** 시작 일자, 또는 반복 시작 일자 */
        startDate?: string;
        /** 종료 일자, 또는 반복 종료 일자 */
        endDate?: string;
        /** 시작 시간 */
        startTime?: string;
        /** 종료 시간 */
        endTime?: string;
        /** 메모 */
        note?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationblockElCreateData, any>({
        path: `/v2/api/v2reservationblock/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationBlock
     * @name ApiV2ReservationblockElUpdate
     * @summary 병원 예약 금지 수정
     * @request POST:/v2/api/v2reservationblock/el/update
     * @secure
     * @response `200` `ApiV2ReservationblockElUpdateData` \[\{v2ReservationBlock\}\] 수정된 v2ReservationBlock 컬렉션 객체 배열
     */
    apiV2ReservationblockElUpdate: (
      data: {
        /** (required) 수정할 예약 금지 _id */
        _id?: string;
        /** (required) 병원 ID */
        hospitalID?: string;
        /** (required) 예약 금지의 반복 일정 여부 */
        isRoutine?: boolean;
        /** 예약 금지로 설정될 담당자 목록 */
        columns?: string[];
        /** 반복 예약 금지 수정 시, 수정 범위 (current, following, all) */
        editRange?: string;
        /** 반복 주기에 대한 단위 기간 (monthly, weekly, daily) */
        routineTimeUnit?: string;
        /** 반복 주기에 대한 빈도 */
        routineRepeatNum?: number;
        /** 매월 반복 중 n번째 주 */
        routineWeekOfMonth?: string;
        /** 반복 요일 표시. */
        routineWeekDays?: number[];
        /** 시작 일자, 또는 반복 시작 일자 */
        startDate?: string;
        /** 종료 일자, 또는 반복 종료 일자 */
        endDate?: string;
        /** 시작 시간 */
        startTime?: string;
        /** 종료 시간 */
        endTime?: string;
        /** 메모 */
        note?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationblockElUpdateData, any>({
        path: `/v2/api/v2reservationblock/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationBlock
     * @name ApiV2ReservationblockElRemove
     * @summary 병원 예약 금지 삭제
     * @request POST:/v2/api/v2reservationblock/el/remove
     * @secure
     * @response `200` `ApiV2ReservationblockElRemoveData` \[\{v2ReservationBlock\}\] 삭제 및 영항 받은 v2ReservationBlock 컬렉션 객체 배열
     */
    apiV2ReservationblockElRemove: (
      data: {
        /** (required) 삭제할 예약 금지 _id */
        _id?: string;
        /** (required) 삭제 적용 일자 */
        date?: string;
        /** 반복 예약 금지 삭제 시, 수정 범위 (current, following, all) */
        editRange?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationblockElRemoveData, any>({
        path: `/v2/api/v2reservationblock/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationBlock
     * @name ApiV2ReservationblockMFind
     * @summary 병원 예약 금지 목록 조회 (모바일)
     * @request GET:/v2/api/v2reservationblock/m/find
     * @secure
     * @response `200` `ApiV2ReservationblockMFindData` \[\{v2ReservationBlock\}\] v2ReservationBlock 컬렉션 객체 배열
     */
    apiV2ReservationblockMFind: (query: ApiV2ReservationblockMFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationblockMFindData, any>({
        path: `/v2/api/v2reservationblock/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationSetting
     * @name ApiV2ReservationsettingElFindOne
     * @summary 병원 예약 설정 객체의 조회. 정보가 없는 경우에 한하여 디폴트 정보를 생성 후 리턴
     * @request GET:/v2/api/v2reservationsetting/el/find/one
     * @secure
     * @response `200` `ApiV2ReservationsettingElFindOneData` \{v2ReservationSetting\} v2ReservationSetting 컬렉션 객체
     */
    apiV2ReservationsettingElFindOne: (query: ApiV2ReservationsettingElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationsettingElFindOneData, any>({
        path: `/v2/api/v2reservationsetting/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationSetting
     * @name ApiV2ReservationsettingElUpdate
     * @summary 병원 예약 설정 객체의 업데이트
     * @request POST:/v2/api/v2reservationsetting/el/update
     * @secure
     * @response `200` `ApiV2ReservationsettingElUpdateData` \{v2ReservationSetting\} v2ReservationSetting 컬렉션 객체
     */
    apiV2ReservationsettingElUpdate: (
      data: {
        _id?: string;
        hospitalID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationsettingElUpdateData, any>({
        path: `/v2/api/v2reservationsetting/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationSetting
     * @name ApiV2ReservationsettingMFindOne
     * @summary 병원 예약 설정 객체의 조회 (모바일)
     * @request GET:/v2/api/v2reservationsetting/m/find/one
     * @secure
     * @response `200` `ApiV2ReservationsettingMFindOneData` \{v2ReservationSetting\} v2ReservationSetting 컬렉션 객체
     */
    apiV2ReservationsettingMFindOne: (query: ApiV2ReservationsettingMFindOneParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationsettingMFindOneData, any>({
        path: `/v2/api/v2reservationsetting/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationStatus
     * @name ApiV2ReservationstatusElFind
     * @summary 병원 예약 상태 객체 목록 조회
     * @request GET:/v2/api/v2reservationstatus/el/find
     * @secure
     * @response `200` `ApiV2ReservationstatusElFindData` \[\{v2ReservationStatus\}\] v2ReservationStatus 컬렉션 객체 배열
     */
    apiV2ReservationstatusElFind: (query: ApiV2ReservationstatusElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationstatusElFindData, any>({
        path: `/v2/api/v2reservationstatus/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationStatus
     * @name ApiV2ReservationstatusElCreate
     * @summary 병원 예약 상태 객체 생성
     * @request POST:/v2/api/v2reservationstatus/el/create
     * @secure
     * @response `200` `ApiV2ReservationstatusElCreateData` \{v2ReservationStatus\} 생성된 v2ReservationStatus 컬렉션 객체
     */
    apiV2ReservationstatusElCreate: (
      data: {
        /** 병원 ID */
        hospitalID?: string;
        /** 예약 상태 이름 */
        title?: string;
        /** 내원으로 표시 사용 여부 */
        isVisitStatus?: boolean;
        /** 취소로 처리 사용 여부 */
        isCancelStatus?: boolean;
        /** 예약 상태 색상의 색상번호 */
        paletteIndex?: number;
        /** 정렬 순서 */
        sortNum?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationstatusElCreateData, any>({
        path: `/v2/api/v2reservationstatus/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationStatus
     * @name ApiV2ReservationstatusElUpdate
     * @summary 병원 예약 상태 객체 수정
     * @request POST:/v2/api/v2reservationstatus/el/update
     * @secure
     * @response `200` `ApiV2ReservationstatusElUpdateData` \{v2ReservationStatus\} 수정된 v2ReservationStatus 컬렉션 객체
     */
    apiV2ReservationstatusElUpdate: (
      data: {
        _id?: string;
        /** 예약 상태 이름 */
        title?: string;
        /** 내원으로 표시 사용 여부 */
        isVisitStatus?: boolean;
        /** 취소로 처리 사용 여부 */
        isCancelStatus?: boolean;
        /** 예약 상태 색상의 색상번호 */
        paletteIndex?: number;
        /** 정렬 순서 */
        sortNum?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationstatusElUpdateData, any>({
        path: `/v2/api/v2reservationstatus/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationStatus
     * @name ApiV2ReservationstatusElRemove
     * @summary 병원 예약 상태 삭제
     * @request POST:/v2/api/v2reservationstatus/el/remove
     * @secure
     * @response `200` `ApiV2ReservationstatusElRemoveData` \{v2ReservationStatus\} 삭제된 v2ReservationStatus 컬렉션 객체
     */
    apiV2ReservationstatusElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationstatusElRemoveData, any>({
        path: `/v2/api/v2reservationstatus/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationStatus
     * @name ApiV2ReservationstatusElSendPush
     * @summary 병원 예약 상태 설정 변경에 대한 푸시 발송
     * @request POST:/v2/api/v2reservationstatus/el/send/push
     * @secure
     * @response `200` `ApiV2ReservationstatusElSendPushData` v2TODO 미정
     */
    apiV2ReservationstatusElSendPush: (
      data: {
        /** 예약 상태 설정이 완료된 병원 ID */
        hospitalID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationstatusElSendPushData, any>({
        path: `/v2/api/v2reservationstatus/el/send/push`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationGroup
     * @name ApiV2ReservationgroupElFind
     * @summary 병원 예약 그룹(부서) 목록 조회
     * @request GET:/v2/api/v2reservationgroup/el/find
     * @secure
     * @response `200` `ApiV2ReservationgroupElFindData` \[\{v2ReservationGroup\}\] v2ReservationGroup 컬렉션 객체 배열
     */
    apiV2ReservationgroupElFind: (query: ApiV2ReservationgroupElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationgroupElFindData, any>({
        path: `/v2/api/v2reservationgroup/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationGroup
     * @name ApiV2ReservationgroupElFindOne
     * @summary 병원 예약 그룹(부서) 조회
     * @request GET:/v2/api/v2reservationgroup/el/find/one
     * @secure
     * @response `200` `ApiV2ReservationgroupElFindOneData` \{v2ReservationGroup\} v2ReservationGroup 컬렉션 객체
     */
    apiV2ReservationgroupElFindOne: (query: ApiV2ReservationgroupElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationgroupElFindOneData, any>({
        path: `/v2/api/v2reservationgroup/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationGroup
     * @name ApiV2ReservationgroupElFindRemoved
     * @summary 삭제된 병원 예약 그룹(부서) 목록 조회
     * @request GET:/v2/api/v2reservationgroup/el/find/removed
     * @secure
     * @response `200` `ApiV2ReservationgroupElFindRemovedData` \[v2ReservationGroup\] v2ReservationGroup 삭제된 컬럼의 _id 배열
     */
    apiV2ReservationgroupElFindRemoved: (query: ApiV2ReservationgroupElFindRemovedParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationgroupElFindRemovedData, any>({
        path: `/v2/api/v2reservationgroup/el/find/removed`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationGroup
     * @name ApiV2ReservationgroupElCreate
     * @summary 병원 예약 그룹(부서) 생성
     * @request POST:/v2/api/v2reservationgroup/el/create
     * @secure
     * @response `200` `ApiV2ReservationgroupElCreateData` \{v2ReservationGroup\} 생성된 v2ReservationGroup 컬렉션 객체
     */
    apiV2ReservationgroupElCreate: (
      data: {
        /** 병원 ID */
        hospitalID?: string;
        /** 병원 그룹(부서) 이름 */
        title?: string;
        /** 예약 당일 안내 사용 여부 */
        usingReservationNotification?: string;
        /** 예약 당일 안내 발송 시간 */
        reservationNotificationTime?: string;
        /** 예약 당일 안내 발송 메시지 내용 */
        reservationNotificationMessage?: string;
        /** 예약 전날 안내 사용 여부 */
        usingReservationBNotification?: string;
        /** 예약 전날 안내 발송 시간 */
        reservationBNotificationTime?: string;
        /** 예약 전날 안내 발송 메시지 내용 */
        reservationBNotificationMessage?: string;
        /** 예약등록즉시 메세지 */
        messageImmediateCreate?: string;
        /** 예약등록즉시 메세지 히스토리 ID */
        messageImmediateCreateHistoryID?: {
          /** 카카오 템플릿 히스토리 ID */
          _id?: string;
          /** 병원 ID */
          hospitalID?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 발신자 키 */
          senderKey?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 메시지 유형 */
          templateMessageType?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 카테고리 코드 */
          categoryCode?: string;
          /** 검수 요청자 ID */
          requesterID?: string;
          /** 검수 수정자 ID */
          modifierID?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
          /** 템플릿 상태 */
          templateStatus?: string;
          /** 코멘트 오브젝트 */
          comments?: {
            /** 코멘트 내용 */
            content?: string;
            /** 코멘트 생성 시간 */
            createdAt?: string;
            /** 코멘트 상태 */
            status?: string;
            /** 코멘트 작성자 이름 */
            userName?: string;
            /** 코멘트 첨부파일 오브젝트 */
            attachment?: {
              /** 첨부파일 내용 */
              content?: string;
              /** 첨부파일 생성 시간 */
              createdAt?: string;
              /** 첨부파일 상태 */
              status?: string;
              /** 첨부파일 작성자 이름 */
              userName?: string;
              /** 첨부파일 오브젝트 */
              attachment?: {
                /** 첨부파일 원본 파일명 */
                originalFileName?: string;
                /** 첨부파일 경로 */
                filePath?: string;
              };
            };
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationgroupElCreateData, any>({
        path: `/v2/api/v2reservationgroup/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationGroup
     * @name ApiV2ReservationgroupElUpdate
     * @summary 병원 예약 그룹(부서) 수정
     * @request POST:/v2/api/v2reservationgroup/el/update
     * @secure
     * @response `200` `ApiV2ReservationgroupElUpdateData` \{v2ReservationGroup\} 수정된 v2ReservationGroup 컬렉션 객체
     */
    apiV2ReservationgroupElUpdate: (
      data: {
        /** (required) group id */
        _id?: string;
        /** 병원 그룹(부서) 이름 */
        title?: string;
        /** 예약 당일 안내 사용 여부 */
        usingReservationNotification?: string;
        /** 예약 당일 안내 발송 시간 */
        reservationNotificationTime?: string;
        /** 예약 당일 안내 발송 메시지 내용 */
        reservationNotificationMessage?: string;
        /** 예약 전날 안내 사용 여부 */
        usingReservationBNotification?: string;
        /** 예약 전날 안내 발송 시간 */
        reservationBNotificationTime?: string;
        /** 예약 전날 안내 발송 메시지 내용 */
        reservationBNotificationMessage?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationgroupElUpdateData, any>({
        path: `/v2/api/v2reservationgroup/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationGroup
     * @name ApiV2ReservationgroupElRemove
     * @summary 병원 예약 그룹(부서) 삭제
     * @request POST:/v2/api/v2reservationgroup/el/remove
     * @secure
     * @response `200` `ApiV2ReservationgroupElRemoveData` \{v2ReservationGroup\} 삭제된 v2ReservationGroup 컬렉션 객체
     */
    apiV2ReservationgroupElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationgroupElRemoveData, any>({
        path: `/v2/api/v2reservationgroup/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationGroup
     * @name ApiV2ReservationgroupElUpdateSort
     * @summary 병원 예약 그룹 정렬순서 일괄 수정
     * @request POST:/v2/api/v2reservationgroup/el/update/sort
     * @secure
     * @response `200` `ApiV2ReservationgroupElUpdateSortData` \{v2ReservationGroup\} 마지막으로 수정된 v2ReservationGroup 컬렉션 객체
     */
    apiV2ReservationgroupElUpdateSort: (
      data: {
        /** 정렬 순서를 변경할 그룹 목록들 */
        groups?: {
          /** 그룹 ID */
          _id?: string;
          /** 정렬 순서 */
          sortNum?: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationgroupElUpdateSortData, any>({
        path: `/v2/api/v2reservationgroup/el/update/sort`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationColumn
     * @name ApiV2ReservationcolumnElFind
     * @summary 병원 예약 컬럼(담당자) 목록 조회
     * @request GET:/v2/api/v2reservationcolumn/el/find
     * @secure
     * @response `200` `ApiV2ReservationcolumnElFindData` \[\{v2ReservationColumn\}\] v2ReservationColumn 컬렉션 객체 배열
     */
    apiV2ReservationcolumnElFind: (query: ApiV2ReservationcolumnElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationcolumnElFindData, any>({
        path: `/v2/api/v2reservationcolumn/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationColumn
     * @name ApiV2ReservationcolumnElFindRemoved
     * @summary 삭제된 병원 예약 컬럼(담당자) 목록 조회
     * @request GET:/v2/api/v2reservationcolumn/el/find/removed
     * @secure
     * @response `200` `ApiV2ReservationcolumnElFindRemovedData` \[v2ReservationColumn\] v2ReservationColumn 삭제된 컬럼의 _id 배열
     */
    apiV2ReservationcolumnElFindRemoved: (
      query: ApiV2ReservationcolumnElFindRemovedParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationcolumnElFindRemovedData, any>({
        path: `/v2/api/v2reservationcolumn/el/find/removed`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationColumn
     * @name ApiV2ReservationcolumnElCreate
     * @summary 병원 예약 컬럼(담당자) 생성
     * @request POST:/v2/api/v2reservationcolumn/el/create
     * @secure
     * @response `200` `ApiV2ReservationcolumnElCreateData` \{v2ReservationColumn\} 생성된 v2ReservationColumn 컬렉션 객체
     */
    apiV2ReservationcolumnElCreate: (
      data: {
        /** 담당자명 */
        title?: string;
        /** 병원 ID */
        hospitalID?: string;
        /** 예약 그룹(부서) ID */
        groupID?: string;
        /** 직원 ID */
        employeeID?: string;
        /** 예약 알림 수신 User 목록 */
        notificationUsers?: string[];
        /** 예약 가능한 프로그램 ID 목록 */
        programs?: string[];
        /**
         * 굵은선 표기 기본 사용 여부
         * @default true
         */
        usingDefaultBoldInterval?: boolean;
        /**
         * 굵은선 표기 기본값 (단위 분)
         * @default 60
         */
        boldInterval?: number;
        /** 예약 시트 내 셀 단위 시간 구분을 위한 구분선 표기 시간 배열 */
        boldTimeIntervals?: string[];
        /**
         * 앱 예약 활성화 여부. true 시 앱 예약 등록 기능 on
         * @default false
         */
        isActive?: boolean;
        /** 앱에서 예약 가능한 프로그램 ID 목록 */
        appPrograms?: string[];
        /**
         * 고객 직접 예약 등록 가능 시간 단위 (day / hour)
         * @default "day"
         */
        canCreateType?: string;
        /**
         * 예약 등록 가능 시간. 기본값 14
         * @default 14
         */
        possibleCreateRange?: number;
        /**
         * 예약 가능 기간 사용 여부.
         * @default true
         */
        usingSameDayBlock?: boolean;
        /**
         * 고객 직접 예약 등록 제한 시간 단위 (day / hour)
         * @default "day"
         */
        sameDayBlockType?: string;
        /**
         * 고객 직접 예약 제한 시간
         * @default 1
         */
        sameDayBlockDuration?: number;
        /**
         * 고객 직접 예약 변경 가능 여부
         * @default false
         */
        canModify?: boolean;
        /**
         * 고객 직접 예약 변경 가능 시간 단위 (day / hour)
         * @default "day"
         */
        canModifyType?: string;
        /**
         * 예약 변경 불가능 시간
         * @default 1
         */
        possibleModifyRange?: number;
        /**
         * 고객 직접 예약 취소 가능 여부
         * @default false
         */
        canCancel?: boolean;
        /**
         * 고객 직접 예약 취소 가능 시간 단위 (day / hour)
         * @default "day"
         */
        canCancelType?: string;
        /**
         * 예약 취소 불가능 시간
         * @default 1
         */
        possibleCancelRange?: number;
        /**
         * 기본 앱 예약 시간 간격 사용 여부
         * @default true
         */
        usingDefaultAppInterval?: boolean;
        /**
         * 앱 예약 시간 간격 (단위 분)
         * @default 60
         */
        appInterval?: number;
        /** 직접 지정한 앱 예약 시간 간격 */
        appTimeIntervals?: string[];
        /**
         * 시간당 예약 가능 인원
         * @default 1
         */
        appMaxCapacity?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationcolumnElCreateData, any>({
        path: `/v2/api/v2reservationcolumn/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationColumn
     * @name ApiV2ReservationcolumnElUpdate
     * @summary 병원 예약 컬럼(담당자) 수정
     * @request POST:/v2/api/v2reservationcolumn/el/update
     * @secure
     * @response `200` `ApiV2ReservationcolumnElUpdateData` \{v2ReservationColumn\} 수정된 v2ReservationColumn 컬렉션 객체
     */
    apiV2ReservationcolumnElUpdate: (
      data: {
        /** 수정할 예약 담당자 ID */
        _id?: string;
        /** 담당자명 */
        title?: string;
        /** 병원 ID */
        hospitalID?: string;
        /** 예약 그룹(부서) ID */
        groupID?: string;
        /** 직원 ID */
        employeeID?: string;
        /** 예약 알림 수신 User 목록 */
        notificationUsers?: string[];
        /** 예약 가능한 프로그램 ID 목록 */
        programs?: string[];
        /**
         * 굵은선 표기 기본 사용 여부
         * @default true
         */
        usingDefaultBoldInterval?: boolean;
        /**
         * 굵은선 표기 기본값 (단위 분)
         * @default 60
         */
        boldInterval?: number;
        /** 예약 시트 내 셀 단위 시간 구분을 위한 구분선 표기 시간 배열 */
        boldTimeIntervals?: string[];
        /**
         * 앱 예약 활성화 여부. true 시 앱 예약 등록 기능 on
         * @default false
         */
        isActive?: boolean;
        /** 앱에서 예약 가능한 프로그램 ID 목록 */
        appPrograms?: string[];
        /**
         * 고객 직접 예약 등록 가능 시간 단위 (day / hour)
         * @default "day"
         */
        canCreateType?: string;
        /**
         * 예약 등록 가능 시간. 기본값 14
         * @default 14
         */
        possibleCreateRange?: number;
        /**
         * 예약 가능 기간 사용 여부.
         * @default true
         */
        usingSameDayBlock?: boolean;
        /**
         * 고객 직접 예약 등록 제한 시간 단위 (day / hour)
         * @default "day"
         */
        sameDayBlockType?: string;
        /**
         * 고객 직접 예약 제한 시간
         * @default 1
         */
        sameDayBlockDuration?: number;
        /**
         * 고객 직접 예약 변경 가능 여부
         * @default false
         */
        canModify?: boolean;
        /**
         * 고객 직접 예약 변경 가능 시간 단위 (day / hour)
         * @default "day"
         */
        canModifyType?: string;
        /**
         * 예약 변경 불가능 시간
         * @default 1
         */
        possibleModifyRange?: number;
        /**
         * 고객 직접 예약 취소 가능 여부
         * @default false
         */
        canCancel?: boolean;
        /**
         * 고객 직접 예약 취소 가능 시간 단위 (day / hour)
         * @default "day"
         */
        canCancelType?: string;
        /**
         * 예약 취소 불가능 시간
         * @default 1
         */
        possibleCancelRange?: number;
        /**
         * 기본 앱 예약 시간 간격 사용 여부
         * @default true
         */
        usingDefaultAppInterval?: boolean;
        /**
         * 앱 예약 시간 간격 (단위 분)
         * @default 60
         */
        appInterval?: number;
        /** 직접 지정한 앱 예약 시간 간격 */
        appTimeIntervals?: string[];
        /**
         * 시간당 예약 가능 인원
         * @default 1
         */
        appMaxCapacity?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationcolumnElUpdateData, any>({
        path: `/v2/api/v2reservationcolumn/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationColumn
     * @name ApiV2ReservationcolumnElRemove
     * @summary 병원 예약 컬럼(담당자) 삭제
     * @request POST:/v2/api/v2reservationcolumn/el/remove
     * @secure
     * @response `200` `ApiV2ReservationcolumnElRemoveData` \{v2ReservationColumn\} 삭제된 v2ReservationColumn 컬렉션 객체
     */
    apiV2ReservationcolumnElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationcolumnElRemoveData, any>({
        path: `/v2/api/v2reservationcolumn/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationColumn
     * @name ApiV2ReservationcolumnElUpdateSort
     * @summary 병원 예약 담당자 정렬순서 일괄 수정
     * @request POST:/v2/api/v2reservationcolumn/el/update/sort
     * @secure
     * @response `200` `ApiV2ReservationcolumnElUpdateSortData` \{v2ReservationColumn\} 마지막으로 수정된 v2ReservationColumn 컬렉션 객체
     */
    apiV2ReservationcolumnElUpdateSort: (
      data: {
        /** 정렬 순서를 변경할 컬럼 목록들 */
        columns?: {
          /** 컬럼(담당자) ID */
          _id?: string;
          /** 정렬 순서 */
          sortNum?: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationcolumnElUpdateSortData, any>({
        path: `/v2/api/v2reservationcolumn/el/update/sort`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationColumn
     * @name ApiV2ReservationcolumnMDate
     * @summary 병원 예약 컬럼(담당자) 목록 조회 (모바일)
     * @request GET:/v2/api/v2reservationcolumn/m/date
     * @secure
     * @response `200` `ApiV2ReservationcolumnMDateData` \[\{v2ReservationColumn\}\] v2ReservationColumn 컬렉션 객체 배열
     */
    apiV2ReservationcolumnMDate: (query: ApiV2ReservationcolumnMDateParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationcolumnMDateData, any>({
        path: `/v2/api/v2reservationcolumn/m/date`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationColumn
     * @name ApiV2ReservationcolumnMActive
     * @summary 병원 직접 예약 가능 여부 조회 (모바일)
     * @request GET:/v2/api/v2reservationcolumn/m/active
     * @secure
     * @response `200` `ApiV2ReservationcolumnMActiveData` 직접 예약 가능 여부 boolean
     */
    apiV2ReservationcolumnMActive: (query: ApiV2ReservationcolumnMActiveParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationcolumnMActiveData, any>({
        path: `/v2/api/v2reservationcolumn/m/active`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationProgram
     * @name ApiV2ReservationprogramElFind
     * @summary 병원 예약 프로그램 목록 조회
     * @request GET:/v2/api/v2reservationprogram/el/find
     * @secure
     * @response `200` `ApiV2ReservationprogramElFindData` \[\{v2ReservationProgram\}\] v2ReservationProgram 컬렉션 객체 배열
     */
    apiV2ReservationprogramElFind: (query: ApiV2ReservationprogramElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationprogramElFindData, any>({
        path: `/v2/api/v2reservationprogram/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationProgram
     * @name ApiV2ReservationprogramElCreate
     * @summary 병원 예약 프로그램 생성
     * @request POST:/v2/api/v2reservationprogram/el/create
     * @secure
     * @response `200` `ApiV2ReservationprogramElCreateData` \{v2ReservationProgram\} 생성된 v2ReservationProgram 컬렉션 객체
     */
    apiV2ReservationprogramElCreate: (
      data: {
        /** 병원 ID */
        hospitalID?: string;
        /** 프로그램 이름 */
        title?: string;
        /** 프로그램 소요 시간 */
        duration?: number;
        /** 프로그램 설명 */
        description?: string;
        /** 정렬 순서 */
        sortNum?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationprogramElCreateData, any>({
        path: `/v2/api/v2reservationprogram/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationProgram
     * @name ApiV2ReservationprogramElUpdate
     * @summary 병원 예약 프로그램 수정
     * @request POST:/v2/api/v2reservationprogram/el/update
     * @secure
     * @response `200` `ApiV2ReservationprogramElUpdateData` \{v2ReservationProgram\} 수정된 v2ReservationProgram 컬렉션 객체
     */
    apiV2ReservationprogramElUpdate: (
      data: {
        /** 수정할 프로그램 ID */
        _id?: string;
        /** 프로그램 이름 */
        title?: string;
        /** 프로그램 소요 시간 */
        duration?: number;
        /** 프로그램 설명 */
        description?: string;
        /** 정렬 순서 */
        sortNum?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationprogramElUpdateData, any>({
        path: `/v2/api/v2reservationprogram/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationProgram
     * @name ApiV2ReservationprogramElRemove
     * @summary 병원 예약 프로그램 삭제
     * @request POST:/v2/api/v2reservationprogram/el/remove
     * @secure
     * @response `200` `ApiV2ReservationprogramElRemoveData` \{v2ReservationProgram\} 삭제된 v2ReservationProgram 컬렉션 객체
     */
    apiV2ReservationprogramElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationprogramElRemoveData, any>({
        path: `/v2/api/v2reservationprogram/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationProgram
     * @name ApiV2ReservationprogramElSendPush
     * @summary 병원 예약 프로그램 설정 변경에 대한 푸시 발송
     * @request POST:/v2/api/v2reservationprogram/el/send/push
     * @secure
     * @response `200` `ApiV2ReservationprogramElSendPushData` v2TODO 미정
     */
    apiV2ReservationprogramElSendPush: (
      data: {
        /** 프로그램 설정이 완료된 병원 ID */
        hospitalID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationprogramElSendPushData, any>({
        path: `/v2/api/v2reservationprogram/el/send/push`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationProgram
     * @name ApiV2ReservationprogramMFind
     * @summary 병원 예약 가능한 프로그램 목록 조회 (모바일)
     * @request GET:/v2/api/v2reservationprogram/m/find
     * @secure
     * @response `200` `ApiV2ReservationprogramMFindData` \[\{v2ReservationProgram\}\] v2ReservationProgram 컬렉션 객체 배열
     */
    apiV2ReservationprogramMFind: (query: ApiV2ReservationprogramMFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationprogramMFindData, any>({
        path: `/v2/api/v2reservationprogram/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationUserNote
     * @name ApiV2ReservationusernoteElFind
     * @summary 병원서비스별 치료 내역 (예약 유저 노트).
     * @request GET:/v2/api/v2reservationusernote/el/find
     * @secure
     * @response `200` `ApiV2ReservationusernoteElFindData` \[\{v2ReservationUserNote\}\] v2ReservationUserNote 컬렉션 객체 배열
     */
    apiV2ReservationusernoteElFind: (query: ApiV2ReservationusernoteElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationusernoteElFindData, any>({
        path: `/v2/api/v2reservationusernote/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description userID, hospiatlID, hserviceID 세가지를 기준으로 upsert 동작
     *
     * @tags v2ReservationUserNote
     * @name ApiV2ReservationusernoteElUpdate
     * @summary 병원서비스별 치료 내역 (예약 유저 노트) 수정
     * @request POST:/v2/api/v2reservationusernote/el/update
     * @secure
     * @response `200` `ApiV2ReservationusernoteElUpdateData` \{v2ReservationUserNote\} v2ReservationUserNote 컬렉션 객체
     */
    apiV2ReservationusernoteElUpdate: (
      data: {
        userID?: string;
        hospitalID?: string;
        hserviceID?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationusernoteElUpdateData, any>({
        path: `/v2/api/v2reservationusernote/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationUserNote
     * @name ApiV2ReservationusernoteElFindDate
     * @summary 특정 기간의 예약에 해당하는 병원서비스별 치료 내역 (예약 유저 노트).
     * @request GET:/v2/api/v2reservationusernote/el/find/date
     * @secure
     * @response `200` `ApiV2ReservationusernoteElFindDateData` \[\{v2ReservationUserNote\}\] v2ReservationUserNote 컬렉션 객체 배열
     */
    apiV2ReservationusernoteElFindDate: (query: ApiV2ReservationusernoteElFindDateParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationusernoteElFindDateData, any>({
        path: `/v2/api/v2reservationusernote/el/find/date`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationDateNote
     * @name ApiV2ReservationdatenoteElFind
     * @summary 일자별 예약 공지사항 조회
     * @request GET:/v2/api/v2reservationdatenote/el/find
     * @secure
     * @response `200` `ApiV2ReservationdatenoteElFindData` \[\{v2ReservationDateNote\}\] v2ReservationDateNote 컬렉션 객체 배열
     */
    apiV2ReservationdatenoteElFind: (query: ApiV2ReservationdatenoteElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationdatenoteElFindData, any>({
        path: `/v2/api/v2reservationdatenote/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2ReservationDateNote
     * @name ApiV2ReservationdatenoteElFindDate
     * @summary 예약 공지사항 목록 조회
     * @request GET:/v2/api/v2reservationdatenote/el/find/date
     * @secure
     * @response `200` `ApiV2ReservationdatenoteElFindDateData` \[\{v2ReservationDateNote\}\] v2ReservationDateNote 컬렉션 객체 배열
     */
    apiV2ReservationdatenoteElFindDate: (query: ApiV2ReservationdatenoteElFindDateParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationdatenoteElFindDateData, any>({
        path: `/v2/api/v2reservationdatenote/el/find/date`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description hospiatlID, date 세가지를 기준으로 upsert 동작
     *
     * @tags v2ReservationDateNote
     * @name ApiV2ReservationdatenoteElUpdate
     * @summary 일자별 예약 공지사항 수정
     * @request POST:/v2/api/v2reservationdatenote/el/update
     * @secure
     * @response `200` `ApiV2ReservationdatenoteElUpdateData` \{v2ReservationDateNote\} 수정된 v2ReservationDateNote 컬렉션 객체
     */
    apiV2ReservationdatenoteElUpdate: (
      data: {
        hospitalID?: string;
        date?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationdatenoteElUpdateData, any>({
        path: `/v2/api/v2reservationdatenote/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2h_Reservation
     * @name ApiV2HreservationElFind
     * @summary reservationID 를 통한 예약 객체 히스토리 조회
     * @request GET:/v2/api/v2hreservation/el/find
     * @secure
     * @response `200` `ApiV2HreservationElFindData` response of v2h_Reservation List
     */
    apiV2HreservationElFind: (query: ApiV2HreservationElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2HreservationElFindData, any>({
        path: `/v2/api/v2hreservation/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2h_Reservation
     * @name ApiV2HreservationElCount
     * @summary reservationID 를 통한 예약 객체 히스토리 수 조회
     * @request GET:/v2/api/v2hreservation/el/count
     * @secure
     * @response `200` `ApiV2HreservationElCountData` 조건에 일치하는 v2h_Reservation 의 수
     */
    apiV2HreservationElCount: (query: ApiV2HreservationElCountParams, params: RequestParams = {}) =>
      this.request<ApiV2HreservationElCountData, any>({
        path: `/v2/api/v2hreservation/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Department
     * @name ApiV2DepartmentElFind
     * @summary 병원 부서 목록 조회
     * @request GET:/v2/api/v2department/el/find
     * @secure
     * @response `200` `ApiV2DepartmentElFindData` \[\{v2Department\}\] v2Department 컬렉션 객체 배열
     */
    apiV2DepartmentElFind: (query: ApiV2DepartmentElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2DepartmentElFindData, any>({
        path: `/v2/api/v2department/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Department
     * @name ApiV2DepartmentElFindOne
     * @summary 병원 부서 단일 조회
     * @request GET:/v2/api/v2department/el/find/one
     * @secure
     * @response `200` `ApiV2DepartmentElFindOneData` \{v2Department\} v2Department 컬렉션 객체
     */
    apiV2DepartmentElFindOne: (query: ApiV2DepartmentElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiV2DepartmentElFindOneData, any>({
        path: `/v2/api/v2department/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Department
     * @name ApiV2DepartmentElCreate
     * @summary 병원 부서 생성
     * @request POST:/v2/api/v2department/el/create
     * @secure
     * @response `200` `ApiV2DepartmentElCreateData` \{v2Department\} 생성된 v2Department 컬렉션 객체
     */
    apiV2DepartmentElCreate: (
      data: {
        /** 병원 부서 이름 */
        title?: string;
        /** 병원 ID */
        hospitalID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2DepartmentElCreateData, any>({
        path: `/v2/api/v2department/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Department
     * @name ApiV2DepartmentElUpdate
     * @summary 병원 부서 수정
     * @request POST:/v2/api/v2department/el/update
     * @secure
     * @response `200` `ApiV2DepartmentElUpdateData` \{v2Department\} 수정된 v2Department 컬렉션 객체
     */
    apiV2DepartmentElUpdate: (
      data: {
        /** (required) department id */
        _id?: string;
        /** 병원 부서 이름 */
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2DepartmentElUpdateData, any>({
        path: `/v2/api/v2department/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Department
     * @name ApiV2DepartmentElUpdateSort
     * @summary 병원 부서 정렬순서 일괄 수정
     * @request POST:/v2/api/v2department/el/update/sort
     * @secure
     * @response `200` `ApiV2DepartmentElUpdateSortData` \{v2Department\} 마지막으로 수정된 v2Department 컬렉션 객체
     */
    apiV2DepartmentElUpdateSort: (
      data: {
        /** 정렬 순서를 변경할 부서 목록들 */
        departments?: {
          /** 부서 ID */
          _id?: string;
          /** 정렬 순서 */
          sortNum?: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2DepartmentElUpdateSortData, any>({
        path: `/v2/api/v2department/el/update/sort`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Department
     * @name ApiV2DepartmentElRemove
     * @summary 병원 부서 삭제
     * @request POST:/v2/api/v2department/el/remove
     * @secure
     * @response `200` `ApiV2DepartmentElRemoveData` \{v2Department\} 삭제된 v2Department 컬렉션 객체
     */
    apiV2DepartmentElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2DepartmentElRemoveData, any>({
        path: `/v2/api/v2department/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Employee
     * @name ApiV2EmployeeElFind
     * @summary 병원 직원 목록 조회
     * @request GET:/v2/api/v2employee/el/find
     * @secure
     * @response `200` `ApiV2EmployeeElFindData` \[\{v2Employee\}\] v2Employee 컬렉션 객체 배열
     */
    apiV2EmployeeElFind: (query: ApiV2EmployeeElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2EmployeeElFindData, any>({
        path: `/v2/api/v2employee/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Employee
     * @name ApiV2EmployeeElCreate
     * @summary 병원 직원 생성
     * @request POST:/v2/api/v2employee/el/create
     * @secure
     * @response `200` `ApiV2EmployeeElCreateData` \{v2Employee\} 생성된 v2Employee 컬렉션 객체
     */
    apiV2EmployeeElCreate: (
      data: {
        /** 담당자명 */
        title?: string;
        /** 병원 ID */
        hospitalID?: string;
        /** 부서 ID */
        departmentID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2EmployeeElCreateData, any>({
        path: `/v2/api/v2employee/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Employee
     * @name ApiV2EmployeeElUpdate
     * @summary 병원 직원 수정
     * @request POST:/v2/api/v2employee/el/update
     * @secure
     * @response `200` `ApiV2EmployeeElUpdateData` \{v2Employee\} 수정된 v2Employee 컬렉션 객체
     */
    apiV2EmployeeElUpdate: (
      data: {
        /** 수정할 예약 담당자 ID */
        _id?: string;
        /** 담당자명 */
        title?: string;
        /** 병원 ID */
        hospitalID?: string;
        /** 병원 부서 ID */
        departmentID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2EmployeeElUpdateData, any>({
        path: `/v2/api/v2employee/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Employee
     * @name ApiV2EmployeeElUpdateSort
     * @summary 병원 직원 정렬순서 일괄 수정
     * @request POST:/v2/api/v2employee/el/update/sort
     * @secure
     * @response `200` `ApiV2EmployeeElUpdateSortData` \{v2Employee\} 마지막으로 수정된 v2Employee 컬렉션 객체
     */
    apiV2EmployeeElUpdateSort: (
      data: {
        /** 정렬 순서를 변경할 직원 목록들 */
        employees?: {
          /** 직원 ID */
          _id?: string;
          /** 정렬 순서 */
          sortNum?: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2EmployeeElUpdateSortData, any>({
        path: `/v2/api/v2employee/el/update/sort`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2Employee
     * @name ApiV2EmployeeElRemove
     * @summary 병원 직원 삭제
     * @request POST:/v2/api/v2employee/el/remove
     * @secure
     * @response `200` `ApiV2EmployeeElRemoveData` \{v2Employee\} 삭제된 v2Employee 컬렉션 객체
     */
    apiV2EmployeeElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2EmployeeElRemoveData, any>({
        path: `/v2/api/v2employee/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkCode
     * @name ApiV2WorkcodeElFind
     * @summary 병원 근무 코드 목록 조회
     * @request GET:/v2/api/v2workcode/el/find
     * @secure
     * @response `200` `ApiV2WorkcodeElFindData` \[\{v2WorkCode\}\] v2WorkCode 컬렉션 객체 배열
     */
    apiV2WorkcodeElFind: (query: ApiV2WorkcodeElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2WorkcodeElFindData, any>({
        path: `/v2/api/v2workcode/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkCode
     * @name ApiV2WorkcodeElFindSchedule
     * @summary 지정된 기간동안 근무 일정이 작성된 근무 코드 목록 조회
     * @request GET:/v2/api/v2workcode/el/find/schedule
     * @secure
     * @response `200` `ApiV2WorkcodeElFindScheduleData` \[\{v2WorkCode\}\] v2WorkCode 컬렉션 객체 배열
     */
    apiV2WorkcodeElFindSchedule: (query: ApiV2WorkcodeElFindScheduleParams, params: RequestParams = {}) =>
      this.request<ApiV2WorkcodeElFindScheduleData, any>({
        path: `/v2/api/v2workcode/el/find/schedule`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkCode
     * @name ApiV2WorkcodeElCreate
     * @summary 병원 근무 코드 생성
     * @request POST:/v2/api/v2workcode/el/create
     * @secure
     * @response `200` `ApiV2WorkcodeElCreateData` \{v2WorkCode\} 생성된 v2WorkCode 컬렉션 객체
     */
    apiV2WorkcodeElCreate: (
      data: {
        /** (required) 담당자명 */
        title?: string;
        /** (required) 병원 ID */
        hospitalID?: string;
        /** (required) 근무 시작 시간. 시,분,초 값만 사용 */
        startedAt?: string;
        /** (required) 근무 종료 시간. 시,분,초 값만 사용 */
        endedAt?: string;
        /** 근무 코드 색상의 색상번호 (기본) */
        paletteIndex?: number;
        /** 사용자 지정 색상 코드 사용여부 */
        usingCustomColor?: boolean;
        /** 색상 코드값 (16진수) */
        customColorCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2WorkcodeElCreateData, any>({
        path: `/v2/api/v2workcode/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkCode
     * @name ApiV2WorkcodeElUpdate
     * @summary 병원 근무 코드 수정
     * @request POST:/v2/api/v2workcode/el/update
     * @secure
     * @response `200` `ApiV2WorkcodeElUpdateData` \{v2WorkCode\} 수정된 v2WorkCode 컬렉션 객체
     */
    apiV2WorkcodeElUpdate: (
      data: {
        /** (required) 근무 코드 _id */
        _id?: string;
        /** 담당자명 */
        title?: string;
        /** 병원 ID */
        hospitalID?: string;
        /** 근무 시작 시간. 시,분,초 값만 사용 */
        startedAt?: string;
        /** 근무 종료 시간. 시,분,초 값만 사용 */
        endedAt?: string;
        /** 근무 코드 색상의 색상번호 (기본) */
        paletteIndex?: number;
        /** 사용자 지정 색상 코드 사용여부 */
        usingCustomColor?: boolean;
        /** 색상 코드값 (16진수) */
        customColorCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2WorkcodeElUpdateData, any>({
        path: `/v2/api/v2workcode/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkCode
     * @name ApiV2WorkcodeElRemove
     * @summary 병원 근무 코드 삭제
     * @request POST:/v2/api/v2workcode/el/remove
     * @secure
     * @response `200` `ApiV2WorkcodeElRemoveData` \{v2WorkCode\} 삭제된 v2WorkCode 컬렉션 객체
     */
    apiV2WorkcodeElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2WorkcodeElRemoveData, any>({
        path: `/v2/api/v2workcode/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkCode
     * @name ApiV2WorkcodeElSendPush
     * @summary 병원 근무 코드 일괄 업데이트에 대한 푸시 발송
     * @request POST:/v2/api/v2workcode/el/send/push
     * @secure
     * @response `200` `ApiV2WorkcodeElSendPushData` v2TODO 미정
     */
    apiV2WorkcodeElSendPush: (
      data: {
        /** 근무 코드 일괄 업데이트가 완료된 병원 ID */
        hospitalID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2WorkcodeElSendPushData, any>({
        path: `/v2/api/v2workcode/el/send/push`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkRecord
     * @name ApiV2WorkrecordElFindDate
     * @summary 일일 근무 일정 목록 조회
     * @request GET:/v2/api/v2workrecord/el/find/date
     * @secure
     * @response `200` `ApiV2WorkrecordElFindDateData` \[\{v2WorkRecord\}\] v2WorkRecord 컬렉션 객체 배열
     */
    apiV2WorkrecordElFindDate: (query: ApiV2WorkrecordElFindDateParams, params: RequestParams = {}) =>
      this.request<ApiV2WorkrecordElFindDateData, any>({
        path: `/v2/api/v2workrecord/el/find/date`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkRecord
     * @name ApiV2WorkrecordElFindSchedule
     * @summary 직원이 존재하는 근무 일정 목록 조회
     * @request GET:/v2/api/v2workrecord/el/find/schedule
     * @secure
     * @response `200` `ApiV2WorkrecordElFindScheduleData` \[\{v2WorkRecord\}\] v2WorkRecord 컬렉션 객체 배열
     */
    apiV2WorkrecordElFindSchedule: (query: ApiV2WorkrecordElFindScheduleParams, params: RequestParams = {}) =>
      this.request<ApiV2WorkrecordElFindScheduleData, any>({
        path: `/v2/api/v2workrecord/el/find/schedule`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description hospiatlID, workCodeID, date 세가지를 기준으로 upsert 동작
     *
     * @tags v2WorkRecord
     * @name ApiV2WorkrecordElUpdate
     * @summary 일일 근무 일정 등록 및 수정
     * @request POST:/v2/api/v2workrecord/el/update
     * @secure
     * @response `200` `ApiV2WorkrecordElUpdateData` \{v2WorkRecord\} 등록, 또는 수정된 v2WorkRecord 컬렉션 객체
     */
    apiV2WorkrecordElUpdate: (
      data: {
        /** (required) 병원 ID */
        hospitalID?: string;
        /** (required) 등록 또는 수정할 일일 근무 일자 */
        date?: string;
        /** (required) 근무 코드 ID. isCustomized true 케이스 입력 시, null 입력 */
        workCodeID?: string;
        employees?: string[];
        /** 수정할 일일 근무 일정. isCustomized true이고 수정 시도할 경우, 반드시 포함 */
        _id?: string;
        /** 커스텀 여부. true 설정 시, startedAt, endedAt 반드시 필요, workCodeID는 무시됨 */
        isCustomized?: boolean;
        /** 근무 시작 일시 */
        startedAt?: string;
        /** 근무 종료 일시 */
        endedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2WorkrecordElUpdateData, any>({
        path: `/v2/api/v2workrecord/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description hospiatlID, workCodeID, date 세가지를 기준으로 upsert 동작
     *
     * @tags v2WorkRecord
     * @name ApiV2WorkrecordElUpdateBatch
     * @summary 일일 근무 일정 일괄 등록 및 수정
     * @request POST:/v2/api/v2workrecord/el/update/batch
     * @secure
     * @response `200` `ApiV2WorkrecordElUpdateBatchData` bulkWrite result
     */
    apiV2WorkrecordElUpdateBatch: (
      data: {
        /** (required) 병원 ID */
        hospitalID?: string;
        /** (required) 등록 또는 수정할 일일 근무 일자 */
        date?: string;
        /** (required) 벌크 데이터 목록 */
        datas?: {
          /** 근무 코드 */
          workCodeID?: string;
          employees?: string[];
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2WorkrecordElUpdateBatchData, any>({
        path: `/v2/api/v2workrecord/el/update/batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkRecord
     * @name ApiV2WorkrecordElRemove
     * @summary 일일 근무 일정 삭제 (직접 설정 경우만)
     * @request POST:/v2/api/v2workrecord/el/remove
     * @secure
     * @response `200` `ApiV2WorkrecordElRemoveData` \{v2WorkCode\} 삭제된 v2WorkCode 컬렉션 객체
     */
    apiV2WorkrecordElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2WorkrecordElRemoveData, any>({
        path: `/v2/api/v2workrecord/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkRecord
     * @name ApiV2WorkrecordElSendPush
     * @summary 병원 근무 일정 일괄 업데이트에 대한 푸시 발송
     * @request POST:/v2/api/v2workrecord/el/send/push
     * @secure
     * @response `200` `ApiV2WorkrecordElSendPushData` v2TODO 미정
     */
    apiV2WorkrecordElSendPush: (
      data: {
        /** 근무 일정 일괄 업데이트 완료된 병원 ID */
        data?: {
          /** stringify 된 근무 코드 목록 */
          workCodeIDs?: string;
          /** stringify 된 시작 일자 */
          startDate?: string;
          /** stringify 된 종료 일자 */
          endDate?: string;
          /** App 버전 */
          hospitalID?: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2WorkrecordElSendPushData, any>({
        path: `/v2/api/v2workrecord/el/send/push`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkHoliday
     * @name ApiV2WorkholidayElFindDate
     * @summary 일일 근무 일정 휴진 목록 조회
     * @request GET:/v2/api/v2workholiday/el/find/date
     * @secure
     * @response `200` `ApiV2WorkholidayElFindDateData` \[\{v2WorkHoliday\}\] v2WorkHoliday 컬렉션 객체 배열
     */
    apiV2WorkholidayElFindDate: (query: ApiV2WorkholidayElFindDateParams, params: RequestParams = {}) =>
      this.request<ApiV2WorkholidayElFindDateData, any>({
        path: `/v2/api/v2workholiday/el/find/date`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkHoliday
     * @name ApiV2WorkholidayElCreate
     * @summary 일일 근무 일정에 대한 휴진 생성
     * @request POST:/v2/api/v2workholiday/el/create
     * @secure
     * @response `200` `ApiV2WorkholidayElCreateData` \{v2WorkHoliday\} 생성된 v2WorkHoliday 컬렉션 객체
     */
    apiV2WorkholidayElCreate: (
      data: {
        /** (required) 병원 ID */
        hospitalID?: string;
        /** (required) 등록 또는 수정할 일일 근무 일자 */
        date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2WorkholidayElCreateData, any>({
        path: `/v2/api/v2workholiday/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkHoliday
     * @name ApiV2WorkholidayElUpdate
     * @summary 일일 근무 일정에 대한 휴진 수정
     * @request POST:/v2/api/v2workholiday/el/update
     * @secure
     * @response `200` `ApiV2WorkholidayElUpdateData` \{v2WorkHoliday\} 수정된 v2WorkHoliday 컬렉션 객체
     */
    apiV2WorkholidayElUpdate: (
      data: {
        /** (required) 근무 코드 _id */
        _id?: string;
        /** 병원 ID */
        hospitalID?: string;
        /** 등록 또는 수정할 일일 근무 일자 */
        date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2WorkholidayElUpdateData, any>({
        path: `/v2/api/v2workholiday/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkHoliday
     * @name ApiV2WorkholidayElRemove
     * @summary 일일 근무 일정에 대한 휴진 삭제
     * @request POST:/v2/api/v2workholiday/el/remove
     * @secure
     * @response `200` `ApiV2WorkholidayElRemoveData` \{v2WorkHoliday\} 삭제된 v2WorkHoliday 컬렉션 객체
     */
    apiV2WorkholidayElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2WorkholidayElRemoveData, any>({
        path: `/v2/api/v2workholiday/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v2WorkHoliday
     * @name ApiV2WorkholidayMFindDate
     * @summary 일일 근무 일정 휴진 목록 조회 (모바일)
     * @request GET:/v2/api/v2workholiday/m/find/date
     * @secure
     * @response `200` `ApiV2WorkholidayMFindDateData` \[\{v2WorkHoliday\}\] v2WorkHoliday 컬렉션 객체 배열
     */
    apiV2WorkholidayMFindDate: (query: ApiV2WorkholidayMFindDateParams, params: RequestParams = {}) =>
      this.request<ApiV2WorkholidayMFindDateData, any>({
        path: `/v2/api/v2workholiday/m/find/date`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 일일 담당자(Column) 및 프로그램, 상태별 Action 횟수 조회. \ - 예약 건수 - 예약 취소 건수 - 예약 시간 - **required** - hospitalID, startDate, endDate
     *
     * @tags Stats-v2Reservation
     * @name ApiStatsV2ReservationDailyElFind
     * @summary 일일 담당자(Column) 및 프로그램별 예약 관련 Action 횟수 조회
     * @request GET:/v2/api/stats/v2reservation/daily/el/find
     * @secure
     * @response `200` `ApiStatsV2ReservationDailyElFindData` \[\{v2Stats_DailyColumnPrograms\}\] v2Stats_DailyColumnPrograms 컬렉션 객체 배열
     */
    apiStatsV2ReservationDailyElFind: (query: ApiStatsV2ReservationDailyElFindParams, params: RequestParams = {}) =>
      this.request<ApiStatsV2ReservationDailyElFindData, any>({
        path: `/v2/api/stats/v2reservation/daily/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stats-v2Reservation
     * @name ApiStatsV2ReservationDailyElFindHospital
     * @summary 일일 예약 관련 총 환자 수 조회
     * @request GET:/v2/api/stats/v2reservation/daily/el/find/hospital
     * @secure
     * @response `200` `ApiStatsV2ReservationDailyElFindHospitalData` \[\{v2Stats_DailyHospital\}\] v2Stats_DailyHospital 컬렉션 객체 배열
     */
    apiStatsV2ReservationDailyElFindHospital: (
      query: ApiStatsV2ReservationDailyElFindHospitalParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiStatsV2ReservationDailyElFindHospitalData, any>({
        path: `/v2/api/stats/v2reservation/daily/el/find/hospital`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 일일 담당자(Column) 및 프로그램별 Action 횟수 조회. \ - 예약 건수 - 예약 취소 건수 - 예약 시간 - **required** - hospitalID, columnID, startDate, endDate
     *
     * @tags Stats-v2Reservation
     * @name ApiStatsV2ReservationMonthlyElFind
     * @summary 월별 담당자(Column) 및 프로그램별 예약 관련 Action 횟수 조회
     * @request GET:/v2/api/stats/v2reservation/monthly/el/find
     * @secure
     * @response `200` `ApiStatsV2ReservationMonthlyElFindData` \[\{v2Stats_MonthlyColumnPrograms\}\] v2Stats_MonthlyColumnPrograms 컬렉션 객체 배열
     */
    apiStatsV2ReservationMonthlyElFind: (query: ApiStatsV2ReservationMonthlyElFindParams, params: RequestParams = {}) =>
      this.request<ApiStatsV2ReservationMonthlyElFindData, any>({
        path: `/v2/api/stats/v2reservation/monthly/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stats-v2Reservation
     * @name ApiStatsV2ReservationMonthlyElFindHospital
     * @summary 월별 예약 관련 총 환자 수 조회
     * @request GET:/v2/api/stats/v2reservation/monthly/el/find/hospital
     * @secure
     * @response `200` `ApiStatsV2ReservationMonthlyElFindHospitalData` \[\{v2Stats_MonthlyHospital\}\] v2Stats_MonthlyHospital 컬렉션 객체 배열
     */
    apiStatsV2ReservationMonthlyElFindHospital: (
      query: ApiStatsV2ReservationMonthlyElFindHospitalParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiStatsV2ReservationMonthlyElFindHospitalData, any>({
        path: `/v2/api/stats/v2reservation/monthly/el/find/hospital`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description - **required** - hospitalID, startDate, endDate
     *
     * @tags Stats-v2WorkRecord
     * @name ApiStatsV2WorkrecordDailyElFind
     * @summary 일별 직원 및 근무 코드별 횟수 조회
     * @request GET:/v2/api/stats/v2workrecord/daily/el/find
     * @secure
     * @response `200` `ApiStatsV2WorkrecordDailyElFindData` workCodeID, employeeID 별 근무 횟수 리스트
     */
    apiStatsV2WorkrecordDailyElFind: (query: ApiStatsV2WorkrecordDailyElFindParams, params: RequestParams = {}) =>
      this.request<ApiStatsV2WorkrecordDailyElFindData, any>({
        path: `/v2/api/stats/v2workrecord/daily/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SI-Almighty-HService
     * @name ApiSiAlHserviceElFindSimple
     * @summary (연동-전능) 스마트닥터 고객번호를 포함하는 환자 간편 조회
     * @request GET:/v2/api/si/al/hservice/el/find/simple
     * @secure
     * @response `200` `ApiSiAlHserviceElFindSimpleData` \[\{HService\}\] HService 컬렉션 객체 배열
     */
    apiSiAlHserviceElFindSimple: (query: ApiSiAlHserviceElFindSimpleParams, params: RequestParams = {}) =>
      this.request<ApiSiAlHserviceElFindSimpleData, any>({
        path: `/v2/api/si/al/hservice/el/find/simple`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServerSetting
     * @name PublicServersettingMFind
     * @summary 서버를 통한 클라이언트 버전 조회
     * @request GET:/v2/public/serversetting/m/find
     * @secure
     * @response `200` `PublicServersettingMFindData` \{ServerSetting\} 병원 모델 객체
     */
    publicServersettingMFind: (params: RequestParams = {}) =>
      this.request<PublicServersettingMFindData, any>({
        path: `/v2/public/serversetting/m/find`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServerSetting
     * @name PublicServersettingHmFind
     * @summary 서버를 통한 클라이언트 버전 조회 (애프터닥 관리자 앱)
     * @request GET:/v2/public/serversetting/hm/find
     * @secure
     * @response `200` `PublicServersettingHmFindData` \{ServerSetting\} 병원 모델 객체
     */
    publicServersettingHmFind: (params: RequestParams = {}) =>
      this.request<PublicServersettingHmFindData, any>({
        path: `/v2/public/serversetting/hm/find`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push-RequestPushNotification
     * @name ApiPushRequestElFind
     * @summary 푸시 발송 요청 조회
     * @request GET:/v2/api/push/request/el/find
     * @secure
     * @response `200` `ApiPushRequestElFindData` \[\{RequestPushNotification\}\] 입력한 hospitalID, type에 대한 RequestPushNotification 컬렉션 객체 배열
     */
    apiPushRequestElFind: (query: ApiPushRequestElFindParams, params: RequestParams = {}) =>
      this.request<ApiPushRequestElFindData, any>({
        path: `/v2/api/push/request/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push-RequestPushNotification
     * @name ApiPushRequestElCreate
     * @summary 푸시 발송 요청 생성
     * @request POST:/v2/api/push/request/el/create
     * @secure
     * @response `200` `ApiPushRequestElCreateData` \{RequestPushNotification\} 생성된 푸시 발송 요청 객체
     */
    apiPushRequestElCreate: (
      data: {
        /**
         * (required) 푸시 콘텐츠 타입
         * @default "HospitalEvent"
         */
        type?: string;
        /** (required) 병원 ObjectId */
        hospitalID?: string;
        /** (required) 병원 이벤트 ObjectId */
        hospitalEventID?: string;
        /** (required) 병원 내 고객에게 전체 발송 여부. false 시 필터 필요 */
        isSendToHospital?: boolean;
        userTagIDs?: string[];
        doctorID?: string[];
        treatmentCategories?: string[];
        isFirstVisit?: boolean[];
        /**
         * 가입 기간 시작 날짜
         * @default "2024-01-01T00:00:00.000+0900"
         */
        startDate?: string;
        /**
         * 가입 기간 종료 날짜
         * @default "2024-01-31T00:00:00.000+0900"
         */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPushRequestElCreateData, any>({
        path: `/v2/api/push/request/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push-ResponsePushNotification
     * @name ApiPushResponseElFind
     * @summary 푸시 발송 성공 조회 - 여러개 보내진 경우 하나만 표시
     * @request GET:/v2/api/push/response/el/find
     * @secure
     * @response `200` `ApiPushResponseElFindData` \[\{ResponsePushNotification\}\] 입력한 hserviceID에 대한 ResponsePushNotification 컬렉션 객체 배열
     */
    apiPushResponseElFind: (query: ApiPushResponseElFindParams, params: RequestParams = {}) =>
      this.request<ApiPushResponseElFindData, any>({
        path: `/v2/api/push/response/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserAction-HospitalEvent
     * @name ApiUseractionHospitaleventMCreate
     * @summary 유저액션-병원이벤트 로그 신규 생성 (mobile)
     * @request POST:/v2/api/useraction/hospitalevent/m/create
     * @secure
     * @response `200` `ApiUseractionHospitaleventMCreateData` \{UserAction-HospitalEvent\} 유저액션-병원이벤트 로그 객체
     */
    apiUseractionHospitaleventMCreate: (
      data: {
        /** (required) 병원 ID */
        hospitalID?: string;
        /** (required) 병원 이벤트 ID */
        hospitalEventID?: string;
        /** (required) 유저 ID */
        userID?: string;
        /** (required) 병원서비스 ID */
        hserviceID?: string;
        /** (optional) 푸시 클릭 후, 연속적으로 진입했을 경우의 requsetPushNotificationID */
        requestPushNotificationID?: string;
        /** (optional) 푸시 클릭 후, 연속적으로 진입했을 경우 true. 그 외의 경우 false */
        isFromPush?: boolean;
        /** (required) 고객이 수행한 동작 (Click / View / Chat) */
        action?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiUseractionHospitaleventMCreateData, any>({
        path: `/v2/api/useraction/hospitalevent/m/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-HealthContentPush
     * @name AdminHealthcontentPushElCreate
     * @summary 건강콘텐츠 푸시 히스토리 객체의 생성
     * @request POST:/v2/admin/healthcontent/push/el/create
     * @secure
     * @response `200` `AdminHealthcontentPushElCreateData` \{h_HealthContentPush\} 건강 콘텐츠 푸시 히스토리 생성된 객체
     */
    adminHealthcontentPushElCreate: (
      data: {
        /** 건강 콘텐츠 ObjectId */
        hcID?: string;
        /** 건강콘텐츠 푸시 메시지 제목 */
        title?: string;
        /** 건강콘텐츠 푸시 메시지 내용 */
        content?: string;
        /** 건강콘텐츠 푸시 전달 대상. (전체/...) */
        targetUser?: string;
        /**
         * 전송 일시
         * @default "2022-12-25T00:00:00.000+0900"
         */
        sentAt?: Date;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHealthcontentPushElCreateData, any>({
        path: `/v2/admin/healthcontent/push/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-HealthContentPush
     * @name AdminHealthcontentPushElFind
     * @summary 건강콘텐츠 푸시 히스토리 객체의 조회
     * @request GET:/v2/admin/healthcontent/push/el/find
     * @secure
     * @response `200` `AdminHealthcontentPushElFindData` \[\{h_HealthContentPush\}\] 건강콘텐츠 푸시 히스토리 객체 배열
     */
    adminHealthcontentPushElFind: (query: AdminHealthcontentPushElFindParams, params: RequestParams = {}) =>
      this.request<AdminHealthcontentPushElFindData, any>({
        path: `/v2/admin/healthcontent/push/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-HealthContentPush
     * @name AdminHealthcontentPushElRemove
     * @summary 건강콘텐츠 푸시 히스토리 객체의 삭제
     * @request POST:/v2/admin/healthcontent/push/el/remove
     * @secure
     * @response `200` `AdminHealthcontentPushElRemoveData` \{h_HealthContentPush\} 삭제된 건강콘텐츠 푸시 히스토리 객체
     */
    adminHealthcontentPushElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHealthcontentPushElRemoveData, any>({
        path: `/v2/admin/healthcontent/push/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-HealthContent
     * @name AdminHealthcontentContentElCreate
     * @summary 건강콘텐츠 객체의 생성
     * @request POST:/v2/admin/healthcontent/content/el/create
     * @secure
     * @response `200` `AdminHealthcontentContentElCreateData` \{HealthContent\} 건강 콘텐츠 생성된 객체
     */
    adminHealthcontentContentElCreate: (
      data: {
        title?: string;
        categoryIDs?: string[];
        summary?: string;
        thumbnailURL?: string;
        contentURL?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHealthcontentContentElCreateData, any>({
        path: `/v2/admin/healthcontent/content/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-HealthContent
     * @name AdminHealthcontentContentElFind
     * @summary 건강콘텐츠 객체의 조회
     * @request GET:/v2/admin/healthcontent/content/el/find
     * @secure
     * @response `200` `AdminHealthcontentContentElFindData` \[\{HealthContent\}\] 건강콘텐츠 객체 배열
     */
    adminHealthcontentContentElFind: (query: AdminHealthcontentContentElFindParams, params: RequestParams = {}) =>
      this.request<AdminHealthcontentContentElFindData, any>({
        path: `/v2/admin/healthcontent/content/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-HealthContent
     * @name AdminHealthcontentContentElRemove
     * @summary 건강콘텐츠 객체의 삭제
     * @request POST:/v2/admin/healthcontent/content/el/remove
     * @secure
     * @response `200` `AdminHealthcontentContentElRemoveData` \{HealthContent\} 삭제된 건강콘텐츠 객체
     */
    adminHealthcontentContentElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHealthcontentContentElRemoveData, any>({
        path: `/v2/admin/healthcontent/content/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-HealthContent
     * @name AdminHealthcontentContentElUpdate
     * @summary 건강콘텐츠 업데이트
     * @request POST:/v2/admin/healthcontent/content/el/update
     * @secure
     * @response `200` `AdminHealthcontentContentElUpdateData` \{HealthContent\} 업데이트 된 건강콘텐츠 객체
     */
    adminHealthcontentContentElUpdate: (
      data: {
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHealthcontentContentElUpdateData, any>({
        path: `/v2/admin/healthcontent/content/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-HealthContentCategory
     * @name AdminHealthcontentCategoryElFind
     * @summary 건강 콘텐츠 카테고리 조회
     * @request GET:/v2/admin/healthcontent/category/el/find
     * @secure
     * @response `200` `AdminHealthcontentCategoryElFindData` \[\{HealthContentCategory\}\] 건강 콘텐츠 카테고리 객체 배열
     */
    adminHealthcontentCategoryElFind: (query: AdminHealthcontentCategoryElFindParams, params: RequestParams = {}) =>
      this.request<AdminHealthcontentCategoryElFindData, any>({
        path: `/v2/admin/healthcontent/category/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-hlsvideo
     * @name AdminHomecareVideocontentHlsvideoElCreate
     * @summary 홈케어콘텐츠 영상 생성
     * @request POST:/v2/admin/homecare/videocontent/hlsvideo/el/create
     * @secure
     * @response `200` `AdminHomecareVideocontentHlsvideoElCreateData` \{HLSVideo\} 홈케어콘텐츠 영상 객체
     */
    adminHomecareVideocontentHlsvideoElCreate: (
      data: {
        writerID?: string;
        title?: string;
        paths?: string[];
        aws?: Record<string, any>[];
        totalVideoSize?: number;
        totalVideoLength?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentHlsvideoElCreateData, any>({
        path: `/v2/admin/homecare/videocontent/hlsvideo/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-hlsvideo
     * @name AdminHomecareVideocontentHlsvideoElFind
     * @summary 홈케어콘텐츠 영상 조회
     * @request GET:/v2/admin/homecare/videocontent/hlsvideo/el/find
     * @secure
     * @response `200` `AdminHomecareVideocontentHlsvideoElFindData` \[\{HLSVideo\}\] 홈케어콘텐츠 영상 객체 배열
     */
    adminHomecareVideocontentHlsvideoElFind: (
      query: AdminHomecareVideocontentHlsvideoElFindParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentHlsvideoElFindData, any>({
        path: `/v2/admin/homecare/videocontent/hlsvideo/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-hlsvideo
     * @name AdminHomecareVideocontentHlsvideoElUpdate
     * @summary 홈케어콘텐츠 영상 수정
     * @request POST:/v2/admin/homecare/videocontent/hlsvideo/el/update
     * @secure
     * @response `200` `AdminHomecareVideocontentHlsvideoElUpdateData` \{HLSVideo\} 홈케어콘텐츠 영상 객체
     */
    adminHomecareVideocontentHlsvideoElUpdate: (
      data: {
        _id?: string;
        writerID?: string;
        title?: string;
        paths?: string[];
        aws?: Record<string, any>[];
        totalVideoSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentHlsvideoElUpdateData, any>({
        path: `/v2/admin/homecare/videocontent/hlsvideo/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-hlsvideo
     * @name AdminHomecareVideocontentHlsvideoElCount
     * @summary 홈케어콘텐츠 영상 파일 수 조회
     * @request GET:/v2/admin/homecare/videocontent/hlsvideo/el/count
     * @secure
     * @response `200` `AdminHomecareVideocontentHlsvideoElCountData` 홈케어콘텐츠 영상 파일 수
     */
    adminHomecareVideocontentHlsvideoElCount: (params: RequestParams = {}) =>
      this.request<AdminHomecareVideocontentHlsvideoElCountData, any>({
        path: `/v2/admin/homecare/videocontent/hlsvideo/el/count`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContentGlobalSetting
     * @name AdminHomecareVideocontentVideocontentglobalsettingElCreate
     * @summary 운동콘텐츠 전체 기본 설정 생성(메디팔 관할)
     * @request POST:/v2/admin/homecare/videocontent/videocontentglobalsetting/el/create
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentglobalsettingElCreateData` \{VideoContentGlobalSetting\} 운동콘텐츠 전체 기본 설정 객체
     */
    adminHomecareVideocontentVideocontentglobalsettingElCreate: (
      data: {
        /** popupImage ObjectID */
        popupImageCV?: string;
        /** 운동콘텐츠 전송 시 기본 코멘트 */
        defaultVCMessage?: string;
        /** 운동콘텐츠 전송 시 채팅 내용 */
        defaultVCChatMessage?: string;
        /** 운동콘텐츠 전달 푸시 알림의 푸시 제목 */
        defaultVCChatMessageTitle?: string;
        /** 운동콘텐츠 전달 푸시 알림의 푸시 내용 */
        defaultVCChatMessageContent?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentglobalsettingElCreateData, any>({
        path: `/v2/admin/homecare/videocontent/videocontentglobalsetting/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContentGlobalSetting
     * @name AdminHomecareVideocontentVideocontentglobalsettingElFind
     * @summary 운동콘텐츠 전체 기본 설정 조회(메디팔 관할)
     * @request GET:/v2/admin/homecare/videocontent/videocontentglobalsetting/el/find
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentglobalsettingElFindData` \[\{VideoContentGlobalSetting\}\] 운동콘텐츠 전체 기본 설정 객체 배열
     */
    adminHomecareVideocontentVideocontentglobalsettingElFind: (
      query: AdminHomecareVideocontentVideocontentglobalsettingElFindParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentglobalsettingElFindData, any>({
        path: `/v2/admin/homecare/videocontent/videocontentglobalsetting/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContentGlobalSetting
     * @name AdminHomecareVideocontentVideocontentglobalsettingElUpdate
     * @summary 운동콘텐츠 전체 기본 설정 수정(메디팔 관할)
     * @request POST:/v2/admin/homecare/videocontent/videocontentglobalsetting/el/update
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentglobalsettingElUpdateData` \{VideoContentGlobalSetting\} 운동콘텐츠 전체 기본 설정 객체
     */
    adminHomecareVideocontentVideocontentglobalsettingElUpdate: (
      data: {
        /** VideoContentGlobalSetting ObjectId */
        _id?: string;
        /** popupImage ObjectID */
        popupImageCV?: string;
        /** 운동콘텐츠 전송 시 기본 코멘트 */
        defaultVCMessage?: string;
        /** 운동콘텐츠 전송 시 채팅 내용 */
        defaultVCChatMessage?: string;
        /** 운동콘텐츠 전달 푸시 알림의 푸시 제목 */
        defaultVCChatMessageTitle?: string;
        /** 운동콘텐츠 전달 푸시 알림의 푸시 내용 */
        defaultVCChatMessageContent?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentglobalsettingElUpdateData, any>({
        path: `/v2/admin/homecare/videocontent/videocontentglobalsetting/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContent
     * @name AdminHomecareVideocontentVideocontentElCreate
     * @summary 운동콘텐츠 신규 생성
     * @request POST:/v2/admin/homecare/videocontent/videocontent/el/create
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentElCreateData` \{VideoContent\} 운동콘텐츠 컬렉션 객체
     */
    adminHomecareVideocontentVideocontentElCreate: (
      data: {
        /** 실제 영상 정보가 있는 HLSVideo의 ObjectId */
        videoFileID?: string;
        /** 운동 처방 대표 썸네일 파일 ObjectId */
        thumbnailFileID?: string;
        /** 운동콘텐츠 부제목 */
        subtitle?: string;
        /** 운동콘텐츠 제목 */
        title?: string;
        categories?: string[];
        /** 관련 질환. ex) 거북목, 족저근막염, ... */
        relatedDiseases?: string;
        /** 운동종류 ex) 마사지, 스트레칭, ... */
        exerciseType?: string;
        /**
         * 운동 콘텐츠가 세부동작인지 아닌지를 체크하는 boolean flag. 세부동작일 경우 true
         * @default false
         */
        isDetail?: boolean;
        exerciseSet?: {
          /** 운동 구성 제목 */
          title?: string;
          /** 운동 구성 제목(영문) */
          titleEn?: string;
          /** 운동 구성 설명 */
          description?: string;
          /** 운동 구성 썸네일 이미지 ObjectId */
          thumbnailFileID?: string;
          /** 운동 챕터 timestamp (단위 - ms, 밀리초) */
          timestamp?: number;
        }[];
        /** 운동 정보 */
        description?: string;
        material?: {
          /** 준비물 명칭 */
          name?: string;
          /** 준비물 썸네일 이미지 ObjectId */
          thumbnailFileID?: string;
        }[];
        /** 주의사항 */
        precaution?: string;
        searchKeyword?: string[];
        /** 자극부위 이미지 ID. */
        stimulateMusclesImageID?: string;
        /** 자극부위 ex) 흉쇄유돌근, 사각근, ... */
        stimulateMuscles?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentElCreateData, any>({
        path: `/v2/admin/homecare/videocontent/videocontent/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContent
     * @name AdminHomecareVideocontentVideocontentElFind
     * @summary 운동콘텐츠 조회
     * @request GET:/v2/admin/homecare/videocontent/videocontent/el/find
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentElFindData` \[\{VideoContent\}\] 운동콘텐츠 객체 배열
     */
    adminHomecareVideocontentVideocontentElFind: (
      query: AdminHomecareVideocontentVideocontentElFindParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentElFindData, any>({
        path: `/v2/admin/homecare/videocontent/videocontent/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContent
     * @name AdminHomecareVideocontentVideocontentElUpdate
     * @summary 운동콘텐츠 수정
     * @request POST:/v2/admin/homecare/videocontent/videocontent/el/update
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentElUpdateData` \{VideoContent\} 운동콘텐츠 컬렉션 객체
     */
    adminHomecareVideocontentVideocontentElUpdate: (
      data: {
        /** VideoContent ObjectId */
        _id?: string;
        /** 실제 영상 정보가 있는 HLSVideo의 ObjectId */
        videoFileID?: string;
        /** 운동 처방 대표 썸네일 파일 ObjectId */
        thumbnailFileID?: string;
        /** 운동콘텐츠 부제목 */
        subtitle?: string;
        /** 운동콘텐츠 제목 */
        title?: string;
        categories?: string[];
        /** 관련 질환. ex) 거북목, 족저근막염, ... */
        relatedDiseases?: string;
        /** 운동종류 ex) 마사지, 스트레칭, ... */
        exerciseType?: string;
        /**
         * 운동 콘텐츠가 세부동작인지 아닌지를 체크하는 boolean flag. 세부동작일 경우 true
         * @default false
         */
        isDetail?: boolean;
        exerciseSet?: {
          /** 운동 구성 제목 */
          title?: string;
          /** 운동 구성 제목(영문) */
          titleEn?: string;
          /** 운동 구성 설명 */
          description?: string;
          /** 운동 구성 썸네일 이미지 ObjectId */
          thumbnailFileID?: string;
          /** 운동 챕터 timestamp (단위 - ms, 밀리초) */
          timestamp?: number;
        }[];
        /** 운동 정보 */
        description?: string;
        material?: {
          /** 준비물 명칭 */
          name?: string;
          /** 준비물 썸네일 이미지 ObjectId */
          thumbnailFileID?: string;
        }[];
        /** 주의사항 */
        precaution?: string;
        searchKeyword?: string[];
        /** 자극부위 이미지 ID. */
        stimulateMusclesImageID?: string;
        /** 자극부위 ex) 흉쇄유돌근, 사각근, ... */
        stimulateMuscles?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentElUpdateData, any>({
        path: `/v2/admin/homecare/videocontent/videocontent/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContent
     * @name AdminHomecareVideocontentVideocontentElRemove
     * @summary 운동콘텐츠 삭제
     * @request POST:/v2/admin/homecare/videocontent/videocontent/el/remove
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentElRemoveData` \{VideoContent\} 운동콘텐츠 컬렉션 객체
     */
    adminHomecareVideocontentVideocontentElRemove: (
      data: {
        /** VideoContent ObjectId */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentElRemoveData, any>({
        path: `/v2/admin/homecare/videocontent/videocontent/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContent
     * @name AdminHomecareVideocontentVideocontentElCount
     * @summary 운동콘텐츠 카테고리별 count 조회
     * @request GET:/v2/admin/homecare/videocontent/videocontent/el/count
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentElCountData` 검색키워드 및 운동콘텐츠 카테고리와 일치하는 운동콘텐츠 수
     */
    adminHomecareVideocontentVideocontentElCount: (
      query: AdminHomecareVideocontentVideocontentElCountParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentElCountData, any>({
        path: `/v2/admin/homecare/videocontent/videocontent/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContentHospital
     * @name AdminHomecareVideocontentVideocontenthospitalElFind
     * @summary 운동콘텐츠 조회
     * @request GET:/v2/admin/homecare/videocontent/videocontenthospital/el/find
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontenthospitalElFindData` \[\{VideoContentHospital\}\] 운동콘텐츠 객체 배열
     */
    adminHomecareVideocontentVideocontenthospitalElFind: (
      query: AdminHomecareVideocontentVideocontenthospitalElFindParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontenthospitalElFindData, any>({
        path: `/v2/admin/homecare/videocontent/videocontenthospital/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContentHospital
     * @name AdminHomecareVideocontentVideocontenthospitalElCreate
     * @summary 병원-커스텀 운동콘텐츠 신규 생성
     * @request POST:/v2/admin/homecare/videocontent/videocontenthospital/el/create
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontenthospitalElCreateData` \{VideoContentHospital\} 병원-커스텀 운동콘텐츠 컬렉션 객체
     */
    adminHomecareVideocontentVideocontenthospitalElCreate: (
      data: {
        /** 병원-커스텀 운동콘텐츠의 베이스가 될 운동콘텐츠 ID */
        vcID?: string;
        /** 병원 ID */
        hospitalID?: string;
        /** 일주일 중 실천할 횟수 (주 n회) */
        doPerWeek?: number;
        /** 처방기간 (n주 동안 진행) */
        duration?: number;
        /** 운동콘텐츠 코멘트 */
        message?: string;
        /** 적합 라벨링을 유무를 체크하는 boolean flag. '적합'일 경우 true */
        isRecommend?: boolean;
        /** 자동 발송에 사용할 운동 콘텐츠인지 여부를 체크하는 boolean flag. */
        isDefault?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontenthospitalElCreateData, any>({
        path: `/v2/admin/homecare/videocontent/videocontenthospital/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description body에서 사용하지 않는 값은 삭제.
     *
     * @tags Admin-VideoContentHospital
     * @name AdminHomecareVideocontentVideocontenthospitalElUpdate
     * @summary 병원-커스텀 운동콘텐츠 신규 생성
     * @request POST:/v2/admin/homecare/videocontent/videocontenthospital/el/update
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontenthospitalElUpdateData` \{VideoContentHospital\} 병원-커스텀 운동콘텐츠 컬렉션 객체
     */
    adminHomecareVideocontentVideocontenthospitalElUpdate: (
      data: {
        /** (required) 병원-커스텀 운동콘텐츠 ID */
        vchID?: string;
        /** 일주일 중 실천할 횟수 (주 n회) */
        doPerWeek?: number;
        /** 처방기간 (n주 동안 진행) */
        duration?: number;
        /** 운동콘텐츠 코멘트 */
        message?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontenthospitalElUpdateData, any>({
        path: `/v2/admin/homecare/videocontent/videocontenthospital/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description - 이용중인 모든 병원, 모든 카테고리(공용+전용)에 대해 신규 영상(VCH)들을 Upsert. - 전용은 해당 병원에만 복사.
     *
     * @tags Admin-VideoContentHospital
     * @name AdminHomecareVideocontentVideocontenthospitalElCopyAll
     * @summary 병원-커스텀 운동콘텐츠 전체 복사.
     * @request GET:/v2/admin/homecare/videocontent/videocontenthospital/el/copy/all
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontenthospitalElCopyAllData` \[\{VideoContentHospital\}\] 모든 병원-커스텀 운동콘텐츠 컬렉션 객체 배열
     */
    adminHomecareVideocontentVideocontenthospitalElCopyAll: (params: RequestParams = {}) =>
      this.request<AdminHomecareVideocontentVideocontenthospitalElCopyAllData, any>({
        path: `/v2/admin/homecare/videocontent/videocontenthospital/el/copy/all`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description - 복사할 공통 카테고리 대 ID 필요. 이용중인 모든 병원에 대해 Upsert copy 형태로 동작.
     *
     * @tags Admin-VideoContentHospital
     * @name AdminHomecareVideocontentVideocontenthospitalElCopyGlobalcategory
     * @summary 공통 대 카테고리에 대한 병원-커스텀 운동콘텐츠 복사.
     * @request GET:/v2/admin/homecare/videocontent/videocontenthospital/el/copy/globalcategory
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontenthospitalElCopyGlobalcategoryData` \[\{VideoContentHospital\}\] 현재까지 생성된 병원-커스텀 운동콘텐츠 컬렉션 객체 수 (count)
     */
    adminHomecareVideocontentVideocontenthospitalElCopyGlobalcategory: (
      query: AdminHomecareVideocontentVideocontenthospitalElCopyGlobalcategoryParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontenthospitalElCopyGlobalcategoryData, any>({
        path: `/v2/admin/homecare/videocontent/videocontenthospital/el/copy/globalcategory`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description - 복사할 대상 병원 ID와 카테고리 대 ID 필요. 선택한 병원, 전용 카테고리에 대해 Upsert copy 형태로 동작.
     *
     * @tags Admin-VideoContentHospital
     * @name AdminHomecareVideocontentVideocontenthospitalElCopyHospitalcategory
     * @summary 병원 전용 대 카테고리에 대한 병원-커스텀 운동콘텐츠 복사.
     * @request GET:/v2/admin/homecare/videocontent/videocontenthospital/el/copy/hospitalcategory
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontenthospitalElCopyHospitalcategoryData` \[\{VideoContentHospital\}\] 현재까지 생성된 병원-커스텀 운동콘텐츠 컬렉션 객체 수 (count)
     */
    adminHomecareVideocontentVideocontenthospitalElCopyHospitalcategory: (
      query: AdminHomecareVideocontentVideocontenthospitalElCopyHospitalcategoryParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontenthospitalElCopyHospitalcategoryData, any>({
        path: `/v2/admin/homecare/videocontent/videocontenthospital/el/copy/hospitalcategory`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description - 입력한 병원ID에 대해 모든 카테고리(공용+전용)에 대해 신규 영상(VCH)들을 Upsert. - 전용은 해당 병원에만 복사.
     *
     * @tags Admin-VideoContentHospital
     * @name AdminHomecareVideocontentVideocontenthospitalElCopyHospital
     * @summary 병원-커스텀 운동콘텐츠 병원ID 기준 복사.
     * @request GET:/v2/admin/homecare/videocontent/videocontenthospital/el/copy/hospital
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontenthospitalElCopyHospitalData` \[\{VideoContentHospital\}\] 모든 병원-커스텀 운동콘텐츠 컬렉션 객체 배열
     */
    adminHomecareVideocontentVideocontenthospitalElCopyHospital: (
      query: AdminHomecareVideocontentVideocontenthospitalElCopyHospitalParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontenthospitalElCopyHospitalData, any>({
        path: `/v2/admin/homecare/videocontent/videocontenthospital/el/copy/hospital`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContentCategory
     * @name AdminHomecareVideocontentVideocontentcategoryElCreate
     * @summary 운동콘텐츠 카테고리 신규 생성
     * @request POST:/v2/admin/homecare/videocontent/videocontentcategory/el/create
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentcategoryElCreateData` \{VideoContentCategory\} 운동콘텐츠 카테고리 컬렉션 객체
     */
    adminHomecareVideocontentVideocontentcategoryElCreate: (
      data: {
        /** 운동콘텐츠 카테고리 명칭 */
        categoryName?: string;
        /** 병원의 ObjectId */
        hospitalID?: string;
        /** 카테고리의 정렬 순서(비워둘 시 기본값 9999) */
        sortNum?: number;
        /** 카테고리 대 여부 boolean */
        isTop?: boolean;
        /** 카테고리 중 여부 boolean */
        isParent?: boolean;
        parentCategoryIDs?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentcategoryElCreateData, any>({
        path: `/v2/admin/homecare/videocontent/videocontentcategory/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description - isTop, hospitalID 필수. - isTop 이 true 일 경우, 카테고리 대 조회(통증 및 재활, 여성건강, 소아청소년 성장...) - isTop 이 false 이고 parentCategoryIDs가 있는 경우, 해당 부모 카테고리에 속한 운동콘텐츠들을 조회 (통증 및 재활에 속하는 고객 운동콘텐츠들)
     *
     * @tags Admin-VideoContentCategory
     * @name AdminHomecareVideocontentVideocontentcategoryElFind
     * @summary 운동콘텐츠 카테고리 목록 조회
     * @request GET:/v2/admin/homecare/videocontent/videocontentcategory/el/find
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentcategoryElFindData` \[\{VideoContentCategory\}\] 운동콘텐츠 카테고리 컬렉션 객체 배열
     */
    adminHomecareVideocontentVideocontentcategoryElFind: (
      query: AdminHomecareVideocontentVideocontentcategoryElFindParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentcategoryElFindData, any>({
        path: `/v2/admin/homecare/videocontent/videocontentcategory/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContentCategory
     * @name AdminHomecareVideocontentVideocontentcategoryElFindOne
     * @summary 운동콘텐츠 카테고리 단일 조회
     * @request GET:/v2/admin/homecare/videocontent/videocontentcategory/el/find/one
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentcategoryElFindOneData` \{VideoContentCategory\} 운동콘텐츠 카테고리 컬렉션 객체
     */
    adminHomecareVideocontentVideocontentcategoryElFindOne: (
      query: AdminHomecareVideocontentVideocontentcategoryElFindOneParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentcategoryElFindOneData, any>({
        path: `/v2/admin/homecare/videocontent/videocontentcategory/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description - 대 카테고리만 조회. - hospitalID를 입력 시, 병원 전용 대 카테고리까지 조회.
     *
     * @tags Admin-VideoContentCategory
     * @name AdminHomecareVideocontentVideocontentcategoryElFindTop
     * @summary 운동콘텐츠 대 카테고리 목록 조회
     * @request GET:/v2/admin/homecare/videocontent/videocontentcategory/el/find/top
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentcategoryElFindTopData` \[\{VideoContentCategory\}\] 운동콘텐츠 카테고리 컬렉션 객체 배열
     */
    adminHomecareVideocontentVideocontentcategoryElFindTop: (
      query: AdminHomecareVideocontentVideocontentcategoryElFindTopParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentcategoryElFindTopData, any>({
        path: `/v2/admin/homecare/videocontent/videocontentcategory/el/find/top`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description - isTop, hospitalID 필수. - isTop 이 true 일 경우, 카테고리 대 조회(통증 및 재활, 여성건강, 소아청소년 성장...) - isTop 이 false 이고 parentCategoryIDs가 있는 경우, 해당 부모 카테고리에 속한 운동콘텐츠들을 조회 (통증 및 재활에 속하는 고객 운동콘텐츠들)
     *
     * @tags Admin-VideoContentCategory
     * @name AdminHomecareVideocontentVideocontentcategoryElFindLast
     * @summary 운동콘텐츠 카테고리 중, 마지막 카테고리 객체 조회(sortNum 기준)
     * @request GET:/v2/admin/homecare/videocontent/videocontentcategory/el/find/last
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentcategoryElFindLastData` \{VideoContentCategory\} 운동콘텐츠 카테고리 컬렉션 객체
     */
    adminHomecareVideocontentVideocontentcategoryElFindLast: (
      query: AdminHomecareVideocontentVideocontentcategoryElFindLastParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentcategoryElFindLastData, any>({
        path: `/v2/admin/homecare/videocontent/videocontentcategory/el/find/last`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description - 컨디셔닝 카테고리 조회.
     *
     * @tags Admin-VideoContentCategory
     * @name AdminHomecareVideocontentVideocontentcategoryElFindConditioning
     * @summary 운동콘텐츠 컨디셔닝 카테고리 조회
     * @request GET:/v2/admin/homecare/videocontent/videocontentcategory/el/find/conditioning
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentcategoryElFindConditioningData` \[\{VideoContentCategory\}\] 운동콘텐츠 카테고리 컬렉션 객체 배열
     */
    adminHomecareVideocontentVideocontentcategoryElFindConditioning: (
      query: AdminHomecareVideocontentVideocontentcategoryElFindConditioningParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentcategoryElFindConditioningData, any>({
        path: `/v2/admin/homecare/videocontent/videocontentcategory/el/find/conditioning`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContentCategory
     * @name AdminHomecareVideocontentVideocontentcategoryElUpdate
     * @summary 운동콘텐츠 카테고리 수정
     * @request POST:/v2/admin/homecare/videocontent/videocontentcategory/el/update
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentcategoryElUpdateData` \{VideoContentCategory\} 운동콘텐츠 카테고리 컬렉션 객체
     */
    adminHomecareVideocontentVideocontentcategoryElUpdate: (
      data: {
        /** 업데이트 할 운동콘텐츠 카테고리 ObjectId */
        _id?: string;
        /** 운동콘텐츠 카테고리 명칭 */
        categoryName?: string;
        /** 카테고리의 정렬 순서 */
        sortNum?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentcategoryElUpdateData, any>({
        path: `/v2/admin/homecare/videocontent/videocontentcategory/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContentCategory
     * @name AdminHomecareVideocontentVideocontentcategoryElUpdateHidden
     * @summary 운동콘텐츠 카테고리 숨김 여부 수정
     * @request POST:/v2/admin/homecare/videocontent/videocontentcategory/el/update/hidden
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentcategoryElUpdateHiddenData` \{VideoContentCategory\} 운동콘텐츠 카테고리 컬렉션 객체
     */
    adminHomecareVideocontentVideocontentcategoryElUpdateHidden: (
      data: {
        /** 업데이트 할 운동콘텐츠 카테고리 ObjectId */
        _id?: string;
        /** (required) 카테고리 숨김 여부 */
        isHidden?: boolean;
        /** (required) 대 카테고리 여부 */
        isTop?: string;
        /** (optional) 병원 ID */
        hospitalID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentcategoryElUpdateHiddenData, any>({
        path: `/v2/admin/homecare/videocontent/videocontentcategory/el/update/hidden`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-VideoContentCategory
     * @name AdminHomecareVideocontentVideocontentcategoryElUpdateTypename
     * @summary 운동콘텐츠 카테고리의 명칭 수정
     * @request POST:/v2/admin/homecare/videocontent/videocontentcategory/el/update/typename
     * @secure
     * @response `200` `AdminHomecareVideocontentVideocontentcategoryElUpdateTypenameData` \[\{VideoContentCategory\}\] 운동콘텐츠 카테고리 컬렉션 객체 배열
     */
    adminHomecareVideocontentVideocontentcategoryElUpdateTypename: (
      data: {
        _id?: string[];
        /** 운동콘텐츠 카테고리 명칭 */
        typeName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHomecareVideocontentVideocontentcategoryElUpdateTypenameData, any>({
        path: `/v2/admin/homecare/videocontent/videocontentcategory/el/update/typename`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Hospital
     * @name AdminHospitalElFind
     * @summary 병원 조회
     * @request GET:/v2/admin/hospital/el/find
     * @secure
     * @response `200` `AdminHospitalElFindData` \[\{Hospital\}\] 병원 객체 배열
     */
    adminHospitalElFind: (query: AdminHospitalElFindParams, params: RequestParams = {}) =>
      this.request<AdminHospitalElFindData, any>({
        path: `/v2/admin/hospital/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Hospital
     * @name AdminHospitalElFindNurse
     * @summary 병원 담당 서비스 매니저 조회
     * @request GET:/v2/admin/hospital/el/find/nurse
     * @secure
     * @response `200` `AdminHospitalElFindNurseData` \[\{User\}\] 사용자 객체 배열
     */
    adminHospitalElFindNurse: (query: AdminHospitalElFindNurseParams, params: RequestParams = {}) =>
      this.request<AdminHospitalElFindNurseData, any>({
        path: `/v2/admin/hospital/el/find/nurse`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Hospital
     * @name AdminHospitalElCreate
     * @summary 신규 병원 생성
     * @request POST:/v2/admin/hospital/el/create
     * @secure
     * @response `200` `AdminHospitalElCreateData` \{Hospital\} 병원 객체
     */
    adminHospitalElCreate: (
      data: {
        name?: string;
        shortName?: string;
        nurseID?: string;
        initialChat?: string[];
        smsChatMessageA?: string;
        smsChatMessageB?: string;
        smsBasicMessage?: string;
        smsReservation?: string;
        smsResendMessage?: string;
        usingVideoContent?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHospitalElCreateData, any>({
        path: `/v2/admin/hospital/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Hospital
     * @name AdminHospitalElCount
     * @summary 병원 수 조회
     * @request GET:/v2/admin/hospital/el/count/
     * @secure
     * @response `200` `AdminHospitalElCountData` 검색키워드와 일치하는 병원 수
     */
    adminHospitalElCount: (query: AdminHospitalElCountParams, params: RequestParams = {}) =>
      this.request<AdminHospitalElCountData, any>({
        path: `/v2/admin/hospital/el/count/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Hospital
     * @name AdminHospitalElUpdate
     * @summary 신규 병원 수정
     * @request POST:/v2/admin/hospital/el/update
     * @secure
     * @response `200` `AdminHospitalElUpdateData` \{Hospital\} 병원 객체
     */
    adminHospitalElUpdate: (
      data: {
        /** 수정할 병원 ObjectID */
        _id?: string;
        name?: string;
        shortName?: string;
        nurseID?: string;
        initialChat?: string[];
        smsBasicMessage?: string;
        smsReservation?: string;
        smsResendMessage?: string;
        usingVideoContent?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHospitalElUpdateData, any>({
        path: `/v2/admin/hospital/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Hospital
     * @name AdminHospitalElFindDoctor
     * @summary 병원의 병원관계자 계정 조회
     * @request GET:/v2/admin/hospital/el/find/doctor
     * @secure
     * @response `200` `AdminHospitalElFindDoctorData` \[\{User\}\] 병원의 병원관계자 객체 배열
     */
    adminHospitalElFindDoctor: (query: AdminHospitalElFindDoctorParams, params: RequestParams = {}) =>
      this.request<AdminHospitalElFindDoctorData, any>({
        path: `/v2/admin/hospital/el/find/doctor`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Hospital
     * @name AdminHospitalElCountDoctor
     * @summary 병원의 병원관계자 계정 수 조회
     * @request GET:/v2/admin/hospital/el/count/doctor
     * @secure
     * @response `200` `AdminHospitalElCountDoctorData` 병원의 병원관계자 계정 수
     */
    adminHospitalElCountDoctor: (query: AdminHospitalElCountDoctorParams, params: RequestParams = {}) =>
      this.request<AdminHospitalElCountDoctorData, any>({
        path: `/v2/admin/hospital/el/count/doctor`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Hospital
     * @name AdminHospitalElCreateDoctor
     * @summary 병원의 병원관계자 생성
     * @request POST:/v2/admin/hospital/el/create/doctor
     * @secure
     * @response `200` `AdminHospitalElCreateDoctorData` \{User\} 사용자 객체
     */
    adminHospitalElCreateDoctor: (
      data: {
        hospitalID?: string;
        name?: string;
        id?: string;
        password?: string;
        type?: number;
        isDoctor?: boolean;
        jobType?: string;
        needInitial?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHospitalElCreateDoctorData, any>({
        path: `/v2/admin/hospital/el/create/doctor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Hospital
     * @name AdminHospitalElUpdateDoctor
     * @summary 병원의 병원관계자 수정
     * @request POST:/v2/admin/hospital/el/update/doctor
     * @secure
     * @response `200` `AdminHospitalElUpdateDoctorData` \{User\} 사용자 객체
     */
    adminHospitalElUpdateDoctor: (
      data: {
        /** 수정할 병원 계정 ObjectID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHospitalElUpdateDoctorData, any>({
        path: `/v2/admin/hospital/el/update/doctor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 조회되는 객체가 있을 경우, '병원 설정 > 이용 중단 내 전체 서비스 종료' 체크박스를 누를 수 있음.
     *
     * @tags Admin-HService
     * @name AdminHserviceElFindIsclosed
     * @summary 병원 기준 HService가 중지되지 않은 사용자가 남아있는지 조회
     * @request GET:/v2/admin/hservice/el/find/isclosed
     * @secure
     * @response `200` `AdminHserviceElFindIsclosedData` \[\{HService\}\] 이용 중단 처리되지 않은 HService 컬렉션 객체 배열 (최대 10건)
     */
    adminHserviceElFindIsclosed: (query: AdminHserviceElFindIsclosedParams, params: RequestParams = {}) =>
      this.request<AdminHserviceElFindIsclosedData, any>({
        path: `/v2/admin/hservice/el/find/isclosed`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description - 병원 서비스 이용 중단 시, 병원ID와 연결된 HService를 모두 종료 처리 - 다른 병원 이용중인 HService가 있는 경우 User에 대한 중단은 하지않음.
     *
     * @tags Admin-HService
     * @name AdminHserviceElUpdateSuspendAll
     * @summary HospitalID 와 연결된 HService 이용 중단 처리
     * @request POST:/v2/admin/hservice/el/update/suspend/all
     * @secure
     * @response `200` `AdminHserviceElUpdateSuspendAllData` \[\{HService\}\] 이용중단 처리된 HService 컬렉션 객체 배열
     */
    adminHserviceElUpdateSuspendAll: (
      data: {
        /** 이용 중단할 병원 ObjectID */
        hospitalID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminHserviceElUpdateSuspendAllData, any>({
        path: `/v2/admin/hservice/el/update/suspend/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Nurse
     * @name AdminNurseElFind
     * @summary 서비스 매니저 계정 조회
     * @request GET:/v2/admin/nurse/el/find
     * @secure
     * @response `200` `AdminNurseElFindData` \[\{User\}\] 서비스 매니저 객체 배열
     */
    adminNurseElFind: (params: RequestParams = {}) =>
      this.request<AdminNurseElFindData, any>({
        path: `/v2/admin/nurse/el/find`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Nurse
     * @name AdminNurseElCreate
     * @summary 신규 서비스 매니저 계정 생성
     * @request POST:/v2/admin/nurse/el/create
     * @secure
     * @response `200` `AdminNurseElCreateData` \{User\} 간호사 유저 객체
     */
    adminNurseElCreate: (
      data: {
        id?: string;
        password?: string;
        name?: string;
        realName?: string;
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminNurseElCreateData, any>({
        path: `/v2/admin/nurse/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Nurse
     * @name AdminNurseElUpdate
     * @summary 서비스 매니저 계정 수정
     * @request POST:/v2/admin/nurse/el/update
     * @secure
     * @response `200` `AdminNurseElUpdateData` \{User\} 서비스 매니저 User 객체
     */
    adminNurseElUpdate: (
      data: {
        /** 수정할 서비스 매니저 계정 ObjectID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminNurseElUpdateData, any>({
        path: `/v2/admin/nurse/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Nurse
     * @name AdminNurseElCount
     * @summary 서비스 매니저 계정 수 조회
     * @request GET:/v2/admin/nurse/el/count/
     * @secure
     * @response `200` `AdminNurseElCountData` 서비스 매니저 계정 수
     */
    adminNurseElCount: (params: RequestParams = {}) =>
      this.request<AdminNurseElCountData, any>({
        path: `/v2/admin/nurse/el/count/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-ServiceSetting
     * @name AdminServicesettingElFind
     * @summary 서비스 설정(ServiceSetting) 조회
     * @request GET:/v2/admin/servicesetting/el/find
     * @secure
     * @response `200` `AdminServicesettingElFindData` \[\{ServiceSetting\}\] 서비스 설정 객체 배열
     */
    adminServicesettingElFind: (query: AdminServicesettingElFindParams, params: RequestParams = {}) =>
      this.request<AdminServicesettingElFindData, any>({
        path: `/v2/admin/servicesetting/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-ServiceSetting
     * @name AdminServicesettingElFindOne
     * @summary 서비스 설정(ServiceSetting) 상세 조회
     * @request GET:/v2/admin/servicesetting/el/find/one
     * @secure
     * @response `200` `AdminServicesettingElFindOneData` \{ServiceSetting\} 서비스 설정 객체
     */
    adminServicesettingElFindOne: (query: AdminServicesettingElFindOneParams, params: RequestParams = {}) =>
      this.request<AdminServicesettingElFindOneData, any>({
        path: `/v2/admin/servicesetting/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-ServiceSetting
     * @name AdminServicesettingElFindUsingvc
     * @summary 모든 병원의 서비스 설정(ServiceSetting) 조회
     * @request GET:/v2/admin/servicesetting/el/find/usingvc
     * @secure
     * @response `200` `AdminServicesettingElFindUsingvcData` \[\{ServiceSetting\}\] 서비스 설정 객체 배열
     */
    adminServicesettingElFindUsingvc: (query: AdminServicesettingElFindUsingvcParams, params: RequestParams = {}) =>
      this.request<AdminServicesettingElFindUsingvcData, any>({
        path: `/v2/admin/servicesetting/el/find/usingvc`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-ServiceSetting
     * @name AdminServicesettingElCreate
     * @summary 서비스 설정(ServiceSetting) 생성
     * @request POST:/v2/admin/servicesetting/el/create
     * @secure
     * @response `200` `AdminServicesettingElCreateData` \{ServiceSetting\} 서비스 설정 객체
     */
    adminServicesettingElCreate: (
      data: {
        /** 해당 설정이 소속된 병원의 ID */
        hospitalID?: string;
        name?: string;
        /** 치료 카테고리 오브젝트. 미작성된 경우 생성하고자 하는 오브젝트 삽입 */
        treatmentCategories?: Record<string, any>[];
        /** 초진, 재진 구분 사용 여부 */
        usingFirstVisit?: boolean;
        /** 초진일 입력 여부 */
        usingStartDate?: boolean;
        /** 가입 직후 최초 영상 카테고리별 자동 전달을 사용할 카테고리 아이디 */
        usingAutoSendVideo?: string[];
        /** 디폴트 이행기간. object array */
        videoContentDuration?: {
          /** 카테고리 대 ObjectID */
          categoryID?: string;
          /** 이행 기간 */
          duration?: number;
          /** 한 주당 이행 횟수 */
          doPerWeek?: number;
        }[];
        /** 운동콘텐츠 전송 시 사용할 기본 코멘트 */
        defaultVCMessage?: string;
        /** 자동발송에 사용할 첫 번째 병원 운동콘텐츠 ObjectId */
        selectedFirstVCH?: string;
        /** 자동발송에 두 번째 병원 운동콘텐츠 ObjectId */
        selectedSecondVCH?: string;
        /** 기본 콘텐츠 전송 시 함께 전달될 문구 */
        firstVCUMessage?: string;
        /** 두 번째 기본 콘텐츠 전송 시 함께 전달될 문구. 예 - 1일 3시간 뒤 */
        secondVCUMessage?: string;
        /**
         * 첫 번째 콘텐츠 발송시간 기준, 두 번째(또는 다음) 콘텐츠 발송시간
         * @default "1970-01-01T03:00:00.000Z"
         */
        sendVCInterval?: string;
        /** 운동콘텐츠 뱃지 출력을 위한 최소 공유 횟수 */
        vcuBadge?: number;
        /** 사용할 대 카테고리 정보 배열 */
        topVCCategories?: {
          /** 카테고리 대 ObjectID */
          categoryID?: string;
          /** 사용 여부 */
          isRemoved?: boolean;
        }[];
        /**
         * 삭제 여부
         * @default false
         */
        isRemoved?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminServicesettingElCreateData, any>({
        path: `/v2/admin/servicesetting/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-ServiceSetting
     * @name AdminServicesettingElCreateSample
     * @summary 서비스 설정(ServiceSetting) 샘플(템플릿) 생성
     * @request POST:/v2/admin/servicesetting/el/create/sample
     * @secure
     * @response `200` `AdminServicesettingElCreateSampleData` \{ServiceSetting\} 서비스 설정 객체
     */
    adminServicesettingElCreateSample: (
      data: {
        name?: string;
        /** 치료 카테고리 오브젝트. 미작성된 경우 생성하고자 하는 오브젝트 삽입 */
        treatmentCategories?: Record<string, any>[];
        /** 초진, 재진 구분 사용 여부 */
        usingFirstVisit?: boolean;
        /** 초진일 입력 여부 */
        usingStartDate?: boolean;
        /** 가입 직후 최초 영상 카테고리별 자동 전달을 사용할 카테고리 아이디 */
        usingAutoSendVideo?: string[];
        /** 디폴트 이행기간. object array */
        videoContentDuration?: {
          /** 카테고리 대 ObjectID */
          categoryID?: string;
          /** 이행 기간 */
          duration?: number;
          /** 한 주당 이행 횟수 */
          doPerWeek?: number;
        }[];
        /** 운동콘텐츠 전송 시 사용할 기본 코멘트 */
        defaultVCMessage?: string;
        /** 자동발송에 사용할 첫 번째 병원 운동콘텐츠 ObjectId */
        selectedFirstVCH?: string;
        /** 자동발송에 두 번째 병원 운동콘텐츠 ObjectId */
        selectedSecondVCH?: string;
        /** 기본 콘텐츠 전송 시 함께 전달될 문구 */
        firstVCUMessage?: string;
        /** 두 번째 기본 콘텐츠 전송 시 함께 전달될 문구. 예 - 1일 3시간 뒤 */
        secondVCUMessage?: string;
        /**
         * 첫 번째 콘텐츠 발송시간 기준, 두 번째(또는 다음) 콘텐츠 발송시간
         * @default "1970-01-01T03:00:00.000Z"
         */
        sendVCInterval?: string;
        /** 운동콘텐츠 뱃지 출력을 위한 최소 공유 횟수 */
        vcuBadge?: number;
        /** 사용할 대 카테고리 정보 배열 */
        topVCCategories?: {
          /** 카테고리 대 ObjectID */
          categoryID?: string;
          /** 사용 여부 */
          isRemoved?: boolean;
        }[];
        /**
         * 삭제 여부
         * @default false
         */
        isRemoved?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminServicesettingElCreateSampleData, any>({
        path: `/v2/admin/servicesetting/el/create/sample`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-ServiceSetting
     * @name AdminServicesettingElCount
     * @summary 서비스 설정(ServiceSetting) 전체 수 조회
     * @request GET:/v2/admin/servicesetting/el/count
     * @secure
     * @response `200` `AdminServicesettingElCountData` 서비스 설정 객체 수
     */
    adminServicesettingElCount: (params: RequestParams = {}) =>
      this.request<AdminServicesettingElCountData, any>({
        path: `/v2/admin/servicesetting/el/count`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-ServiceSetting
     * @name AdminServicesettingElUpdate
     * @summary 서비스 설정(ServiceSetting) 수정
     * @request POST:/v2/admin/servicesetting/el/update
     * @secure
     * @response `200` `AdminServicesettingElUpdateData` \{ServiceSetting\} 서비스 설정 객체
     */
    adminServicesettingElUpdate: (
      data: {
        /** Service Setting Object ID */
        _id?: string;
        /** 수정하고자 하는 병원 ID */
        hospitalID?: string;
        name?: string;
        /** 치료 카테고리 오브젝트. 미작성된 경우 생성하고자 하는 오브젝트 삽입 */
        treatmentCategories?: Record<string, any>[];
        /** 초진, 재진 구분 사용 여부 */
        usingFirstVisit?: boolean;
        /** 초진일 입력 여부 */
        usingStartDate?: boolean;
        /** 가입 직후 최초 영상 카테고리별 자동 전달을 사용할 카테고리 아이디 */
        usingAutoSendVideo?: string[];
        /** 디폴트 이행기간. object array */
        videoContentDuration?: {
          /** 카테고리 대 ObjectID */
          categoryID?: string;
          /** 이행 기간 */
          duration?: number;
          /** 한 주당 이행 횟수 */
          doPerWeek?: number;
        }[];
        /** 운동콘텐츠 전송 시 사용할 기본 코멘트 */
        defaultVCMessage?: string;
        /** first vch objectID */
        selectedFirstVCH?: string;
        /** second vch objectID */
        selectedSecondVCH?: string;
        /** first vcu message (comment) */
        firstVCUMessage?: string;
        /** second vcu message (comment) */
        secondVCUMessage?: string;
        /**
         * 첫 번째 콘텐츠 발송시간 기준, 두 번째(또는 다음) 콘텐츠 발송시간
         * @default "1970-01-01T03:00:00.000Z"
         */
        sendVCInterval?: string;
        /** 운동콘텐츠 공유 뱃지 출력을 위한 공유횟수 환자 상위 n% 입력 */
        vcuBadge?: number;
        /** 사용할 대 카테고리 정보 배열 */
        topVCCategories?: {
          /** 카테고리 대 ObjectID */
          categoryID?: string;
          /** 사용 여부 */
          isRemoved?: boolean;
        }[];
        /**
         * 삭제 여부
         * @default false
         */
        isRemoved?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminServicesettingElUpdateData, any>({
        path: `/v2/admin/servicesetting/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-ServiceSetting
     * @name AdminServicesettingElUpdateSample
     * @summary 샘플 서비스 설정(ServiceSetting) 수정
     * @request POST:/v2/admin/servicesetting/el/update/sample
     * @secure
     * @response `200` `AdminServicesettingElUpdateSampleData` \{ServiceSetting\} 서비스 설정 객체
     */
    adminServicesettingElUpdateSample: (
      data: {
        /** Service Setting Object ID */
        _id?: string;
        name?: string;
        /** 치료 카테고리 오브젝트. 미작성된 경우 생성하고자 하는 오브젝트 삽입 */
        treatmentCategories?: Record<string, any>[];
        /** 초진, 재진 구분 사용 여부 */
        usingFirstVisit?: boolean;
        /** 초진일 입력 여부 */
        usingStartDate?: boolean;
        /** 가입 직후 최초 영상 카테고리별 자동 전달을 사용할 카테고리 아이디 */
        usingAutoSendVideo?: string[];
        /** 디폴트 이행기간. object array */
        videoContentDuration?: {
          /** 카테고리 대 ObjectID */
          categoryID?: string;
          /** 이행 기간 */
          duration?: number;
          /** 한 주당 이행 횟수 */
          doPerWeek?: number;
        }[];
        /** 사용할 대 카테고리 정보 배열 */
        topVCCategories?: {
          /** 카테고리 대 ObjectID */
          categoryID?: string;
          /** 사용 여부 */
          isRemoved?: boolean;
        }[];
        /**
         * 삭제 여부
         * @default false
         */
        isRemoved?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminServicesettingElUpdateSampleData, any>({
        path: `/v2/admin/servicesetting/el/update/sample`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 병원 내 권한 목록 조회.
     *
     * @tags Admin-HospitalAuthorizationType
     * @name AdminAuthorizationtypeElFind
     * @summary 병원 내 권한 목록
     * @request GET:/v2/admin/authorizationtype/el/find
     * @secure
     * @response `200` `AdminAuthorizationtypeElFindData` \[\{AuthorizationType\}\] 병원 내 사용중인 권한 목록
     */
    adminAuthorizationtypeElFind: (query: AdminAuthorizationtypeElFindParams, params: RequestParams = {}) =>
      this.request<AdminAuthorizationtypeElFindData, any>({
        path: `/v2/admin/authorizationtype/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-ServerSetting
     * @name AdminSettingVersionElFind
     * @summary 앱 버전 설정(ServerSetting) 조회
     * @request GET:/v2/admin/setting/version/el/find
     * @secure
     * @response `200` `AdminSettingVersionElFindData` \[\{ServerSetting\}\] 앱 버전 설정 객체 배열
     */
    adminSettingVersionElFind: (params: RequestParams = {}) =>
      this.request<AdminSettingVersionElFindData, any>({
        path: `/v2/admin/setting/version/el/find`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-ServerSetting
     * @name AdminSettingVersionElUpdate
     * @summary 앱 버전 설정(ServerSetting) 수정
     * @request POST:/v2/admin/setting/version/el/update
     * @secure
     * @response `200` `AdminSettingVersionElUpdateData` \[\{ServerSetting\}\] 업데이트된 앱 버전 설정 객체 배열
     */
    adminSettingVersionElUpdate: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminSettingVersionElUpdateData, any>({
        path: `/v2/admin/setting/version/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-IntegrationSetting
     * @name AdminIntegrationsettingElFindOne
     * @summary 연동 설정(IntegrationSetting) 상세 조회
     * @request GET:/v2/admin/integrationsetting/el/find/one
     * @secure
     * @response `200` `AdminIntegrationsettingElFindOneData` \{IntegrationSetting\} 연동 설정 객체
     */
    adminIntegrationsettingElFindOne: (query: AdminIntegrationsettingElFindOneParams, params: RequestParams = {}) =>
      this.request<AdminIntegrationsettingElFindOneData, any>({
        path: `/v2/admin/integrationsetting/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-IntegrationSetting
     * @name AdminIntegrationsettingElCreate
     * @summary 연동 설정(IntegrationSetting) 생성
     * @request POST:/v2/admin/integrationsetting/el/create
     * @secure
     * @response `200` `AdminIntegrationsettingElCreateData` \{IntegrationSetting\} 생성된 연동 설정 객체
     */
    adminIntegrationsettingElCreate: (
      data: {
        /** (required) 병원 ID */
        hospitalID?: string;
        /** 연동사 API 접근을 위한 클라이언트 토큰 (병원별 발급) */
        clientToken?: string;
        /** 연동사 타입 (ALM _ 전능 스마트닥터) */
        integrationType?: string;
        /** 연동사 별 커스터마이징을 위한 객체 값 */
        customObject?: Record<string, any>;
        /** 연동 시 고객 등록 연동 사용 여부 */
        usingRegist?: boolean;
        /** 연동 시 예약 시트 연동 사용 여부 */
        usingReservation?: boolean;
        /** 연동 시 대시보드 기능 사용 여부 */
        usingDashboard?: boolean;
        /**
         * 삭제 여부
         * @default false
         */
        isRemoved?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminIntegrationsettingElCreateData, any>({
        path: `/v2/admin/integrationsetting/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-IntegrationSetting
     * @name AdminIntegrationsettingElUpdate
     * @summary 연동 설정(IntegrationSetting) 수정
     * @request POST:/v2/admin/integrationsetting/el/update
     * @secure
     * @response `200` `AdminIntegrationsettingElUpdateData` \{IntegrationSetting\} 수정된 연동 설정 객체
     */
    adminIntegrationsettingElUpdate: (
      data: {
        /** 연동 설정 ID */
        _id?: string;
        /** 병원 ID (변경 시에만 입력) */
        hospitalID?: string;
        /** 연동사 API 접근을 위한 클라이언트 토큰 (병원별 발급) */
        clientToken?: string;
        /** 연동사 타입 (ALM _ 전능 스마트닥터) */
        integrationType?: string;
        /** 연동사 별 커스터마이징을 위한 객체 값 */
        customObject?: Record<string, any>;
        /** 연동 시 고객 등록 연동 사용 여부 */
        usingRegist?: boolean;
        /** 연동 시 예약 시트 연동 사용 여부 */
        usingReservation?: boolean;
        /** 연동 시 대시보드 기능 사용 여부 */
        usingDashboard?: boolean;
        /** 삭제 여부 */
        isRemoved?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminIntegrationsettingElUpdateData, any>({
        path: `/v2/admin/integrationsetting/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-AnsweringChat
     * @name AdminAnsweringchatElFind
     * @summary 자동 응대 채팅 조회
     * @request GET:/v2/admin/answeringchat/el/find
     * @secure
     * @response `200` `AdminAnsweringchatElFindData` \[\{AnsweringChat\}\] 자동 응대 채팅 객체 배열
     */
    adminAnsweringchatElFind: (query: AdminAnsweringchatElFindParams, params: RequestParams = {}) =>
      this.request<AdminAnsweringchatElFindData, any>({
        path: `/v2/admin/answeringchat/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-AnsweringChat
     * @name AdminAnsweringchatElCount
     * @summary 자동 응대 채팅 수 조회
     * @request GET:/v2/admin/answeringchat/el/count
     * @secure
     * @response `200` `AdminAnsweringchatElCountData` 자동 응대 채팅 객체 수
     */
    adminAnsweringchatElCount: (query: AdminAnsweringchatElCountParams, params: RequestParams = {}) =>
      this.request<AdminAnsweringchatElCountData, any>({
        path: `/v2/admin/answeringchat/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-AnsweringChatSetting
     * @name AdminAnsweringchatsettingElFind
     * @summary 자동 응대 채팅 설정(AnsweringChatSetting) 조회
     * @request GET:/v2/admin/answeringchatsetting/el/find
     * @secure
     * @response `200` `AdminAnsweringchatsettingElFindData` \[\{AnsweringChatSetting\}\] 자동 응대 채팅 설정 객체 배열
     */
    adminAnsweringchatsettingElFind: (query: AdminAnsweringchatsettingElFindParams, params: RequestParams = {}) =>
      this.request<AdminAnsweringchatsettingElFindData, any>({
        path: `/v2/admin/answeringchatsetting/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-AnsweringChatSetting
     * @name AdminAnsweringchatsettingElCreate
     * @summary 자동 응대 채팅 설정(AnsweringChatSetting) 생성
     * @request POST:/v2/admin/answeringchatsetting/el/create
     * @secure
     * @response `200` `AdminAnsweringchatsettingElCreateData` \{AnsweringChatSetting\} 생성된 자동 응대 채팅 설정 객체
     */
    adminAnsweringchatsettingElCreate: (
      data: {
        /** (required) 병원 ID */
        hospitalID?: string;
        /** 자동 응대 채팅 기능 사용 여부 (채팅 예약 기준) */
        usingAnsweringChat?: boolean;
        /** 일반 텍스트 상담 시 자동 응대 */
        usingGeneralChat?: boolean;
        /** 병원 운영시간 */
        careSchedule?: Record<string, any>[];
        /** 병원 운영시간 내 자동 응대 채팅 메시지 내용 */
        businessHourMessage?: string;
        /** 병원 운영시간 외 자동 응대 채팅 메시지 내용 */
        nonBusinessHourMessage?: string;
        /** 메시지 발송까지의 자동 응대 대기 시간 (단위 n분) */
        interval?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminAnsweringchatsettingElCreateData, any>({
        path: `/v2/admin/answeringchatsetting/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-AnsweringChatSetting
     * @name AdminAnsweringchatsettingElUpdate
     * @summary 자동 응대 채팅 설정(AnsweringChatSetting) 수정
     * @request POST:/v2/admin/answeringchatsetting/el/update
     * @secure
     * @response `200` `AdminAnsweringchatsettingElUpdateData` \{AnsweringChatSetting\} 수정된 자동 응대 채팅 설정 객체
     */
    adminAnsweringchatsettingElUpdate: (
      data: {
        /** 자동 응대 채팅 설정 ID */
        _id?: string;
        /** 자동 응대 채팅 기능 사용 여부 (채팅 예약 기준) */
        usingAnsweringChat?: boolean;
        /** 일반 텍스트 상담 시 자동 응대 */
        usingGeneralChat?: boolean;
        /** 병원 운영시간 */
        careSchedule?: Record<string, any>[];
        /** 병원 운영시간 내 자동 응대 채팅 메시지 내용 */
        businessHourMessage?: string;
        /** 병원 운영시간 외 자동 응대 채팅 메시지 내용 */
        nonBusinessHourMessage?: string;
        /** 메시지 발송까지의 자동 응대 대기 시간 (단위 n분) */
        interval?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminAnsweringchatsettingElUpdateData, any>({
        path: `/v2/admin/answeringchatsetting/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Monitoring-Hospital
     * @name AdminMonitoringHospitalElFind
     * @summary 모니터링 대상 병원 조회
     * @request GET:/v2/admin/monitoring/hospital/el/find
     * @secure
     * @response `200` `AdminMonitoringHospitalElFindData` \[\{Admin_HospitalList\}\] 모니터링 대상 병원 객체 배열
     */
    adminMonitoringHospitalElFind: (params: RequestParams = {}) =>
      this.request<AdminMonitoringHospitalElFindData, any>({
        path: `/v2/admin/monitoring/hospital/el/find`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-HospitalEvent
     * @name AdminEventHospitalEventElFind
     * @summary 병원이벤트 목록 조회
     * @request GET:/v2/admin/event/hospital/event/el/find
     * @secure
     * @response `200` `AdminEventHospitalEventElFindData` \[\{HospitalEvent\}\] 병원이벤트 객체 배열
     */
    adminEventHospitalEventElFind: (query: AdminEventHospitalEventElFindParams, params: RequestParams = {}) =>
      this.request<AdminEventHospitalEventElFindData, any>({
        path: `/v2/admin/event/hospital/event/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-HospitalEvent
     * @name AdminEventHospitalEventElFindOne
     * @summary 병원이벤트 상세 조회
     * @request GET:/v2/admin/event/hospital/event/el/find/one
     * @secure
     * @response `200` `AdminEventHospitalEventElFindOneData` \{HospitalEvent\} 병원이벤트 객체
     */
    adminEventHospitalEventElFindOne: (query: AdminEventHospitalEventElFindOneParams, params: RequestParams = {}) =>
      this.request<AdminEventHospitalEventElFindOneData, any>({
        path: `/v2/admin/event/hospital/event/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservedSMS
     * @name ApiReservedsmsElCount
     * @summary 예약된 가입문자 재발송(ReservedSMS) 개수 조회
     * @request GET:/v2/api/reservedsms/el/count
     * @secure
     * @response `200` `ApiReservedsmsElCountData` response count of Reserved SMS Models
     */
    apiReservedsmsElCount: (query: ApiReservedsmsElCountParams, params: RequestParams = {}) =>
      this.request<ApiReservedsmsElCountData, any>({
        path: `/v2/api/reservedsms/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReservedSMS
     * @name ApiReservedsmsElFind
     * @summary 예약된 가입문자 재발송(ReservedSMS) 조회
     * @request GET:/v2/api/reservedsms/el/find
     * @secure
     * @response `200` `ApiReservedsmsElFindData` response of Reserved SMS Models
     */
    apiReservedsmsElFind: (query: ApiReservedsmsElFindParams, params: RequestParams = {}) =>
      this.request<ApiReservedsmsElFindData, any>({
        path: `/v2/api/reservedsms/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CAReservedChat
     * @name AdminCaCareservedchatElCount
     * @summary 예약된 자동 상담채팅 개수 조회
     * @request GET:/v2/admin/ca/careservedchat/el/count
     * @secure
     * @response `200` `AdminCaCareservedchatElCountData` response count of Reserved SMS Models
     */
    adminCaCareservedchatElCount: (query: AdminCaCareservedchatElCountParams, params: RequestParams = {}) =>
      this.request<AdminCaCareservedchatElCountData, any>({
        path: `/v2/admin/ca/careservedchat/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CAReservedChat
     * @name AdminCaCareservedchatElFind
     * @summary 예약된 자동 상담채팅 조회
     * @request GET:/v2/admin/ca/careservedchat/el/find
     * @secure
     * @response `200` `AdminCaCareservedchatElFindData` response of Reserved SMS Models
     */
    adminCaCareservedchatElFind: (query: AdminCaCareservedchatElFindParams, params: RequestParams = {}) =>
      this.request<AdminCaCareservedchatElFindData, any>({
        path: `/v2/admin/ca/careservedchat/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CAReservedChat
     * @name AdminCaCareservedchatElCreate
     * @summary 자동 상담채팅 모델 생성
     * @request POST:/v2/admin/ca/careservedchat/el/create
     * @secure
     * @response `200` `AdminCaCareservedchatElCreateData` \[\{CAReservedChat\}\] 생성된 CAReservedChat 객체
     */
    adminCaCareservedchatElCreate: (
      data: {
        /** 대상자의 병원ID */
        hospitalID?: string;
        /** 대상자의 서비스ID */
        hserviceID?: string;
        /** 대상자의 채팅방ID */
        chatRoomID?: string;
        /** 대상자의 병원이름 */
        hospitalName?: string;
        /** 대상자의 이름 */
        receiverName?: string;
        /** 대상자의 전화번호 */
        receiverPhone?: string;
        /** 전달할 채팅 내용의 배열 */
        contents?: {
          /** 채팅 타입 */
          type?: string;
          /** 전달할 채팅의 텍스트 내용 */
          content?: string;
        }[];
        /** 상담 알고리즘의 Identifier(임시) */
        caName?: string;
        /** 상담 알고리즘의 사이클 Identifier */
        caCycle?: string;
        /** 테스트 시 기록하고자 하는 내용 */
        description?: string;
        /**
         * 발송 예정일시
         * @default "2030-01-01T10:00:00.000+0900"
         */
        sendDateTime?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminCaCareservedchatElCreateData, any>({
        path: `/v2/admin/ca/careservedchat/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CAReservedChat
     * @name AdminCaCareservedchatElCreatemany
     * @summary 자동 상담채팅 모델 생성
     * @request POST:/v2/admin/ca/careservedchat/el/createmany
     * @secure
     * @response `200` `AdminCaCareservedchatElCreatemanyData` \[\{CAReservedChat\}\] 생성된 CAReservedChat 객체
     */
    adminCaCareservedchatElCreatemany: (
      data: {
        /** 대상자의 병원ID */
        hospitalID?: string;
        /** 대상자의 서비스ID */
        hserviceID?: string;
        /** 대상자의 채팅방ID */
        chatRoomID?: string;
        /** 대상자의 병원이름 */
        hospitalName?: string;
        /** 대상자의 이름 */
        receiverName?: string;
        /** 대상자의 전화번호 */
        receiverPhone?: string;
        /** 전달할 채팅 내용의 배열 */
        contents?: {
          /** 채팅 타입 */
          type?: string;
          /** 전달할 채팅의 텍스트 내용 */
          content?: string;
        }[];
        /** 상담 알고리즘의 Identifier(임시) */
        caName?: string;
        /** 상담 알고리즘의 사이클 Identifier */
        caCycle?: string;
        /** 테스트 시 기록하고자 하는 내용 */
        description?: string;
        /**
         * 발송 예정일시
         * @default "2030-01-01T10:00:00.000+0900"
         */
        sendDateTime?: string;
      }[],
      params: RequestParams = {},
    ) =>
      this.request<AdminCaCareservedchatElCreatemanyData, any>({
        path: `/v2/admin/ca/careservedchat/el/createmany`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Stats-HospitalEvent
     * @name AdminStatsEventHospitalEventElFind
     * @summary 병원이벤트 통계 목록 조회
     * @request GET:/v2/admin/stats/event/hospital/event/el/find
     * @secure
     * @response `200` `AdminStatsEventHospitalEventElFindData` \[\{stats_HospitalEvent\}\] 정렬된 stats_HospitalEvent 컬렉션 객체 배열
     */
    adminStatsEventHospitalEventElFind: (query: AdminStatsEventHospitalEventElFindParams, params: RequestParams = {}) =>
      this.request<AdminStatsEventHospitalEventElFindData, any>({
        path: `/v2/admin/stats/event/hospital/event/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Stats-HospitalEvent
     * @name AdminStatsEventHospitalEventElCount
     * @summary 병원이벤트 통계 수 조회
     * @request GET:/v2/admin/stats/event/hospital/event/el/count
     * @secure
     * @response `200` `AdminStatsEventHospitalEventElCountData` stats_HospitalEvent 수
     */
    adminStatsEventHospitalEventElCount: (
      query: AdminStatsEventHospitalEventElCountParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminStatsEventHospitalEventElCountData, any>({
        path: `/v2/admin/stats/event/hospital/event/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Stats-HospitalEventPushNotification
     * @name AdminStatsEventHospitalEventpushElFind
     * @summary 병원이벤트 푸시 알림 통계 목록 조회
     * @request GET:/v2/admin/stats/event/hospital/eventpush/el/find
     * @secure
     * @response `200` `AdminStatsEventHospitalEventpushElFindData` \[\{stats_HospitalEventPushNotification\}\] 정렬된 stats_HospitalEventPushNotification 컬렉션 객체 배열
     */
    adminStatsEventHospitalEventpushElFind: (
      query: AdminStatsEventHospitalEventpushElFindParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminStatsEventHospitalEventpushElFindData, any>({
        path: `/v2/admin/stats/event/hospital/eventpush/el/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin-Stats-HospitalEventPushNotification
     * @name AdminStatsEventHospitalEventpushElCount
     * @summary 병원이벤트 푸시 알림 통계 수 조회
     * @request GET:/v2/admin/stats/event/hospital/eventpush/el/count
     * @secure
     * @response `200` `AdminStatsEventHospitalEventpushElCountData` stats_HospitalEventPushNotification 객체 수
     */
    adminStatsEventHospitalEventpushElCount: (
      query: AdminStatsEventHospitalEventpushElCountParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminStatsEventHospitalEventpushElCountData, any>({
        path: `/v2/admin/stats/event/hospital/eventpush/el/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Email
     * @name PublicEmailSend
     * @summary 홈페이지에서 문의 받은 이메일 발송
     * @request POST:/v2/public/email/send
     * @secure
     * @response `200` `PublicEmailSendData` \{Email\} 발송된 이메일 내용
     */
    publicEmailSend: (
      data: {
        /** 메일 제목 */
        subject?: string;
        /** 메일 본문 */
        text?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PublicEmailSendData, any>({
        path: `/v2/public/email/send`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicEmailSendLogs
     * @name ApiPublicEmailSendLogsList
     * @summary 공개 이메일 발송 성공 로그 목록 조회
     * @request GET:/v2/api/public-email-send-logs/list
     * @secure
     * @response `200` `ApiPublicEmailSendLogsListData` 공개 이메일 발송 성공 로그 목록
     */
    apiPublicEmailSendLogsList: (query: ApiPublicEmailSendLogsListParams, params: RequestParams = {}) =>
      this.request<ApiPublicEmailSendLogsListData, any>({
        path: `/v2/api/public-email-send-logs/list`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicEmailSendLogs
     * @name ApiPublicEmailSendLogsDetail
     * @summary 공개 이메일 발송 성공 로그 상세 조회
     * @request GET:/v2/api/public-email-send-logs/detail
     * @secure
     * @response `200` `ApiPublicEmailSendLogsDetailData` 공개 이메일 발송 성공 로그 상세
     */
    apiPublicEmailSendLogsDetail: (query: ApiPublicEmailSendLogsDetailParams, params: RequestParams = {}) =>
      this.request<ApiPublicEmailSendLogsDetailData, any>({
        path: `/v2/api/public-email-send-logs/detail`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public-Regist-ThirdParty
     * @name PublicRegistKakaoConsult
     * @summary 카카오 상담톡 등록요청
     * @request POST:/v2/public/regist/kakao/consult
     * @secure
     * @response `200` `PublicRegistKakaoConsultData` \{Kakao_Linkage_History\} 생성된 요청 객체
     */
    publicRegistKakaoConsult: (
      data: {
        /** (optional) 병원 ID */
        hospitalID?: string;
        /** 병원명 */
        tempHospitalName?: string;
        /** 신청자명 */
        realName?: string;
        /** 연락처 */
        phone?: string;
        /** 시작 희망일시 */
        requestStartedAt?: Date;
        /** 요청자 ID */
        requsetUserID?: string;
        /** 채널 검색용 아이디 */
        pf_id?: string;
        /** 고객센터 전화번호 */
        contact_phone?: string;
        /** 상담가능 일시 - 월 */
        possibleDays_Mon?: boolean;
        /** 상담가능 일시 - 화 */
        possibleDays_Tue?: boolean;
        /** 상담가능 일시 - 수 */
        possibleDays_Wed?: boolean;
        /** 상담가능 일시 - 목 */
        possibleDays_Thu?: boolean;
        /** 상담가능 일시 - 금 */
        possibleDays_Fri?: boolean;
        /** 상담가능 일시 - 토 */
        possibleDays_Sat?: boolean;
        /** 상담가능 일시 - 일 */
        possibleDays_Sun?: boolean;
        /** 상담가능일시 - 시작 */
        possibleStartedAt?: string;
        /** 상담가능일시 - 종료 */
        possibleEndedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PublicRegistKakaoConsultData, any>({
        path: `/v2/public/regist/kakao/consult`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public-Regist-ThirdParty
     * @name PublicRegistKakaoFriend
     * @summary 카카오 친구/알림톡 등록요청
     * @request POST:/v2/public/regist/kakao/friend
     * @secure
     * @response `200` `PublicRegistKakaoFriendData` \{Kakao_Linkage_History\} 생성된 요청 객체
     */
    publicRegistKakaoFriend: (
      data: {
        /** (optional) 병원 ID */
        hospitalID?: string;
        /** 병원명 */
        tempHospitalName?: string;
        /** 신청자명 */
        realName?: string;
        /** 연락처 */
        phone?: string;
        /** 시작 희망일시 */
        requestStartedAt?: Date;
        /** 요청자 ID */
        requsetUserID?: string;
        /** 관리자 전화번호 */
        contact_phone?: string;
        /** 발송용 키 */
        senderKey?: string;
        /** 카테고리(대) */
        category_l?: string;
        /** 카테고리(중) */
        category_m?: string;
        /** 카테고리(소) */
        category_s?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PublicRegistKakaoFriendData, any>({
        path: `/v2/public/regist/kakao/friend`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 서버 설정 조회
     *
     * @tags ServerSetting
     * @name GetServerSettingHandler
     * @summary 서버 설정 조회: ts
     * @request GET:/v2/public/serversetting/el
     * @secure
     * @response `200` `GetServerSettingHandlerData` success
     */
    getServerSettingHandler: (params: RequestParams = {}) =>
      this.request<GetServerSettingHandlerData, any>({
        path: `/v2/public/serversetting/el`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
